const stringsES = {
    errorBoundaryTitle: "¡Ups! Algo salió mal.",
    errorBoundaryMessage:
        "Ocurrió un error inesperado.\nSi el problema persiste, por favor contacte al equipo de soporte.",
    errorBoundaryRetryButton: "Volver a Intentar",
    tableCode: "Código de tabla",
    viewDetailsOf: "Ver detalle de {part}",
    editDetailsOf: "Editar {part}",
    Código: "Código",
    Nombre: "Nombre",
    occupants: "ocupantes",
    highlightWorkplaces: "Resaltar lugares de trabajo",
    highlightManagement: "Resaltar gerencias",
    editPosition: "Editar cargo",
    viewPosition: "Ver detalle de cargo",
    selectBranch: "Seleccione la sucursal",
    orientation: "Orientación",
    up: "Arriba",
    left: "Izquierda",
    on: "el",
    at: "a las",
    anonymousFemaleLowercase: "anónima",
    obligatoryValueType: "Tipo de valor informado es Obligatorio",
    seniorityError: 'La "antigüedad hasta" debe ser mayor o igual a la "Antigüedad desde"',
    valueMustBeGreaterThanZeroTableType: "El valor debe ser mayor o igual a 0",
    checkTimeFormat: "Verifique el formato. El mismo debe ser, por ejemplo, 09:00.",
    timeGreaterThanCollaboratorWorktime: "La hora ingresada supera la jornada del colaborador",
    timeGreaterThan2359: "La hora ingresada supera el máximo (23:59)",
    commaSeparatorThreeDecimalsNoZero:
        "Solo se permiten 3 decimales. Se debe usar la coma como separador. No se puede ingresar 0.",
    commaSeparatorThreeDecimals: "Solo se permiten 3 decimales. Se debe usar la coma como separador.",
    commaSeparatorFiveDecimalsNoZero:
        "Solo se permiten 5 decimales. Se debe usar la coma como separador. No se puede ingresar 0.",
    commaSeparatorFiveDecimals: "Solo se permiten 5 decimales. Se debe usar la coma como separador.",
    commaSeparatorTwoDecimalsNoZero:
        "Solo se permiten 2 decimales. Se debe usar la coma como separador. No se puede ingresar 0.",
    commaSeparatorTwoDecimals: "Solo se permiten 2 decimales. Se debe usar la coma como separador.",
    commaSeparatorGenericDecimalsNoZero:
        "Solo se permiten {number} decimales. Se debe usar la coma como separador. No se puede ingresar 0.",
    commaSeparatorGenericDecimals: "Solo se permiten {number} decimales. Se debe usar la coma como separador.",
    invalidPeriodMessage: "Ingrese un período válido (YYYY/MM)",
    extraHoursTableInvalidCodeMessage:
        "El código debe comenzar con una letra. Solo se pueden ingresar letras mayúsculas.",
    invalidYearSelected: "El Año ingresado no es válido",
    startDateMustBeGreaterThanEndDate: 'La "Fecha de inicio" debe ser menor o igual a la "Fecha final"',
    endDateErrorFestiviesTable: 'La "Fecha final" debe ser mayor o igual a la "Fecha de inicio"',
    checkYearFestivitiesDate: "Verifique el año de las fechas ingresadas",
    duplicatedDataEntryPerSociety: "Ya existe un registro con el Tipo de concepto y Concepto seleccionados",
    duplicatedDataExtraHoursAuthorization: "Ya existe un registro con el Código de empleado y Fecha seleccionados",
    distributionCostInsertValue: "Centro de costo, Proyecto o Dimensión deben contener un valor",
    performanceEvaluation: "Evaluación de desempeño",
    fromDateAlt: "Del",
    toDateAlt: "al",
    pendingEvaluations: "Evaluaciones del desempeño que debes realizar",
    indicator: "Indicador",
    scaleForPotentialQuestions: "Escala para la clasificación de las preguntas de potencial",
    groupsToEvaluate: "Grupo de cargos a evaluar",
    createPerformanceForm: "Crear formulario de desempeño",
    editPerformanceForm: "Editar formulario de desempeño",
    duplicatePerformanceForm: "Duplicar formulario de desempeño",
    createQuestion: "Creación de pregunta",
    defaultQuestions: "Preguntas predeterminadas",
    editQuestion: "Modificar pregunta",
    addQuestion: "Agregar pregunta",
    deleteQuestion: "Eliminar pregunta",
    scaleWarningDialogLine1:
        "Para el mismo código de formulario {code} todas las escalas utilizadas para Competencias y Objetivos y para cualquier tipo de evaluación (Diseño de formulario) deben tener la misma calificación numérica para los máximos y mínimos",
    scaleWarningDialogLine2:
        '"La escala de objetivos" y "La escala de competencias" debe tener el mismo valor de calificación numérica para el mínimo y el máximo',
    forExample: "Por ejemplo",
    lowerThanExpected: "Bajo lo esperado",
    asExpected: "Lo esperado",
    aboveExpected: "Sobre lo esperado",
    poor: "Malo",
    fair: "Regular",
    good: "Bueno",
    veryGood: "Muy bueno",
    calibrated: "Calibrada",
    maximumCalification: "Calificación máxima",
    minimumCalification: "Calificación mínima",
    questionsForPerformanceEvaluation: "Preguntas para evaluar el potencial",
    yearEvaluations: "Año de evaluaciones",
    onlyEvaluationsWithFinalScore: "Solo evaluaciones descendentes y con nota final",
    calibrationMessage:
        "Tu evaluación del desempeño ha sido calibrada, revísala nuevamente desde Gestión del desempeño/Resumen y resultados para aceptarla ({selectedProcess})",
    approvePerformanceSummary: "¿Acepta la evaluación de desempeño?",
    graphicsPerformanceSummaryLine1:
        "Las calificaciones y notas mostradas no son notas finales y solo consideran las evaluaciones que se han realizado hasta este momento.",
    graphicsPerformanceSummaryLine2: "Tampoco consideran posibles acciones del comité de calibración.",
    graphicsPerformanceSummaryLine3:
        "Las calificaciones y notas mostradas son notas finales porque todas las evaluaciones han sido realizadas.",
    initialScreenPerformanceSummaryResults:
        "En este momento no hay evaluaciones del desempeño disponibles para ver el resumen y sus resultados (Si hay un proceso activo, debes esperar a que las evaluaciones sean publicadas).",
    interviewsAndFeedbackNoData:
        "En este momento no hay evaluaciones del desempeño disponibles para ver la entrevista y feedback (Si hay un proceso activo, debes esperar a que las evaluaciones pasen al estado En Feedback).",
    potentialQuestions: "Preguntas de potencial",
    noData: "No hay información disponible",
    orderAlreadyInUse: "El orden ingresado ya se encuentra en uso",
    finalScorePotential: "NOTA FINAL DE POTENCIAL",
    partialScorePerformance: "NOTA PARCIAL DE DESEMPEÑO",
    finalScorePerformance: "NOTA FINAL DE DESEMPEÑO",
    asOf: "al",
    interviewDate: "Fecha de la entrevista",
    deliveredBy: "Entregado por",
    feedbackPublicationMessage:
        "Para modificar este feedback o realizar comentarios, acceda a la función Mis Feedbacks desde Mi Escritorio",
    specialtyCode: "Código de la especialidad",
    specialtyName: "Nombre de la especialidad",
    specialtySettingsDefinition: "Definición de especialidades",
    noSpecialtySettingsDefinition: "No se encontraron especialidades",
    newSpecialty: "Nueva especialidad",
    categoryCode: "Código de la categoría",
    categoryName: "Nombre de la categoría",
    newCategory: "Nueva categoría",
    noCategorySettingsDefinition: "No se encontraron categorías",
    categorySettingsDefinition: "Definición de categorías",
    categoryDuplicated: "La categoría se ha duplicado correctamente",
    categoryCreated: "La categoría se ha creado correctamente",
    categoryModified: "La categoría se ha actualizado correctamente",
    categoryDeleted: "La categoría se ha eliminado correctamente",
    categoryInUse: "No es posible eliminar la categoría porque está en uso",
    categoryInUseModify: "No es posible eliminar la categoría porque está en uso",
    duplicatedDataCategory: "No puede existir más de una categoría que comparta el mismo código o nombre",
    specialtyDuplicated: "La especialidad se ha duplicado correctamente",
    specialtyCreated: "La especialidad se ha creado correctamente",
    specialtyModified: "La especialidad se ha actualizado correctamente",
    specialtyDeleted: "La especialidad se ha eliminado correctamente",
    specialtyInUse: "No es posible eliminar la especialidad porque está en uso",
    specialtyInUseModify: "No es posible modificar la especialidad porque está en uso",
    duplicatedDataSpecialty: "No puede existir más de una especialidad que comparta el mismo código o nombre",
    systemTableDuplicated: "La tabla de sistema se ha duplicado correctamente",
    systemTableCreated: "La tabla de sistema se ha creado correctamente",
    systemTableModified: "La tabla de sistema se ha actualizado correctamente",
    systemTableDeleted: "La tabla de sistema se ha eliminado correctamente",
    userTableDuplicated: "La tabla de usuario se ha duplicado correctamente",
    userTableCreated: "La tabla de usuario se ha creado correctamente",
    userTableModified: "La tabla de usuario se ha actualizado correctamente",
    userTableDeleted: "La tabla de usuario se ha eliminado correctamente",
    evaluationProcessDefnitionAssignmentLine2:
        "Si usted reemplaza al evaluador, debe considerar que se mantendrán la calificaciones ya realizadas por el evaluador actual, ¿desea continuar?",
    evaluationProcessDefnitionAssignmentLine3:
        "Si usted asigna a un nuevo evaluador, se eliminará por completo la evaluación que ya le han realizado, ¿desea continuar?",
    evaluationProcessDefnitionAssignmentLine1:
        "El evaluado {evaluated} ya ha sido calificado por el evaluador {evaluator} en el tipo de evaluación {formType}.",
    percentageMyRequests: "Porcentaje del valor solicitado sobre el sueldo: {percentage}",
    percentageExceedsMyRequests:
        "El valor que esta solicitando excede el porcentaje máximo permitido sobre su sueldo ({percentage}%)",
    onboardingMaterialCreated: "El material o recurso se ha creado correctamente",
    onboardingMaterialModified: "El material o recurso se ha actualizado correctamente",
    onboardingMaterialDeleted: "El material o recurso se ha eliminado correctamente",
    positionEditorError: "La cantidad de puestos no puede ser menor a la cantidad de puestos ocupados.",
    stepFourMessagePerformanceForm:
        "Si deshabilita la evaluación del potencial todas las preguntas existentes y relacionadas con ese tipo de la evaluación serán eliminadas",
    stepOneMessagePerformanceForm:
        "Si modifica el tipo de formulario, todas las preguntas existentes y relacionadas con ese tipo de la evaluación serán eliminadas",
    stepTwoMessagePerformanceForm:
        "Si deshabilita la evaluación de competencias transversales todas las competencias que fueron seleccionadas y relacionadas con ese tipo de a la evaluación serán eliminadas",
    evaluationProcessDefinitionMessage1:
        "Se eliminarán todos los datos relacionados con el proceso: red de evaluadores, calificaciones de las competencias, calificaciones de las metas y objetivos, el resultado final de las evaluaciones ya calificadas y la clasificación del potencial con 9-boxes",
    evaluationProcessDefinitionMessage2: "¿Está seguro que desea continuar?",
    replacedEvaluators: "Se ha(n) reemplazado {number} evaluador(es)",
    assignedEvaluators: "Se ha(n) asignado {number} evaluador(es)",
    recognitionPlanDialogLine1: "El plan contiene a empleados con puntos ya asignados.",
    recognitionPlanDialogLine2:
        "Antes de eliminarlo recomendamos que los traspase a otro plan, porque en caso contrario perderan todos sus puntos y reconocimientos obtenidos.",
    recognitionPlanDialogLine3: "¿Confirma su eliminación de todos modos?",
    deleteSpecialty: "Eliminar especialidad",
    deleteCategory: "Eliminar categoría",
    deleteSpecialtyContent: "¿Desea eliminar la especialidad?",
    deleteCategoryContent: "¿Desea eliminar la categoría?",
    createCategory: "Creación de categorías",
    createSpecialty: "Creación de especialidades",
    performanceSummaryResultAcceptRejectAccepted: "Evaluación aceptada con éxito",
    performanceSummaryResultAcceptRejectRefused: "Evaluación objetada con éxito",
    mailDialogEvaluationProcessDefinition: 'El registro seleccionado debe estar en estado "En feedback"',
    mailDialogEvaluationProcessDefinition2: 'El registro seleccionado debe estar en estado "En curso"',
    conceptFormulaFunction:
        'El concepto que quiere actualizar no tiene fórmulas, ni la fórmula estándar ni la personalizada, por ende, para poder considerarlo en un proceso de cálculo, este concepto deberá ingresarse siempre con "Valor informado”, para ello debe seleccionar la opción "Valor obligatorio" en el campo "Estructura de ingreso".',
    recognitionsPlanAssigmentLine1:
        "El colaborador ya tiene puntos ganados, si lo elimina perderá todos sus puntos y reconocimientos obtenidos.",
    recognitionsPlanAssigmentLine2: "Antes de eliminarlo puede traspasarlo de plan si lo desea.",
    recognitionsPlanAssigmentLine3: "¿Confirma su eliminación de todos modos?",
    doYouWantToDeleteAttachment: "¿Desea borrar el adjunto?",
    assistanceAnalysisLine1: "Considere que los cambios aquí aplicados, tales como:",
    assistanceAnalysisLine3: "- Cambios de horarios",
    assistanceAnalysisLine4: "- Autorización de horas extras",
    assistanceAnalysisLine5: "- Justificación de ausencias",
    assistanceAnalysisLine6:
        "No se verán reflejados en los resultados del análisis de asistencia hasta que se ejecute nuevamente el proceso de “Cálculo de análisis de asistencia”",
    valueCannotBeGreaterThanAbscenseHours: "El valor ingresado no puede ser mayor a las horas de ausencia ({hours})",
    performanceFormInUse:
        'Para este formulario hay datos que ya no pueden modificarse (Se mostrarán solo para visualización) porque el formulario está relacionado con uno o más procesos de evaluación del desempeño que aún no están "cerrados"',
    evaluationAccepted: "Su evaluación ha sido aceptada con fecha {acceptanceDate}",
    onBoardingProcessAssignmentMessage3Line1: "La asignación no se ha realizado.",
    onBoardingProcessAssignmentMessage3Line2:
        "Ha seleccionado empleados que ya se encuentran en un proceso actual de onboarding.",
    onBoardingProcessAssignmentMessage3Line3: "Debe omitirlos de la lista seleccionada:",
    onBoardingProcessAssignmentMessage4Line1:
        "Si modifica el estado del proceso a “Cerrado”, considere que aún existen colaboradores para los cuales el proceso no se ha realizado por completo.",
    onBoardingProcessAssignmentMessage4Line2: "¿Cambia el estado a “Cerrado” de todos modos?",
    onBoardingProcessAssignmentMessage5Line1: "Si elimina el proceso de onboarding, también se eliminará:",
    onBoardingProcessAssignmentMessage5Line2:
        "Toda la trazabilidad y el detalle de los colaboradores que han participado.",
    onBoardingProcessAssignmentMessage5Line3: "Sus comentarios, adjuntos, y feedbacks recibidos durante el proceso.",
    onBoardingProcessAssignmentMessage5Line4: "Las acciones realizadas y las etapas por las cuales han pasado.",
    onBoardingProcessAssignmentMessage5Line5: "¿Está seguro que desea continuar?",
    pollNotFound: "No se encontró la encuesta",
    insertDecimalsNoZeroAllowed: "Solo se permiten {decimals} decimales. No se puede ingresar 0.",
    onBoardingProcessAssignmentMessage1Linea1:
        "Si elimina al colaborador del proceso de onboarding, también se eliminará:",
    onBoardingProcessAssignmentMessage1Linea2: "Toda la trazabilidad y el detalle de su participación en el proceso.",
    onBoardingProcessAssignmentMessage1Linea3: "Sus comentarios, adjuntos, y feedbacks recibidos durante el proceso.",
    onBoardingProcessAssignmentMessage1Linea4: "Las acciones realizadas y las etapas por las cuales ha pasado.",
    onBoardingProcessAssignmentMessage1Linea5: "¿Está seguro que desea continuar?",
    onBoardingProcessAssignmentMessage2Linea1:
        "No es posible agregar a nuevos colaboradores a este proceso, porque ya hay actividades avanzadas para uno o más colaboradores.",
    onBoardingProcessAssignmentMessage2Linea2: "Cree un nuevo proceso para incorporar a nuevos colaboradores.",
    deleteRowsConfirmation: "¿Desea eliminar los registros seleccionados?",
    performanceEvaluationErrorMessage:
        'Los ponderados de los objetivos del colaborador para el período "{periodName}" no totalizan 100%, no es posible evaluarlo',
    selectNextStage: "Seleccione la siguiente etapa",
    attentionForStage: "Atención: para el estado {statusName}",
    collaboratorAssistanceAnalysis: "Análisis de asistencia del colaborador",
    assetsDiscountsRequiresBank: 'Se requiere Banco para la forma de pago "Depósito"',
    evalProcessWarningMessage:
        "A todos los colaboradores seleccionados se les asignará como evaluador a su manager directo, ¿desea continuar?",
    extraHoursAuthorizationConfirmMessage1:
        "Para guardar información, los filtros aplicados serán desactivados. Posteriormente podrá activarlos nuevamente.",
    extraHoursAuthorizationConfirmMessage2:
        "Para agregar colaboradores, los filtros aplicados serán desactivados. Posteriormente podrá activarlos nuevamente.",
    extraHoursAuthorizationMessage:
        'Solo es posible eliminar el registro cuando "No existan" horas en "Horas extras Sin Autorizar", si desea no autorizar ninguna, ingrese 00:00 en "Horas Extras Autorizadas"',
    assetsDiscountsRequiresBankAccount: 'Se requiere Cuenta Bancaria para la forma de pago "Depósito"',
    assetsDiscountsDateEndGreaterThan: 'El "Período hasta" debe ser mayor o igual al "Período desde"',
    assetsDiscountsDateStartLessThan: 'El "Período desde" debe ser menor o igual al "Período hasta"',
    assetsDiscountsDecimalQuantity: "Solo se permiten {decimals} decimales.",
    areYouSureYouWantToExecuteProcess: `¿Está seguro que desea ejecutar el proceso: {process}?`,
    assetsDiscountsEntryPerConceptSetDuplicated: `Verifique que no haya más de un registro con la misma fecha para un colaborador ({duplicated})`,
    codeMustNotExceed3Chars: "El código no puede exceder los 3 caracteres!",
    nameMustNotExceed60Chars: "El nombre no puede exceder los 60 caracteres!",
    checkIfDatesAreCompletes: "Verifique que las celdas de Fecha esten completas",
    timePerDayCantExceedHours: "El tiempo por día no puede superar las {maxHours} horas",
    quadrantSuccesfullyUpdated: "El cuadrante se ha actualizado correctamente",
    typesOfSkills: "Competencias",
    createSpecificCompetencyWarning:
        'Para el campo "Grupo de competencias" defina un nombre que será compartido por uno o más cargos o bien defina el "Nombre del cargo" exacto, para un cargo en específico.',
    competencyType: "Tipo de competencia",
    notesMessageLine1:
        "Si elimina la tarea, también se eliminará el feedback completo y todo lo que este contenga (texto, referencia, evidencia y comentarios)",
    vacationsYearRequired: "En año es necesario que ingrese un período anual válido, Ej: 2022/2023",
    sumMustEqual100:
        "La suma de los ponderados es correcta y totaliza 100% para los grupos de las competencias específicas",
    sumErrorTypesOfSkills:
        "La suma de los ponderados totaliza {number}% para {verificationFailures}. Es necesario complementar con otra competencia o reasignar los ponderados",
    systemTableCheckChange:
        "Para indicar que la tabla tiene visado debe existir el campo “U_vis = Status de visación” dentro de la estructura de la tabla",
    deleteTableSystemUser: "¿Desea eliminar la tabla del {isSystemTables}?",
    invalidConceptCode:
        'El código del concepto no es válido. Puede contener únicamente letras, números y los caracteres "-", "_"',
    structureType: "Tipo de estructura o Tipo de conjunto",
    notPossibleToDeleteAssetAndDiscount:
        "No es posible eliminar un haber o descuento cuya modalidad de ingreso sea por sociedad",
    prepaid: "Prepagada",
    entryByImportAlt: "Ingreso vía importación",
    installments: " cuotas",
    installmentAlt: "1 cuota",
    installmentsToPrepay: "Cuotas a prepagar",
    prepayLoan: "Prepagar préstamo",
    pendingInstallments: "Cuotas pendientes",
    invalidInstallmentQuantity: "La cantidad de cuotas no es válida",
    invalidInstallmentQuotaNumber: "El número de cuota de referencia no es válido",
    emptyTableEntryByInstallments:
        'La tabla se encuentra vacía. En caso de haber llenado los datos de cabecera, presione "Generar cuotas"',
    installmentSumErrorPendingInstallments: "La sumatoria de cuotas pendientes no coincide con el saldo pendiente",
    checkCellForValidValues: "Verifique que las celdas tengan valores válidos",
    requiresReceiverSelection: "Requiere selección de destinatario",
    anotherConcept: "Otro concepto",
    extraVariableFieldAlt: "Complemento descriptivo",
    divisionSettingsModifiedSuccesfully: "La unidad de negocio se ha actualizado correctamente",
    divisionSettingsCreatedSuccesfully: "La unidad de negocio se ha creado correctamente",
    divisionSettingsDeletedSuccesfully: "La unidad de negocio se ha eliminado correctamente",
    delegatesAttentionsTo: " delega atenciones a ",
    loadedTemplate: "Plantilla cargada actualmente",
    digitalFolderFileType: "Tipo de archivo en carpeta",
    digitalFolderInstance: "Instancia laboral en carpeta",
    enableAlertMessage: "Habilitar envío de alerta",
    consentInUse: "No es posible eliminar el consentimiento para el colaborador porque ya ha sido recepcionado",
    noAccessToDigitalFolder: "No posee acceso a la carpeta digital de {name}",
    communicationSuccesfullyDeleted: "Comunicación eliminada correctamente",
    actionSuccesfullyCreated: "Acción creada correctamente",
    responsibleAssignedSucessfully:
        "Responsable asignado correctamente. La comunicación ahora será visualizada solamente por el nuevo responsable.",
    communicationClassifiedSuccesfully: "Comunicación clasificada correctamente",
    messageCommunicationChannelLine1:
        'Usted puede cambiar el estado de la comunicación a: "Resuelta" o bien "Dejarla sin efecto", y con ello quedará el registro histórico.',
    messageCommunicationChannelLine2: "Si la elimina se perderá toda la información y trazabilidad de la comunicación.",
    messageCommunicationChannelLine3: "¿Desea eliminarla de todos modos?",
    attentionResponsibleAlt: "Responsable de atención",
    createdByAlt: "Creada por",
    complaints: "Reclamos",
    suggestions: "Sugerencias",
    reports: "Denuncias",
    complaintsLine1Part1: "Considera que cuando realices una ",
    complaintsLine1Part2: '"Denuncia"',
    complaintsLine1Part3:
        ", asignaremos a un encargado/a para atenderla de inmediato y tomaremos las medidas correctivas que sean necesarias a la brevedad.",
    complaintsLine2:
        "Cuando hagas una denuncia incluye la mayor cantidad de datos posibles, tales como: Fechas, horarios, relato de los hechos, lugares o nombres de personas si es necesario, porque eso nos permitirá analizar en detalle la denuncia realizada.",
    complaintsLine3: "Recuerda que, en caso de denuncias, requerimos la mayor información posible para ayudarte.",
    complaintsLine4: "Escucharte, es parte de nuestro compromiso.",
    commentRelatedWith: "Comentario relacionado con su",
    your: "Tu",
    thanksForSharingYour: "Gracias por compartir tu",
    communicationChannelMessageCreated: "con nosotros. A la brevedad asignaremos a un encargado para su atención.",
    communicationChannelMessageModified: "fue modificada exitósamente",
    suggestionLowercase: "sugerencia",
    complaintLoweracase: "reclamo",
    reportLowercase: "denuncia",
    thirdPartyReportLowercase: "denuncia a nombre de un tercero",
    commentRelatedWithThirdPartyReport: "Comentario relacionado con la denuncia",
    thirdPartyReportNameSurname: "Apellido y nombre del denunciante",
    queryLowerCase: "consulta",
    newResponsibleCommunication: "Nuevo responsable de la atención",
    newCommunicationStatus: "Nuevo estado de la comunicación",
    actualStatus: "Estado actual",
    responsibleAssignedAlt: "Responsable asignado",
    changeStatusCommunicationChannel:
        'Al pasar la comunicación a los estados "Se deja sin efecto" o "Resuelta", ya no se permitirá realizar más acciones o crear nuevas respuestas',
    representationColor: "Color de representación",
    calcReferenceModifiedCorrectly: "Referencia de cálculo actualizado correctamente",
    calcReferenceAddedCorrectly: "Referencia de cálculo creado correctamente",
    calcReferenceRemovedCorrectly: "Referencia de cálculo eliminado correctamente",
    cannotDeleteCalendarAssociatedCalcProcessSingular:
        "El calendario de tiempos no puede modificarse porque ya está relacionado con el proceso de cálculo",
    cannotDeleteCalendarAssociatedCalcProcessPlural:
        "El calendario de tiempos no puede modificarse porque ya está relacionado con los procesos de cálculo",
    notPossibleToChangeCalendarType: 'No es posible cambiar un calendario a estado "Histórico" en forma manual',
    fromDateCantBeLessThanEndDate: '"Fecha hasta" no puede ser menor a "Fecha desde"',
    fieldStructureTable: "Estructura de campos de la tabla",
    sql: "SQL",
    fieldNamesForQueries: "Nombres de campos para consultas",
    allowEditorForSystemTables: "Habilitar editores para la tabla del sistema",
    publicationCenterCreate: "Creación de centro de publicación",
    exportErrorHistoricAccumulators:
        "Para exportar la plantilla con datos es necesario que la cantidad de registros, en cada exportación, no sea superior a 50.000",
    selectQueryPeriod: "Seleccione período de consulta",
    accumulator: "Acumulador",
    performanceInterviewAndFeedback: "Entrevista y Feedback",
    spanish: "Español",
    english: "English",
    Personal: "Personal",
    create: "Crear",
    chat: "Chat",
    charts: "Gráficos",
    assignPIN: "Asignación de PIN",
    roleAccess: "Roles de acceso",
    icariusTech: "Tecnología de ICARIUS",
    createdBy: "Cargado por",
    contractEndDate: "Fecha término de contrato",
    maxCharPossible: "Max. permitido:",
    cellphoneVisible: "Su celular será visible",
    cellphoneVisibleShort: "Celular",
    civilStateVisible: "Su estado civil será visible",
    civilStateVisibleShort: "Estado civil",
    bornDateVisible: "Su fecha de nacimiento será visible",
    bornDateVisibleShort: "Fecha de nacimiento",
    personalAddressVisible: "Su dirección particular será visible",
    personalAddressVisibleShort: "Dirección particular",
    showUnreadAlerts: "No leídos",
    nineBoxSettings: "Definición de 9-Boxes",
    talentClassification: "Clasificación del talento",
    performanceEvaluations: "Evaluaciones del desempeño",
    performanceEvaluationsCalibration: "Calibración del desempeño",
    performanceSummaryAndResults: "Resumen y resultados",
    forms: "Formularios",
    geminiDisclaimer: "La IA de ICARIUS puede mostrar información imprecisa",
    geminiErrorMessage: "Ocurrió un error desconocido.",
    geminiInputPlaceholder: "Escribe algo...",
    botInitialMessage: "Hola, ¿En qué puedo ayudarte hoy?",
    geminiChatbox: "Chatbox IA de ICARIUS",
    performanceManagement: "Gestión del desempeño",
    talentAcquisition: "Adquisición del talento",
    showAllAlerts: "Todos",
    alertsFilterBy: "Filtrar por",
    references: "Referencias",
    comingSoon: "Proximamente",
    completeFields: "Existen valores no completados en el formulario",
    offsetY: "Desplazamiento Y",
    offsetX: "Desplazamiento X",
    alertChangeProfilePhoto:
        "Apreciado colaborador: Si usted quiere cargar o cambiar su fotografía, le solicitamos que sea una fotografía personal y para uso corporativo. Muchas gracias por su colaboración.",
    zoom: "Zoom",
    rotation: "Rotación",
    news: "Noticias",
    uploadNewPhoto: "Cargar nueva foto",
    modifyMyPhoto: "Modificar foto de perfil",
    correctlyModifiedPhoto: "Su foto se modificó correctamente",
    dataUpdate: "Actualización de datos",
    correctlyModifiedPersonalData: "Su información personal se actualizó correctamente",
    myPersonalData: "Datos personales",
    rightPannelSwitchIndication: "Indique si los siguientes datos personales serán visibles en el Directorio",
    help: "Ayuda",
    personales: "Personales",
    contrato: "Contrato",
    remuneracion: "Remuneración",
    ubicacion: "Ubicación",
    tiempos: "Tiempos",
    timeZones: "Zonas horarias",
    selectContactToStartConversation: "Seleccione un contacto",
    startConversation: "Inicie una conversación",
    messagePlaceholder: "Escribe un mensaje...",
    sombrear: "Resaltar",
    selectColorTitle: "Seleccione un color",
    theme: "Temas y colores",
    color: "Color",
    green: "Verde",
    red: "Rojo",
    lightBlue: "Celeste",
    blue: "Azul",
    gold: "Oro",
    orange: "Naranja",
    silver: "Plata",
    teal: "Teal",
    purple: "Violeta",
    pink: "Rosa",
    brown: "Marrón",
    of: "de",
    pinWillChange: "Cambio o asignación de PIN",
    recoverPinDialogText: "El pin para el usuario {user} y cliente {client} se cambiará o asignará",
    recoverPinDialogTextFull:
        "El pin para el usuario {user}, cliente {client} y sociedad {society} se cambiará o asignará",
    albanyTechnologies: "Albany Technologies",
    contact: "Contacto",
    undefinedContact: "No se han definido datos de contacto",
    aboutUsTitle: "ICARIUS (ODESA)",
    thisPage: "Exportar página",
    allPages: "Exportar todos",
    myPeopleTableTitle: "Mi Personal",
    everyone: "Todos",
    activeAndPlantPersonnel: "Vigentes y de planta ",
    id: "Identificador",
    code: "Código de empleado",
    name: "Nombre",
    nameAndSurname: "Apellido y nombres",
    liquidoNeto: "Liquido/Neto",
    income: "Fecha de ingreso",
    coin: "Moneda",
    salary: "Sueldo/Salario",
    filter: "Filtrar",
    close: "Cerrar",
    contactQr: "QR de contacto",
    export: "Exportar",
    searchLabel: "Buscar",
    filterBy: "Filtrar por",
    noEmployeesToShow: "Sin empleados para mostrar",
    newAnnotation: "Ingrese nueva anotación",
    noAnnotationsOfThisType: "No existen anotaciones del tipo seleccionado",
    noAnnexesForThisFilter: "No existen archivos para los filtros seleccionados",
    selectType: "Seleccionar tipo / Resetear",
    selectInstance: "Seleccionar instancia / Resetear",
    iconNewAnnotation: "Nueva anotación",
    iconEditAnnotation: "Editar anotación",
    merit: "Mérito",
    demerit: "Demérito",
    noType: "Anotación sin clasificación",
    noSubtype: "Sin subtipo",
    subtypeTitle: "Por subtipo de anotación",
    categoryTitle: "Por categoría de la anotación",
    meritsTitle: "Por méritos y deméritos",
    noAnnotations: "No posee anotaciones",
    annotationsConfirm: "¿Desea eliminar la anotación?",
    visibleColaborador: "Visible para el colaborador",
    invisibleColaborador: "No visible para el colaborador",
    availableColaborador: "Disponible para el colaborador",
    notAvailableColaborador: "No disponible para el colaborador",
    maxChar: "Max. permitido: 512",
    currentChar: "Cant. caracteres:",
    enterText: "Ingrese Texto",
    fieldRequeriment: "Todos los campos son obligatorios.",
    type: "Tipo",
    instance: "Instancia",
    subtype: "Subtipo",
    lastStatus: "Último status",
    status: "Status",
    viewAnnotationTitle: "Número de anotación, categoría y subtipo",
    viewAnnotationTime: "Fecha y hora de creación",
    viewAnnotationNewTime: "Fecha y hora de modificación",
    viewAnnotationVisibility: "Visibilidad",
    viewAnnotationContent: "Contenido de la anotación",
    viewAnnexVisibility: "Disponible",
    iconNewAnnex: "Nuevo archivo",
    viewAnnexTitle: "Número de archivo, instancia y tipo",
    viewAnnexContent: "Texto del archivo",
    selectAnnex: "Seleccione archivo",
    viewAnnexFile: "Documento del archivo",
    annexConfirm: "¿Desea eliminar el archivo?",
    iconEditAnnex: "Editar archivo",
    annexNoType: "Sin tipo",
    maxCharAnnex: "Max. permitido: 250",
    documentsListTitle: "Listado de archivos",
    noAnnexYet: "Aún no ha seleccionado archivo",
    clicIndication: "Clic en gráficos para desplegar listado",
    downloadAnnexFolder: "Descargar carpeta",
    downloadAnnexFolderConfirm: "¿Desea descargar la carpeta?",
    noAnnexes: "No posee archivos",
    annexFechaVencimiento: "Fecha de vencimiento",
    annexDateHelper: "Si ingresa fecha de Vencimiento, la misma debe ser superior a la fecha actual",
    annexRequired: "Obligatorio",
    annexNotRequired: "No Obligatorio",
    expires: "Vence el:",
    by: ", por ",
    notAvailable: "No disponible",
    newEmployee: "Nuevo empleado",
    scheduleProgrammed: "Horario programado para hoy",
    assistanceStatus: "Estado de asistencia",
    documents: "Documentos",
    contracts: "Contratos",
    payroll: "Nómina",
    absences: "Ausencias",
    times: "Tiempos",
    familiarGroup: "Grupo familiar",
    fatherLastName: "Apellido paterno",
    firstName: "Primer nombre",
    employeeNumber: "Número de empleado",
    officePhone: "Teléfono de oficina",
    particularPhone: "Teléfono particular",
    bloodType: "Grupo sanguíneo",
    age: "Edad",
    passportNumber: "Número de pasaporte",
    expirationPassport: "Expiración del pasaporte",
    motherLastName: "Apellido materno",
    secondName: "Segundo nombre",
    extension: "Extensión",
    donante: "Donador",
    contractCode: "Código de contrato",
    contractAmount: "Cantidad de contrataciones",
    antiquityDate: "Fecha de antigüedad",
    contractMotive: "Motivo de contratación",
    legalMotive: "Motivo de termino legal",
    calculationMotive: "Motivo de termino calculo",
    familyAllowanceSection: "Tramo asignacion familiar",
    additionalMonthVacation: "Meses adicional vacaciones",
    additionalVacationDate: "Fecha adicional vacaciones",
    additionalDaysVacation: "Días adicional vacaciones",
    previsionInstitution: "Institución de previsión",
    vacationsUpdateDate: "Fecha actualización Cta. Cte. Vacaciones",
    affiliationDate: "Fecha afiliación previsional",
    healthInstitution: "Institución de salud",
    heavyWork: "Trabajo pesado",
    extremeZoneReduction: "Rebaja zona extrema",
    extremeZonePercentage: "Porcentaje zona extrema",
    taxOtherCountry: "Impone en otro país",
    valueOtherCountry: "Valor cotizado en otro país",
    ineClassif: "Clasificación INE",
    specialCapabilities: "Capacidades especiales",
    businessSalary: "Sueldo empresarial",
    icariusMenuProfile: "Perfil menú ICARIUS",
    calendarType: "Tipo de calendario",
    scheduleControlType: "Tipo de control horario",
    cardCode: "Código de tarjeta/credencial",
    freedExtraHours: "Horas extras liberadas",
    canMarkMobile: "Puede marcar desde Móviles",
    canMarkICARIUS: "Puede marcar desde ICARIUS",
    canCapturePosition: "Puede capturar geoposición",
    updateOK: "Datos actualizados exitosamente",
    createdOK: "Empleado creado exitosamente",
    namesAndLastnames: "Apellidos y nombres",
    employeeMasterSidebarTitle: "Datos complementarios",
    accessPerm: "Permisos de acceso",
    otherData: "Otros datos",
    contratacionType: "Tipo de contratación",
    creationUserPhotoInfo: "Los cambios se reflejarán al crear el usuario",
    icariusProfile: "Perfil ICARIUS",
    groups: "Grupos",
    personalesTitle: "personales",
    ubicacionTitle: "ubicacion",
    tiemposTitle: "tiempos",
    contratoTitle: "contrato",
    remuneracionTitle: "remuneracion",
    scheduleDate: "Fecha de programación",
    scheduleCode: "Código horario para la fecha",
    receiptsTableTitle: "Recibos",
    quickSearch: "Búsqueda rápida...",
    myreceiptsMessage:
        "Su comprobante de pago ha sido descargado y usted ya tiene registrada la aceptación del mismo con fecha {accepted_date} a las {accepted_time} hrs",
    receipts: "Comprobantes de pago",
    certificates: "Certificados",
    myCredential: "Mi credencial",
    myPositionDescription: "Mi descripción del cargo",
    positionDescription: "Descripción del cargo",
    receiptsViewAll: "Todo",
    receiptsViewSignPending: "Pendientes de firma",
    receiptSignNotFound: "Documentos solicitados no encontrados",
    receiptSignFiltered: "Los datos se han filtrado con éxito para firmarlos digitalmente",
    receiptUnauth: "Usted no está no habilitado como firmante de documentos",
    receiptWrongPing: "PIN ingresado incorrecto",
    receiptWrongDocument: "Ocurrió un problema con alguno de los documentos seleccionados, intente nuevamente",
    receiptSuccess: "Recibos firmados exitosamente",
    certificatesViewAll: "Todo",
    certificatesViewSignPending: "Documentos para firmar",
    certificateSignNotFound: "Documentos solicitados no encontrados",
    certificateSignFiltered: "Los datos se han filtrado con éxito para firmarlos digitalmente",
    certificateUnauth: "Usted no está no habilitado como firmante de documentos",
    certificateWrongPing: "PIN ingresado incorrecto",
    certificateWrongDocument: "Ocurrió un problema con alguno de los documentos seleccionados, intente nuevamente",
    certificateSuccess: "Certificados firmados exitosamente",
    internalCode: "Código interno",
    hrefState: "",
    employeeCode: "Código de empleado",
    names: "Nombres",
    internalNumber: "Número interno",
    state: "Estado",
    email: "Email",
    fType: "Tipo de funcionario",
    position: "Cargo",
    positionDate: "Fecha asignación cargo",
    function: "Función",
    functionDate: "Fecha asignación función",
    civilState: "Estado civil",
    sex: "Sexo",
    nationality: "Nacionalidad",
    category: "Categoría",
    managementCenter: "Centro de publicación",
    costCenter: "Centro de costo de gestión",
    specialty: "Especialidad",
    bornDate: "Fecha de nacimiento",
    linkedin: "LinkedIn",
    photo: "Fotografía",
    direcMaps: "",
    address: "Dirección",
    comuna: "Comuna",
    provicia: "Provincia",
    region: "Región",
    country: "País",
    postalCode: "Código postal",
    cellphone: "Celular",
    phoneExtension: "Extensión telefónica",
    contractType: "Tipo de contrato",
    incomeDate: "Fecha de contratación",
    outcomeDate: "Fecha de egreso",
    noOutcomeDate: "(Sin fecha de egreso)",
    paymentLocation: "Lugar de pago",
    jobLocation: "Lugar de trabajo",
    management: "Gerencia",
    department: "Departamento",
    viewEmployeesInManagementCenter: "Ver empleados en este centro de publicación",
    viewEmployeesInManagementCenterPlural: "Ver empleados en estos centros de publicación",
    employeesAssignedToManagementCenter: "Colaboradores asignados a este centro de publicación",
    employeesAssignedToManagementCenterPlural: "Colaboradores asignados a estos centros de publicación",
    noEmployeesAssignedToManagementCenter: "No hay colaboradores asignados a este centro de publicación",
    section: "Sección",
    paymentMethod: "Forma de pago",
    paymentType: "Tipo de pago",
    bank: "Banco",
    bankAccount: "Cuenta bancaria",
    bankAccountType: "Tipo de cuenta",
    salaryUnit: "Unidad salarial",
    jornadaType: "Tipo de jornada",
    hoursPerDay: "Horas diarias contrato",
    hoursPerMonth: "Horas mensuales contrato",
    laborUnion: "Sindicato",
    retired: "Jubilado",
    scheduleName: "Nombre del horario",
    shift: "Turno",
    shiftName: "Nombre del turno",
    shiftDate: "Fecha asignación turno",
    comments: "Comentarios",
    comment: "Comentario",
    opinion: "Opinión",
    workPhone: "Teléfono del trabajo",
    phone: "Teléfono",
    responsibleEmail: "Email del responsable de la respuesta",
    responsiblePhone: "Teléfono del responsable de la respuesta",
    responsibleName: "Responsable de la respuesta",
    requester: "Solicitante",
    toExcel: "a Excel",
    toJson: "a JSON",
    toXml: "a XML",
    toTxt: "a TXT",
    toPdf: "a PDF",
    toIcarius: "a IA de ICARIUS",
    plantPersonnel: "Personal de planta",
    contratista: "Contratista",
    centroDeGestion: "Centro de publicación",
    noFaceFound: "La imagen no parece contener un rostro humano",
    fileSameName: "Ya existe un archivo con el mismo nombre",
    fileTypeNotValid: "El tipo de archivo no está admitido",
    vigente: "Vigente",
    noVigente: "No vigente",
    allAnnotations: "Todas las anotaciones",
    annotationsByDate: "Desde última contratación",
    allAnnexes: "Todos los archivos",
    annexesByDate: "Desde última contratación",
    changingPin: "Cambiar mi PIN",
    correctlyRequestedCorrection: "Corrección solicitada correctamente",
    correctionRequest: "Solicitud de corrección",
    requestCorrection: "Reclamar corrección",
    detailCorrectionRequest: "Detalla la corrección que deseas solicitar:",
    currentPin: "PIN actual",
    newPin: "Nuevo PIN",
    newPinConfirmation: "Repita su nuevo PIN",
    pinCorrectlyChanged:
        "PIN cambiado correctamente. Utilice su nuevo PIN en el próximo acceso, ya sea en la Plataforma WEB o en la APP",
    pinRegenerationConfirmed:
        "Revise nuevamente su casilla de correo porque se le ha enviado un PIN de acceso transitorio.",
    mailSent: "Se han enviado a su correo electrónico las indicaciones para la restauración de su PIN de acceso.",
    portal: "Portal del {role}",
    toolbarTitle: "Albany Technologies",
    disagree: "Cancelar",
    agree: "Aceptar",
    atention: "Atención",
    invalidSizeGemini: "El tamaño del archivo no puede superar los {maxSize} MB",
    invalidFileTypeGemini:
        "El tipo de archivo no es válido. Solo se permiten imagenes, archivos de texto, documentos PDF y archivos Excel",
    maxFilesGemini: "Solo se pueden adjuntar hasta {maxFiles} archivos",
    yes: "Si",
    explainFormulaWithAI: "Entiende la fórmula con la IA de ICARIUS",
    no: "No",
    sentTo: "Enviada a",
    managerPhone: "Teléfono del receptor",
    managerEmail: "Email del receptor",
    lastActionTime: "Hora última acción",
    lastActionDate: "Fecha última acción",
    loginSubtitle: "Auto consulta colaborativa del personal",
    version: "Versión",
    loginAs: "Ingresar como",
    collaborator: "Colaborador",
    collaborators: "Colaboradores",
    manager: "Manager",
    employer: "Empleador",
    noResultsFoundQuery: 'No se encontraron resultados para "{query}"',
    searchCommandsConfigurationScreens: "Buscar menús, configuraciones, pantallas...",
    recoverPinAccessCode: "Recuperar PIN de acceso",
    copyright: "Copyright (C) {year} ICARIUS",
    allRightsReserved: "Todos los derechos reservados",
    credits: "Créditos",
    icariusMail: "soporte@icariusglobal.com",
    albanyWebsite: "albany.company",
    icariusWebsite: "icariusglobal.com",
    icariusForoWebsite: "soporte.icarius.online",
    client: "Cliente",
    commentRequiredForFeedback: "Para recibir un feedback debe agregar un comentario",
    user: "Usuario",
    pin: "PIN",
    key: "Clave",
    selectSocietyTitle: "Seleccione una sociedad",
    society: "Sociedad",
    favouriteSliderTitle: "Enlaces de utilidad",
    downloadSliderTitle: "Documentos de interés",
    pollSliderTitle: "Encuestas",
    countersSliderTitle: "Números",
    directory: "Directorio",
    alerts: "Alertas y avisos",
    notices: "Avisos",
    myPin: "Mi PIN",
    closeSession: "Cerrar sesión",
    menuConfigurator: "Configuración de menú",
    onboardingProfiles: "Perfiles de onboarding",
    typesOfPublicationFormats: "Tipos de formatos para las publicaciones",
    typesOfOnboardingActions: "Tipos de acciones de onboarding",
    typesOfPublicationChannels: "Tipos de canales para las publicaciones",
    classificationApplicantsTypes: "Tipos de clasificación para postulantes",
    loginTitle: "Log In",
    mainTitle: "Inicio",
    myAssistanceTitle: "Mi asistencia",
    assistanceTitle: "Marcas de asistencia",
    myPeopleTitle: "Mi personal",
    nineBoxClassification: "Clasificación 9-Boxes",
    chatTitle: "Chat",
    certificateFullTitle: "Comprobantes y certificados",
    myCertificateFullTitle: "Mis comprobantes y certificados",
    myCertificatesConfirmationTitle: "¿Acepta el certificado generado?",
    receiptsFullTitle: "Recibos y comprobantes de pago",
    receiptsShortTitle: "Comprobantes de pago",
    myReceiptsFullTitle: "Mis recibos y comprobantes de pago",
    myHistoricalReceiptsFullTitle: "Mis recibos y comprobantes de pago históricos",
    myReceiptsConfirmationTitle: "¿Acepta el recibo generado?",
    confirmReceipt: "Motivo por el cuál no está conforme con el recibo generado",
    deniedDocumentMessage: "Por favor ingrese el motivo del rechazo del documento",
    certificateTitle: "Certificados",
    myCertificateTitle: "Mis certificados",
    noCertificates: "No posee certificados",
    selectCertificate: "Comprobante o certificado",
    privacyPolicy: "SOBRE LA PROTECCIÓN DE DATOS Y PRIVACIDAD",
    noReceipts: "No existen recibos con firma digital disponibles para descarga",
    selectReceipt: "Recibo o comprobante de pago",
    selectCalcMethod: "Proceso de cálculo",
    confirmCertificateReceipt: "Motivo por el cuál no está conforme con el certificado generado",
    holidaysTitle: "Cta. cte. vacaciones",
    loansTitle: "Cta. cte. préstamos",
    loansTitleLong: "Cuenta corriente de préstamos",
    myAnnotationsTitle: "Mis anotaciones",
    myAnnexesTitle: "Mi carpeta digital",
    myInfoTitle: "Mis datos",
    receiptsTitle: "Recibos",
    myReceiptsTitle: "Mis recibos",
    myHistoricalReceiptsTitle: "Mis recibos históricos",
    requestsTitle: "Solicitudes",
    requestsControlTitle: "Control de solicitudes",
    schedulerTitle: "Hoja de tiempos",
    decisionCubes: "Cubos de gestión",
    kpiIndicators: "Indicadores (KPI)",
    query: "Consultas",
    eventsIncome: "Importación de eventos",
    eventsAuth: "Autorización de eventos",
    employeeMaster: "Maestro de personas",
    myKpiIndicators: "Mis indicadores (KPI)",
    myPending: "Mis pendientes",
    myPendingEmployer: "Mis pendientes",
    myQueries: "Mis consultas",
    queries: "Consultas",
    myDigitalSign: "Mi firma digital",
    myDecisionCubes: "Mis cubos de gestión",
    groupEvents: "Eventos por grupos",
    individualEvents: "Eventos individuales",
    parametrization: "Parametrización",
    myRequests: "Mis solicitudes",
    myRequestsManager: "Mis solicitudes",
    myRequestsSecondGrid: "myRequestsSecondGrid",
    myPendingSecondGrid: "myPendingSecondGrid",
    timeManagement: "Gestión de tiempos",
    engagement: "Engagement",
    managementNav: "Gestión y análisis",
    calculationManagement: "Gestión de cálculos",
    Remunerations: "Remuneraciones",
    settings: "Ajustes",
    changeTheme: "Cambiar tema",
    requestedDocuments: "Documentos solicitados",
    signedDocuments: "Documentos firmados",
    digitalReceipts: "Recibos digitales",
    digitalCertificates: "Certificados digitales",
    themeAndColors: "Color corporativo",
    generalSettings: "Parámetros generales",
    general: "General",
    next: "Siguiente",
    previous: "Anterior",
    pollInfo: "Pregunta {actualNumber} de {totalNumber}",
    submit: "Enviar",
    gratitudMessage: "¡Muchas gracias por participar en nuestra encuesta!",
    alreadyAnswered: "Usted ya participó de esta encuesta",
    aboveMaximumPoll: "Contiene respuestas que sobrepasan el limite",
    required: "Requerido",
    errorConnection: "Ocurrio un error al comunicarse. Intente nuevamente",
    anonymousPoll: "Esta encuesta es anónima y de carácter no vinculante",
    gridCopy: "Copiar",
    gridCopyWithHeaders: "Copiar con encabezados",
    gridExport: "Exportar",
    group: "Grupo",
    directoryTableTitle: "Directorio",
    tarjetero: "Tarjetero",
    directAccess: "Acceso directo",
    messageFrom: "Mensaje de ",
    read: "Leído",
    markAsRead: "Marcar como leído",
    markAsUnread: "Marcar como no leído",
    selectQuery: "Seleccionar consulta",
    annotations: "Anotaciones",
    annex: "Carpeta Digital",
    confirmDelete: "¿Desea eliminar la plantilla?",
    confirmUpdate: "¿Desea actualizar la plantilla?",
    save: "Guardar",
    statistics: "Estadística",
    template: "Nombre de plantilla",
    createTemplate: "Crear plantilla",
    templateNotEmptyWarning:
        'Solo puede fijar filtros sobre la consulta en estado original de ésta grilla, seleccione la opción "Resetear" para mostrar la consulta en su estado original',
    deleteTemplate: "Eliminar plantilla",
    exportTemplate: "Exportar plantilla",
    updateTemplate: "Actualizar plantilla",
    exportQuery: "Exportar consulta",
    importQuery: "Importar consulta",
    importTemplate: "Importar plantilla",
    selectTemplate: "Seleccionar plantilla / Resetear",
    templateExclusiveToMe: "Exclusiva para mi",
    templateAllCollaborators: "Todos los colaboradores",
    templateAllManagers: "Todos los managers",
    templateAllEmployers: "Todos los empleadores",
    templateOnlyEmployersPlantPersonnel: "Solo empleadores de planta",
    templateOnlyProvidersEmployers: "Solo empleadores proveedores",
    templateCreate: "Plantilla creada con éxito",
    templateImport: "Plantilla importada con éxito",
    templateUpdate: "Plantilla actualizada con éxito",
    templateDelete: "Plantilla borrada con éxito",
    pollReview: "Análisis de encuestas",
    question: "Pregunta",
    visualizationRol: "Rol de visualización",
    delete: "Eliminar",
    confirmDeletAlert: "¿Desea eliminar la alerta o aviso?",
    shrink: "Contraer todo",
    expand: "Expandir todo",
    answerPollNotice: "Debe responder la pregunta para continuar",
    myAssistenceTitle: "Mi asistencia",
    everyPollAnswer: 'Todas las respuestas de "{answer}"',
    countVoters: "Cantidad de votantes",
    cant: "Cantidad",
    questions: "Preguntas",
    noPollReviewData: "Aún no se han registrado datos de encuestas.",
    hour: "Hora",
    assistancePlace: "Lugar de asistencia",
    date: "Fecha",
    votos: "Votos",
    noAlertsOrNotification: "No existen alertas o avisos.",
    noUnreadAlertsOrNotification: "No existen alertas o avisos sin leer.",
    info: "Información",
    clickHereForDetailedAnswers: "Haga clic aquí para leer las respuestas",
    respuestaParentesis: " respuesta)",
    respuestasParentesis: " respuestas)",
    answer: "Respuesta",
    responsible: "Responsable",
    noKPIdata: "No existen KPI disponibles por el momento.",
    aboutUs: "Acerca de ICARIUS",
    inDate: "Fecha de entrada",
    inHour: "Hora de entrada",
    outOfZoneIN: "Fuera de zona (ENTRADA)",
    outDate: "Fecha de salida",
    outHour: "Hora de salida",
    outOfZoneOUT: "Fuera de zona (SALIDA)",
    generate: "Generar",
    total: "Total",
    permissions: "Permisos",
    loansDetailEmployer: "loansDetailEmployer",
    loansDetailCollaborator: "loansDetailCollaborator",
    numberLoansGranted: "Cantidad de préstamos otorgados",
    totalValueLoansGranted: "Valor total de préstamos otorgados",
    totalPaid: "Total pagado",
    totalPendingBalance: "Total saldo pendiente",
    totalInstallments: "Total cuotas",
    totalPaidInstallments: "Total cuotas pagadas",
    totalPendingInstallments: "Total cuotas pendientes",
    referenceCode: "Código de Referencia",
    referenceInstallment: "Cuota de referencia",
    installmentValue: "Valor de la cuota",
    periodDiscount: "Período de descuento",
    installmentState: "Estado de la cuota",
    installmentNumber: "N° de cuota",
    grantedValueLoan: "Valor del préstamo otorgado",
    noLoansToShow:
        "El formato actual de la grilla no permite graficar. Para poder hacerlo, deje la grilla en su formato de visualización inicial.",
    value: "Valor",
    vacationRequestTitle: "Vacaciones",
    permissionRequestTitle: "Permisos",
    loanRequestTitle: "Anticipos",
    expenseRequestTitle: "Reintegro de gastos",
    permissionType: "Tipo de permiso",
    vacationsType: "Tipo de vacaciones",
    holidays: "Vacaciones",
    expenses: "Gastos",
    advance: "Anticipo",
    permission: "Permisos",
    raise: "Aumento de sueldo",
    firing: "Desvinculación",
    requestRequested: "Solicitada",
    requestCancelled: "Anulada",
    requestChangedProposed: "Propuesta de cambio",
    requestChangeAccepted: "Cambio aceptado",
    requestChangeRejected: "Cambio rechazado",
    requestApproved: "Aprobada",
    requestRejected: "Rechazada",
    loanType: "Tipo de anticipo",
    loanType2: "Tipo de préstamo",
    startDate: "Fecha de inicio",
    newDelegation: "Crear delegación",
    startDateValidation: "La fecha debe ser posterior al día actual",
    delegationEndDateValidation: "La fecha debe ser posterior a la fecha de inicio",
    editStartDateValidation: "La fecha debe ser posterior a la fecha original",
    addressee: "Destinatario",
    endDate: "Fecha de término",
    amountOfDays: "Cantidad de días",
    timePerDay: "Tiempo por día",
    detail: "Detalle",
    loanDetail: "Detalle del préstamo",
    amountLoanRequested: "Valor del anticipo solicitado",
    amountLoanRequestedValidation: "El valor debe ser mayor a 0 y menor a ",
    expectedDateOfPay: "Fecha esperada de cobro",
    fieldRequired: "Campo obligatorio",
    expenseDeleteConfirmation: "¿Desea borrar el gasto?",
    newExpenseItem: "Nuevo gasto",
    noExpenses: "Aún no ha creado ningún gasto.",
    expenseAmount: "Valor del gasto",
    requestsInHistory: "Históricas",
    requestsInProgress: "En proceso",
    requestHistory: "Historial de la solicitud",
    cantCreateNewRequest: "No es posible realizar una nueva solicitud de este tipo, porque ya existe una en curso",
    legalVacation: "Vacaciones legales",
    additionalVacation: "Vacaciones adicionales",
    fullDay: "Día completo",
    halfDay: "Medio día",
    cancelRequest: "Anular",
    answerPropose: "Responder propuesta",
    approveRequest: "Aprobar",
    rejectRequest: "Rechazar",
    editRequest: "Editar",
    optionalField: "Opcional",
    maxCharRequests: "Max. permitido: 1024",
    howToSelectMoreDays:
        "Si desea ingresar más días que los Solicitados, rechace la solicitud indicándole al Colaborador la cantidad de días que propone en el campo de Detalle.",
    requestEditTitle: "Propuesta de Cambio en la Solicitud de",
    requestCreateTitle: "Solicitud de",
    requestBy: "Responsable del último status",
    sendMessage: "Enviar mensaje",
    youNeedAtLeastOneRow: "Debe seleccionar al menos un registro.",
    requestMailConfirm:
        "¿Desea enviar, a los responsables seleccionados, un mensaje de advertencia para la pronta atención de las solicitudes?",
    mailsHaveBeenSent: "El mensaje fue enviado con éxito",
    docsHaveBeenDeleted: "Se eliminaron con éxito {numberOfDocuments} documentos pendientes de aprobación",
    delegatorName: "Nombre de quien delega",
    delegatorCode: "Código de quien delega",
    delegatorEmail: "Email de quien delega",
    delegatedName: "Nombre del destinatario",
    delegatedCode: "Código del destinatario",
    delegatedEmail: "Email del destinatario",
    delegationDateFrom: "Fecha desde",
    delegationDateTo: "Fecha hasta",
    delegationSent: "Delegación enviada",
    delegationReceived: "Delegación recibida",
    delegation: "Delegación",
    delegationsTitle: "Delegar solicitudes",
    noDelegationsRows: "Usted no tiene delegaciones enviadas ni recibidas.",
    confirmDeleteDelegation: "¿Desea eliminar la delegación?",
    proposeChange: "Proponer cambio",
    answerChangeTitle: "¿Aprueba el cambio propuesto?",
    acceptRequest: "¿Aprueba la solicitud?",
    cancelRequestTitle: "¿Desea anular la solicitud?",
    insertComment: "Ingrese un comentario",
    delegationAlready: "Ya existe una delegación para ese usuario en esa fecha",
    matches: "Coincidencias",
    datesCollide: "El rango de fechas seleccionado se superpone con fechas de solicitudes previas",
    days: "días",
    reply: "Responder",
    goBack: "Volver",
    errorExecutingQuery: "Error al ejecutar la consulta de usuario",
    noQueryGroups: "No existen grupos de consultas disponibles por el momento",
    invalidData: "Hay datos inválidos o incompletos",
    validData: "Todos los datos son válidos",
    moreOrEqualThan: "Mayor igual",
    lessOrEqualThan: "Menor igual",
    notContains: "No contiene",
    contains: "Contiene",
    notEqual: "No igual",
    equal: "Igual",
    year: "Año",
    month: "Mes",
    localidad: "Localidad",
    gridVideo: "Grillas – Parte {part}",
    pinChangedLogoutRequest:
        "El PIN ha sido modificado con éxito. Si tienes acceso a más de una sociedad para el mismo cliente, considera que el nuevo PIN asignado deberá ser utilizado para ingresar en todas las sociedades a partir de este momento. Si deseas permanecer en ICARIUS, por favor, vuelve a ingresar al sistema.",
    parameters: "Parámetros",
    changeSociety: "Cambiar sociedad",
    orderByUnread: "Ordenar por no leídos",
    visualizationGrid: "Grilla de visualización",
    viewMoreData: "Ver protección de datos",
    myProgress: "Mi avance",
    viewAll: "Ver todas",
    viewArchived: "Ver archivadas",
    reverseOrder: "Invertir orden",
    tagName: "Nombre de la etiqueta",
    tagTitle: "Etiquetas",
    createTag: "Nueva etiqueta",
    editTags: "Editar etiquetas",
    orderByNotes: "Ordenar por",
    ascOrder: "Ascendente",
    desOrder: "Descendente",
    archived: "Archivados",
    createNote: "Nueva tarea",
    labelCorrectlyDeleted: "Etiqueta eliminada correctamente",
    labelCorrectlyModified: "Etiqueta modificada correctamente",
    labelCorrectlyCreated: "Etiqueta creada correctamente",
    title: "Título",
    writeHereYourNote: "Escribe aquí tu tarea",
    lastEdited: "Ult. edición",
    archive: "Archivar",
    unarchive: "Desarchivar",
    changeLabels: "Modificar etiquetas",
    addChecklist: "Agregar tarea",
    addImage: "Agregar imagen",
    addReminder: "Agregar recordatorio",
    deleteNote: "Eliminar tarea",
    cancel: "Cancelar",
    clear: "Limpiar",
    today: "Hoy",
    ok: "Aceptar",
    addItem: "Agregar ítem",
    addLabel: "Agregar etiqueta",
    confirmDeleteNote: "¿Desea eliminar la tarea?",
    totemManagementTitle: "Gestión de tótems",
    noTotems: "No existen tótems disponibles",
    home: "Inicio",
    myNotes: "Mis tareas",
    notes: "Tareas",
    totemCorrectlyUpdated: "Tótem correctamente actualizado",
    totemCorrectlyDeleted: "Tótem correctamente eliminado",
    totemCorrectlyAdded: "Tótem correctamente agregado",
    entrada: "Entrada",
    salida: "Salida",
    promptDeleteTotem: "¿Desea eliminar el tótem?",
    totem: "Tótem",
    assistanceTotem: "Tótem de asistencia",
    newAssistanceTotem: "Nuevo tótem",
    totemCode: "Código",
    totemID: "ID tótem",
    workplace: "Lugar de asistencia",
    editTotem: "Editar tótem",
    createTotem: "Crear tótem",
    newTotem: "Nuevo tótem",
    totemAsociatedInThisDevice: "Este es el tótem está asociado a este equipo",
    noTotemFound: "Este tótem de registro de asistencia ha sido deshabilitado.",
    registryOK: "{move} registrada con éxito.",
    invalidAssistanceCredentials: "Usted no puede registrar asistencia con el Cliente, Usuario y PIN que ha ingresado.",
    assistanceRegistryDisabled:
        "El registro de asistencia está deshabilitado. Póngase en contacto con un administrador.",
    assistanceLicenceExpired: "La licencia de uso de ICARIUS expiró. Póngase en contacto con un administrador.",
    cantRegisterAssistance: "Usted no está habilitado para marcar asistencia.",
    cantRegisterAssistanceVacation:
        "Usted no puede marcar asistencia hoy ya que se encuentra de vacaciones/licencia/permiso",
    registerBlocked: "Se ha bloqueado el registro de asistencia. Comuníquese con Recursos Humanos",
    registerMarkedInasistance:
        "No puede marcar asistencia porque ya existen inasistencias registradas para el día de hoy",
    vacationsTitle: "Cta. cte. vacaciones",
    myVacationsTitle: "Cta. cte. vacaciones",
    vacationsTitleLong: "Cuenta corriente de vacaciones",
    viewVacationAccountability: "Ver saldos",
    totalAvailableBalance: "Saldo total disponible para solicitar",
    totalPlusUnusedAvailableBalance:
        "Saldo total disponible en caso de desvinculación (a la fecha de actualización de la cuenta corriente)",
    additionalBalance: "Saldo adicionales",
    legalOthersBalance: "Saldo legales y otros",
    totalDebitUsedDays: "Total débitos (Días utilizados)",
    totalCredit: "Total créditos (Días ganados)",
    totalAdditionalDays: "Total de días adicionales",
    usedAdditionalDays: "Días utilizados (adicionales)",
    totalOtherDays: "Total de otros días",
    usedLegalDays: "Días utilizados (legales y otros)",
    totalOtherLegalDays: "Total de días legales",
    usedTotalDays: "Días utilizados o reservados totales",
    availableLegalDays: "Días legales y otros disponibles",
    availableAdditionalDays: "Días adicionales disponibles",
    legalDays: "Legales",
    additionalDays: "Adicionales",
    otherDays: "Otros",
    debits: "Débitos",
    description: "Descripción",
    pendingDays: "Días pendientes",
    movement: "Movimiento",
    dailyQuantity: "Cantidad diaria",
    daysQuantity: "Cantidad de días",
    availableTotalDays: "Días totales disponibles",
    debitAvailableTotalIfFired: "Saldo total disponible (si se desvincula)",
    debitAvailableTotalToRequest: "Saldo total disponible para solicitar",
    debitAvailableAditional: "Saldo (adicionales o progresivos)",
    digitalSignature: "Firma digital",
    DigitalSignatureTitle: "Firmantes",
    newSigner: "Nuevo firmante",
    promptDeleteSigner: "¿Desea eliminar el firmante?",
    authorizedDocuments: "Documentos autorizados",
    dateFrom: "Fecha desde",
    hourFrom: "Hora desde",
    dateEnd: "Fecha hasta",
    hourEnd: "Hora hasta",
    activeSigner: "Firmante activo",
    inactiveSigner: "Firmante inactivo",
    editSigner: "Modificar firmante",
    noSigners: "No hay firmantes registrados",
    signer: "Firmante",
    active: "Activo",
    inactive: "Inactivo",
    signerCorrectlyDeleted: "Firmante correctamente eliminado",
    signerCorrectlyAdded: "Firmante correctamente creado",
    signerCorrectlyUpdated: "Firmante correctamente actualizado",
    edit: "Editar",
    autoGeneratedBySign: "Auto generado por firma Digital - Firmante: {signer}",
    autoGeneratedBySystem: "Auto generado por el sistema",
    requestsColabInstructivo: "Solicitudes del colaborador",
    ctaCteVacacionesInstructivo: "Instructivo Cta. cte.",
    confirmDeleteAllReadAlerts: "¿Confirma que desea eliminar todas las alertas y avisos leídos?",
    deleteAllReadAlerts: "Eliminar todos los leídos",
    nameSurnameLegalSigner: "Firmante legal",
    captionLegalName: "Si el firmante legal es distinto al seleccionado, ingrese sus apellidos y nombres",
    expectedDateOfDisengagement: "Fecha esperada para la desvinculación",
    disengagementOperativeType: "Motivo para el registro en las anotaciones del colaborador",
    disengagementLegalType: "Tipo de desvinculación legal",
    detailDisengagement: "Detalle el causal de la solicitud de desvinculación",
    mailRequestedDocuments:
        "¿Desea enviar a los destinatarios correspondientes un mensaje para la pronta atención de los documentos pendientes de aprobación?",
    noDocumentsForMail: "No se encuentran documentos pendientes de aprobación",
    requestDocuments: "Solicitar documentos",
    requestDocumentsTitle: "Solicitar documento con firma digital",
    request: "Solicitar",
    noDocumentsRequest: "No existen documentos con firma digital disponibles por el momento",
    selectDocument: "Seleccione documento",
    documentRequestDuplicated: "Ya existe una solicitud en curso para este tipo de documento",
    documentRequestOK: "Solicitud enviada",
    requestedDocumentsTitle: "Documentos solicitados",
    requestDate: "Fecha de solicitud",
    requestHour: "Hora de solicitud",
    typeRequestedDoc: "Tipo de documento solicitado",
    codeRequestedDoc: "Código de documento solicitado",
    sign: "Firmar",
    confirmPin: "Confirmar PIN",
    download: "Descargar",
    signDate: "Fecha de la firma",
    signTime: "Hora de la firma",
    signDocType: "Tipo de documento",
    signDocCod: "Código de documento",
    signDocName: "Nombre de documento",
    signRef: "Referencia",
    signerCode: "Código del firmante",
    signerFullName: "Apellido y nombre del firmante",
    signerCodeTo: "Código del destinatario",
    signerToFullName: "Apellido y nombres del destinatario",
    succesfullySignedDocs: "Se han firmado digitalmente {cant} documentos",
    requestReceptor: "Receptor de la solicitud",
    disengagementRequestedFor: "Desvinculación solicitada para",
    reasonToRegisterInDigitalFolder: "Motivo para registrar en las anotaciones del colaborador",
    disengagement: "desvinculación",
    payRise: "aumento de sueldo",
    disengagementTitle: "Desvinculación",
    payRiseTitle: "Aumento de sueldo",
    payRiseRequestedFor: "Aumento solicitado para",
    myReceiptsConfirmDocNotExist:
        "Aún no está disponible el documento firmado digitalmente. ¿Desea descargarlo de todos modos sin firma digital?",
    previewDocuments: "Previsualizar",
    previewDocumentsTooltip: "Previsualizar antes de firmar",
    signTooltip: "Firmar documentos previsualizados",
    confirmAcceptRequestedDocuments: "¿Confirma realizar la firma digital de los documentos seleccionados?",
    confirmDeleteRequestedDocuments: "¿Confirma realizar la eliminación de los documentos seleccionados?",
    reason: "Motivo",
    legalReason: "Motivo legal",
    expectedDate: "Fecha esperada",
    newProposedSalary: "Valor solicitado",
    requestedBy: "Solicitada por",
    derivate: "Derivar",
    derivationSuccessfull: "La solicitud se ha derivado con éxito",
    derivateRequestTitle: "Derivación de solicitud",
    firingLegalType: "Tipo de desvinculación legal",
    multipleSeverances:
        "Se grabaron los datos de la Desvinculación en el Maestro de Personas, sin embargo se encontró más de UN TIPO DE FINIQUITO habilitado como NOMINA y se HABILITÓ AL COLABORADOR en todos los tipos encontrados, para revisar esta situación, acceda a la función: MAESTRO DE PERSONAS – Datos complementarios – Botón: Nóminas",
    frequency: "Frecuencia",
    actualSalary: "Sueldo actual",
    salaryCoin: "Moneda del sueldo",
    payRiseExpectedDate: "Fecha esperada de aumento",
    newSalaryValue: "El nuevo valor del sueldo",
    signedDocumentsMailErrorTitle: "Los siguientes mail no se han podido enviar",
    signedDocumentsDeleteErrorTitle: "Los siguientes documentos no se han podido eliminar",
    signedDocumentsDocumento: "Documento",
    signedDocumentsDestinatario: "Destinatario",
    signedDocumentsMotivo: "Motivo",
    signedDocumentsNotRequired: "Aprobación no requerida",
    signedDocumentsInvalidDocument: "Documento inválido",
    errorAwaitingColaboratorConfirmationDeleteDocs:
        "No es posible eliminar éste documento porque pertenece a una solicitud que ya ha sido aprobada y se está esperando el conforme del Colaborador",
    settingDocuments: "Preparando documentos",
    labelRowsPerPage: "Alertas por página",
    nextPage: "Página siguiente",
    previousPage: "Página anterior",
    moreThan: "mas de",
    deletedDocumentsMotivo: "Motivo",
    confirmDeleteDocument: "Confirmación de eliminación de documentos",
    invalidDataDeleteDocs: "No se encuentra como aprobante del codigo de documento el destinatario enviado",
    invalidStatusDeleteDocs: "El documento no está pendiente de firma",
    invalidSignerDeleteDocs: "Firmante inválido",
    generateAndDownloadNoSign: "Generar y descargar",
    generateAndDownloadWithSign: "Generar y descargar con firma digital",
    youCanOnlyDeleteDocumentsWithPendingApproval: "Solamente se pueden eliminar documentos pendientes de aprobación",
    qrExampleDigitalSignCertificatesReceipt:
        "Ejemplo de su firma digital que se insertará en el documento - Aceptación o Rechazo",
    socketDisconnect:
        "Ha ocurrido un error inesperado. A continuación será redirigido al login de acceso de la plataforma.",
    youNeedAtLeastOneRowAprovalPending:
        "Debe seleccionar al menos un registro. El estado sólo puede ser PENDIENTE DE APROBACIÓN.",
    requestCreatedOK: "Solicitud creada con éxito",
    requestDeletedOK: "Solicitud anulada con éxito",
    requestChangeSentSnack: "Propuesta de cambio enviada con éxito",
    requestChangeAcceptedSnack: "Aceptación de la propuesta de cambio enviada con éxito",
    requestChangeRejectedSnack: "Rechazo de la propuesta de cambio enviada con éxito",
    requestAccetedSnack: "La solicitud fue aprobada con éxito",
    requestRejectedSnack: "La solicitud fue rechazada con éxito",
    newSalaryMustBeGreaterThanPreviousSalary: "El sueldo propuesto debe ser superior al sueldo actual del Colaborador",
    signUnauthDocuments: "Usted no está no habilitado para firmar los documentos seleccionados",
    idFiscal: "ID Fiscal",
    companyName: "Nombre empresa",
    quantityDocsSigned: "Documentos firmados",
    dateTimeSign: "Fecha y hora de firma",
    idFiscalReceptor: "ID Fiscal receptor",
    receiver: "Receptor",
    viewCompanies: "Ver empresas",
    documentInspection: "Fiscalización de documentos",
    registerAssistance: "Registrar asistencia",
    yourLastAssistanceEntryIs: "Su último registro de asistencia ha sido el día: ",
    lastAssistanceEntryOrigin: "El origen de dicho registro fue:",
    lastAssistanceEntryOriginTotemICARIUS: "Tótem de ICARIUS",
    lastAssistanceEntryOriginWebICARIUS: "Web de ICARIUS",
    lastAssistanceEntryOriginAppICARIUS: "App de asistencia de ICARIUS",
    lastAssistanceEntryOriginClock: "Reloj de captura de terceros",
    lastAssistanceEntryOriginManualManager: "Registro manual del Manager",
    lastAssistanceEntryOriginManualEmployer: "Registro manual del Empleador",
    exit: "SALIDA",
    entrance: "ENTRADA",
    fiscalizationLoginTitle: "Acceso a la fiscalización de documentos digitales",
    fiscalizationIngresar: "Ingresar",
    fiscalizationCambiar: "Cambiar",
    fiscalizationRecuperarPass: "Recuperar contraseña",
    fiscalizationEnd: "Terminar fiscalizacion",
    fiscalizationMailMsg: "Puede acceder a fiscalizar documentos desde el mail que le llegará a su casilla de correos",
    fiscalizationInvalidToken: "Token inválido. El tiempo programado para el acceso ha expirado.",
    fiscalizationPassMail:
        "Puede acceder a recuperar su contraseña desde el mail que le llegará a su casilla de correos",
    fiscalizationPassUpdated: "Pin actualizado",
    fiscalizationRecoveryCodeInvalid: "Codigo de recuperación inválido",
    fiscalizationPinReq: "Su PIN debe tener entre 6 y 20 caracteres",
    collabData: "Datos del colaborador",
    viewButton: "Ver",
    noNotes: "No se encontraron tareas",
    headerSaluteWithName: "¡Hola {name}!",
    headerSaluteNoName: "¡Hola!",
    selectTypeOfDocument: "Seleccione tipo de documento",
    noSignable: "Usted no está no habilitado para firma digital",
    certificateDigitalFullTitle: "Comprobantes y certificados - Firma Digital",
    receiptsDigitalFullTitle: "Recibos y comprobantes de pago - Firma Digital",
    noDocumentsToGenerate: "No se encontraron documentos para generar",
    sendNote: "Enviar",
    shareNote: "Compartir",
    commentAction: "Comentar",
    writeHereYourComment: "Añadir un comentario...",
    editCommentAction: "Guardar",
    attachments: "Archivos adjuntos",
    attachFileToNote: "Agregar adjunto",
    accept: "Aceptar",
    refuse: "Rechazar",
    newSharedNote: "Nueva tarea compartida",
    newSentNote: "Nueva tarea recibida",
    numberOfComments: "{number} comentarios",
    numberOfCommentsSingular: "{number} comentario",
    sharedWith: "Compartida con",
    myGroupsTitle: "Mis grupos",
    newGroup: "Nuevo grupo",
    noGroups: "Aún no perteneces a ningún grupo",
    groupMembers: "Miembros",
    groupCreateTitle: "Crear nuevo grupo",
    groupEditTitle: "Editar grupo",
    groupName: "Nombre del grupo",
    groupDescription: "Descripción / función del grupo",
    groupAddMembers: "Añadir miembros",
    groupDeleteQuestion: "¿Está seguro que desea borrar el grupo?",
    groupCheckValues: "Datos invalidos, por favor revise lo ingresado",
    groupSearchLabel: "Buscar colaborador",
    groupCurrentMembers: "Miembros actuales",
    groupLeave: "Salir del grupo",
    groupValidationError: "Datos invalidos",
    groupInvalidGroup: "No se encontró al grupo seleccionado",
    groupInvalidParticipants: "Hubo un error con los usuarios seleccionados. Por favor, intente nuevamente",
    groupUnauth: "Ud. no es el dueño del grupo",
    groupAtLeastOneUser: "Para crear o modificar, el grupo debe tener al menos un integrante",
    groupLeaveQuestion: "¿Está seguro que desea abandonar el grupo?",
    groupLeaveExplanation: "Al ser creador del mismo, el grupo será eliminado para todos",
    groupMembersTitle: "Miembros del grupo",
    groupImagesTitle: "Seleccionar imagen de galería",
    groupSelectedMembers: "miembros seleccionados",
    groupsExplanation: "Los grupos ayudarán a organizarte mejor",
    groupsNewGroup: "Crear nuevo grupo",
    societyPeopleAndGroupsSearchLabel: "Buscar grupo o colaborador",
    viewComments: "Ver comentarios",
    viewCollaborators: "Compartida con",
    unauth: "Usted no está autorizado para realizar la acción",
    attachmentFailedOperation: "Ocurrió un error intentando eliminar el archivo adjunto",
    fileLimitExceeded: "Se excedió el limite de 12 archivos por tarea",
    fileSizeExceeded: "El archivo adjunto excede los 5 MB",
    imageSizeExceeded: "La imagen excede los 5 MB",
    invalidFile: "Archivo no admitido",
    noFilesUploaded: "Error en la subida de archivos",
    invalidColaboratorsGroups: "Revise la lista de colaboradores y/o grupos",
    invalidColaborators: "Revise la lista de colaboradores",
    invalidGroups: "Revise la lista de grupos",
    validationError: "Datos inválidos",
    invalidParticipants: "Hubo un error con los usuarios seleccionados. Por favor, intente nuevamente",
    commentNotFound: "Comentario no encontrado",
    noteNotFound: "Tarea no encontrada",
    assignResponsible: "Asignar responsable",
    cantAssignResponsible: "No puede asignar responsable",
    changeResponsible: "Cambiar responsable",
    cantChangeResponsible: "No se puede cambiar al responsable",
    notAssigned: "Sin responsable asignado",
    exportQueryOnly: "Exportar solo consulta",
    exportQueryAndTemplates: "Exportar consulta y plantillas",
    queryImport: "Consulta importada exitosamente",
    subTasks: "Subtareas",
    noSubtasks: "No hay subtareas creadas",
    noSubtasksTooltip: "Sin subtareas definidas",
    openSubtasks: "Abrir subtareas",
    showAllTags: "Todos",
    tasks: "Progreso",
    subtask: "Subtarea",
    subtaskProgress: "Progreso de subtarea",
    task: "Tarea",
    taskProgress: "Progreso de tarea",
    taskUpdateDate: "Fecha de actualización",
    note: "Tarea",
    progressFilter: "Filtro de progreso",
    progressFilterNoFilter: "Sin filtro",
    progressFilterAbove40: "Más de 40%",
    progressFilterAbove70: "Más de 70%",
    progressFilterLessEqualThan40: "Menor o igual a 40%",
    subitemEndDateWarning:
        "La fecha de término de cada subtarea no puede ser menor a su fecha de progreso, ni mayor a la fecha de término de la tarea padre",
    itemEndDateWarning:
        "La fecha de término de cada tarea no puede ser menor a su fecha de progreso, ni a la fecha de progreso o fecha de término de sus subtareas",
    taskFinished: "Finalizada",
    taskEndsToday: "Hoy finaliza el plazo",
    variableDaysRemaining: "Quedan {daysDifference} días",
    taskDelayed: "Con atraso",
    taskDelay: "Días de atraso",
    taskInTime: "Con tiempo a favor",
    taskDaysRemaining: "Días para finalizar",
    taskNoFilter: "Sin filtro",
    noteInvalidDates: "Hay tareas/subtareas con fechas invalidas",
    noteInvalidResponsible: "No te encuentras autorizado para modificar algunas de las tareas/subtareas",
    deleteSubtaskConfirm: "¿Desea eliminar la subtarea?",
    deleteTaskConfirm: "¿Desea eliminar la tarea?",
    notaSharedOk: "La tarea se ha compartido con éxito",
    notaSentOk: "La tarea ha sido enviada con éxito",
    noteSendAction: "Enviar",
    noteShareAction: "Compartir",
    colaboratorsCanModify: "Los colaboradores podrán modificar:",
    theirPic: "Su fotografía",
    theirSexCivilNationalityCell: "Su sexo, estado civil, nacionalidad y celular",
    theirBancAndAccount: "Su banco y cuenta bancaria",
    theirAddress: "Su dirección personal",
    appCanMarkOutside: "APP Asistencia puede marcar fuera de zona",
    webLogo: "Logo para plataforma WEB",
    documentsLogo: "Logo para plantillas de documentos",
    mailsLogo: "Logo para correos",
    useDigitalSign: "Usar firma digital",
    acceptFiscalization: "Aceptar fiscalización remota",
    typeOfSignature: "Tipo de firma digital de colaborador",
    accessGroupAdmin: "Grupo para acceso de administradores",
    rrhhEmail: "Email genérico de RRHH",
    latLongSociety: "Latitud/longitud del horario de la sociedad",
    footerRRHHMail: "Pie de correo del área RRHH",
    contactoPhone: "Teléfono de contacto",
    contactMail: "Email de contacto",
    contactCell: "Celular de contacto",
    contactAddress: "Dirección de contacto",
    twitter: "Twitter",
    instagram: "Instagram",
    facebook: "Facebook",
    digitalSignDisclaimer: "Disclaimer para firma digital",
    latLongCities: "Latitud/longitud de horarios de ciudades",
    employerMasterOrderFields: "Orden de campos del Maestro de Empleados",
    digitalFolderSettingsTitle: "Definición de carpeta digital",
    digitalFolderSettingsPageTitle:
        "Definición de carpeta digital (Documentos obligatorios) y documentos que pueden cargar los colaboradores",
    generics: "Obligatorios genéricos",
    genericsUpdatedOK: "Documentos actualizados exitosamente",
    byPosition: "Obligatorios por cargo",
    documentsThatCanBeUploadedByCollaboratorsThemselves: "Documentos que pueden cargar los colaboradores",
    documentPosition: "Cargo",
    documentInstance: "Instancia",
    documentMandatory: "Documento obligatorio",
    selectPosition: "Seleccionar cargo / Resetear",
    documentDeletedOK: "Documento eliminado exitosamente",
    documentDeleteQuestion: "¿Está seguro que desea eliminar la obligatoriedad del documento?",
    noDocumentsForPosition: "No se encontraron documentos",
    createNewDocument: "Agregar por cargo",
    editDocument: "Editar por cargo",
    documentCreatedOK: "Documento creado exitosamente",
    documentUpdatedOK: "Documento actualizado exitosamente",
    digitalFolderValidation: "Todos los campos son obligatorios",
    documentSamePositionInstanceError: "El tipo de documento ya está asignado para el mismo cargo e instancia",
    taskControl: "CONTROL DE TAREAS",
    uploadImage: "Cargar una imagen",
    externalDocuments: "Documentos externos",
    externalDocumentsLong: "Documentos externos para firmar",
    documentRole: "Rol",
    uploadExternalDocuments: "Subir documentos",
    previewExternalDocuments: "Previsualizar documentos",
    signExternalDocuments: "Firmar documentos",
    deleteExternalDocuments: "Eliminar documentos",
    confirmDeleteExternalDocuments: "¿Desea eliminar los documentos?",
    confirmSignExternalDocumentsTitle: "Confirmación de firma de documentos",
    confirmSignExternalDocuments: "¿Confirma realizar la firma digital de los documentos seleccionados?",
    selectExternalFiles: "Seleccionar archivos para subir",
    filesMustBePdf: "Los archivos deben tener extensión .pdf",
    filesMustStartWithCode:
        "Los archivos deben comenzar con el codigo del empleado o número interno seguido de guión bajo (Ej. 12345_nombre_archivo.pdf)",
    selectDocumentRole: "Seleccione rol destinatario",
    externalDocumentTitle: "Ingrese título del documento",
    uploadButtonText: "Subir",
    documentUploadedOK: "Documentos subidos exitosamente",
    errorUploadFile: "Existen archivos que no corresponden a {role} de su dependencia.",
    managers: "managers",
    employers: "empleadores",
    myDigitalDocuments: "Mis documentos digitales",
    digitalDocuments: "Documentos digitales",
    noDigitalDocuments:
        "Desde la función de Documento Digitales, usted podrá firmar y eventualmente descargar, los documentos que requieran su firma digital. Tanto los documentos que usted haya solicitado al empleador para que él los firme digitalmente, como aquellos que el propio empleador haya firmado y puesto a su disposición para su firma. En estos momentos, no existe ninguno disponible para acceder en esas categorías.",
    digitalDocumentConfirmationTitle: "¿Acepta el documento generado?",
    rejectDocument: "Ingrese el motivo por el cuál no está conforme con el documento generado",
    documentInvalidTemplate: "No se encontró la plantilla relacionada con el documento",
    dateApprobation: "Fecha de aprobación",
    timeApprobation: "Hora de aprobación",
    permissionTimeRange: "El rango valido de tiempo es de {from} minutos a {max}:{maxMin} horas",
    permissionTimeNotGreater: "Tiempo por día no puede ser mayor al tiempo por dia solicitado originalmente",
    fileMustBeImage: "El archivo debe ser una imagen (.jpg, .jpeg, .png, .bpm o .gif)",
    activationDeactivation: "Activación y desactivación ICARIUS",
    PG: "Habilitar ICARIUS para esta sociedad",
    CLIENTE: "Código de cliente",
    STOP: "Servicio detenido",
    STOPTIME: "Hora de reanudación para mostrar",
    STOPMSG: "Mensaje para mostrar",
    requests: "Solicitudes",
    VACMAXCTACTE: "Solicitar vacaciones solo hasta el saldo",
    VACPLUSCTACTE: "Máximo de vacaciones adicionales al saldo",
    PORMAXANT: "Porcentaje máximo para anticipos",
    RECEP: "Receptores por cargo o por grupos",
    identificationAndSocietyData: "Identificación y datos de la sociedad",
    decimalFieldsDefinition: "DEFINICIÓN DE DECIMALES PARA CAMPOS NUMÉRICOS",
    QTY_DEC_DOC: "Para documentos (Base de cálculo y Valor)",
    EMAILRRHH: "Email genérico de RRHH",
    GO_LOCALTIME: "Latitud/Longitud horario de la sociedad",
    GO_DTO_RRHH: "Pie de correo área RRHH",
    GO_TELEFONO: "Teléfono de contacto",
    GO_EMAIL: "Email de contacto",
    GO_CELULAR: "Celular de contacto",
    GO_ADDRESS: "Dirección de contacto",
    GO_TWITTER: "X (Twitter)",
    GO_FACEBOOK: "Facebook",
    GO_INSTAGRAM: "Instagram",
    GO_LINKEDIN: "Linkedin",
    JUSTIFY_QUALIFICATIONS: "El evaluador debe justificar las calificaciones mínimas y máximas?",
    SHOW_BEHAVIOR_SKILLS: "Mostrar comportamiento de indicadores en competencias",
    WEIGHT_DISTRIBUTION_FOR_NON_EXISTENT: "Distribución de ponderados para evaluaciones no existentes",
    ALLOW_COMPLAINTS_CHANNEL: "Habilitar el envío de denuncias",
    SHOW_RECOGNITION_POINTS_IN_ANALYTICS: "Mostrar puntos de reconocimientos en analítica del desempeño",
    SHOW_SALARY_DATA_IN_ANALYITICS: "Mostrar datos salariales en analítica del desempeño",
    START_HOLIDAYS_ON_NON_WORKING_DAY: "Puede iniciar vacaciones en día no hábil",
    ALLOW_HALF_DAY_HOLIDAYS: "Pueden solicitar vacaciones de 1/2 días",
    digitalSign: "De firma digital",
    ALLOW_MODIFY_UPDATE_DATE_VACATIONS_EMPLOYEE_MASTER:
        "Se puede modificar la fecha de actualización de la Cte. Cte. de vacaciones del maestro de personas",
    goalsAndObjectives: "DE LAS METAS Y OBJETIVOS DE DESEMPEÑO",
    performanceCompetenciesDescription: "DE LAS COMPETENCIAS ESPECÍFICAS PARA DESEMPEÑO Y DE LA DESCRIPCIÓN DE CARGOS",
    SHOW_WEIGHT_SPECIFIC_SKILLS: "Mostrar ponderados en las competencias específicas",
    COLMETASYOBJ: "Puede el colaborador definir metas y objetivos",
    FIRMADIGITAL: "Usar firma digital",
    FISCALIZACION: "Aceptar fiscalización remota",
    FIRMACOL: "Tipo de firma digital colaborador",
    DISCLAMER: "Disclamer para firma digital",
    timezones: "De zonas horarias",
    GO_CITYHOUR: "Latitud/Longitud horarios de ciudades",
    SOCIETYNAME: "Nombre de la sociedad",
    TAXID: "Identificador fiscal",
    QTY_DEC_AMOUNTS: "Importes",
    QTY_DEC_PRICES: "Precios",
    QTY_DEC_RATES: "Tasas",
    QTY_DEC_QUANTITIES: "Cantidades",
    QTY_DEC_PERCENTAGES: "Porcentajes",
    logosAndCustomization: "De logos y personalización",
    lightWebsiteLogo: "Logo para plataforma web con tema light",
    darkWebsiteLogo: "Logo para plataforma web con tema dark",
    templateLogo: "Logo para plantillas de documentos",
    emailLogo: "Logo para correos",
    permissionsGeneralParameters: "De permisos y accesos a los datos",
    colaboratorPermissions: "Datos que podrá modificar el propio colaborador",
    geographicStructureSettings: "De la organización geográfica",
    GEO_DIVISION1: "División geográfica 1",
    GEO_DIVISION2: "División geográfica 2",
    GEO_DIVISION3: "División geográfica 3",
    hideFieldsPeopleMasterGeneralParameters: "Ocultar:",
    peopleMasterGeneralParameters: "DEL MAESTRO DE PERSONAS",
    SHOW_CONTRACT_DATA: "Muestra datos del CONTRATO",
    SHOW_SALARY: "Muestra datos de la REMUNERACION",
    SHOW_ABSENT_COLABORATORS_GRID_TO_COLABORATORS: "Mostrar cuadro de colaboradores ausentes en rol del colaborador",
    SHOW_TIME_DATA: "Muestra datos de TIEMPOS",
    SHOW_SPECIAL_CLASSIFICATIONS: "Muestra datos de CLASIFICACIONES ESPECIALES",
    ASSUME_DATES: "Asumir fecha de contratación para otras fechas",
    SHOW_OFFICE_PHONE: "Teléfono de oficina",
    SHOW_PERSONAL_PHONE: "Teléfono particular",
    SHOW_PASSPORT_DATA: "Número de pasaporte y expiración",
    SHOW_DOMICILIARY_DATA: "Datos domiciliarios (Excepto la dirección)",
    SHOW_CONTRACT_CODE: "Código de contrato",
    SHOW_CONTRACT_MOTIVE: "Motivo de contratación",
    SHOW_SECTION: "Sección",
    SHOW_PUBLICATION: "Centro de publicación",
    SHOW_IS_RETIRED: "Jubilado",
    SHOW_WORKER_TYPE: "Tipo de trabajador",
    SHOW_FAMILY_ALLOWANCE_DATA: "Tramo de asignación familiar",
    SHOW_EXTREME_ZONE: "Rebaja por zona extrema y porcentaje",
    SHOW_ADDITIONAL_VACATIONS_DATA: "Meses adicionales de vacaciones, fecha y días",
    SHOW_BUSSINESS_SALARY: "Sueldo empresarial",
    SHOW_HARD_WORK: "Trabajo pesado",
    SHOW_IMPOSED_IN_ANOTHER_COUNTRY: "Impone en otro país y su valor cotizado",
    SHOW_SCHEDULED_NOTICE: "Marcar con aviso programado",
    SHOW_DONOR_BLOOD_TYPE: "Grupo sanguíneo y donador",
    SHOW_DIVISION: "Unidad de negocio",
    colaboratorsWillBeAbleToModifiy: "Los colaboradores podrán modificar",
    GO_UPDATEPHOTO: "Su fotografía",
    EDIT_SEX: "Su sexo",
    EDIT_CIVILSTATUS: "Su estado civil",
    EDIT_NATIONALITY: "Su nacionalidad",
    EDIT_CELLPHONE: "Su celular",
    EDIT_LINKEDIN: "Su LinkedIn",
    EDIT_PERSONAL_EMAIL: "Su Email personal",
    GO_UPDATEBANK: "Su banco y Cuenta bancaria",
    GO_UPDATEDIR: "Su dirección personal",
    OBLIGATORY_FIELDS_EMPLOYEE_MASTER: "Campos obligatorios en el Maestro de personas",
    ORDFIELDMAFU: "Orden campos del Maestro de empleados",
    GRUPOEMP: "Grupo para acceso de administradores",
    HISTORICAL_DATA_TRACEABILITY: "Histórico de trazabilidad de datos",
    SOCIAL_FEED_PUBLICATIONS: "Publicaciones en muro social",
    ALERTS_AND_NOTICES: "Alertas y avisos",
    PENDING_REMINDERS: "Acciones pendientes",
    mobileApps: "De las apps",
    historicalDataDuration: "De las vigencias de datos históricos",
    MARCAFUERAZONA: "APP Asistencia puede marcar fuera de zona",
    tooltipWebLogo: ".png min 200x200px",
    tooltipTemplateLogoLine1: "*.jpg con fondo blanco",
    tooltipTemplateLogoLine2: "max 300x200px",
    tooltipTemplateLogoLine3: "min 75x75px.",
    tooltipEmailLogoLine1: "*.jpg con fondo blanco",
    tooltipEmailLogoLine2: "max 750x750px",
    fillClientGeneralSettings: "Verifique el código de cliente",
    fillStopMsgGeneralSettings: "Verifique el mensaje para mostrar cuando el servicio está detenido",
    fillStopTimeGeneralSettings: "Verifique el horario de reanudación para mostrar cuando el servicio está detenido",
    fillHREmailGeneralSettings: "Verifique el email de RRHH para envíos genéricos",
    fillHRDTOGeneralSettings: "Verifique el pie de correo para el área de RRHH",
    fillContactEmailGeneralSettings: "Verifique el email de contacto",
    fillMaxPercentageAdvance: "Verifique el porcentaje máximo de anticipos",
    fillDisclaimerGeneralSettings: "Verifique el disclaimer para firma digital",
    fillFirmaColGeneralSettings: "Verifique el tipo de firma de colaborador",
    dataSucessfullySaved: "Los datos han sido grabados con éxito",
    publishedProcess: "Proceso publicado",
    aiGeneratedSQL: "Escriba en lenguaje natural la consulta que desea crear con IA",
    pollSettings: "Definición de encuestas",
    newPoll: "Nueva encuesta",
    pollCreation: "Creación de encuesta",
    pollFrom: "Desde",
    pollTo: "Hasta",
    pollType: "Tipo",
    pollRole: "Rol de visualización",
    pollFamily: "Familia",
    pollReference: "Referencia",
    pollQuestion: "Pregunta",
    pollQuestionType: "Tipo de pregunta",
    pollQuestionOption: "Opción",
    pollAddOption: "+ Agregar opción",
    pollName: "Nombre de la encuesta",
    pollDescription: "Descripción",
    deletePollOption: "Eliminar opción",
    pollOption: "Opción",
    confirmDeletePoll: "¿Desea eliminar la encuesta?",
    newPollQuestion: "Nueva pregunta",
    pollDeletedOK: "Encuesta eliminada con éxito",
    pollCreatedOK: "Encuesta creada con éxito",
    pollModifiedOK: "Encuesta editada con éxito",
    questionAtLeastTwoOption: "Debe tener al menos 2 opciones",
    questionAtLeastThreeOption: "Debe tener al menos 3 opciones",
    pollFieldsRequiredAndOptions:
        "Todos los campos son obligatorios, y las preguntas con opciones deben tener mas de una",
    pollDuplication: "Duplicar",
    pollDuplicationTitle: "Duplicar encuesta",
    pollFieldsRequired: "Todos los campos son obligatorios",
    pollDuplicationMessage: "Por favor, ingrese el nombre y las fechas de la encuesta.",
    pollDuplicationMessage2: "Estos datos reemplazaran los originales.",
    pollDeleteDialogTitle: "Eliminar encuesta",
    pollDeleteIsInUse: "La encuesta que eliminará {name} ya contiene votaciones. ¿Desea eliminarla de todos modos?",
    pollDeleteQuestion: "¿Esta seguro que desea eliminar la encuesta {name}?",
    typeOfScoreFieldsRequiredAndOptions: "Todos los campos son obligatorios y debe haber al menos una nota",
    confirmDeleteTypeOfScore: "¿Desea eliminar el tipo de nota?",
    newTypeOfScoreQuestion: "Nueva nota",
    typeOfScoreDeletedOK: "Tipo de nota eliminada con éxito",
    typeOfScoreCreatedOK: "Tipo de nota creada con éxito",
    typeOfScoreModifiedOK: "Tipo de nota editada con éxito",
    typeOfScoreFieldsRequired: "Todos los campos son obligatorios",
    typeOfScoreDeleteDialogTitle: "Eliminar tipo de nota",
    typeOfScoreDeleteItem: "¿Esta seguro que desea eliminar el tipo de nota {name}?",
    ratingScaleFieldsRequiredAndOptions: "Todos los campos son obligatorios y debe haber al menos una calificación",
    confirmDeleteRatingScale: "¿Desea eliminar el tipo de escala?",
    newRatingScaleQuestion: "Nueva calificación",
    ratingScaleDeletedOK: "Tipo de escala eliminada con éxito",
    ratingScaleCreatedOK: "Tipo de escala creada con éxito",
    ratingScaleModifiedOK: "Tipo de escala editada con éxito",
    ratingScaleFieldsRequired: "Todos los campos son obligatorios",
    ratingScaleDeleteDialogTitle: "Eliminar tipo de escala",
    ratingScaleDeleteItem: "¿Esta seguro que desea eliminar el tipo de escala {name}?",
    accessSettingsTitle: "Accesos y propiedades",
    manangersAndEmployers: "Managers y empleadores",
    newManager: "Nuevo manager",
    selectManager: "Seleccionar manager",
    filterByManager: "Filtrar por manager",
    managerActive: "Activo",
    accessGroups: "Grupos de acceso",
    isEmployer: "Staff de RR.HH. (Empleador)",
    noManagerFound: "No se encontró manager",
    managersUpdatedOK: "Actualización finalizada con éxito",
    managersCreatedOK: "Creación finalizada con éxito",
    managerDeletedOK: "Eliminación finalizada con éxito",
    errorEmployeeInUseAlready: "Ya existen filas con el empleado seleccionado",
    errorTwoEmployersAlready: "No pueden existir más de un Manager o Empleador que compartan el mismo correo",
    viewAccessGroups: "Ver grupos",
    currentGroups: "Grupos actuales",
    groupsWarning: "En caso de no seleccionar ningun grupo, se dará acceso a todos los grupos",
    findGroupByName: "Buscar grupo por nombre",
    onlineUsers: "Usuarios en línea",
    onlineCollab: "Colaboradores",
    onlineManagers: "Managers",
    onlineEmployers: "Empleadores",
    taskResponsibleName: "Apellido y nombre del responsable",
    assignedTask: "Tarea asignada",
    noteGlobalProgress: "Progreso global de la tarea",
    noteOwner: "Propietario de la tarea",
    noteMailSent: "Mail enviado con éxito",
    noteMailOwner:
        "Solo puede enviar mensajes a los responsables de las tareas en aquellas Notas que son de su propiedad",
    noteTaskGridData: "Progreso de la tarea",
    noteOwner2: "Propietario de la nota",
    noteGlobalProgress2: "Progreso global de la nota",
    noteProgressCollaborator: "Progreso global de {user}",
    noteMyGlobalProgress: "Mi progreso global",
    note2: "Nota",
    noteInUseGoalsAndObjectives:
        "No es posible eliminar la tarea porque está en uso en las metas y objetivos de los colaboradores",
    noteInUseEvaluation:
        "No puede eliminarse porque el feedback asociado está relacionado con la evaluación de desempeño",
    taskLinkedToFeedback: "Esta tarea está vinculada al feedback",
    mailMyPeopleWillBeSent: "Se enviará a {amount} colaborador/es",
    mailTextPlaceholder: "Escribe aquí tu mensaje",
    mailLinkPlaceholder: "Insertar link",
    mailCoordPlaceholder: "Insertar coordenadas",
    mailUploadFile: "Subir adjunto",
    mailLinkText: "Activar link",
    mailUndoLinkText: "Desactivar link",
    mailCoordText: "Activar coordenadas",
    mailUndoCoordText: "Desactivar coordenadas",
    mailSend: "Enviar",
    mailFieldInvalid: "El campo no puede estar vacío",
    mailCoordInvalid: "Ejemplo de coordenadas válidas: -33.42560642629101, -70.6139463736171",
    mailInvalidFileType: "El archivo no puede ser .exe",
    mailInvalidFileSize: "El archivo no puede superar los 5mb",
    mailFileAttached: "1 archivo adjunto",
    mailMyPeopleSent: "Mails enviados con éxito",
    attachment: "Adjunto",
    approvationType: "Tipo de aprobación",
    periodicity: "Periodicidad",
    annotationsAnalysisTitle: "Análisis de anotaciones",
    annoText: "Texto de anotación",
    noDataToChart:
        "El formato actual de la grilla no permite graficar. Para poder hacerlo, deje la grilla en su formato de visualización inicial.",
    sendingMail: "Enviando mail...",
    duplicate: "Duplicar",
    selectColabFire: "Seleccionar colaborador: Solicitud de desvinculación",
    selectColabRise: "Seleccionar colaborador: Solicitud de aumento de sueldo",
    selectedColab: "Colaborador seleccionado",
    historicalProcessesTitle: "Procesos históricos",
    currentProcessesTitle: "Procesos actuales",
    processCode: "Código de proceso",
    processDescription: "Descripción",
    processType: "Tipo de proceso",
    processSubtype: "Tipo de subproceso",
    processDateFrom: "Fecha desde",
    processDateTo: "Fecha hasta",
    processPeriod: "Período",
    processPaymentDate: "Fecha de pago",
    processStatus: "Estado",
    processDateLast: "Fecha último proceso",
    processTimeLast: "Hora último proceso",
    processNew: "Crear proceso",
    processEdit: "Editar proceso",
    processCodeChar: "No se permiten espacios ni los siguientes caracteres especiales: / \\ _ : * ¿ ? “ | < > = +",
    processCodeUse: "El código no puede estar en uso",
    processGridLabel: "Seleccionar los colaboradores que serán procesados.",
    deleteTable: "Eliminar tabla",
    tableDeleteConfirm: "¿Está seguro que desea eliminar la tabla {table}?",
    tableDeleteSecondConfirm:
        "Si elimina la tabla {table} se perderá en forma completa toda la información que dicha tabla contiene. ¿Aún así está seguro de eliminarla?",
    fieldDeleteConfirm: "¿Está seguro que desea eliminar el campo {field}?",
    fieldDeleteSecondConfirm:
        "Si elimina el campo {field} se perderán todos los datos que dicho campo contiene. ¿Aún así está seguro de eliminarlo?",
    deleteField: "Eliminar campo",
    createField: "Crear campo",
    modifyField: "Modificar campo",
    fieldCreatedOK: "Campo creado con éxito",
    fieldEditedOK: "Campo editado con éxito",
    fieldNoExist: "No existe el campo que se desea modificar",
    fieldDeletedOK: "Campo eliminado con éxito",
    cannotExistMoreThanOneFieldWithSameCodeOrName:
        "No puede existir más de un campo que comparta el mismo código o nombre",
    tableCreatedOK: "Tabla creada con éxito",
    tableEditedOK: "Tabla  editada con éxito",
    tableNoExist: "No existe la tabla que se desea modificar",
    tableDeletedOK: "Tabla eliminada con éxito",
    processCreatedOK: "Proceso de cálculo creado con éxito",
    processEditedOK: "Proceso de cálculo editado con éxito",
    processModifyConfirm:
        "Si ha modificado datos del proceso, o bien si ha cambiado la selección de colaboradores que participarán en este proceso, recuerde que debe hacer un reproceso del cálculo ¿Desea continuar?",
    processNoExist: "No existe el proceso de cálculo que se desea modificar",
    processDeletedOK: "Procesos de cálculo eliminados con éxito",
    processDeleteConfirm: "¿Está seguro que desea eliminar los procesos de cálculo?",
    processCalculate: "Calcular",
    calcProcessTraceability: "Trazabilidad del proceso de cálculo",
    processExecutePartialConfirm:
        "¿Está seguro que desea ejecutar un proceso de cálculo PARCIAL para {amount} colaboradores?",
    processExecuteTotalConfirm:
        "¿Está seguro que desea ejecutar un proceso de cálculo TOTAL para {amount} colaboradores?",
    youNeedOneRow: "Debe seleccionar un unico proceso",
    digitalFolderAnalysisTitle: "Análisis de carpeta digital",
    digitalFolderNotAvailable: "Archivos faltantes",
    digitalFolderAvailable: "Archivos existentes",
    digitalFolderSelectInstance: "Seleccionar instancia",
    digitalFolderEveryInstance: "Todas las instancias",
    digitalFolderInstanceReq: "Debe seleccionar Al ingreso, Al egreso o Ciclo de vida",
    digitalFolderFechadecarga: "Fecha de carga",
    digitalFolderHoradecarga: "Hora de carga",
    digitalFolderInstancia: "Instancia",
    digitalFolderTipodedocumentooarchivo: "Tipo de documento o archivo",
    digitalFolderTipodedocumentooarchivoFaltante: "Tipo de documento o archivo faltante",
    digitalFolderTextodescriptivo: "Texto descriptivo",
    digitalFolderNombredelarchivo: "Nombre del archivo",
    digitalFolderFechadevencimiento: "Fecha de vencimiento",
    digitalFolderResponsabledelacarga: "Responsable de la carga",
    digitalFolderSituacion: "Situación",
    accessByGroups: "Acceso por grupos",
    tasksAndTelecommuting: "Tareas y teletrabajo",
    employeesProcessesTitle: "Colaboradores procesados",
    employeesProcessDeleteConfirm:
        "¿Está seguro que desea eliminar a los colaboradores seleccionados del proceso de cálculo?",
    employeesProcessDeletedOK: "Se han eliminado los colaboradores del proceso de cálculo",
    employeesProcessResult: "Resultado",
    employeesProcessOthers: "Otros",
    employeesProcessDetail: "Detalle",
    employeesProcessReferences: "Referencias",
    employeesProcessDialogTitle: "Consulta",
    employeesProcessName: "Nombre",
    employeesProcessAmount: "Cantidad",
    employeesProcessBaseCalculo: "Base de cálculo",
    employeesProcessHaberesAportes: "Haberes con aportes",
    employeesProcessDescuentosLegales: "Descuentos legales",
    employeesProcessHaberesSinAporte: "Haberes sin aportes",
    employeesProcessDescuentosVarios: "Descuentos varios",
    employeesProcessConcepto: "Concepto",
    employeesProcessCodigoConcepto: "Código del concepto",
    employeesProcessNombreConcepto: "Nombre del concepto",
    employeesProcessPorcentaje: "Porcentaje",
    employeesProcessValor: "Valor",
    employeesProcessFecha: "Fecha",
    employeesProcessValueType: "Tipo de valor",
    employeesProcessAnnexComment: "Comentario anexo",
    employeesProcessPeriodoImputacion: "Período de imputación",
    employeesProcessCentroBeneficio: "Centro de costo",
    employeesProcessProyecto: "Proyecto",
    employeesProcessDimension2: "Dimensión 2",
    employeesProcessDimension3: "Dimensión 3",
    employeesProcessDimension4: "Dimensión 4",
    employeesProcessDimension5: "Dimensión 5",
    employeesProcessCodigoReferencia: "Código de referencia",
    employeesProcessReferencia1: "Referencia 1",
    employeesProcessReferencia2: "Referencia 2",
    employeesProcessCantidadConvertida: "Cantidad convertida",
    employeesProcessPeriodoReliquidacion: "Período de reliquidación",
    employeesProcessMesesReliquidar: "Meses a reliquidar",
    employeesProcessEntidad: "Entidad",
    employeesProcessTipoComprobante: "Tipo de comprobante",
    employeesProcessSerieComprobante: "Serie del comprobante",
    employeesProcessNumeroComprobante: "Número del comprobante",
    employeesProcessOrigen: "Origen",
    employeesProcessValorNumerico: "Valor numérico",
    employeesProcessValorAlfanumerico: "Valor alfanumérico",
    employeesProcessValorFecha: "Valor fecha",
    employeesProcessComentarios: "Comentarios",
    employeesProcessTipoValor: "Tipo de valor",
    employeesProcessCodigoAccion: "Código de acción",
    employeesProcessObjetoAccion: "Objeto de acción",
    employeesProcessFechaAccion: "Fecha de la acción",
    employeesProcessAccionesSQL: "Acciones de SQL",
    employeesProcessTotal: "Líquido/Neto",
    geoanalysisTitle: "Geoanálisis",
    noGeoanalysisGroups: "No existen grupos de consultas de geoanálisis disponibles por el momento",
    openMap: "Abrir mapa",
    closeMap: "Cerrar mapa",
    exportAsExcel: "Exportar para My Maps",
    accessosSegmentadoPorGrupos: "Accesos segmentado por grupos",
    selectColumn: "Seleccionar columna",
    deleteManagerQuestion: "¿Esta seguro que desea eliminar al Manager de la lista?",
    deleteEmployerQuestion: "¿Esta seguro que desea eliminar al Empleador de la lista?",
    publicationSettings: "Publicaciones del inicio",
    newPublication: "Nueva publicación",
    publicationName: "Nombre de la publicación",
    publicationFrom: "Desde",
    publicationTo: "Hasta",
    publicationRole: "Rol de visualización",
    publicationText: "Texto",
    publicationLink: "Link",
    publicationDownload: "Descarga",
    publicationType: "Tipo",
    publicationNumber: "Número",
    publicationImage: "Imagen",
    confirmDeletePublication: "¿Desea eliminar la publicación?",
    publicationDeleteDialogTitle: "Eliminar publicación",
    publicationCreation: "Creación de publicación",
    publicationDeletedOK: "Publicación eliminada con éxito",
    publicationCreatedOK: "Publicación creada con éxito",
    publicationModifiedOK: "Publicación editada con éxito",
    publicationExplanation: "Las publicaciones te ayudaran a mantener informada a tu organización",
    noPublications: "Aún no hay publicaciones creadas",
    publicationNewsModal: "Noticias destacadas",
    validationURLPreview: "La URL indicada no posee imagen de previsualización. Por favor, cargue una imagen.",
    publicationInvalidFileType: "Tipo de archivo inválido",
    publicationFileTypeExplanation:
        "Debe ser de alguno de los siguientes tipos: jpg, bmp, png, jpeg, rar, zip, gz, tar, xls, xlsx, txt, rtf, doc, docx, pdf, html",
    downloadAttachment: "Descargar archivo adjunto",
    answerPoll: "Responder encuesta",
    generatePublications: "Generar publicaciones",
    filterbranches: "Sucursales",
    filtercategory: "Categorías",
    filtercontractType: "Tipo de contratos",
    filterfunction: "Funciones",
    filterfunctionType: "Tipo de funcionarios",
    filtergender: "Sexo",
    filtermanagement: "Gerencias",
    filtermaritalStatus: "Estado civil",
    filterpositions: "Cargos",
    filterretiredPersonal: "Jubilados",
    filtershifts: "Turnos",
    filterspecialty: "Especialidades",
    filterunion: "Sindicatos",
    filterworkplaces: "Lugares de trabajo",
    filtermanagementCenters: "Centros de publicación",
    filtersOK: "Filtros actualizados con éxito",
    orgChart: "Organigrama",
    positionEditor: "Estructura de cargos",
    cargosMenu: "Cargos",
    centersSettings: "Centros de costo de gestión y de publicación",
    newCenter: "Nuevo centro de costo de gestión y de publicación",
    centerCode: "Código",
    centerName: "Nombre",
    cantDeleteCenter: "No es posible eliminar el Centro de publicación porque está en uso",
    deleteCenterQuestion: "¿Esta seguro que desea eliminar al Centro de publicación de la lista?",
    noCentersFound: "No se encontraron Centros de publicación",
    centerCodePlaceholder: "Ingrese código",
    centerNamePlaceholder: "Ingrese nombre",
    centerDuplicatedData: "No puede existir más de un centro de publicación que compartan el mismo código o nombre",
    centersUpdatedOK: "Actualización finalizada con éxito",
    centersCreatedOK: "Creación finalizada con éxito",
    centerDeletedOK: "Eliminación finalizada con éxito",
    permissionsSettings: "Permisos para solicitudes",
    newPermission: "Nuevo permiso",
    permissionName: "Nombre del permiso",
    permissionCode: "Código del permiso",
    confirmDeletePermission: "¿Desea eliminar el permiso?",
    permissionDeleteDialogTitle: "Eliminar permiso",
    permissionCreation: "Creación de permiso",
    permissionDeletedOK: "Permiso eliminado con éxito",
    permissionCreatedOK: "Permiso creado con éxito",
    permissionModifiedOK: "Permiso editado con éxito",
    noPermissions: "Aún no hay permisos creados",
    permissionDuplicatedData: "No puede existir más de un permiso que comparta el mismo código o nombre",
    positionEditorId: "ID",
    positionEditorPositionName: "Nombre del cargo",
    positionEditorPositionQuantity: "Cantidad de puestos",
    positionEditorOccupiedPositions: "Puestos ocupados",
    positionEditorFreePositions: "Puestos libres",
    positionEditorResponsabilityDegree: "Grado de responsabilidad",
    positionEditorSuperior: "Cargo superior",
    positionEditorAssistant: "Asistente",
    familySettings: "Definición de familiares",
    newFamily: "Nuevo tipo de familiar",
    familyCode: "Código",
    familyName: "Nombre",
    cantDeleteFamily: "No es posible eliminar el tipo de familiar porque está en uso",
    deleteFamilyQuestion: "¿Está seguro que desea eliminar el tipo de familiar de la lista?",
    noFamilyFound: "No se encontraron definición de familiares",
    familyCodePlaceholder: "Ingrese código",
    familyNamePlaceholder: "Ingrese nombre",
    familyDuplicatedData: "No puede existir más de un tipo de familiar que comparta el mismo código o nombre",
    familyUpdatedOK: "Actualización finalizada con éxito",
    familyCreatedOK: "Creación finalizada con éxito",
    familyDeletedOK: "Eliminación finalizada con éxito",
    functionsSettings: "Definición de funciones",
    newFunction: "Nueva función",
    noTargets: "No se encontraron niveles de competencias",
    deleteFunctionQuestion: "¿Esta seguro que desea eliminar la función de la lista?",
    noFunctionsFound: "No se encontraron funciones",
    functionCode: "Código",
    functionCodePlaceholder: "Ingrese código",
    functionName: "Nombre",
    functionNamePlaceholder: "Ingrese nombre",
    functionsUpdatedOK: "Actualización finalizada con éxito",
    functionsCreatedOK: "Creación finalizada con éxito",
    functionsDeletedOK: "Eliminación finalizada con éxito",
    functionsDuplicatedData: "No puede existir más de una función que comparta el mismo código o nombre",
    cantDeleteFunction: "No es posible eliminar la función porque está en uso",
    advancesSettings: "Anticipos para solicitudes",
    newAdvance: "Nuevo anticipo",
    noAdvances: "Aún no hay anticipos creados",
    advanceCreation: "Creación de anticipos",
    advanceName: "Nombre del anticipo",
    advanceType: "Tipo del anticipo",
    advanceCode: "Código del anticipo",
    advanceDeleteDialogTitle: "Eliminar anticipo",
    confirmDeleteAdvance: "¿Desea eliminar el anticipo?",
    advanceDeletedOK: "Anticipo eliminado con éxito",
    advanceCreatedOK: "Anticipo creado con éxito",
    advanceModifiedOK: "Anticipo editado con éxito",
    advanceDuplicatedData: "No puede existir más de un anticipo que comparta el mismo código o nombre",
    documentPublication: "Publicación de documentos",
    newDocumentPublication: "Nuevo documento",
    documentReceipts: "Recibos",
    documentCertificates: "Certificados y Comprobantes",
    documentRequests: "Documentos de solicitudes",
    documentExternal: "Documentos externos",
    documentAssistance: "Informes de asistencia",
    documentByRequest: "Documentos a pedido",
    documentsGenerated: "Documentos auto generados durante descarga de carpeta digital",
    documentPublicationName: "Nombre del documento",
    documentPublicationRole: "Rol de visualización",
    documentPublicationType: "Tipo",
    confirmDeleteDocumentPublication: "¿Desea eliminar el documento publicado?",
    documentPublicationDeleteDialogTitle: "Eliminar publicación",
    documentPublicationCreation: "Publicación de documento",
    documentPublicationDeletedOK: "Publicación eliminada con éxito",
    documentPublicationCreatedOK: "Publicación creada con éxito",
    documentPublicationModifiedOK: "Publicación editada con éxito",
    noDocumentPublication: "Aún no hay documentos creados",
    documentIncludedFolder: "Incluido en descarga de carpeta digital",
    documentPublicationWorkflow: "Relacionado al workflow",
    documentPublicationCode: "Plantilla relacionada",
    documentPublicationSign: "Con firma digital",
    contractTypesSettings: "Tipos de contrato",
    newContractType: "Nuevo tipo de contrato",
    noContractTypes: "No se encontraron tipos de contrato",
    contractTypeCode: "Código de contrato",
    contractTypeName: "Nombre de contrato",
    contractTypeCalification: "Calificación",
    contractTypeDeleteDialogTitle: "Eliminar tipo de contrato",
    confirmDeleteContractType: "¿Desea eliminar el tipo de contrato?",
    contractTypeCreation: "Creación de tipo de contrato",
    contractTypeDuplicatedData: "No puede existir más de un tipo de contrato que comparta el mismo código o nombre",
    contractTypeDeletedOK: "Tipo de contrato eliminado con éxito",
    contractTypeCreatedOK: "Tipo de contrato creado con éxito",
    contractTypeModifiedOK: "Tipo de contrato editado con éxito",
    cantDeleteContractType: "No es posible eliminar el tipo de contrato porque está en uso",
    conceptGroups: "Grupos para conceptos",
    newConceptGroup: "Nuevo grupo",
    conceptGroupNamePlaceholder: "Ingrese nombre",
    conceptGroupName: "Nombre",
    conceptGroupCode: "Número",
    noConceptGroupsFound: "No se encontraron grupos para conceptos",
    conceptsInUse: "No se puede modificar el concepto por estar en uso",
    contractorCode: "Código de contratista",
    contractorName: "Nombre de contratista",
    contractorAddress: "Dirección",
    contractorContactName: "Nombre de contacto",
    contractorContactMail: "Mail de contacto",
    contractorContactPhone: "Telefono de contacto",
    contractorType: "Tipo",
    contractorSettings: "Contratistas",
    newContractor: "Nuevo contratista",
    contractorDeleteDialogTitle: "Eliminar contratista",
    confirmDeleteContractor: "¿Desea eliminar al contratista?",
    contractorCreation: "Creación de contratista",
    noContractors: "No se encontraron contratistas",
    contractorDuplicatedData: "No puede existir más de un contratista que comparta el mismo código o nombre",
    contractorDeletedOK: "Contratista eliminado con éxito",
    contractorCreatedOK: "Contratista creado con éxito",
    contractorModifiedOK: "Contratista editado con éxito",
    cantDeleteContractor: "No es posible eliminar al contratista porque está en uso",
    functionaryTypesSettings: "Tipos de funcionario",
    newFunctionaryType: "Nuevo tipo de funcionario",
    noFunctionaryTypes: "No se encontraron tipos de funcionario",
    functionaryTypeCode: "Código de funcionario",
    functionaryTypeName: "Nombre de funcionario",
    functionaryTypeProcess: "Procesos automáticos",
    functionaryTypeRequiresClient: "Requiere cliente/proveedor",
    functionaryTypePlant: "Personal de planta",
    functionaryTypeNoPlant: "Externos o Subcontratos",
    functionaryTypeDeleteDialogTitle: "Eliminar tipo de funcionario",
    confirmDeleteFunctionaryType: "¿Desea eliminar el tipo de funcionario?",
    functionaryTypeCreation: "Creación de tipo de funcionario",
    functionaryTypeDuplicatedData:
        "No puede existir más de un tipo de funcionario que comparta el mismo código o nombre",
    functionaryTypeDeletedOK: "Tipo de funcionario eliminado con éxito",
    functionaryTypeCreatedOK: "Tipo de funcionario creado con éxito",
    functionaryTypeModifiedOK: "Tipo de funcionario editado con éxito",
    cantDeleteFunctionaryType: "No es posible eliminar el tipo de funcionario porque está en uso",
    locationSettings: "Definición de lugares de trabajo",
    worksAndTasksSettings: "Definición de obras y faenas",
    divisionsSettings: "Unidades de negocio",
    conceptsAndFormulas: "Conceptos y fórmulas",
    conceptsFormulasFunctions: "Conceptos, fórmulas y funciones",
    accumulatorSettings: "Definición de acumuladores",
    organizationalDefinitions: "Definición de la organización",
    allergiesExamsDiseases: "Definición de perfil médico",
    examCode: "Código de examen",
    diseaseCode: "Código de enfermedad",
    allergyCode: "Código de alergia",
    calculationReferences: "Referencias de cálculo",
    entryExitTypes: "Definición de contrataciones",
    publications: "Publicaciones",
    requestsSettings: "Definición de solicitudes",
    thirdPartySettings: "Definición de terceros",
    locationSettingsBox: "Definición de ubicaciones",
    organizationStructure: "Estructura departamental",
    geographicalStructure: "Organización geográfica",
    issueTypesSettings: "Definición de incidencias",
    absenceTypes: "Tipos de inasistencia",
    permissionTypes: "Tipos de permiso",
    licenceTypes: "Tipos de licencia",
    positionsClassification: "Clasificaciones de cargos",
    managementDefinition: "Definición de gestión",
    alertsSettings: "Definición de Alertas/Avisos",
    conceptsSetSettingsTitle: "Conjunto de conceptos",
    thirdPartyClassification: "Clasificación de terceros",
    thirdParty: "Terceros",
    thirdPartySingular: "Tercero",
    laborUnions: "Sindicatos",
    paymentTypes: "Formas de pago",
    documentTemplates: "Plantillas para documentos",
    assetsAndDiscountsScreenSelector: "Haberes y descuentos",
    assetsAndDiscountsCreation: "Creación de haberes y descuentos",
    digitalWarehouseFileTypes: "Tipos de archivo de bodega digital",
    trainingData: "Definición de formación",
    schooling: "Escolaridades",
    studies: "Estudios",
    specializations: "Especializaciones",
    languages: "Idiomas",
    benefitsSettingsBox: "Beneficios",
    affiliationInstitutionDefinition: "Definición de instituciones de afiliación",
    retirementDefinition: "Previsión",
    healthDefinition: "Salud",
    ratingsAndGeneralValues: "Índices y valores generales",
    familyAsignations: "Asignaciones familiares",
    ratings: "Índices",
    taxTable: "Tabla de impuestos",
    processScheduling: "Programación de procesos actuales",
    entryByImport: "Ingreso via importación",
    filterDepartamento: "Departamento",
    filterCargo: "Cargo",
    "filterObra o Faena": "Obra o Faena",
    filterGerencia: "Gerencia",
    "filterLugar de trabajo": "Lugar de trabajo",
    filterTurno: "Turno",
    filterHorario: "Horario",
    filterColaborador: "Colaborador",
    filterAcumuladores: "Acumuladores",
    "filterGrupos para conceptos": "Grupos para conceptos",
    "filterConjunto de conceptos": "Conjunto de conceptos",
    "filterEstructura de ingreso": "Estructura de ingreso",
    digitalWarehouse: "Bodega digital",
    kpiDefinition: "Definición de KPI",
    geoQuery: "Consultas para geoanálisis",
    queryDefinition: "Definición de consultas",
    generalValues: "Valores generales",
    conceptStructure: "Estructura de ingreso de conceptos",
    conceptsSet: "Conjunto de conceptos",
    extraHoursAuthorization: "Autorización de horas extras",
    holidayTable: "Tabla de vacaciones",
    extraHoursTable: "Tipos de horas extras",
    festivitiesTable: "Feriados y días festivos",
    groupClassification: "Clasificación de grupos",
    bankSettings: "Bancos",
    deleteBankTitle: "Eliminar banco",
    deleteBankMessage: "¿Desea eliminar el banco?",
    viewBankAssociatedCollaborators: "Ver empleados con este banco asignado",
    createBankTitle: "Creación de banco",
    bankSettingsCode: "Código bancario",
    bankSettingsName: "Nombre del banco",
    bankSettingsNew: "Nuevo banco",
    bankSettingsNoBanksFound: "No se encontraron bancos",
    bankSettingsCollaboratorsWithThisBank: "Colaboradores asignados a este banco",
    bankSettingsDuplicatedData: "El código o nombre del banco ya está en uso",
    bankSettingsInUseCollaborator: "El banco está asignado a un colaborador",
    bankSettingsInUseAssetsDiscounts: "El banco está asignado a Haberes y Descuentos",
    bankSettingsNoAssociatedCollaborator: "No hay colaboradores asignados a este banco",
    currencySettings: "Monedas",
    deleteCurrencyTitle: "Eliminar moneda",
    deleteCurrencyMessage: "¿Desea eliminar la moneda?",
    viewCurrencyAssociatedCollaborators: "Ver colaboradores con sueldo o salario asignado a esta moneda",
    createCurrencyTitle: "Creación de moneda",
    currencySettingsCode: "Código de moneda",
    currencySettingsName: "Nombre de la moneda",
    currencySettingsNew: "Nueva moneda",
    currencySettingsNoCurrenciesFound: "No se encontraron monedas",
    currencySettingsCollaboratorsWithThisCurrency: "Colaboradores con sueldo o salario asignado a esta moneda",
    currencySettingsDuplicatedData: "El código o nombre de la moneda ya está en uso",
    currencySettingsInUseCollaborator: "La moneda está asignada al sueldo o salario de un colaborador",
    currencySettingsNoAssociatedCollaborator: "No hay colaboradores con sueldo o salario asignado a esta moneda",
    currencyUpdatedOk: "La moneda se ha actualizado correctamente",
    currencyCreatedOk: "La moneda se ha creado correctamente",
    currencyDeletedOk: "La moneda se ha eliminado correctamente",
    payrollTypesSettings: "Tipos de nómina",
    entryPerConcept: "Ingreso por concepto",
    entryPerSociety: "Ingreso por sociedad",
    assetsDiscountsSummary: "Resumen de haberes y descuentos",
    attendanceReport: "Consulta de presentismo",
    entryPerConceptSet: "Ingreso por conjunto de conceptos",
    entryTypes: "Motivos de ingreso",
    exitTypes: "Motivos de egreso",
    allergiesSettings: "Alergias",
    examsSettings: "Exámenes",
    diseasesSettings: "Enfermedades",
    categoriesSettings: "Categorías",
    specialtiesSettings: "Especialidades",
    userAlertsSettings: "Alertas y avisos del usuario",
    systemAlertsSettings: "Alertas y avisos del sistema",
    massEntry: "Ingreso masivo",
    conceptsAndFormulasScreenSelector: "Conceptos, fórmulas y funciones",
    calculationsFunctions: "Funciones de cálculo",
    CALC_ONLINE: "Habilitar procesos en línea",
    SHOW_9BOXES_C: "Muestra clasificación 9-Boxes al colaborador",
    MANAGER_GESPER: "Habilitar a managers la gestión directa de permisos",
    ORGCHART: "Publicar organigrama",
    MANAGER_SEE_UNPUBLISHED_PROCESSES: "Manager pueden ver procesos de cálculo sin publicar",
    SHOW_POINTS_TO_REDEEM: "Muestra puntos para canje en el medallero",
    MANAGER_GESVAC: "Habilitar a managers la gestión directa de vacaciones",
    specialProcessDefinition: "Definición de procesos especiales",
    accountingImputations: "Imputaciones contables",
    typesOfBenefits: "Tipos de beneficios",
    typesOfScore: "Notas para evaluaciones",
    ratingScales: "Escalas para calificaciones",
    benefitsForPlans: "Beneficios para planes",
    recognitionPlansAssignment: "Asignación de reconocimientos",
    organizationalBenefits: "Beneficios organizacionales",
    dataCapture: "Ingreso de datos vía API",
    myDesktop: "Mi escritorio",
    specialProcessExecution: "Ejecución de procesos especiales",
    myPeopleSchedule: "Gestión de horarios",
    mySchedule: "Mis horarios programados",
    rebuildAccumulators: "Recomposición de acumuladores",
    turnDefinition: "Definición de turnos",
    schedulesDefinition: "Definición de horarios",
    schedulesProgramming: "Programación de horarios",
    historicAccumulators: "Acumuladores históricos",
    assetsDiscountsEntryByInstallments: "Ingreso por cuotas",
    alertsTemplates: "Plantillas de WhatsApp",
    calendarDefinition: "Definición de calendarios",
    issueManagementScreenSelector: "Gestión de incidencias",
    issueSummary: "Resumen de incidencias",
    issueLicences: "Gestión de licencias médicas",
    issuePermissions: "Gestión de permisos",
    issueAbsences: "Gestión de inasistencias",
    issueVacations: "Gestión de vacaciones",
    consentTypes: "Tipos de consentimiento",
    benefitsCenter: "Centros de costo",
    projects: "Proyectos",
    consentPublication: "Publicación de consentimientos",
    VACATIONS_ENABLED: "Habilitar solicitud de vacaciones",
    PERMISSIONS_ENABLED: "Habilitar solicitud de permisos",
    LOANS_ENABLED: "Habilitar solicitud de anticipos",
    historicalProcesses: "Procesos históricos",
    myApprovedConsents: "Mis consentimientos aprobados",
    consentsScreenSelector: "Consentimientos",
    documentsScreenSelector: "Documentos",
    pollScreenSelector: "Encuestas",
    PROCESS_USER: "Código de usuario para cálculos en alertas",
    userTablesDefinition: "Editores de tablas de usuario",
    extensibility: "Extensibilidad",
    catalogs: "Catálogo de base de datos",
    ESQVAC: "Esquema de cálculo de vacaciones",
    userTables: "Editor de tablas de usuario",
    relatedTablesDefinition: "Definición de tablas relacionadas",
    extensibilityScreenSelector: "Modelamiento",
    systemTablesDefinition: "Editores de tablas del sistema",
    systemTables: "Editor de tablas del sistema",
    GT_ALERT2: "Trabajo en día no programado",
    GT_ALERT3: "Marcas inconsistentes",
    GT_ALERT4: "Hrs. Ext. Sin Autorizar",
    GT_ALERT5: "Atraso en la Entrada",
    GT_ALERT6: "Ausencias",
    GT_ALERT7: "Retiro Anticipado",
    GT_ALERT8: "Demora en el Break",
    GT_ALERT9: "Cambio del horario planificado",
    TRACE_DATA: "Activar la trazabilidad de datos",
    CONNECTED_USERS_ENABLED: "Visualizar los usuarios en línea",
    transactionLog: "Log de transacciones",
    assistanceAnalysis: "Análisis de asistencia",
    GT_PROC: "Proceso especial a ejecutar para el análsisis de asistencia",
    GT_HIGHLIGHT_YELLOW:
        "Cuantas horas y minutos mínimos, de asistencia adicional deben transcurrir, para destacar en amarillo",
    GT_HIGHLIGHT_RED:
        "Cuantas horas y minutos mínimos, de asistencia adicional deben transcurrir, para destacar en rojo",
    GT_SELECT_WORKPLACE: "Permitir seleccionar lugar de trabajo al marcar desde la WEB",
    CON_BENEF: "Consentimiento para uso de beneficios",
    PERM_BENEF: "Permiso para los días ganados",
    CTO_BENEF: "Concepto para pago directo de beneficios en dinero",
    recognitionPlans: "Planes de reconocimiento",
    feedbackPurpose: "Propósitos de feedback",
    reasonForPointAwarding: "Motivos para la entrega de puntos",
    myBenefits: "Mis beneficios",
    actions: "Mis acciones y recordatorios",
    recognitionScreenSelector: "Reconocimientos",
    recognitionAnalysis: "Análisis de reconocimientos",
    actionTypes: "Tipos de acciones",
    pollComparison: "Comparación de encuestas",
    feed: "Social",
    HABPUBMURO: "Habilitar muro social",
    DURPUBMURO: "Duración de publicaciones en muro social",
    feedback: "Feedback",
    communicationChannel: "Canal de comunicaciones",
    communicationClassification: "Clasificación de comunicaciones",
    userMenus: "Definición de menús de usuario",
    socialBlacklist: "Usuarios bloqueados en Social",
    performanceDefinition: "Definiciones de desempeño",
    periodsForObjectives: "Períodos para objetivos",
    typesOfObjectives: "Tipos de objetivos",
    positionGroupsForEvaluations: "Grupos de cargos para evaluaciones",
    skillsCode: "Código de competencia",
    indicatorNumber: "Número de indicador",
    indicatorName: "Nombre del indicador",
    behaviorDescription: "Descripción del comportamiento",
    typesOfSkillsSpecific: "Competencias específicas",
    typesOfSkillsTransversal: "Competencias transversales",
    goalsAndObjectivesTitle: "Metas y objetivos",
    myGoalsAndObjectivesTitle: "Mis metas y objetivos",
    talentAcquisitionSettings: "Definiciones de adquisición del talento",
    performanceForms: "Formularios de desempeño",
    evaluationProcessDefinition: "Procesos de evaluación",
    USER_TO_PUBLISH_RECOGNITION: "Usuario para publicar reconocimientos en muro",
    performanceAnalytics: "Analítica del desempeño y talento",
    performanceAnalyticsEvaluations: "Analítica de evaluaciones del desempeño",
    performanceAnalyticsHistoric: "Análisis histórico del desempeño",
    performanceAnalyticsTalent: "Analítica del talento",
    ALLOW_CALIBRATION_IN_TALENT_CLASSIFICATION: "Se permite calibrar en la clasificación del talento",
    ALLOW_ACCEPT_REJECT: "Se permite que el evaluado acepte u objete su evaluación",
    onboardingMaterials: "Materiales y recursos de onboarding",
    onboardingScreenSelector: "Onboarding",
    onboardingProcesses: "Procesos de onboarding",
    onboardingProcessesAssignment: "Asignación a procesos de onboarding",
    onboardingTracking: "Seguimiento de onboarding",
    myOnboardingTracking: "Mis procesos de onboarding",
    DELETE_PROCESS_SQL: "SQL para ejecutar al momento de eliminar un proceso de cálculo",
    changeLanguage: "Cambiar idioma",
    ICARIUS_NOT_AVAILABLE: "ICARIUS no está disponible en estos momentos",
    employerAdministrator: "Empleador Administrador",
    myDigitalWarehouse: "Mi bodega digital",
    utilityDownloads: "Descargas de utilidad",
    darkMode: "Modo oscuro",
    lightMode: "Modo claro",
    shortcut: "Acceso directo",
    absentCollaborators: "Colaboradores ausentes",
    generateDocuments: "Generar documentos",
    selectProcess: "Debe seleccionar un proceso",
    process: "Proceso",
    noProcessOnline: "No existe un procedo definido por defecto para poder calcular",
    processSucessfullyInitialized: "Proceso iniciado con éxito",
    noProcessOnlineCalculate: "No existe un procedo definido por defecto para poder consultar",
    noProcessFound: "No se encontraron procesos para ejecutar",
    viewConsent: "Visualización de consentimiento",
    viewAcceptConsent: "Visualización y aceptación de consentimiento",
    acceptanceDate: "Fecha de aceptación",
    consentText: "Texto del consentimiento",
    removeFromFavorites: "Quitar de favoritos",
    addToFavorites: "Añadir a favoritos",
    succesfullyModified: "Modificación exitosa",
    wrongFormatFiles: "Hay archivos de formato inválido",
    selectFiles: "Seleccionar archivo",
    validFormats: "Formatos válidos",
    countSelectedFiles: "Cantidad de archivos seleccionados",
    cantMoveToColumn: "No puedes moverlo a esta columna.",
    coordinates: "Coordenadas",
    link: "Link",
    invalidURL: "Debe ser una url válida.",
    accumulatedPoints: "Puntos acumulados",
    pointsRemaining: "Te faltan",
    recognitionInProgress: "Reconocimiento en progreso",
    viewTimeline: "Ver línea de tiempo",
    medalTableConfirmationMessage: "¿Está seguro que desea {action} {points} puntos a {userName}?",
    medalTableConfirmationExceptionMessage: "Solo puede {action} entre 1 y {maxPoints} puntos",
    deliverPoints: "Entregar puntos",
    medalTableActionTitle: "{action} de puntos",
    pointsAwarded: "Entrega de puntos",
    pointsValueMedalTable: "{points} punto(s) = Valor {value}",
    discount: "Descuento",
    assignment: "Asignación",
    discountAction: "descontar",
    assignPointsAction: "entregar",
    keepGettingPoints: "¡Sigue sumando puntos!",
    starCollaborator: "¡Colaborador estrella!",
    superstarCollaborator: "¡Colaborador super estrella!",
    recognitionPlan: "Plan de reconocimiento",
    historicalLabel: "Histórico",
    pointsAvailableForTrade: "Puntos disponibles para canje",
    won: "Ganados",
    firstMedal: "¡Vamos por tu primer medalla!",
    noDataFound: "No se encontraron datos",
    fullHistory: "Todo el historial",
    points: "{points} puntos",
    accumulatedPointsUntilToday: "Puntos acumulados a la fecha",
    deliveryReason: "Motivo de la entrega",
    inactiveCollaboratorCantDeliverPoints:
        "El colaborador se encuentra inactivo dentro del plan de reconocimientos, no es posible entregarle puntos.",
    noPlanMatch: "El colaborador no tiene asociado el plan indicado",
    pointsDeliveredSuccefully: "Puntos entregados con éxito",
    modificationMadeSuccesfullyMedalTable: "Ajuste realizado con éxito",
    discountDate: "Fecha de descuento",
    namesAndLastnamesManagerEmployer: "Apellidos y nombres (Managers/Empleadores)",
    canReceiveRequests: "Puede recibir solicitudes ?",
    icariusAdministrator: "Administrador de ICARIUS",
    groupsWithAccess: "Grupos con acceso",
    initialYear: "Año de inicio",
    initialPeriod: "Período de inicio",
    credit: "Crédito",
    debit: "Débito",
    balanceAtTransaction: "Saldo al movimiento",
    transactionDate: "Fecha de movimiento",
    installment: "Cuota",
    clasification: "Clasificación",
    availability: "Disponibilidad",
    accountingEntry: "Asiento",
    condition: "Condición",
    liquidReportedValue: "Valor informado líquido",
    grossReportedValue: "Valor informado bruto",
    youHaveUnreadAlerts: "Tienes {unread_alert_quantity} alerta/s sin leer",
    generatedDocument: "Documento generado",
    settingDownload: "Preparando descarga...",
    creatingSignedDocuments: "Generando documentos firmados",
    creatingDocuments: "Generando documentos",
    processing: "Procesando",
    processInformationNotFound: "No se encontró información del proceso",
    disableComment: "Desactivar comentario",
    emptyCommentWarning: "El comentario no puede estar vacío",
    createComment: "Crear comentario",
    editComment: "Editar comentario",
    commentHowToTagForEmail: "Para que tu comentario también llegue por correo, menciona a los destinatarios con @",
    commentsNotFound: "No se encontraron comentarios",
    seeAll: "Ver todos",
    revisionDate: "Fecha de revisión",
    eventDate: "Fecha del evento",
    event: "Evento",
    purpose: "Propósito",
    reference: "Referencia",
    feedbackHowSent: "¿Cómo has dado el feedback?",
    feedbackHowReceived: "¿Cómo deseas recibir el feedback?",
    uploadEvidence: "Subir evidencia",
    uploadFile: "Subir archivo",
    progressPercentage: "% de progreso",
    chooseGoalsAndObjectives: "Elegir metas y objetivos",
    none: "Ninguno",
    noneFemale: "Ninguna",
    selectedUserHasNoGoalsAndObjectives: "El usuario seleccionado no posee metas y objetivos activos",
    invalidLinkWarning: "Ingrese un link válido",
    enterLink: "Ingresar link",
    previewOnlyForPDF: "Solo se pueden previsualizar archivos con formato .pdf",
    linkToPoll: "Asociar a encuesta",
    poll: "Encuesta",
    onlySeenByCollaborators: "Será visualizada por todos los colaboradores.",
    onlySeenBySelectedPerson: "Solo la persona que selecciones.",
    onlySeenBySelectedPeopleList: "Solo la lista de personas que selecciones.",
    onlySeenBySelectedGroup: "Solo las personas dentro del grupo que selecciones.",
    onlySeenBySelectedTask: "Solo las personas que compartan la tarea que selecciones.",
    mustSelectOption: "Debe seleccionar una opción",
    whoCanSeePublication: "Quién puede ver la publicación",
    whoReceivesFeedback: "Quién recibe el feedback",
    whoGivesFeedback: "Quién debe darte feedback",
    feedbackWillBeViewedBy: "Tu feedback podrá ser visualizado por quienes tú indiques",
    publicationWillBeViewedBy: "Tu publicación se mostrará en Social, y podrá ser visualizada por quienes tú indiques.",
    feedbackAndTaskWillBeLinked: "Con esta opción, el feedback y la tarea quedarán vinculados",
    selected: "Seleccionados",
    selectTaskThatCanView: "Selecciona la tarea que puede visualizar",
    selectGroupThatCanView: "Selecciona el grupo que puede visualizar",
    createFeedback: "Crear feedback",
    editFeedback: "Editar feedback",
    createPublication: "Crear publicación",
    editPublication: "Editar publicación",
    allFieldsRequiredAndSelectReceiver: "Debe ingresar los campos obligatorios y elegir los destinatarios",
    mustEnterPublicationText: "Debe ingresar el texto de la publicación",
    giveFeedback: "Dar feedback",
    requestFeedback: "Solicitar feedback",
    allowComments: "Permitir comentarios",
    seeLikes: "Ver me gusta",
    like: "Me gusta",
    mustEnterReason: "Debe ingresar el motivo",
    enterReason: "Ingrese motivo",
    commentHasBeenDisabled: "Solo tu puedes ver este comentario ya que ha sido desactivado por {responsibleName}.",
    publicationHasBeenDisabled: "Solo tu puedes ver esta publicación ya que ha sido desactivada por {responsibleName}.",
    edited: "Editado",
    whoCanSee: "Quién puede ver",
    eventAssistanceConfirmation: "Asistiré al evento",
    eventAssistance: "Asistencia al evento",
    searchByName: "Buscar por nombre",
    noResultsFound: "No se encontraron resultados",
    feedbackDeleteConfirmation: "¿Desea borrar el feedback?",
    publicationDeleteConfirmation: "¿Desea borrar la publicación?",
    feedbackIsLinkedToTask: "Este feedback está vinculado a la tarea",
    feedbackDeleteWarning:
        "Si elimina el feedback, también se eliminará la tarea completa y todo lo que esta contenga (Actividades, avances, adjuntos y comentarios)",
    revision: "Revisión",
    disablePublication: "Desactivar publicación",
    disable: "Desactivar",
    reactivate: "Reactivar",
    loadMore: "Cargar más",
    youHaveBeenBlocked:
        "Usuario bloqueado: no puedes crear ni interactuar con otras publicaciones porque has sido bloqueado.",
    publicationsNotFound: "No se encontraron publicaciones",
    private: "Privado",
    public: "Público",
    custom: "Personalizado",
    taskTeam: "Equipo de tarea",
    delivered: "Entregado",
    received: "Recibido",
    requested: "Solicitado",
    topTenFeedbackGivers: "Top 10 personas que han dado más feedback",
    topTenFeedbackGiversToMe: "Top 10 personas que me han dado más feedback",
    timeline: "Línea de tiempo",
    graphStatistics: "Estadísticas gráficas",
    selectedFeedback: "Feedbacks seleccionados",
    myFeedback: "Mi feedback",
    onlyDelivered: "Solo entregados",
    deliveredAndReceived: "Entregados y recibidos",
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre",
    multipleCollaboratorsSelected: "Varios colaboradores seleccionados",
    from: "De",
    to: "A",
    mustSelectOneRow: "Debe seleccionar un registro",
    cantDeleteOtherPeopleFeedback: "No puede eliminar el feedback seleccionado porque usted no lo ha enviado",
    cantDeleteLinkedToEvaluation: "No puede eliminarse porque está relacionado con la evaluación de desempeño",
    taskAlreadyLinkedToFeedback: "La tarea seleccionada ya está asociada a otro feedback",
    allPendingTasks: "Todos los pendientes",
    allTasks: "Todas las tareas",
    viewProgressOf: "Ver progreso de",
    noQueriesFound: "No se encontraron consultas",
    notPossibleToVisualizeProgress:
        "No es posible visualizar su avance, porque usted no tiene tareas asignadas en este momento.",
    mustSelectItem: "Debe seleccionar un item",
    typesOfSkillsIndicatorsDeletePrompt: "¿Desea borrar el indicador?",
    feedbackCode: "Código del feedback",
    pendingTasks: "Tareas pendientes",
    myPendingTasks: "Mis tareas pendientes",
    noPendingTasks: "No hay tareas pendientes",
    noteAlreadyShared: "Está intentando compartir la nota con los usuarios que ya tienen la nota compartida",
    noteMustSelectToShare: "Debe seleccionar a alguien para enviar la nota",
    orderByTasks: "Ordenar por tareas",
    orderByProgress: "Ordenar por avance",
    myToDoSelectCollaborator: "Seleccione un Colaborador para ver sus avances",
    whoSends: "Quién lo envía",
    whoReceives: "Quién lo recibe",
    text: "Texto",
    modality: "Modalidad",
    period: "Período",
    image: "Imagen",
    evidence: "Evidencia",
    scope: "Alcance",
    commentsAreAllowed: "Se permiten comentarios",
    likes: "Me gusta",
    role: "Rol",
    whoSendsCode: "Código de quién lo envía",
    whoReceivesCode: "Código de que quién lo recibe",
    publish: "Publicar",
    myPendingConsents: "Mis consentimientos pendientes",
    myVacations: "Mis vacaciones",
    myLoans: "Mis préstamos",
    myFeedbacks: "Mis feedbacks",
    myCommunicationChannel: "Mi canal de comunicaciones",
    myPeopleVacations: "Vacaciones de mi personal",
    myPeopleAnnotations: "Anotaciones de mi personal",
    myPeopleTime: "Horarios de mi personal",
    timeChangeRequests: "Solicitudes de cambios de horarios",
    myCreatedCommunications: "Mis comunicaciones creadas",
    communicationsToAttend: "Comunicaciones que debo atender",
    myOnboardingTasks: "Mis tareas de onboarding",
    openMyPersonalData: "Abrir Datos Personales",
    sendMessageToManager: "Enviar mensaje al manager",
    myMedalTable: "Mi medallero",
    noRegisteredAssistanceData: "No hay asistencias registradas",
    lastAssistanceRegistry: "Último registro de asistencia",
    totalProgressLowercase: "progreso total",
    collaboratorsProgress: "Progreso de colaboradores",
    oneDayRemaning: "Queda 1 día",
    daysRemaning: "Quedan {remainingDays} día",
    taskFinishedMale: "Finalizado",
    taskShortageProgress: "Faltante",
    daysDelay: "Atraso de {remainingDays} días",
    oneDayDelay: "Atraso de 1 día",
    lastAlerts: "Últimas notificaciones",
    lastCreatedAnnotations: "Últimas anotaciones que has realizado",
    lastReceivedAnnotations: "Últimas anotaciones recibidas",
    myFavouriteGeolocationQueries: "Mis consultas de geoanálisis favoritas",
    myFavouriteKPI: "Mis KPI favoritos",
    pendingPolls: "Encuestas pendientes",
    myFavouriteQueries: "Mis consultas favoritas",
    willBeSentToMyManager: "Se enviará a mi manager",
    consentAlreadyAccepted: "Consentimiento ya aceptado",
    thanksForAcceptingConsent: "Muchas gracias por aceptar el consentimiento",
    deleteSelectedAlerts: "Eliminar alertas seleccionadas",
    deleteReadAlerts: "Eliminar todas las leídas",
    selectFilter: "Seleccionar filtro",
    noFilter: "Sin filtro",
    downloadHasBegun: "La descarga ha comenzado...",
    inePoll: "Encuesta INE (Plantilla en Excel)",
    encryptor: "Encriptador",
    fingerprintRegistration: "Registro con huellero",
    assistanceRegistrationApp: "App para registro de asistencia",
    legalFilesAndDocuments: "Archivos y documentos legales",
    assistanceRegistration: "Registro de asistencia",
    utils: "Utilitarios",
    yourProgrammedScheduledForToday: "Su horario programado para hoy es",
    myAssistanceRegistration: "Mi registro de asistencia",
    mustSelectJobLocation: "Debe seleccionar un lugar de trabajo",
    pollAnswered: "Encuesta respondida",
    giveOpinion: "Déjanos tu opinión",
    pollMedalTablePoints: "Quienes respondan esta encuesta recibirán {points} puntos en su medallero",
    openDigitalWarehouse: "Abrir bodega digital",
    noDigitalWarehouse: "No posee bodega digital",
    hasDigitalWarehouse: "Contiene bodega digital",
    tag: "Etiquetar",
    addMembers: "Añadir miembros",
    membersSelected: "Miembros seleccionados",
    viewCollaboratorsList: "Ver colaboradores de la lista",
    viewAsList: "Ver como lista",
    viewAsTree: "Ver como árbol",
    preview: "Previsualizar",
    groupDigitalWarehouse: "Bodega digital del grupo",
    enterRequiredFields: "Ingrese los campos obligatorios",
    editFile: "Editar archivo",
    createFile: "Crear archivo",
    folder: "Carpeta",
    subfolder: "Subcarpeta",
    fileType: "Tipo de archivo",
    fileOnFolderAlreadyExists: "Ya existe un archivo con el mismo nombre en esa fecha y carpeta/subcarpeta",
    cantDeleteFileInUse: "No es posible eliminar el archivo porque está en uso",
    fileDeletedSuccessfully: "Archivo eliminado con éxito",
    fileCreatedSuccessfully: "Archivo creado con éxito",
    filesCreatedSuccessfully: "archivos creado con éxito",
    fileEditedSuccessfully: "Archivo actualizado con éxito",
    personalEmail: "Email personal",
    weeklyHoursContract: "Horas semanales contrato",
    helpAssistant: "Asistente de ayuda",
    dataProtection: "Protección de datos",
    changeProfileImageWarning:
        "Apreciado colaborador: si usted quiere cargar o cambiar su fotografía, le solicitamos que sea una fotografía personal y para uso corporativo.",
    changeProfileImageThanks: "Muchas gracias por su colaboración.",
    mustSelectImage: "Debe seleccionar una imagen",
    historicCertificatesReceiptsWarning1:
        "Los procesos que se visualizan corresponden únicamente a aquellos en los cuales usted ya tiene aceptado el comprobante de pago.",
    historicCertificatesReceiptsWarning2:
        "Si no visualiza un proceso en específico es porque aún no se encuentra disponible, o bien porque usted aún no acepta el comprobante de pago de dicho proceso. Si este fuera el caso, acceda a Mis Recibos para aceptar los documentos pendientes.",
    mustSelectQuery: "Debe seleccionar una consulta",
    file: "Archivo",
    uploader: "Usuario de carga",
    groupMemberPermissions: "Permisos miembros del grupo",
    noOnboardingTask:
        "Usted no tiene en estos momentos tareas de Onboarding donde este definido como “Responsable de su atención”",
    profile: "Perfil",
    onboardingTrackingFromTo: "Desde el {startDate} hasta el {endDate}",
    onboardingTrackingProgress:
        "Progreso total del proceso: {processProgressValue}% ({amountInProgress} de {amountTotal})",
    activeProcesses: "Procesos activos",
    everyProcess: "Todos los procesos",
    lookAtProcessTree: "Ver árbol del proceso",
    moment: "Momento",
    actionType: "Tipo de acción",
    onboardingTrackingMomentProgress:
        "Progreso del momento: {processProgressValue}% ({amountInProgress} de {amountTotal})",
    seeEmployeeData: "Ver datos del empleado",
    assignToProcessControl: "Asignar al control del proceso",
    removeFromProcessControl: "Quitar del control del proceso",
    stopProcessControl: "Detener del control del proceso",
    reassignProcessControl: "Reasignar al control del proceso",
    moveToDone: "Pasar al estado “Realizado”",
    removeProcessCompletely: "Eliminar completamente del proceso",
    reminderDate: "Fecha de recordatorio",
    onboardingTrackingDescriptionHelperText:
        "Cuando ingrese la descripción o la modifique, recuerde que para que llegue una notificación al responsable asignado, es necesario que acceda nuevamente a esta acción, pulse clic y cree un comentario",
    commentCantBeEmpty: "El comentario no puede estar vacío",
    howToTagInComment: "Para que tu comentario también llegue por correo, menciona a los destinatarios con @",
    processTree: "Árbol de visualización del proceso",
    excludeStoppedCollaborators: "Excluir colaboradores detenidos",
    excludeUnnecessaryActions: "Excluir acciones no necesarias",
    onlyIncludePlannificatedActions: "Solo incluir planificadas",
    includePlannificatedAndInProgressActions: "Incluir planificadas y En curso",
    collaboratorsInProcess: "colaboradores en el proceso",
    howToEditFeedback:
        "Para modificar este feedback o realizar comentarios, acceda a la función Mis Feedbacks desde Mi Escritorio",
    collaboratorAssignedToControlProcess: "Colaborador asignado al control del proceso con éxito",
    collaboratorRemovedFromControlProcess: "Colaborador eliminado del control del proceso con éxito",
    collaboratorUpdated: "Colaborador actualizado con éxito",
    responsibleAssigned: "Responsable asignado con éxito",
    actionDeleted: "Acción eliminada con éxito",
    actionUpdated: "Acción actualizada con éxito",
    actionReplicated: "Acción replicada con éxito",
    collaboratorsNotFound: "No se encontraron colaboradores",
    replicateWarning:
        "El responsable asignado, la descripción de la acción, y las fechas serán asignadas al resto de las acciones del mismo tipo que estén en estado planificado.",
    doYouWishToContinue: "¿Desea continuar?",
    cantAssignCollaboratorToProcessControl1:
        "No es posible asignar el colaborador al control del proceso, porque el proceso ya ha avanzado al 2do momento para otros colaboradores.",
    cantAssignCollaboratorToProcessControl2: "Solo pueden asignarse cuando el proceso está en el 1er momento.",
    cantAssignCollaboratorToProcessControl3:
        "Elimine al colaborador de este proceso y asígnelo en otro proceso de onboarding",
    deleteActionQuestion: "¿Está seguro que desea eliminar la acción?",
    deleteCollaboratorProcessOnboardingWarning1:
        "Si elimina al colaborador del proceso de onboarding, también se eliminará:",
    deleteCollaboratorProcessOnboardingWarning2: "Toda la trazabilidad y el detalle de su participación en el proceso.",
    deleteCollaboratorProcessOnboardingWarning3: "Sus comentarios, adjuntos, y feedbacks recibidos durante el proceso.",
    deleteCollaboratorProcessOnboardingWarning4: "Las acciones realizadas y las etapas por las cuales ha pasado.",
    removeCollaboratorProcessOnboardingWarning1:
        "Si quita el colaborador del control del proceso de onboarding (Kanban), también se eliminará:",
    removeCollaboratorProcessOnboardingWarning2: "Toda la trazabilidad y el detalle de su participación en el proceso.",
    removeCollaboratorProcessOnboardingWarning3: "Sus comentarios, adjuntos, y feedbacks recibidos durante el proceso.",
    removeCollaboratorProcessOnboardingWarning4: "Las acciones realizadas y las etapas por las cuales ha pasado.",
    removeCollaboratorProcessOnboardingWarning5:
        "Si bien permanecerá dentro del proceso, no se mantendrá el detalle de las acciones realizadas.",
    removeCollaboratorProcessOnboardingWarning6:
        "Sin embargo, se permitirá que posteriormente lo rasigne al control del proceso nuevamente.",
    moveCollaboratorToDoneWarning1:
        "Si pasa el colaborador a la etapa “Realizado” significa que el proceso de onboarding para el colaborador ha finalizado.",
    moveCollaboratorToDoneWarning2:
        "A partir de ese estado solo podrá consultarlo, pero ya no podrá modificarlo o realizar nuevas acciones dentro del control del proceso de onboarding para dicho colaborador.",
    hasBeenAnswered: "Ha sido respondida.",
    hasNotbeenAnswered: "Aún no ha sido respondida.",
    accessMaterial: "Acceder a material",
    acceptTermsAndConditions: "Acepto los terminos y condiciones",
    observations: "Observaciones",
    observationsRequired: "Las observaciones son obligatorias si decide rechazar el documento",
    mustSelectDocument: "Debe seleccionar un documento",
    previewDocumentBeforeSigning: "Previsualice el documento antes de proceder a firmarlo",
    acceptAndSign: "Aceptar y firmar",
    previewDocument: "Previsualizar documento",
    viewAttachment: "Ver adjunto",
    wrongPIN: "El PIN ingresado es incorrecto",
    approvalAndSignSuccessfull: "La aprobación y firma del documento se ha realizado con éxito",
    documentRejectionSuccessfull: "El rechazo del documento se ha realizado con éxito",
    openEmojiSelector: "Abrir selector de emojis",
    collaboratorAnnotations: "Anotaciones del colaborador",
    checkWeight: "Verificar ponderados",
    goalsAndObjectivesCharts: "Gráficos de las metas y objetivos",
    amountByProgress: "Cantidad por avance",
    amountByStatus: "Cantidad por estado",
    mustSelectCollaborator: "Debe seleccionar un colaborador",
    createObjective: "Crear objetivo",
    editObjective: "Editar objetivo",
    selectCollaborator: "Seleccionar colaborador",
    selectCollaborators: "Seleccionar colaboradores",
    objectiveType: "Tipo de objetivo",
    objective: "Objetivo",
    objectiveName: "Nombre de objetivo",
    objectiveWeight: "Ponderado del objetivo",
    assignationDate: "Fecha de asignación",
    relatedTask: "Tarea relacionada",
    progressDate: "Fecha de progreso",
    progressPercentageObjective: "Porcentaje de avance de progreso",
    mustBeApprovedByCollaborator: "¿Debe aprobarlo el colaborador?",
    mustByApprovedByManager: "¿Debe aprobarlo el manager?",
    doYouApproveObjective: "¿Apruebas el objetivo?",
    doesCollaboratorApproveObjective: "¿Aprobado por el colaborador?",
    doesManagerApproveObjective: "¿Aprobado por el manager?",
    viewGrid: "Ver grilla",
    myManager: "Mi manager",
    allObjectives: "Todos los objetivos",
    objectivesAssignedByMe: "Objetivos que he asignado",
    noObjectivesForYouInPeriod: "No posee metas y objetivos para el período seleccionado",
    noCollaboratorWithObjectivesInPeriod: "Ningún colaborador posee metas y objetivos para el período seleccionado",
    noCollaboratorSelectedWithObjetivesInPeriod:
        "El colaborador no posee metas y objetivos para el período seleccionado",
    personalObjectives: "Objetivos personales",
    organizationObjectives: "Objetivos de la organización",
    selectedCollaboratorNoObjectivesOfType: "El colaborador seleccionado no posee metas y objetivos de este tipo",
    assignedBy: "Asignado por",
    progressStatus: "Estado de avance",
    youMustApproveObjective: "Debes aprobar el objetivo",
    objectiveDescription: "Descripción del objetivo",
    objectiveWeightWarning:
        "La suma de los ponderados totaliza {number}% para {verificationFailuresValue}. Es necesario complementar con otro objetivo o reasignar los ponderados",
    objectiveWeightCollaboratorOk: "La suma de los ponderados es correcta y totaliza 100% para sus objetivos asignados",
    objectiveWeightSelectedCollaboratorsOk:
        "La suma de los ponderados es correcta y totaliza 100% para los colaboradores seleccionados",
    objectiveCantBeDeletedCreatedBy: "El objetivo no puede eliminarse, ha sido creado por su {selectedRowRole}",
    deleteObjectiveQuestion: "¿Desea eliminar el objetivo?",
    mustSelectOneRowAndPeriod: "Debe seleccionar al menos un registro y un período",
    objectiveFeedbackWarning:
        "Ha modificado datos que se incluyen en el Feedback (fecha de término o % de progreso), actualice primero antes de enviar el Feedback.",
    mustIApproveObjective: "¿Debo aprobar el objetivo?",
    assignerRole: "Rol del asignador",
    datesInvalid: "Las fechas ingresadas no son válidas",
    objectiveAlreadyExistsNameOrCode: "Ya existe un objetivo con el mismo nombre o código",
    objectiveInUse: "No es posible eliminar el objetivo porque está en uso",
    objectiveWeightWarning2:
        "La suma de los ponderados del colaborador en el período seleccionado no puede superar el valor máximo de 100",
    objectiveAlreadyEvaluated:
        "No es posible eliminar el objetivo porque ya ha sido calificado en la evaluación: {evaluationName}",
    objectiveDeletedOk: "Objetivo eliminado con éxito",
    objectiveCreatedOk: "Objetivo creado con éxito",
    objectiveModifiedOk: "Objetivo actualizado con éxito",
    expiresToday: "Vence hoy",
    atTime: "al",
    objectiveStatus: "Estado del objetivo",
    objectiveAssigner: "Asignador del objetivo",
    postpone: "Postergar",
    forFinalResultOfPotentialEvaluation: "Para el resultado final de la evaluación de potencial",
    onboardingStageProfiles: "Perfiles de etapas de onboarding",
    cannotDeleteRatingScaleBecauseItIsUsedInPerformanceForms:
        "No es posible eliminar la escala para calificación porque está en uso en los formularios de desempeño",
    noFormatTypesFoundForPublications: "No se encontraron tipos de formato para las publicaciones",
    attendanceMarks: "Marcas de asistencia",
    timeStartDate: "Fecha desde de tiempos",
    newProject: "Nuevo proyecto",
    onlyOnePurposeCanShareSameCodeOrName: "No puede existir más de un propósito que comparta el mismo código o nombre",
    alphanumericEdit: "Edit alfanumérico",
    quota: "Cuota",
    numericWithDecimalsAndNotEligibleAsMarker: "Numérico con decimales y no elegible como marcador",
    earningsAndDeductionsByConceptGroup: "Haberes y descuentos - Por conjunto de conceptos",
    onlyActiveEmployeesAllowedForMassProjectChange:
        "Para el cambio masivo de obra o faena debe seleccionar solo a colaboradores vigentes",
    withVisa: "Con visado",
    publicationCenters: "Centros de publicación",
    day: "Día",
    someDataLockedForThisFormDueToLinkedEvaluationProcesses:
        "Para este formulario hay datos que ya no pueden modificarse (Se mostrarán solo para visualización) porque el formulario está relacionado con uno o más procesos de evaluación del desempeño que aún no están ",
    scaleTypeName: "Nombre del tipo de escala",
    analytical: "Analítico",
    amountToReceive: "Valor a recibir",
    npsExcellent: "NPS excelente",
    onlyOneDefaultProcessAllowedAtATime: "Solo es posible definir un proceso por defecto a la vez",
    bulkFileUpload: "Carga masiva de archivos",
    newConceptCode: "Código del nuevo concepto",
    advanceCurrency: "Moneda del anticipo",
    descriptiveTextForContractsAndOthers: "Texto descriptivo para contratos y otros",
    confirmDeleteEvaluatedAndEvaluatorsRecords:
        "¿Está seguro que quiere eliminar los registros de evaluados y evaluadores seleccionados?",
    preloadedVariables: "Variables Precargadas",
    allPlans: "Todos los planes",
    currentCalculationProcessSchedule: "Programación de procesos de cálculo actuales",
    quotaStatus: "Estado de la cuota",
    processCodeAlreadyExistsForAnotherCalculation: "El código de proceso ya existe para otro proceso de cálculo",
    withMultipleSignatures: "Con firma múltiple",
    thirdPartyName: "Nombre del tercero",
    outstandingPerformance3: "3 Desempeño sobresaliente",
    scheduledShiftAlreadyExistsForThatDate: "Ya existe un horario programado para el turno con esa fecha",
    competencyAlreadyExists: "Ya existe una competencia de este tipo",
    cannotDeletePaymentMethodBecauseItIsInUse: "No es posible eliminar la forma de pago porque está en uso",
    createFamilyMemberRecord: "Crear registro de familiar",
    exportTemplateWithData: "Exportar plantilla con datos",
    mustSelectAtLeastOneFilter: "Debe seleccionar al menos un filtro",
    createHealthInstitution: "Creación de institución de salud",
    dateWithPicker: "Fecha con picker",
    paymentMethodDeletedSuccessfully: "Forma de pago eliminada con éxito",
    confirmDeleteEmployeeFromPlan: "¿Está seguro que quiere eliminar al colaborador del plan?",
    editPeriodForObjectives: "Editar período para objetivos",
    alertAndNotificationDefinition: "Definición de alertas y avisos",
    editRecord: "Editar registro",
    whatTypeOfDocumentDoYouWantToCreate: "¿Qué tipo de documento desea crear?",
    studyTypeDeletedSuccessfully: "Tipo de estudio eliminado con éxito",
    absenceUpdatedSuccessfully: "Inasistencia actualizada con éxito",
    deleteMaterialOrResource: "Eliminar material o recurso",
    exitReasons: "Motivos de egreso",
    costCenterUpdatedSuccessfully: "Centro de costo actualizado con éxito",
    extraVariableField: "Extra variable field",
    inputSource: "Origen de entrada",
    positionAssignmentDate: "Fecha asignación cargo",
    specificCompetencyGroupForPosition: "Grupo competencias específicas cargo",
    fromPerformanceRatings: "De las calificaciones de desempeño",
    indexDeletedSuccessfully: "Índice eliminado con éxito",
    capturedViaOtherSystemApi: "Vía captura desde otro sistema (API)",
    noReasonsFoundForPointDelivery: "No se encontraron motivos para la entrega de puntos",
    confirmDeleteBenefitType: "¿Desea eliminar el tipo de beneficio?",
    imputationAlreadyExistsForSameConceptEntryTypeAndCondition:
        "Ya existe una imputación para el mismo concepto, asiento, tipo de imputación y condición",
    publicationReference: "Referencia de publicación",
    unscheduledWorkday: "Trabajo en día no programado",
    sqlToGetRecipients: "SQL para obtener destinatarios",
    secondLevelGeographicOrganizationIsMandatory: "El segundo nivel de organización geográfica es obligatorio",
    reasonsForPointDelivery: "Motivos para entrega de puntos",
    historical: "Históricas",
    entered: "Ingresado",
    peopleMaster: "PeopleMaster",
    ragBlueWhiteText: "rag-blue-whiteText",
    mandatoryAttachment: "Adjunto obligatorio",
    labelAbbreviation: "Abreviatura para etiqueta",
    absencesAlternative: "Inasistencias",
    final: "Final",
    changeSchedules: "Cambiar horario",
    descriptionCannotBeEmpty: "La descripción no puede estar vacía",
    mustSelectAtLeastOneItem: "Debe seleccionar al menos un item",
    positionIdMustBeNumber: "El ID del cargo debe ser un número",
    deletePensionInstitution: "Eliminar institución de previsión",
    crossCompetencies: "Competencias transversales",
    deleteThirdParty: "Eliminar tercero",
    formula: "Fórmula",
    previewPdf: "Previsualizar PDF",
    newRating: "Nueva calificación",
    returnFromBreak: "Regreso del break",
    averageFromMyEvaluators: "Promedio de mis evaluadores",
    conceptFamily: "Familia del concepto",
    workLocationAssignmentDate: "Fecha asignación lugar de trabajo",
    creditAndDebitMustBeGreaterThanZeroIfPresent: "Crédito y débito, en caso de tener valor, deben ser mayores a 0",
    benefitTypeUpdatedSuccessfully: "Tipo de beneficio actualizado con éxito",
    newEvaluatorSelection: "Selección del nuevo evaluador",
    icon1MinimumValue: "icon1MinimumValue",
    commentsAndObservations: "Comentarios y observaciones",
    organizationObjective2: "Objetivo de la organización 2",
    newNoteType: "Nuevo tipo de nota",
    finalGrade: "Nota final",
    collaboratorsPercentage: "Porcentaje de colaboradores",
    mustEnterMandatoryParameters: "Debe ingresar los valores de los parámetros que son obligatorios",
    paymentMethods: "Formas de pago",
    yellow: "Amarilla",
    peerWeightedScore: "Ponderado de pares",
    associatedWithThisTeam: "Asociado a este equipo",
    conceptCode: "Codigo del concepto",
    lowerPrice: "Rebaja",
    actionUpdatedSuccessfully: "Acción actualizada con éxito",
    cannotDeleteProjectBecauseItIsInUse: "No es posible eliminar la Obra o Faena porque está en uso",
    alphaComma: "Alfa,",
    cannotDeleteConceptBecauseItIsInUse: "No es posible eliminar el concepto porque está en uso",
    referenceEmployee: "Empleado de referencia",
    viewOnlyObjectives: "Objetivos solo de visualización",
    noQuotaEntriesFound: "No se encontraron ingresos en cuotas",
    signers: "Firmantes",
    specialProcessExecutionInProgress: "Ejecución en proceso para el proceso especial seleccionado",
    exportData: "Exportar datos",
    updatedQuadrantOrderSuccessfully: "Orden de cuadrantes actualizado con éxito",
    thisBenefitAlreadyExistsAsOrganizationalBenefitAndItIsNotPossibleToDeactivateAssignPointsOrDefineItWithAccessModeThroughPointsRedemptionFirstItMustBeDeletedFromOrganizationalBenefitsBeforeProceedingWithTheseChanges:
        "Este beneficio ya existe como Beneficio Organizacional y no es posible: Dejarlo inactivo, Asignarle puntos o definirlo con modo de acceso Mediante canje por puntos. Primero debe eliminarlo de los Beneficios Organizacionales para luego proceder con estos cambios",
    last3Years: "Últimos 3 años",
    unauthorized: "Unauthorized",
    massiveDepartmentalStructureChangeCompletedSuccessfully:
        "El cambio masivo de estructura departamental ha finalizado con éxito",
    concepts: "Conceptos",
    executionMoment: "Momento de ejecución",
    viewCalendar: "Ver calendario",
    viewPositionData: "Ver cargo de {name}",
    competencyEvaluationsDifferences: "Evaluaciones por competencia (diferencias)",
    youMustSelectASingleRecord: "Debe seleccionar un único registro",
    youCannotAccessBecauseYourPinRecoveryHasExpiredPleaseRecoverYourPinAgain:
        "No es posible acceder porque la recuperación de su PIN ha expirado. Por favor, recupere su PIN nuevamente.",
    accountingAccountDescription: "Desc. de la Cuenta contable",
    changePositions: "Cambiar cargos",
    potentialPtsFor9Boxes3: "Pts. Potencial hasta para 9-Boxes 3",
    periodFrom: "Período desde",
    legalDaysCanContainUpTo3Decimals: "Días legales puede contener hasta 3 decimales",
    deletedValuesPressSaveToMakeChangesPermanent:
        "Valores eliminados. Presione guardar para hacer permanentes los cambios.",
    potentialUntil: "Potencial hasta",
    allPayrolls: "Todas las nóminas",
    ifNecessaryIncludeAnAttachment: "Si es necesario incluya un adjunto",
    classificationDeletedSuccessfully: "Clasificación eliminada con éxito",
    editAbsence: "Editar inasistencia",
    cannotExistValuesWithTheSameTypeCodeAndName: "No pueden existir valores con el mismo Tipo, Código y Nombre",
    parameterNumber: "Número de parámetro",
    queriesForGeoanalysis: "Consultas para geoanálisis",
    forExistenceControlDuringRecordDeletion: "Para control de existencia durante la eliminación de registros",
    youMustChooseADocument: "Debe elegir un documento",
    medicalLeaveManagement: "Gestión de licencias médicas",
    assignmentDateToFunction: "Fecha asignación a la función",
    earnedAdditionalOrProgressive: "Ganados (adicionales o progresivos)",
    noShiftAssigned: "Sin turno asignado",
    youCannotEditYourOwnVacations: "No puede editar sus propias vacaciones",
    calculationSequence: "Secuencia de cálculo",
    neutral: "Neutra",
    cannotExistMoreThanOneMaterialOrResourceWithTheSameCodeOrName:
        "No puede existir más de un material o recurso que comparta el mismo código o nombre",
    assessedPosition: "Cargo del evaluado",
    pleaseEnterNameDescriptionAndApplicationOfTheFunctionTheseDataWillReplaceTheOriginals:
        "Por favor, ingrese el nombre, la descripción y la aplicación de la función. Estos datos reemplazarán los originales.",
    noObjectiveTypesFound: "No se encontraron tipos de objetivos",
    cannotExistMoreThanOneUnionWithTheSameCodeOrName:
        "No puede existir más de un sindicato que comparta el mismo código o nombre",
    stepName: "Nombre del paso",
    costCenter2: "Centro de costo 2",
    queryDefinitionCreatedSuccessfully: "Definición de consulta creada con éxito",
    queryDefinitionExportedSuccessfully: "Definición de consulta exportada con éxito",
    queryDefinitionImportedSuccessfully: "Definición de consulta importada con éxito",
    queryDefinitionImplementedSuccessfully: "Definición de consulta implementada con éxito",
    generateWithAI: "Crear con IA",
    generateQueryWithAI: "Crear consulta con IA",
    promptHistory: "Historial de indicaciones",
    implementQuery: "Guardar consulta",
    testQuery: "Probar consulta",
    testQueryResults: "Resultados de prueba",
    summary: "Resumen",
    warnings: "Advertencias",
    minimumScores: "Calificaciones mínimas",
    youMustSelectASingleItem: "Debe seleccionar un único item",
    youMustSelectAPeriod: "Debe seleccionar un periodo",
    earningsAndDiscounts: "Haberes y descuentos",
    summaryDisplay: "Visualización de resumen",
    calculationIndicatorString: "Indicador de cálculo String",
    openDetailTable: "Abrir tabla detalle",
    permissionsForRequests: "Permisos para solicitudes",
    conceptsInputStructureImportedSuccessfully: "Estructura de ingreso de conceptos importada con éxito",
    enableEditorsForSystemTable: "Habilitar editores para tabla del sistema",
    activeCustomization: "Personalización activa",
    determineForSelectedCollaboratorsWhoWillBeTheirEvaluator:
        "Determine para los colaboradores seleccionados quien será su evaluador",
    entitlementDays: "Días de derecho",
    youMustSelectTypeFirst: "Debe seleccionar Tipo primero",
    newFormatTypeForPublications: "Nuevo tipo de formato para las publicaciones",
    locationAndOrganizationalData: "Ubicación y datos organizacionales",
    theNumericValueOfTheScoreMustBeLessThan10000: "El valor numérico de la calificación debe ser menor a 10000",
    unjustifiedAbsences: "Ausencias sin justificar",
    selectedPlural: "Seleccionados",
    itIsNotPossibleToDeleteStructuresBecauseTheyHaveEarningsOrDiscountsReportedInThem:
        "No es posible eliminar las estructuras porque tienen haberes o descuentos informados en ella",
    onePoorPerformance: "1 Desempeño pobre",
    availableForCollaborator: "Disponible para colaborador",
    npsVeryGood: "NPS muy bueno",
    workOrJob: "Obra o faena",
    payrollTypeName: "Nombre del tipo de nómina",
    weeklyContractHours: "Horas semanales contrato",
    selectFamilyAndSurveyTypeToStart: "Seleccione familia y tipo de encuesta para comenzar.",
    performancePtsFor9Boxes1: "Pts. Desempeño hasta para 9-Boxes 1",
    evaluatesCrossCompetencies: "Evalúa competencias transversales?",
    vitalSalary: "Salario vital",
    paidValue: "Valor pagado",
    itIsNotPossibleToDeleteTheRecordBecauseItIsInUse: "No es posible eliminar el registro porque está en uso",
    completionDate: "Fecha de finalización",
    formDesign: "Diseño del formulario",
    noteitemstatusfilter: "NoteItemStatusFilter",
    cannotExistMoreThanOneStudyTypeWithTheSameCodeOrName:
        "No puede existir más de un tipo de estudio que comparta el mismo código o nombre",
    projectString: "Proyecto String",
    shiftAssignmentDate: "Fecha asignación al turno",
    optional: "Optativo",
    aProcessWithTheSameCodeOrNameAlreadyExists: "Ya existe un proceso con el mismo código o nombre",
    nameScheduledTime: "Nombre del horario programado",
    regionalStructure: "Estructura regional",
    generateVoucherAndSendToCollaboratorForDigitalSignature:
        "Generar comprobante y enviar al colaborador para su firma digital",
    vacationTableXlsx: "Tabla de vacaciones.xlsx",
    returnDate: "Fecha de retorno",
    costCenter5: "Centro de costo 5",
    doYouWantToDeleteTheScheduleAlt: "¿Desea eliminar el horario?",
    calibrationGroup: "Grupo de calibración",
    nov: "Nov",
    itIsNotPossibleToSelectDifferentTypesOfEvaluationToAssignEvaluators:
        "No es posible seleccionar distintos tipos de evaluación para asignar evaluadores",
    extraHoursWorked: "Hrs Extras Realizadas",
    anExceptionForThisDayAlreadyExists: "Ya existe una excepción para este dia",
    descriptiveText: "Texto descriptivo",
    oneLimitedPotential: "1 Potencial limitado",
    valueUntilClock: "Valor hasta Clock",
    itIsNotPossibleToDeleteThePermissionBecauseItIsInUse: "No es posible eliminar el permiso porque está en uso",
    groupNumber: "Número del grupo",
    reasonsForPointDeliveryLong: "Motivos para la entrega de puntos",
    specialProcessDeletedSuccessfully: "Proceso especial eliminado con éxito",
    resizePositionsAndModify: "Redimensionar puestos y modificar",
    doYouWantToDeleteTheVacations: "¿Desea eliminar las vacaciones?",
    viewResult: "Ver resultado",
    cannotExistMoreThanOneConsentTypeWithTheSameCodeOrName:
        "No puede existir más de un tipo de consentimiento que comparta el mismo código o nombre",
    contractTypes: "Tipos de contratos",
    distribution: "Distribución",
    processStatusLong: "Estado del proceso",
    cannotEditTheCalendarBecauseItIsInHistoricalState:
        "No es posible editar el calendario porque se encuentra en estado histórico",
    collaboratorList: "Lista de colaboradores",
    visaStatus: "Status de visación",
    applicablePeriod: "Período aplicable",
    recognitions: "Reconocimientos",
    currentContract: "Contrato actual",
    referenceCodeString: "Código de referencia String",
    communicationStatus: "Estado de la comunicación",
    thisFieldHasAnAutomaticTableRelationshipThereforeTheDropdownListWillLoadAutomaticallyUnlessYouEnterYourOwnSqlForTheList:
        "Este campo tiene una relación automática entre tablas. Por ende, la lista desplegable se cargará en forma automática excepto que usted ingrese su propio SQL para la lista.",
    quadrantPositionYX: "Posición del cuadrante (Y,X)",
    calibratedPerformanceNumericScore: "Nota numérica desempeño calibrada",
    mustHaveScheduledStatus: "Debe tener estado Programado",
    periodForObjectives: "Período para objetivos",
    copyDataToReplicate: "Copiar datos para replicar",
    conceptType: "Tipo de concepto",
    specifyCompetencyScale: "Especifique la escala de competencias",
    viewSql: "SQL de visualización",
    doYouWantToDeleteHealthInstitution: "¿Desea eliminar la institución de salud?",
    commentsColon: "Comentarios:",
    studyTypeUpdatedSuccessfully: "Tipo de estudio actualizado con éxito",
    cannotDeleteGroupClassificationBecauseItIsInUse:
        "No es posible eliminar la clasificación de grupos porque está siendo utilizada",
    execute: "Ejecutar",
    mustSelectAtLeastOneRow: "Debe seleccionar al menos una fila",
    recordCreatedSuccessfully: "Registro creado con éxito",
    thePaymentOfTheIndicatedValueWillBeMadeInYourPayrollCalculation:
        "El pago del valor indicado se hará en tu cálculo de nómina",
    specifyCompetenciesToEvaluate: "Especifique las competencias a evaluar",
    project: "Proyecto",
    summaryAndCharts: "Resumen y gráficos",
    organizationObjectivesPoints: "Pond. objetivos organización",
    allergies: "Alergias",
    indexUpdatedSuccessfully: "Índice actualizado con éxito",
    numnone: "NumNone",
    collaboratorsWithInProgressStatus: "Colaboradores con estado en curso",
    scaleTypeCreation: "Creación de tipo de escala",
    holidaysAndFestiveDays: "Feriados y días festivos",
    absenceTypeIsMandatory: "El tipo de inasistencia es obligatorio",
    newStudyType: "Nuevo tipo de estudio",
    competencyDeletedSuccessfully: "Competencia eliminada con éxito",
    noPublicationChannelTypesFound: "No se encontraron tipos de canales para las publicaciones",
    assignmentDateToResponsible: "Fecha asignación responsable",
    scheduleDeletedSuccessfully: "Horario eliminado con éxito",
    doYouWantToDeleteTheEarnings: "¿Desea eliminar los haberes?",
    doYouWantToDeleteTheSpecialization: "¿Desea eliminar la especialización?",
    group09: "Grupo 09",
    deleteEarnings: "Eliminar haberes",
    goldMedals: "Medallas de oro",
    payrollCalculationProcesses: "De los procesos de cálculo de nómina",
    noThirdPartyClassificationsFound: "No se encontraron clasificaciones de terceros",
    permissionCreatedSuccessfully: "Permiso creado con éxito",
    allocationCreatedSuccessfully: "Imputación creada con éxito",
    entryDelayTolerance: "Tolerancia de atraso en la entrada",
    netShiftHours: "Horas netas del turno",
    licenseTypeString: "Tipo de licencia string",
    bronzeShields: "Escudos de bronce",
    listShort: "List",
    calibrationResponsible: "Responsable calibración",
    viewTypes: "Ver tipos",
    planIdentification: "Identificación del plan",
    allocationUpdatedSuccessfully: "Imputación actualizada con éxito",
    editHistoricalAccumulator: "Editar acumulador histórico",
    relativeCode: "Código de familiar",
    searchExcelFile: "Buscar archivo excel",
    cannotDeleteRecordBecauseThereArePaidInstallmentsInTheInstallmentDetailOnlyPrepaymentIsAllowed:
        "No es posible eliminar el registro porque ya existen cuotas pagadas en el detalle de cuotas. Solo se permite prepagarlo.",
    group01: "Grupo 01",
    clickOnTheChartsToViewDetails: "Haga clic en los gráficos para ver el detalle",
    doYouWantToDeleteCostCenter: "¿Desea eliminar el centro de costo?",
    pleaseEnterConceptCodeAndNameTheseDataWillReplaceTheOriginals:
        "Por favor, ingrese el código de concepto y nombre. Estos datos reemplazarán los originales.",
    entryHours: "Horas de entrada",
    someConceptCodesEnteredDoNotExistInTheDatabase:
        "Alguno de los códigos de concepto ingresados no existe en la base de datos.",
    cannotDeleteStudyTypeBecauseItIsInUse: "No es posible eliminar el tipo de estudio porque está en uso",
    descriptiveRatings: "Calificaciones descriptivas",
    payrollTypes: "Tipos de nómina",
    mustSelectARecordToReplicate: "Debe seleccionar un registro para replicar",
    calendarDeletedSuccessfully: "Calendario eliminado con éxito",
    mustBePositiveNumber: "Debe ser número positivo",
    classificationName: "Nombre de la clasificación",
    mustSelectNewStatus: "Debe seleccionar un nuevo estado",
    currentAccounts: "Cuentas corrientes",
    performanceAndTalentAnalyticsSettings: "De la analítica del desempeño y talento",
    messageBodyText: "Texto para cuerpo del mensaje",
    physicalCodeOfField: "Código físico del campo",
    changeShifts: "Cambiar turnos",
    personalData: "Datos personales",
    evaluationStartDate: "Fecha desde de evaluación",
    doYouWantToMarkSelectedRecordsAsObserved: "¿Desea marcar los registros seleccionados como observados?",
    negative: "Negativo",
    cannotDeleteJobClassificationBecauseItIsInUse:
        "No es posible eliminar la clasificación de cargo porque está en uso",
    benefitTypes: "Tipos de beneficios",
    payrollEnablement: "Habilitación en nóminas",
    editorForModificationOnly: "Editor solo para modificación",
    completeNodeNameAndCode: "Complete el nombre y código del nodo.",
    selectAnIncomeStructure: "Seleccione una estructura de ingreso",
    historicalAccumulatorUpdatedSuccessfully: "Acumulador histórico actualizado con éxito",
    receiptSentSuccessfully: "Recibo enviado con éxito",
    latitudeAndLongitude: "Latitud y longitud",
    relatedTableField: "Campo de la tabla relacionada",
    medicalLeaveTypes: "Tipos de licencia médica",
    unblockUser: "Desbloquear usuario",
    sqlStatements: "Sentencias de SQL",
    appearanceSequence: "Secuencia de aparición",
    mustSelectAnEmployee: "Debe seleccionar un empleado",
    valueBetween1And9999: "Valor entre 1 y 9999",
    calibratedCompetenciesRating: "Calificación calibrada competencias",
    toClassifyCommunicationYouMustBeTheResponsibleInChargeOfTheAttentionIfNecessaryAssignYourselfFirstAsTheResponsible:
        "Para clasificar la comunicación usted debe ser el responsable a cargo de la atención. Si lo requiere, asígnese primero como el responsable.",
    analyticalAccountingEntry: "Asiento contable analítico",
    enteredDescriptionWillBePartOfTheUploadedFileName:
        "La descripción que se ingresa formará parte del nombre del archivo que se carga",
    createAttendanceMark: "Crear marca de asistencia",
    editAttendanceMark: "Editar/completar marca de asistencia",
    enterReasonForDeletion: "Ingrese el motivo de la eliminación",
    valueFromYellow: "Valor desde Yellow",
    tableType: "Tipo de tabla",
    sqlForDropdownList: "SQL para lista desplegable",
    duplicateFunction: "Duplicar función",
    queryParameterDeletedSuccessfully: "Parámetro de consulta eliminado con éxito",
    valuesForDetail: "Valores para detalle",
    attentionResponsible: "Responsable de la atención",
    featuredNews: "Noticias destacadas",
    evaluateOrganizationObjectives: "Evalúa objetivos de la organización?",
    toGiveFeedbackTheEvaluatedScoreStateMustBeFinalScore:
        "Para poder dar feedback, el estado de la nota del evaluado debe ser 'Nota Final'",
    currentCollaboratorsToProcess: "Colaboradores actuales para procesar",
    onSpecificDate: "En fecha específica",
    adminAccessGroup: "Grupo para acceso de administradores",
    evaluatorComments: "Comentarios del evaluador",
    onboardingEndDate: "Fecha final del onboarding",
    doYouWantToDeleteThePreventionInstitution: "¿Desea eliminar la institución de previsión?",
    planUpdatedSuccessfully: "Plan actualizado con éxito",
    avatar: "Avatar",
    goalScale: "La escala de objetivos",
    cannotManageModificationOfOwnInformation: "No puede gestionar la modificación de su propia información",
    import: "Importar",
    personal: "Personales",
    grantedLoanValue: "Valor del préstamo otorgado",
    unionCreatedSuccessfully: "Sindicato creado con éxito",
    applicationStartDate: "Fecha desde de aplicación",
    verifyWeighted: "Verificar ponderados",
    toAccessBenefitsYouNeedToReviewAndAcceptTheConsentToUse:
        "Para el acceso a los beneficios, es necesario que revise y acepte el consentimiento de uso",
    fri: "Vie",
    system: "Sistema",
    fileName: "Nombre archivo",
    noteTypeName: "Nombre del tipo de nota",
    doYouWantToDeleteTheTemplate: "¿Desea eliminar la plantilla?",
    assignmentDate: "Fecha de asignación",
    employee: "Empleado",
    viewingRole: "Rol de visualización",
    quadrantClassification: "Clasificación cuadrante",
    indemnityForAllEvents: "Indemnización a todo evento",
    massiveJobChange: "Cambio masivo de cargo",
    cannotApproveProcessBecauseNoCollaboratorsWereProcessed:
        "No se puede aprobar el proceso porque no existen colaboradores procesados",
    values: "Valores",
    thirdPartyClassificationUpdatedSuccessfully: "Clasificación de terceros actualizada con éxito",
    incomeByConcept: "Ingreso por concepto",
    indexCreatedSuccessfully: "Índice creado con éxito",
    enterComment: "Ingrese comentario",
    inputUser: "Usuario de ingreso",
    formType: "Tipo de formulario",
    calibrationCommittee: "Comité de calibración",
    consentAlreadyAcceptedFinalDot: "Consentimiento ya aceptado.",
    incomeByConceptSet: "Ingreso por conjunto de conceptos",
    deleteGroupClassification: "Eliminar clasificación de grupo",
    descending: "Descendente",
    specialProcessCreatedSuccessfully: "Proceso especial creado con éxito",
    evaluationProcessUpdatedSuccessfully: "Proceso de evaluación actualizado con éxito",
    cannotDeleteUserWithSignedDocuments: "No puede borrar usuario que posea documentos firmados",
    newReminderDateForAlert: "Nueva fecha recordatoria para alerta",
    onDate: "En fecha",
    bankDistribution: "Distribución por banco",
    fieldStructure: "Estructura de campos",
    editPermission: "Editar permiso",
    imputation: "Imputación",
    processScheduleDeletedSuccessfully: "Programación de proceso eliminada con éxito",
    valuesDeletedSuccessfully: "Valores eliminados con éxito",
    specialProcessAlreadyAssociatedWithAnotherAlertOrNoticeAndWithSameExecutionModeItCannotBeAssociatedAgainWithSameExecutionMode:
        "El proceso especial ya está asociado a otra alerta o aviso y con el mismo modo de ejecución. No es posible asociarlo más de una vez con el mismo modo de ejecución.",
    holidaysAndFestiveDaysXlsx: "Feriados y días festivos.xlsx",
    forMassiveContractChangeYouMustSelectOnlyActiveCollaborators:
        "Para el cambio masivo de contratos debe seleccionar solo a colaboradores vigentes",
    forMassiveDivisionChangeYouMustSelectOnlyActiveCollaborators:
        "Para el cambio masivo de unidad de negocio debe seleccionar solo a colaboradores vigentes",
    forMassiveManagementCenterChangeYouMustSelectOnlyActiveCollaborators:
        "Para el cambio masivo de centro de publicación debe seleccionar solo a colaboradores vigentes",
    createIndex: "Crear índice",
    totalDaysToBeUsedInTheFuture: "Total de días por utilizar a futuro",
    noteTypeWithEnteredNameAlreadyExists: "Ya existe un tipo de nota con el nombre ingresado",
    cannotCreateParametersBecauseSpecialProcessIsAssociatedWithUserAlertOrNotice:
        "No es posible crear parámetros porque el proceso especial está asociado con una alerta o aviso del usuario",
    maxRatingsQty: "Qty. calificaciones máximas",
    vacationManagement: "Gestión de vacaciones",
    hasAssociatedValues: "Tiene valores asociados",
    noEvaluationsRegisteredYet: "Aún no se han registrado evaluaciones.",
    viewOnly: "Solo visualización",
    absenceType: "Tipo de inasistencia",
    evaluationPeriod: "Período de la evaluación",
    calendarWithSamePeriodAndCalendarTypeAlreadyExists:
        "Ya existe un calendario con el mismo periodo y tipo de calendario",
    competencyName: "Nombre de la competencia",
    alertsDeletedSuccessfully: "Alertas eliminadas éxito",
    finalPotentialNoteType: "Tipo nota final potencial",
    doYouWantToDeleteOrganizationalBenefit: "¿Desea eliminar el beneficio organizacional?",
    changeCostCentersOfManagement: "Cambiar centros de costo de gestión",
    mustSelectAnOption: "Debe seleccionar una opción",
    vacationsCreatedSuccessfully: "Vacaciones creadas con éxito",
    permissionTypeString: "Tipo de permiso string",
    verifyFirstLevelOfGeographicalOrganization: "Verifique el primer nivel de organización geográfica",
    attached: "Adjunto",
    photograph: "Fotografía",
    areYouSureYouWantToDeleteThePlan: "¿Esta seguro que desea eliminar el plan?",
    thirdParties: "Terceros",
    seniorityUntilYears: "Antigüedad hasta (Años)",
    back: "Volver",
    createKpiAndChartsForPayrollDashboard: "Creación de KPI y Gráficos para el Dashboard de Nómina",
    hoursAndMinutesHhmm: "Horas y Minutos (hhmm)",
    selectATimeCalendar: "Seleccione un calendario de tiempo",
    timePicker: "Hora con picker",
    structuresDeletedSuccessfully: "Estructuras eliminadas con éxito",
    pointsToObtain: "Puntos para obtenerlos",
    deleteShift: "Eliminar turno",
    observationsUpdatedSuccessfully: "Observaciones actualizadas con éxito",
    parameterOrderNumber: "Número de orden del parámetro",
    sub: "Sub",
    massiveLoadOfAccountingCostDistribution: "Carga masiva de la distribución contable de costos",
    deleteThirdPartyClassification: "Eliminar clasificación de terceros",
    newStep: "Nuevo paso",
    transfer: "Traspasar",
    customFormula: "Fórmula Personalizada",
    createConsentType: "Crear tipo de consentimiento",
    exportEmptyTemplate: "Exportar plantilla vacía",
    noFileTypesFound: "No se encontraron tipos de archivo",
    createStudyTypes: "Creación de tipos de estudios",
    selectAtleastOneCollaborator: "Debe seleccionar al menos un colaborador",
    createSkillBasedTraining: "Crear capacitación basada en competencias",
    incomeType: "Tipo de ingreso",
    deleteCalendar: "Eliminar calendario",
    ifYouChangeMomentOrActionTypeThereAreMaterialsOrResourcesLinkedToOnboardingStepThatDoNotMatchTheTypeOfMomentOrActionYouAreDefiningAndWillBeDeletedDoYouWantToProceedAnyway:
        "Si cambia el momento o tipo de acción, hay materiales o recursos vinculados al paso del Onboarding que no corresponden al tipo de momento o acción que está definiendo y serán eliminados. ¿Desea proceder de todos modos?",
    setPersonalObjectives: "Pond. objetivos personales",
    until: "Hasta",
    fileTypeDeletedSuccessfully: "Tipo de archivo eliminado con éxito",
    toAcceptOrObjectYourPerformanceEvaluationYouMustBeTheEvaluated:
        "Para aceptar u objetar tu evaluación del desempeño, debes ser el evaluado",
    ascendingEvaluation: "Evaluación ascendente",
    paymentMethodUpdatedSuccessfully: "Forma de pago actualizada con éxito",
    cannotHaveMoreThanOneHealthInstitutionSharingSameCodeOrName:
        "No puede existir más de una institución de salud que comparta el mismo código o nombre",
    massiveUpdateOfCostCentersFinishedSuccessfully:
        "La actualización masiva de los centros de costo ha finalizado con éxito",
    activeFemale: "Activa",
    authorizedExtraHours: "Hrs. Extras Autorizadas",
    editVacations: "Editar vacaciones",
    newSetOfConcepts: "Nuevo conjunto de conceptos",
    areYouSureYouWantToDeleteCollaboratorOnboardingProcess:
        "¿Está seguro que desea eliminar al colaborador el proceso de onboarding?",
    executionDayOfWeek: "Día de la semana de ejecución",
    onlyTransactionsWithStatusEnteredCanBeDeleted: "Solo es posible eliminar transacciones cuyo estado sea Ingresada",
    costCenterDeletedSuccessfully: "Centro de costo eliminado con éxito",
    evaluationAcceptedByEvaluated: "Evaluación aceptada por el evaluado",
    authorizedExtraHoursSuccessfully: "Horas extras autorizadas con éxito",
    entryTime: "Hora de ingreso",
    allFieldsAreRequiredAndNewGroupCannotBeInUse:
        "Todos los campos son obligatorios, y el grupo nuevo no puede estar en uso",
    requestedSalaryIncreaseJustificationDetail: "Detalle de la justificación del aumento solicitado",
    newActionType: "Nuevo tipo de acción",
    processPublished: "Proceso publicado",
    doYouWantToDeleteTheAccumulator: "¿Desea eliminar el acumulador?",
    departmentalStructure: "Estructura departamental",
    cannotDeleteThirdPartyClassificationBecauseItIsInUse:
        "No es posible eliminar la clasificación de terceros porque está en uso",
    noResponsibleAssigned: "Sin responsable asignado",
    authorizationAlreadyExistsForThisDay: "Ya existe una autorización para este día",
    sqlForContextManagement: "SQL para gestión del contexto",
    deleteStudyType: "Eliminar tipo de estudio",
    ofConcepts: "De los Conceptos",
    userTableEditors: "Editores de tablas de usuario",
    areYouSureYouWantToDeleteSelected9BoxesClassificationRecords:
        "¿Seguro que desea eliminar los registros de clasificación 9-Boxes seleccionados?",
    selectedFileIsNotPdfFormat: "El archivo seleccionado no tiene formato .pdf",
    totalLegalDeductions: "Total de descuentos legales",
    byDate: "Por fecha",
    myScheduledShifts: "Mis horarios programados",
    createCalculationReference: "Creación de referencia de cálculo",
    youMustSelectAtLeastOnePayroll: "Debe seleccionar al menos una nómina",
    publicationManagementCenters: "Centros de gestión de publicaciones",
    importFamilyGroupTemplate: "Importar plantilla de grupo familiar",
    jobId: "ID del cargo",
    startDiagrammingYourStructure: "Comienza a diagramar tu estructura!",
    calibratedPotentialRating: "Calificación calibrada potencial",
    tableName: "Nombre de la tabla",
    massUploads: "Cargas masivas",
    newGroupClassification: "Nueva clasificación de grupo",
    cannotDeleteClassificationTypeBecauseItIsInUse:
        "No es posible eliminar el tipo de clasificación porque está en uso",
    selectSpecialActionYouWantToExecute: "Seleccione la acción especial que desea ejecutar",
    available: "Disponible",
    othersCanContainUpTo3Decimals: "Otros puede contener hasta 3 decimales",
    fromTheSystem: "Del sistema",
    alertOrNoticeWithSameNameAndRecipientAlreadyExists:
        "Ya existe una alerta o aviso con el mismo nombre y destinatario que ha ingresado",
    acceptingTheEvaluationWillGenerateADocumentWithADigitalSignatureThatWillBeSavedInYourDigitalFolder:
        "Aceptando la evaluación emitirá un documento con firma digital que se guardará en su carpeta digital",
    cannotSelectYourself: "No puede seleccionarse a sí mismo",
    calculationCondition: "Condicional de cálculo",
    thousands: "Miles",
    onboardingProcessUpdatedSuccessfully: "Proceso de onboarding actualizado con éxito",
    cannotHaveMoreThanOneQuerySharingSameCodeOrName:
        "No puede existir más de una consulta que comparta el mismo código o nombre",
    accumulatorCode: "Código del acumulador",
    createProvision: "Creación de previsión",
    motivationalPotentialOfTheJobCanRangeFrom1To125: "El potencial motivador del cargo puede ir de 1 a 125.",
    reasonForDeletion: "Motivo de la eliminación",
    createClassificationTypes: "Creación de tipos de clasificaciones",
    youMustSelectAtLeastOneConcept: "Debe seleccionar al menos un concepto",
    cannotMoveBecauseTreeHeightExceedsLimit: "No se puede mover porque la altura del árbol excede el límite!",
    functionNameLong: "Nombre de función",
    realEstateAppraisalRole: "Rol avalúo bien raíz",
    createNewActionOrResponse: "Crear nueva acción o respuesta",
    cannotExistValuesWithSameTypeStartDateAndEndDate:
        "No pueden existir valores con el mismo Tipo, Fecha Desde y Fecha Hasta",
    assignCollaborators: "Asignar colaboradores",
    conceptInputStructure: "Estructura de ingreso conceptos",
    generalIndicesAndValues: "Índices y valores generales",
    costCenterDesc5: "Desc. Centro de costo 5",
    annotationsRegistration: "Registro en anotaciones",
    familyMemberTypes: "Tipos de familiares",
    doYouWantToDeleteTheFormatType: "¿Desea eliminar el tipo de formato?",
    familyMemberRecordDeletedSuccessfully: "Registro de familiar eliminado con éxito",
    error: "Error.",
    byAccountAndConcept: "Por cuenta y concepto",
    specifyObjectiveScale: "Especifique la escala de objetivos",
    calibrationComments: "Comentarios de la calibración",
    specialClassifications: "Clasificaciones especiales",
    weightedPeerEvaluation: "Ponderado evaluación de pares",
    functionWhenFinished: "Función al finalizar",
    youMustSelectASingleEmployee: "Debe seleccionar un único empleado",
    scheduledEntry: "Entrada programada",
    expectedEntry: "Entrada esperada",
    realEntry: "Entrada real",
    breakTime: "Tiempo del break",
    jobStructure: "Estructura de cargos",
    justificationCompletedSuccessfully: "Justificación realizada con éxito",
    bankAndBankAccountFieldsCannotBeEmpty: "Los campos Banco y Cuenta bancaria no pueden estar vacíos",
    massTerminations: "Desvinculaciones masivas",
    totalAssignedCollaborators: "Total colaboradores asignados",
    evaluationDate: "Fecha de la evaluación",
    deleteCostCenter: "Eliminar centro de costo",
    lastUpdateDate: "Fecha de última actualización",
    downloadR8DesktopVersion: "Descargar R8 versión escritorio",
    publicationChannelTypes: "Tipos de canales para las publicaciones",
    updateTime: "Hora de actualización",
    wasCalibrated: "Fue calibrada",
    shiftChangeCompletedSuccessfully: "Cambio de horario realizado con éxito",
    noCalibratedRecordsToUpdate: "No hay registros calibrados para actualizar",
    consentTypeString: "Tipo de consentimiento string",
    massShiftChanges: "Cambio de turnos masivo",
    massDivisionChanges: "Cambio de unidad de negocio masivo",
    managementCenterChanges: "Cambio de centro de publicación masivo",
    newConceptGroupAlt: "Nuevo grupo para concepto",
    licenseCode: "Código de licencia",
    areYouSureYouWantToGeneratePermissionReceiptAlreadyApprovedByYouThatMustBeDigitallySignedByTheCollaboratorAndAfterSignatureReceiptWillBeSentByEmail:
        "¿Está seguro que desea generar un comprobante de permisos ya aprobado por usted, y que deberá ser firmado digitalmente por el colaborador, para que luego de su firma reciba el comprobante por correo?",
    licenseType: "Tipo de licencia",
    evaluationPeriodShort: "Período de evaluación",
    massTerminationsCompletedSuccessfully: "Las desvinculaciones masivas ha finalizado con éxito",
    youSelectedTheHighestRatingJustifyWithYourCommentsPlease:
        "Ha seleccionado la mayor calificación, justifique con sus comentarios por favor",
    attendanceAnalysis: "Análisis de asistencia",
    calibration: "Calibración",
    evaluationProcessCreatedSuccessfully: "Proceso de evaluación creado con éxito",
    noOccupant: "(Sin ocupante)",
    selectedCollaborators: "Colaboradores seleccionados:",
    relatedTableDeletedSuccessfully: "Tabla relacionada eliminada con éxito",
    sqlRecipients: "SQL destinatarios",
    autocomplete: "Autocomplete",
    newOnboardingActionType: "Nuevo tipo de acción de onboarding",
    byObjective: "Por objetivo",
    completeFolder: "Carpeta completa",
    classificationCode: "Código de la clasificación",
    areYouSureYouWantToDeleteTheParameter: "¿Está seguro que desea eliminar el parámetro?",
    noActionTypesFound: "No se encontraron tipos de acción",
    recordModifiedSuccessfully: "Registro modificado con éxito",
    doYouWantToDeleteTheObjectiveType: "¿Desea eliminar el tipo de objetivo?",
    scheduledBreak: "Break programado",
    competence: "Competencia",
    planVisualization: "Visualización del plan",
    cannotEditYourOwnAbsences: "No puede editar sus propias inasistencias",
    userAlertsAndNotices: "Alertas y avisos del usuario",
    cannotExistMoreThanOneWorkplaceSharingSameCodeOrName:
        "No puede existir más de un lugar de trabajo que comparta el mismo código o nombre",
    cannotExceed23_59: "No puede superar las 23:59hs",
    massRehire: "Recontratación masiva",
    costCenterAssignmentDate: "Fecha asignación centro de costo",
    elementWithNodeCodeAlreadyExists: "Ya existe un elemento con el código del nodo!",
    doYouWantToRemoveObservationFromSelectedRecords: "¿Desea quitar la observación de los registros seleccionados?",
    processName: "Nombre de proceso",
    massDepartmentStructureChange: "Cambio masivo de estructura departamental",
    codeAlt: "Codigo",
    ascendingEvaluator: "Evaluador ascendente",
    midnight: "0:00",
    saveStep: "Guardar paso",
    moveToNewDate: "Mover a nueva fecha",
    noDocumentTemplatesFound: "No se encontraron plantillas para documentos",
    descendingEvaluation: "Evaluación descendente",
    daysWithScheduleChange: "Días con cambio de horario",
    participation: "Participación",
    addCollaborator: "Agregar colaborador",
    conditionalConcept3: "Concepto condicional 3",
    familyTypeString: "Tipo de familiar string",
    cannotRunSameCalculationProcess2OrMoreTimesAtOnceTheSelectedCalculationProcessIsCurrentlyRunning:
        "No es posible ejecutar el mismo proceso de cálculo 2 o más veces a la vez. El proceso de cálculo seleccionado está actualmente en ejecución.",
    workgroup: "Grupo de trabajo",
    sep: "Sep",
    dropdownList: "Lista desplegable",
    doYouWantToDeleteOnboardingStepForProfile: "¿Desea eliminar el paso del onboarding para el perfil?",
    jobSpecificCompetencies: "Competencias específicas del cargo",
    myPersonal: "Mi PERSONAL",
    totalUsed: "Total utilizadas",
    addCompetencies: "Agregar competencias",
    recompositionOfHistoricalAccumulators: "Recomposición de acumuladores históricos",
    evaluatedCode: "Código del evaluado",
    published: "Publicado",
    doYouWantToDeleteFileType: "¿Desea eliminar el tipo de archivo?",
    noteStatus: "Estado de la nota",
    veryNegative: "Muy Negativa",
    evaluatePersonalObjectivesQuestionMark: "Evalúa objetivos personales?",
    aScheduleWithTheseDataAlreadyExists: "Ya existe una programación con esos datos",
    valueOfEachPoint: "Valor de cada punto",
    promoters: "Promotores",
    importLicenses: "Importar licencias",
    areYouSureYouWantToDelete: "¿Está seguro que desea eliminar?",
    totalTaxableWages: "Total de haberes Imponibles",
    oneOfTheEnteredCollaboratorsIsAlreadyAssociatedWithTheProcess:
        "Uno de los colaboradores ingresados ya está asociado al proceso",
    legalDaysMustBeGreaterThanZero: "Los días legales deben ser mayor a cero",
    paid: "Pagada",
    personalObjective2: "Objetivo personal 2",
    deleteImage: "Delete Image",
    timeCalendar: "Calendario de tiempos",
    creationOfWagesAndDeductions: "Creación de haberes y descuentos",
    periodName: "Nombre del período",
    enus: "en-US",
    evaluationNotes: "Notas para evaluaciones",
    fileDescriptionText: "Texto descriptivo del archivo",
    hoursToJustify: "Horas a justificar",
    legalAndOtherBalance: "Saldo (legales y otros)",
    health: "Salud",
    totalCompanyCost: "Total costo empresa",
    generalCommentsFromEvaluatorOrCalibrationCommittee:
        "Comentarios generales del evaluador o del Comité de calibración",
    parameterDuplicatedSuccessfully: "Parámetro duplicado con éxito",
    upTo500CollaboratorsCanBeSelected: "Se pueden seleccionar como máximo 500 colaboradores",
    doYouWantToDeleteTheAbsence: "¿Desea eliminar la inasistencia?",
    jan: "Ene",
    seniorityInYears: "Antigüedad desde (Años)",
    aug: "Ago",
    cannotDeleteSelectedStructuresBecauseTheyAreInUse:
        "No es posible eliminar las estructuras seleccionadas porque están en uso",
    competenceDuplicatedSuccessfully: "Competencia duplicada con éxito",
    duplicateQuestion: "Pregunta duplicada",
    additionalOrProgressiveUsedDays: "Días utilizados (adicionales o progresivos)",
    costDistributionXlsx: "Distribucion de costos.xlsx",
    attention: "Atención",
    createPermission: "Crear permiso",
    collaboratorsWithPlannedStatus: "Colaboradores con estado planificado",
    class: "Clase",
    noCompetenciesForThisGroup: "No hay competencias disponibles",
    transversalCompetency: "Transversales",
    transversalSingularCompetency: "Transversal",
    specificSingularCompetency: "Específica",
    specificCompetency: "Específicas",
    noCompetenciesForThisPosition: "No hay competencias para este cargo",
    noCompetenciesAddedYet: "No hay competencias agregadas.",
    viewCompetenciesForThisPosition: "Ver competencias en su cargo",
    createCompetencyWarning:
        'Si el tipo de competencia es transversal, se auto asignará "Transversales" en el campo "Grupo de competencias"',
    noCompetenciesAdded: "No hay competencias agregadas",
    selectedRecordMustBeInState: "El registro seleccionado debe estar en estado ",
    noRecipientFoundForYourRequestItCannotBeSentReportThisToHumanResources:
        "No se encontró a ningún receptor para la atención de su solicitud. La misma no puede enviarse. Informe sobre esta situación a Recursos Humanos",
    cannotDeleteOnboardingStageProfileBecauseItIsInUse:
        "No es posible eliminar el perfil de etapas de onboarding porque está en uso",
    cannotDeleteYourOwnVacations: "No puede eliminar sus propias vacaciones",
    areYouSureYouWantToRunTheProcess: "¿Está seguro que desea ejecutar el proceso?",
    resolved: "Resuelta",
    newConcept: "Nuevo concepto",
    evaluatePotential: "Evalúa potencial",
    generateUsageCertificate: "Generar comprobante de uso",
    cannotHaveMoreThanOneReasonSharingSameCodeOrName:
        "No puede existir más de un motivo que comparta el mismo código o nombre",
    benefitTypeCreatedSuccessfully: "Tipo de beneficio creado con éxito",
    massContractChange: "Cambio masivo de contratos",
    cannotAssignPositionBecauseNoVacancies: "No es posible asignar el Cargo ingresado porque no tiene puestos libres",
    addWithDataReplica: "Agregar con replica de datos",
    parameterListSelectorType: "Tipo de selector para lista de parámetros",
    mustSelectAtLeastOneRecord: "Debe seleccionar al menos un registro",
    mustSelectAtLeastOneSpecificRecord: "Debe seleccionar al menos un registro de tipo específico",
    scheduledTimeForToday: "Horario programado para hoy",
    currentStartDate: "Fecha de inicio en curso",
    totalCompanyCostWithCorporateBenefits: "Total costo empresa con beneficios corporativos",
    studyTypes: "Tipos de estudio",
    responsibleAssignmentTime: "Hora asignación responsable",
    areYouSureYouDoNotAuthorizeAnyOvertime00_00: "¿Está seguro que no autoriza ninguna hora extra (00:00)?",
    cannotDeleteVacationsBecauseTheyAreInUse: "No es posible eliminar las vacaciones porque están en uso",
    fromCommunicationChannel: "Del canal de comunicaciones",
    fromDataAnalytics: "De analísis de datos",
    SHOW_IA_QUERIES: "Activar consultas IA",
    groupAppearanceSequence: "Secuencia de aparición del grupo",
    publicationDeletedSuccessfully: "Publicación eliminada con éxito",
    cannotDeletePostingBecauseItIsInUse: "No es posible eliminar la imputación porque está en uso",
    indexWithSamePeriodAlreadyExists: "Ya existe un indice con el mismo período",
    search: "Buscar",
    deleteSchedule: "Eliminar horario",
    mustSelectRecipient: "Debe seleccionar un destinatario",
    municipalPatentRole: "Rol patente municipal",
    riskCenter: "Centro de riesgo",
    establishmentCode: "Código de establecimiento",
    establishmentType: "Tipo de establecimiento",
    calibratedClassification: "Clasificación calibrada",
    totalPending: "Total pendientes",
    totalOverdue: "Total vencidas",
    totalTruncated: "Total truncas",
    paymentDateWillBeDeterminedByHR: "* La fecha de pago será determinada por Gestión de Personas",
    cannotDeletePeriodBecauseItIsInUse: "No es posible eliminar el período porque está en uso",
    objectiveRatingScale: "Escala calificación objetivos",
    noHiringDateRegistered: "Sin fecha de contratación registrada",
    absenceCreatedSuccessfully: "Inasistencia creada con éxito",
    planDetail: "Detalle del plan",
    userName: "Nombre del usuario",
    authorizedOvertimes: "Extras autorizadas",
    doYouWantToDeleteFeedbackPurpose: "¿Desea eliminar el propósito de feedback?",
    hiringReason: "Motivo de contratación",
    allFieldsAreRequired: "Todos los campos son obligatorios",
    doYouWantToDeletePosting: "¿Desea eliminar las imputaciones?",
    alertOrNoticeCode: "Código de Alerta o Aviso",
    viewIndicators: "Ver competencias para el grupo",
    viewIndicatorsPosition: "Ver competencias para el cargo",
    yourObjectiveRating: "Su calificación en objetivos",
    postingDeletedSuccessfully: "Imputación eliminada con éxito",
    internalRecordCode: "Código interno del registro",
    startDiagrammingYourOrganizationalChart: "Comienza a diagramar tu organigrama!",
    doYouWantToDeleteFamilyAssignment: "¿Desea eliminar la asignación familiar?",
    thisProcessTypeCannotBePublishedBecauseItIsSpecialOrSimulationProcess:
        "Este tipo de proceso no es posible publicarlo porque es un proceso especial o de simulación",
    evaluatesTransversalCompetencies: "Evalúa comp. transversales",
    doYouWantToDeleteFieldDefinitionFromTable: "¿Desea eliminar la definición de campo de la tabla?",
    totalReservedForFutureUse: "Total reservadas para uso a futuro",
    cannotHaveMoreThanOneDefinitionWithSameSourceTableAndField:
        "No puede haber más de una definición con la misma tabla origen y campo origen",
    maximum: "Máximo",
    selectedRecordCannotBeDeleted: "El registro seleccionado no se puede eliminar",
    nameCode: "Name",
    documentPublications: "Publicaciones de documentos",
    benefitRequestProcessedSuccessfully: "La solicitud del beneficio se ha procesado con éxito",
    mustSelectAtLeastOneImage: "Debe seleccionar al menos una imagen",
    calibratedPerformanceFinalGrade: "Nota final desempeño calibrada",
    relatedTable: "Tabla relacionada",
    mustSelectAtLeastOnePerformanceEvaluation: "Debe seleccionar al menos una evaluación del desempeño",
    processDuration: "Duración del proceso",
    forNpsSurveyTypeOnly1QuestionWithOptionsCanBeCreatedContainingOptionsFrom1To10:
        "Para un tipo de encuesta NPS solo es posible crear 1 pregunta con opciones (La cual debe contener las opciones de 1 a 10)",
    indicatorCreatedSuccessfully: "Indicador creado con éxito",
    onaOption: "Grupo de personas",
    onaSurveyTypeError:
        "Para un tipo de encuesta ONA, solo es posible crear preguntas de opción múltiple con un mínimo de 3 opciones y un máximo de 10 opciones",
    areYouSureYouWantToDeleteQueryDefinition: "¿Está seguro que desea eliminar la definición de consulta?",
    alertOrNoticeOrigin: "Origen de Alerta o Aviso",
    attendanceMarkCreatedSuccessfully: "Marca de asistencia creada con éxito",
    cannotHaveMoreThanOneCalculationReferenceSharingSameCodeOrName:
        "No puede existir más de una referencia de cálculo que comparta el mismo código o nombre",
    weightedObjectives: "Ponderados objetivos",
    deleteSpecialization: "Eliminar especialización",
    classificationTypeDeletedSuccessfully: "Tipo de clasificación eliminada con éxito",
    reasonCreation: "Creación de motivo",
    doYouWantToDeleteSelectedRows: "¿Desea eliminar las filas seleccionadas?",
    mydesktop: "MyDesktop",
    executionStartDate: "Fecha de ejecucion desde",
    entryDate: "Fecha de entrada",
    mustSelectOnlyOneConcept: "Debe seleccionar un único concepto",
    generalValuesXlsx: "Valores generales.xlsx",
    toCreateAnActionOrResponseYouMustBeResponsibleForTheAttentionIfRequiredAssignYourselfAsTheResponsibleFirst:
        "Para crear una acción o respuesta usted debe ser el responsable a cargo de la atención. Si lo requiere, asígnese primero como el responsable.",
    activeStatus: "Estado: Activo",
    canReceiveRequestsAffirm: "Puede recibir solicitudes",
    ctrlfToSearchTextWithinTrace: "Ctrl+F para buscar texto dentro del Trace",
    paymentDate: "Fecha de pago",
    sexString: "Sexo string",
    surveyComparison: "Comparación de encuestas",
    doYouWantToDeleteActionType: "¿Desea eliminar el tipo de acción?",
    authorizedOvertimeHours: "Horas extras que autoriza",
    cannotDeleteFamilyAssignmentBecauseItIsInUse: "No es posible eliminar la asignación familiar porque está en uso",
    generateFieldNamesForQueries: "Generar nombres de campos para consultas",
    onboardingProfileUpdatedSuccessfully: "Perfil de onboarding actualizado con éxito",
    onboardingStatus: "Estado en el onboarding",
    formDesignName: "Nombre diseño del formulario",
    saveAlt: "Save",
    delegationCreation: "Creación de delegación",
    unions: "Sindicatos",
    loanTypeAlt: "Tipo de préstamo",
    viewUnpostedConcepts: "Ver conceptos sin imputación",
    sourceFieldName: "Nombre del campo origen",
    whatsappTemplates: "Plantillas de WhatsApp",
    workplaceAlt: "Lugar de trabajo",
    authorizedOvertimeHoursLong: "Horas extras autorizadas",
    noProjectsFound: "No se encontraron proyectos",
    incomeStructure: "Estructura de ingreso",
    publicationUpdatedSuccessfully: "Publicación actualizada con éxito",
    statusTranslated: "Estado",
    doubleClickInBlankSpaceToCreateAuthorizationForOvertime:
        "Haga doble click en espacio en blanco para crear autorización sobre estas horas extra",
    quadrantFeatures: "Características del cuadrante",
    acceptScheduleChangeRequest: "¿Acepta la solicitud de cambio de horario?",
    canOnlyDeleteRecordWhen: "Solo es posible eliminar el registro cuando",
    evaluatorSelectionWithFreeSelection: "Elección de evaluadores con selección libre",
    ufOfTheDay9: "UF del día 9",
    evaluatorPosition: "Cargo del evaluador",
    updateCompletedSuccessfully: "Actualización realizada con éxito",
    valueUntilIcon2: "Valor hasta Icono 2",
    referenceColumnNumbers: "Nros columnas referencia",
    accessMode: "Modo de acceso",
    createConceptGroup: "Creación de grupo para conceptos",
    evaluationsByObjectiveDifferences: "Evaluaciones por objetivo (diferencias)",
    deleteFileType: "Eliminar tipo de archivo",
    cannotDeleteScheduleBecauseItIsInUse: "No es posible eliminar la programación porque está en uso",
    planned: "Planificado",
    edit9boxClassification: "Editar clasificación 9-box",
    globalAveragesOfEvaluationsByGradeType: "Promedios globales de evaluaciones por tipo de nota",
    definitionOfSpecialProcesses: "Definición de procesos especiales",
    oct: "Oct",
    columnSelectorTypes: "Tipos de Selectores por columnas",
    cannotDeleteThirdPartyBecauseItIsInUse: "No es posible eliminar al tercero porque está en uso",
    cannotSelectSelfEvaluationToAssignEvaluatorsBecauseEvaluatorWillBeTheCollaborator:
        "No es posible seleccionar una autoevaluación para asignar evaluadores porque el evaluador será el propio colaborador",
    scheduleWithSameCodeOrNameAlreadyExists: "Ya existe un horario con el mismo código o nombre",
    quadrantName: "Nombre del cuadrante",
    amount: "Importe",
    survey: "Encuesta",
    approvedRequestRememberToSaveChanges: "Solicitud aprobada, recuerde guardar los cambios",
    onboardingStartDate: "Fecha inicio del onboarding",
    kpiDefinitionCreatedSuccessfully: "Definición de KPI creada con éxito",
    newMedicalLeaveType: "Nuevo tipo de licencia médica",
    selectedCompetenciesMustBeSpecificType: "Las competencias seleccionadas deben ser de tipo Específica",
    feedbackDate: "Fecha del feedback",
    exportTemplateForImport: "Exportar plantilla para importación",
    motivatorPotential1To125: "Potencial motivador (1 a 125)",
    decimals0To5: "Decimales (0 a 5)",
    performanceFormCreatedSuccessfully: "Formulario de desempeño creado con éxito",
    assignToOnboardingProcess: "Asignar a proceso de onboarding",
    planWithSameCodeAndNameAlreadyExists: "Ya existe un plan con el mismo código y nombre",
    mustSelectAtLeastOneRole: "Debe seleccionar al menos un rol",
    doYouWantToDeleteMedicalLeaveType: "¿Desea eliminar el tipo de licencia médica?",
    performanceEvaluationProcessStart: "Inicio del proceso de calificación del desempeño",
    hasRequestWithPendingDocumentationForApprovalInProcess:
        "Tiene una solicitud con documentación pendiente de aprobación en trámite",
    bulkFileUploadInDigitalFolder: "Carga masiva de archivos en carpeta digital",
    setName: "Nombre del conjunto",
    mustCompleteAllValues: "Debe completar todos los valores",
    dom: "Dom",
    before: "Antes",
    inactiveEditor: "Editor inactivo",
    informativeGraphics: "Gráficos informativos",
    entryHelp: "Ayuda para el ingreso",
    viewEntryHelp: "Ver ayuda para el ingreso",
    viewGaussBell: "Ver campana de Gauss",
    gaussBell: "Campana de Gauss",
    noGroupClassificationsFound: "No se encontraron clasificaciones de grupo",
    kpiDescriptionText: "Texto descriptivo de KPI",
    bronzeMedals: "Medallas de bronce",
    usesConfetti: "Utiliza confetti",
    sqlForLevel2GraphicsTitleOptional: "SQL para titulo de Gráficos Nivel 2 (Optativo)",
    doYouWantToDeleteConsent: "¿Desea eliminar el consentimiento?",
    channelTypeIsInUseInApplicantMaster: "El tipo de canal está en uso en el Maestro de postulantes",
    highlightByTags: "Resaltar por etiquetas",
    gridTableMenuOrAssociatedQuery: "Grilla, tabla, menú o consulta asociada",
    jobGroup: "Grupo de cargos",
    employeeCodeChange: "Cambio de código de empleado",
    veryPositive: "Muy Positiva",
    newInstallmentIncome: "Nuevo ingreso en cuotas",
    enteredValueCannotBeGreaterThanTotalOvertime: "El valor ingresado no puede ser mayor al total de horas extra",
    youCanSelectEvaluatorFreely: "Podrás seleccionar libremente al evaluador.",
    conceptUpdatedSuccessfully: "Concepto actualizado con éxito",
    performanceGood2: "2 Desempeño bueno",
    notification: "Notificación",
    newCalculationReference: "Nueva referencia de cálculo",
    legalVacationsAndOthers: "Vacaciones legales y otros",
    toBeUsedInTheFutureLegalAndOthers: "Por utilizar a futuro (legales y otros)",
    sourceField: "Campo origen",
    workplaceDeletedSuccessfully: "Lugar de trabajo eliminado con éxito",
    bankString: "Banco String",
    millions: "Millones",
    euro: "Euro",
    companyCost: "Costo empresa",
    prepay: "Prepagar",
    extraHoursToAuthorize: "Horas extra realizadas por autorizar",
    locationGroup: "Grupo de ubicación",
    documentationType: "Tipo de documentación",
    communicationAssignedToAnotherEmployer: "La comunicación ya está asignada a otro empleador",
    noSpecializationsFound: "No se encontraron especializaciones",
    cannotEditThisRecordBecauseNoEditPermission: "No puede editar este registro porque no tiene permiso de edición",
    genericReference1: "Referencia genérica 1",
    massiveFamilyGroupUpload: "Carga masiva de grupo familiar",
    costCenterDesc: "Desc. Centro de costo",
    conceptInUseInOtherTables: "El concepto está en uso por otras tablas.",
    incomeStructuresOfConcepts: "Estructuras de ingreso de conceptos",
    massiveHolidaysAndFestiveDaysDuplication: "Duplicar feriados y días festivos de forma masiva",
    cannotDeleteClassificationBecauseInUse: "No es posible eliminar la clasificación porque está en uso",
    totalExtras: "Total extras",
    familyAllowanceCreatedSuccessfully: "Asignación familiar creada con éxito",
    jobGroupsForEvaluations: "Grupos de cargos para evaluaciones",
    approvingProcessAndPassingItToHistoryMeansNoRecalculations:
        "Aprobar un proceso y pasarlo al histórico significa que ya no podrá realizar recálculos ni alterar sus valores.",
    positionAssignmentDateAlt: "Fecha asignación al cargo",
    timeDefinition: "Definición de tiempos",
    recomposePositions: "Recomponer puestos",
    collaboratorsInPlans: "Colaboradores en planes",
    cannotHaveValuesWithSameTypeSeniorityFromAndUntil:
        "No pueden existir valores con el mismo Tipo, Antigüedad Desde y Antigüedad Hasta",
    standardPerformanceNumericScore: "Nota numérica desempeño estándar",
    organizationChartPdf: "Organigrama.pdf",
    duplicateHolidaysAndFestiveDays: "Duplicar feriados y días festivos",
    programmingStatus: "Estado de programación",
    projectsAndWorks: "Obras y Faenas",
    specificCompensationWeights: "Pond. comp. específicas",
    absenceHours: "Horas ausencia",
    anotherNodeWithSameCodeExists: "Existe otro nodo con el mismo código.",
    loans: "Préstamos",
    cannotHaveMoreThanOneShiftWithSameCodeOrName:
        "No puede existir más de un turno que comparta el mismo código o nombre",
    cannotEditOwnPermissions: "No puede editar sus propios permisos",
    view: "Ver",
    executionTime: "Hora de ejecución",
    mustSelectACalendar: "Debe seleccionar un calendario",
    deleteReason: "Eliminar motivo",
    unionCreation: "Creación de sindicatos",
    potential: "Potencial",
    numericEdit: "Edit numérico",
    icon2MinimumValue: "icon2MinimumValue",
    removeObservationFromReviewedRecords: "Quitar observación de los registros (Ya fueron revisados)",
    reset: "Resetear",
    onboardingProfileCreatedSuccessfully: "Perfil de onboarding creado con éxito",
    newPaymentMethod: "Nueva forma de pago",
    compensation: "Remuneracion",
    habAndDescConceptsSetXlsx: "Hab. y Desc. - Conjunto de conceptos.xlsx",
    functionOnStart: "Función al iniciar",
    processApprovalSavesDataInHistoryForFutureQueriesAndUpdatesCalculations:
        "La probación del proceso guardará todos los datos en los históricos para posteriores consultas y actualizará los acumuladores que son fundamentales para los procesos de cálculo siguientes. Un proceso en estado histórico solo le permitirá: Consultar los resultados del proceso, acceder al tablero de indicadores del mismo y emitir recibos o comprobantes, pero NO permtirá realizar recálculos.",
    noOnboardingActionTypesFound: "No se encontraron tipos de acción de onboarding",
    cannotHaveFunctionsWithSameName: "No pueden existir funciones con el mismo nombre",
    functionDefinition: "Definición de funciones",
    duplicatePayrollType: "Duplicar tipo de nómina",
    fromAlt: "Desde",
    specializationCreation: "Creación de especializaciones",
    evaluatedFunction: "Función del evaluado",
    treeStructure: "Estructura en forma de árbol",
    activeEditor: "Editor activo",
    standardPotentialFinalScore: "Nota final potencial estándar",
    toDefinePaymentConceptLinkedToBenefitValueOfBenefitMustBeGreaterThanZero:
        "Para definir un concepto de pago remunerativo asociado al beneficio, el valor del beneficio debe ser mayor a cero",
    executionDateUntil: "Fecha de ejecucion hasta",
    canReceiveRequestsQuestionMarks: "¿Puede recibir solicitudes?",
    groupClassificationCreation: "Creación de clasificación de grupo",
    licenseCreatedSuccessfully: "Licencia creada con éxito",
    minimumWage: "Salario mínimo",
    alphanumericNotEligibleAsMarker: "Alfanumérico y no elegible como marcador",
    familyAllowanceDeletedSuccessfully: "Asignación familiar eliminada con éxito",
    cannotDeleteConceptSetBecauseInUse: "No se puede eliminar el conjunto de conceptos por estar en uso",
    esES: "es-ES",
    addAtLeastOneStep: "Agregue al menos un paso",
    consentReceived: "Consentimiento recepcionado",
    canOnlyRequestEvaluatorsWithPendingPerformanceState:
        "Solo se puede solicitar a los evaluadores que realicen las calificaciones del desempeño cuando el estado de la misma sea Pendiente",
    ranking: "Ranking",
    costCenterCreation: "Creación de centro de costo",
    toCreateCollaboratorsOrDeleteThemProcessMustBeOpen:
        "Para crear colaboradores en el proceso o bien eliminarlos, primero debe cambiar el estado del proceso de “Cerrado” a “Abierto”",
    assignedToResponsible: "Asignada a un responsable",
    dataGridSortingFields: "Campos para orden de datos en grilla",
    occupiedPositions: "Puestos ocupados",
    conceptDuplicatedSuccessfully: "Concepto duplicado con éxito",
    numericScore: "Nota numérica",
    formEvaluatorType: "Evaluador del tipo de formulario",
    application: "Aplicación",
    geoanalysisQueryDefinitionModifiedSuccessfully: "Definición de consulta para geoanálisis modificada con éxito",
    acceptOrObjectEvaluation: "Aceptar u objetar evaluación",
    thankYouForAcceptingConsent: "Muchas gracias por aceptar el consentimiento",
    noQueryAssociatedWithThisProcess: "No existe una consulta asociada a este proceso",
    periodCreatedSuccessfully: "Período creado con éxito",
    weightedSumMustBe100: "La suma de los ponderados debe ser 100",
    destinationCodeField: "Campo código destino",
    wantToDeleteProcessSchedule: "¿Desea eliminar la programación del proceso?",
    inFeedback: "En Feedback",
    unionUpdatedSuccessfully: "Sindicato actualizado con éxito",
    competenciesWeighted: "Ponderado competencias",
    queryCode: "Código de consulta",
    specificEmails: "Emails específicos",
    loanUpdatedSuccessfully: "Prestamo actualizado con éxito",
    dailyContractHours: "Horas diarias contrato",
    forMassTerminationsYouMustSelectOnlyActiveCollaborators:
        "Para las desvinculaciones masivas debe seleccionar solo a colaboradores vigentes",
    templateCreation: "Creación de plantilla",
    calendarCreatedSuccessfully: "Calendario creado con éxito",
    publicationDateFrom: "Fecha desde publicación",
    costCenterString: "Centro de costo String",
    cannotCalibrateCompetencyIndicatorBecauseItDoesNotCorrespondToEvaluation:
        "No se permite calibrar el indicador de la competencia porque no corresponde a su evaluación",
    objectivesByEvaluation: "Objetivos por evaluación",
    extraHoursAuthorizationXlsx: "Autorizacion de horas extras.xlsx",
    cannotExistMoreThanOnePaymentMethodWithSameCodeOrName:
        "No puede existir más de una forma de pago que comparta el mismo código o nombre",
    inProgress: "En progreso",
    competenciesVsObjectivesRatings: "Calificaciones de competencias vs. objetivos",
    jobGroupForEvaluationCreatedSuccessfully: "Grupo de cargo para evaluación creado con éxito",
    weightedScores: "Ponderados",
    newPermissionType: "Nuevo tipo de permiso",
    userMenuDefinition: "Definición de menús de usuario",
    evaluation: "Evaluación",
    bronzeShield: "Escudo de bronce",
    periodUpdatedSuccessfully: "Período modificado con éxito",
    free: "Libres",
    superiorPosition: "Cargo superior",
    employeeType: "Tipo de funcionario",
    geoanalysisQueriesDefinition: "Definición de consultas para geonálisis",
    corporateBenefitsTotalCorporateBenefits: "Total de beneficios corporativos (Beneficios empresariales)",
    departmentCode: "Código de departamento",
    groupEditedSuccessfully: "Grupo editado con éxito",
    recordDeletedSuccessfully: "Registro eliminado con éxito",
    dateType: "Date",
    errorEditingNodeOccurred: "Ocurrió un error editando el nodo.",
    peerEvaluation: "Evaluación De pares",
    initialLoadTime: "Hora de carga inicial",
    planMaximumBudget: "Presupuesto máximo del plan",
    noModifiedDataToSave: "No hay datos modificados para guardar",
    toDefineAccessModeWithFreeDispositionCannotHavePointsOrAuthorizedAbsenceDaysOrRelatedPaymentConcept:
        "Para definir modo de acceso con libre disposición no puede tener puntos, ni días de ausencia autorizados ni concepto de pago relacionado",
    descendantEvaluator: "Evaluador descendiente",
    missing: "Faltante",
    forFinalResultOfPerformanceEvaluation: "Para el resultado final de la evaluación del desempeño",
    cannotHaveGroupsWithSameName: "No pueden existir grupos con el mismo nombre",
    earnedDays: "Días ganados",
    costCenter4: "Centro de costo 4",
    variableCodesContainsCalculationProcessCodesToBeDeleted:
        "La variable #CODES# contiene los códigos de procesos de cálculo que se eliminaran",
    normal: "Normal",
    withDigitalSignature: "Con firma digital",
    classification: "Clasificación",
    specializationUpdatedSuccessfully: "Especialización actualizada con éxito",
    selectedRecordCannotBeEdited: "El registro seleccionado no se puede editar",
    group12: "Grupo 12",
    attendanceAnalysisSheet: "Planilla de análisis de asistencia",
    changeProjectOrWork: "Cambiar obra o faena",
    finalPotentialScoreAlternative: "Nota final potencial",
    hasPendingPinRecoveryInProcess: "Ya tiene una recuperación de su PIN en trámite.",
    objectivesWeighted: "Ponderado de objetivos",
    thirdPartyCreation: "Creación de terceros",
    consentTypeCreation: "Creación de tipo de consentimiento",
    globalPerformanceAverage: "Promedio global desempeño",
    finalSummary: "Resumen final",
    newWorkplace: "Nuevo lugar de trabajo",
    valueUntilIcon1: "Valor hasta Icono 1",
    noWorkplacesFound: "No se encontraron lugares de trabajo",
    jobGroupsForEvaluationsCreation: "Creación de grupos de cargos para evaluaciones",
    performancePointsUntilFor9Boxes3: "Pts. Desempeño hasta para 9-Boxes 3",
    talentClassification9boxes: "De la clasificación del talento (9-Boxes)",
    requiresBank: "Requiere banco",
    seat: "Asiento",
    pending: "Pendiente",
    contractor: "Contratista",
    goldMedal: "Medalla de oro",
    historicalCostDistribution: "Distribución de costos histórica",
    jobClassificationCreatedSuccessfully: "Clasificación de cargo creada con éxito",
    templateCreatedSuccessfully: "Plantilla creada con éxito",
    highlightPositionsWithVacancies: "Resaltar puestos con vacantes",
    loanInstallments: "Cuotas de Préstamos",
    workplaceCreatedSuccessfully: "Lugar de trabajo creado con éxito",
    createPeriodForObjectives: "Crear período para objetivos",
    reference1: "Referencia 1",
    valueFromClock: "Valor desde Clock",
    competenciesAverage: "Promedio competencias",
    mobile: "Celular",
    costCenterCreatedSuccessfully: "Centro de costo creado con éxito",
    cannotDisableEditorCreationForSelectedSystemTableBecauseEditorsExist:
        "No es posible deshabilitar la creación de editores para la tabla del sistema seleccionada porque ya existe uno o más editores que la utilizan. Antes de deshabilitarla debe eliminar los editores existentes",
    paymentMethodString: "Forma de pago String",
    modificationOnly: "Solo para modificación",
    totalExtraHours: "Total de horas extras",
    enterLocationToGetCoordinates: "Ingrese ubicación para obtener coordenadas",
    digitalWarehouseFileTypeCreation: "Creación de tipo de archivos de bodega digital",
    calendarUpdatedSuccessfully: "Calendario actualizado con éxito",
    amountToPay: "Valor a pagar",
    documentWithDigitalSignatureAlreadyPublishedUsingSelectedTemplateSelectAnotherOrGenerateNewTemplateCodeForDocument:
        "Ya existe un documento publicado con firma digital que utiliza la plantilla seleccionada, seleccione otro o genere un nuevo código de plantilla para este documento",
    closingDate: "Fecha de cierre",
    healthInstitutionUpdatedSuccessfully: "Institución de salud actualizada con éxito",
    youCannotAuthorizeYourOwnOvertime: "Usted no puede autorizarse sus propias horas extras",
    relatedTableCreatedSuccessfully: "Tabla relacionada creada con éxito",
    dayAndMonthOfExecutionYear: "Día y Mes del año de ejecución",
    awardsAndPromotion: "Premios y Difusión",
    scaleTypeCode: "Código del tipo de escala",
    replicate: "Replicar",
    classificationTypeCreatedSuccessfully: "Tipo de clasificación creada con éxito",
    exportFamilyGroupTemplate: "Exportar plantilla de grupo familiar",
    processScheduleUpdatedSuccessfully: "Programación de proceso actualizada con éxito",
    averageRanking: "Ranking promedio",
    noUnionsFound: "No se encontraron sindicatos",
    accountingEntryForExport: "Asiento contable para exportar",
    simple: "Simple",
    actionRegistrationDate: "Fecha de registro de la acción",
    paidInstallments: "Cuotas pagadas",
    nameCannotBeModifiedBecauseItIsUsedInConceptFormulasOrFunctions:
        "El nombre no puede modificarse porque está siendo utilizado en fórmulas de conceptos o funciones",
    redFemale: "Roja",
    onboardingActionTypes: "Tipos de acciones de onboarding",
    calculationTerminationReason: "Motivo de término cálculo",
    toDeleteEvaluatedAndEvaluatorRecordsTheSelectedRecordsMustBeOfTheSameEvaluationType:
        "Para eliminar registros de evaluados y evaluadores, los registros seleccionados deben ser del mismo tipo de evaluación",
    inProgressAlternative: "En curso",
    digitalizationOptions: "Opciones de digitalización",
    createHistoricalAccumulator: "Crear acumulador histórico",
    totalAdditionalVacation: "Total de vacaciones adicionales",
    entry: "Entrada",
    withSignature: "Con firma",
    noKpiQueriesAvailable: "No hay consultas o KPI disponibles",
    requestDeletion: "Eliminación de solicitud",
    highlightByCompetencyGroup: "Resaltar por grupo de competencias",
    schedule: "Horario",
    targetRatingScales: "Nivel equivalente de esta calificación para el desarrollo de las competencias",
    unauthorizedOvertimeShort: "Hrs Extras Sin Autorizar",
    partialViewVisibleToCollaboratorsInTheirAccessGroups:
        "VISTA PARCIAL - Se visualiza a los colaboradores que pertenecen a sus grupos de acceso",
    employersUppercase: "Empleadores",
    previewTemplate: "Previsualizar plantilla",
    pleaseEnterCodeAndNameOfPayrollTypeThisDataWillReplaceOriginals:
        "Por favor, ingrese el código y nombre del tipo de nómina. Estos datos reemplazarán los originales.",
    changeDepartmentalStructure: "Cambiar estructura departamental",
    wantToDeleteJobGroupForEvaluation: "¿Desea eliminar el grupo de cargo para evaluación?",
    cannotHaveMoreThanOneActionTypeWithSameCodeOrName:
        "No puede existir más de un tipo de acción que comparta el mismo código o nombre",
    deletePermissionType: "Eliminar tipo de permiso",
    cannotDeletePayrollTypeBecauseItIsInUse: "No es posible eliminar el tipo de nómina porque está en uso",
    onboarding: "Onboarding",
    reference2: "Referencia 2",
    standardClassification: "Clasificación estándar",
    workOrProject: "Obra o Faena",
    noAccessToPermissionManagement: "No posee acceso a la gestión de permisos",
    evaluatesOrganizationObjectives: "Evalúa objetivos organización",
    scheduleCreatedSuccessfully: "Horario programado con éxito",
    receiptNumber: "Número de comprobante",
    noteNameCannotExceed60Characters: "El nombre de la nota no puede tener más de 60 caracteres",
    benefitsUsageDetail: "Detalle de uso de beneficios",
    performanceEvaluationCalibration: "Calibración de la evaluación del desempeño",
    previredCode: "Código de Previred",
    cannotDeleteCompetencyBecauseItIsInUse: "No es posible eliminar la competencia porque está en uso",
    hours: "Hrs. ",
    selectEvaluationTypesToIncludeInFormAndTheirWeights:
        "Seleccione los tipos de evaluaciones que incluirá el formulario y sus ponderados",
    visible: "Visible",
    viewWithIndicators: "Visualización de las competencias para el grupo",
    viewWithIndicatorsPosition: "Visualización de las competencias para el cargo",
    wantToSendEvaluatorsMessageIndicatingStartOfPerformanceEvaluationProcess:
        "¿Desea enviar a los evaluadores seleccionados un mensaje indicando que se da inicio al proceso de evaluación del desempeño y que ya pueden comenzar a realizar sus calificaciones?",
    ifYouDeleteAnOnboardingStageProfileAllItsStepsWillBeDeletedAreYouSureYouWantToDeleteIt:
        "Si elimina un perfil de etapas de onboarding tambien se eliminarán todos los pasos que este contiene, ¿está seguro que desea eliminarlo?",
    onboardingStartDateAlt: "Fecha inicio onboarding",
    publishOnWall: "Publicar en muro",
    evaluationProcessDuplicatedSuccessfully: "Proceso de evaluación duplicado con éxito",
    searchInFormulas: "Buscar en fórmulas",
    periodString: "PeríodoString",
    healthInstitutionDeletedSuccessfully: "Institución de salud eliminada con éxito",
    payrollsAndHistories: "Nóminas e históricos",
    globalPotentialAverageByEvaluation: "Promedio global del potencial por evaluación",
    wantToDeleteIndicator: "¿Desea borrar el indicador?",
    conditionalConcept2: "Concepto condicional 2",
    bold13pxArial: "bold 13px Arial",
    neutralMale: "Neutro",
    sqlForKpiTitleRequiredForAllKpi: "SQL para titulo del KPI (Necesario para todos los KPI)",
    quadrant: "Cuadrante",
    totalTaxableIncome: "Total de haberes tributables",
    evaluationProcessCode: "Código del proceso de evaluación",
    publicCommentForAction: "Comentario público de la acción: ",
    downloadSurveySummary: "Descargar resumen de la encuesta",
    reportedValueType: "Tipo de valor informado",
    areYouSureYouWantToDeleteThePerformanceForm: "¿Esta seguro que desea eliminar el formulario de desempeño?",
    discountPeriod: "Período de descuento",
    cannotDeleteProjectBecauseItIsInUseAlt: "No es posible eliminar el proyecto porque está en uso",
    wantToDeleteShift: "¿Desea eliminar el turno?",
    completed: "Realizado",
    createAbsenceTypes: "Creación de tipos de inasistencia",
    cannotDeletePrevisionInstitutionBecauseItIsInUse:
        "No es posible eliminar la institución de previsión porque está en uso",
    incomeStructures: "Estructuras de ingreso",
    helpText: "Texto de ayuda",
    objectiveScaleType: "Tipo de escala objetivos",
    createThirdParty: "Crear tercero",
    attendanceMarkDeletedSuccessfully: "Marca de asistencia eliminada con éxito",
    withReception: "Con recepción",
    paymentToThirdParties: "Pago a terceros",
    editorsCanDeleteTableRecords: "¿Los editores pueden eliminar registros de la tabla?",
    modifyTable: "Modificar tabla",
    createTable: "Crear tabla",
    disabled: "Desactivada",
    updateObservations: "Actualizar observaciónes",
    noClassificationTypesFound: "No se encontraron tipos de clasificaciones",
    deleteHealthInstitution: "Eliminar institución de salud",
    judicialRetention: "Retención judicial",
    fieldsForDataFilterInGrid: "Campos para filtro de datos en grilla",
    deleteProcessSchedule: "Eliminar programación de proceso",
    typeString: "Tipo string",
    calibratedPerformanceFrom9boxes1A3: "Desempeño calibrado desde 9-Boxes (1 a 3)",
    daysToUseInFutureLegalAndOther: "Días por utilizar a futuro (legales y otros)",
    myPlannedActions: "Mis acciones planificadas",
    sqlForLevel2ChartsHorizontalVerticalPieOrLine:
        "SQL para Gráficos Nivel 2 (Horizontal, Vertical, de Torta o de Líneas)",
    tableControlField: "Campo de control de la tabla",
    employeePhoto: "Foto del colaborador",
    actionName: "Nombre de la acción",
    mustSelectARecord: "Debe seleccionar un registro",
    cannotHaveMoreThanOneThirdPartyClassificationWithSameCodeOrName:
        "No puede existir más de una clasificación de terceros que comparta el mismo código o nombre",
    wantToDeleteGroupClassification: "¿Desea eliminar la clasificación de grupo?",
    cannotDeleteBenefitForHistoricalPlan: "No se puede eliminar el beneficio para un plan histórico",
    salaryGrade1a: "Salario Grado 1-A",
    databaseCatalog: "Catálogo de base de datos",
    consultEmployeesNotParticipatingInProcess: "Consultar colaboradores que no participan en el proceso",
    benefit: "Beneficio",
    competencyScaleType: "Tipo de escala competencias",
    entryAttendancePlace: "Lugar de asistencia de entrada",
    wantToDeletePermissionType: "¿Desea eliminar el tipo de permiso?",
    ifYouWantToIncludeSQLDataInEmailBodyCheck:
        "Si desea que en el cuerpo del correo se incluyan datos del SQL de visualización, marque ",
    maxRatingsQtyNoDot: "Qty calificaciones máximas",
    interviewAndFeedback: "Entrevista y Feedback",
    endOfScheduledBreak: "Término break programado",
    wantToDeleteThirdParty: "¿Desea eliminar al tercero?",
    competencyGroup: "Grupo de competencias",
    noCompetencyGroupDefined: "Sin grupo de competencias definido",
    classificationUpdatedSuccessfully: "Clasificación actualizada con éxito",
    maximumRatings: "Calificaciones máximas",
    areYouSureYouWantToDeleteVacationPeriod: "¿Está seguro que quiere eliminar el período de vacaciones?",
    authorizeOvertime: "Autorizar horas extra",
    thirdPartyClassificationCreatedSuccessfully: "Clasificación de terceros creada con éxito",
    wantToDeleteRecord: "¿Desea eliminar el registro?",
    organizationalObjectives: "Objetivos organizacionales",
    massAssignmentToOnboardingProcessCompletedSuccessfully:
        "La asignación masiva al proceso de onboarding ha finalizado con éxito",
    familyUpdatedSuccessfully: "Familiar actualizado con éxito",
    scheduledHours: "Horas programadas",
    cannotHaveMoreThanOneSpecializationWithSameCodeOrName:
        "No puede existir más de una especialización que comparta el mismo código o nombre",
    specificCompetency1OfJob: "Competencia específica 1 del cargo",
    specificCompetency2OfJob: "Competencia específica 2 del cargo",
    cannotDeleteValuesBecauseSelectedValuesAreInUse:
        "No es posible eliminar los valores porque los valores seleccionados están en uso",
    cannotHaveConceptsWithSameCode: "No pueden existir conceptos con el mismo código",
    absenceManagement: "Gestión de inasistencias",
    clearCopiedData: "Limpiar los datos copiados",
    downloadDocument: "Descargar documento",
    evaluated: "Evaluado",
    documentGeneratedSuccessfullyAndSentToEmployeeDigitalFolder:
        "Documento generado con éxito y enviado a la carpeta digital del colaborador",
    superiorPositionId: "ID del cargo superior",
    cannotDeleteIndicatorBecauseItIsInUse: "No es posible eliminar el indicador porque está en uso",
    fieldComment: "Comentario del campo",
    deleteAccumulator: "Eliminar acumulador",
    thisDocumentTypeRequiresMultipleApproversOrSigners:
        "Este tipo de documento requiere múltiples aprobadores o firmantes.",
    calibratedPotential9boxes: "Potencial calibrado 9-Boxes",
    awardDelivery: "Entrega de premio",
    performanceEvaluationCalibratedSuccessfully: "Evaluación de desempeño calibrada con éxito",
    add: "Agregar",
    noAbsenceTypesFound: "No se encontraron tipos de inasistencia",
    evaluatePotentialQuestionMark: "Evalúa potencial?",
    last10Years: "Últimos 10 años",
    viewVisualizationTree: "Ver árbol de visualización",
    responsibleAssigner: "Asignador del responsable",
    redeemedPoints: "Puntos canjeados",
    purposeCode: "Código del propósito",
    areYouSureYouWantToDeleteTemplate: "¿Esta seguro que desea eliminar la plantilla?",
    employeeAnnotations: "Anotaciones del colaborador",
    specialProcessWithSameNameOrCodeAlreadyExists: "Ya existe un proceso especial con el mismo nombre o código",
    valuesByConcept: "Valores por concepto",
    editSchedule: "Editar horario",
    incomeInInstallments: "Ingreso en cuotas",
    checkThatRatingValuesAreInAscendingOrder: "Verifique que los valores de las calificaciones tengan orden creciente",
    absenceTypeString: "Tipo de inasistencia string",
    balance: "Saldo",
    lastUpdateTime: "Hora de última actualización",
    stepAndStageReview: "Revisión de pasos y etapas",
    bankRequiredForPaymentMethod: "Se requiere Banco para la forma de pago ",
    periodUntil: "Período hasta",
    myActionsAndReminders: "Mis acciones y recordatorios",
    descriptiveAdditions: "Complementos Descriptivos",
    deleteLoan: "Eliminar préstamo",
    specialActions: "Acciones especiales",
    ageGroup: "Grupo etario",
    originalConceptCode: "Código de concepto original",
    columnSelectorForEachSQLColumnType: "Tipo de selector por cada columna del SQL",
    ddmmyyyyHhmm: "DD-MM-YYYY hh:mm",
    attendanceMark: "Marca de asistencia",
    numericRatingValue: "Valor numérico de la calificación",
    additionalOrProgressiveBalance: "Saldo adicionales o progresivos",
    cannotDeleteObjectiveTypeBecauseInUseInEmployeeGoals:
        "No es posible eliminar el tipo de objetivo porque está en uso en las metas y objetivos de los colaboradores",
    silverMedal: "Medalla de plata",
    incomeBySociety: "Ingreso por sociedad",
    thirdPartyClassificationDeletedSuccessfully: "Clasificación de terceros eliminada con éxito",
    geoanalysisQueryDuplicatedSuccessfully: "Definición de consulta para geoanálisis duplicada con éxito",
    cannotHaveMoreThanOneObjectiveTypeWithSameCodeOrName:
        "No puede existir más de un tipo de objetivo que comparta el mismo código o nombre",
    pointsAndRedemptionScheme: "Puntos y Esquema de canje",
    potentialIndicator9boxes: "Indicador potencial 9-Boxes",
    wantToDeleteProject: "¿Desea eliminar el proyecto?",
    evaluationEndDate: "Fecha hasta de evaluación",
    generateReceipt: "Generar comprobante",
    noObjectives: "Sin objetivos",
    competencyDescription: "Descripción de la competencia",
    assistant: "Asistente",
    dic: "Dic",
    enterPositionName: "Ingrese el nombre del cargo",
    entryDateAlt: "Fecha de ingreso",
    usageManual: "Instructivo o guía de uso",
    noCommonQuestionsBetweenSelectedSurveys: "No hay preguntas en común entre las encuestas seleccionadas.",
    earningsAndDeductionsBySocietyxlsx: "Haberes y descuentos - Por sociedad.xlsx",
    ofBenefits: "De los beneficios",
    keyField: "Campo clave",
    historicalAccumulators: "Acumuladores históricos",
    userCodeThatBlocked: "Código de usuario que bloqueó",
    geoanalysisQueryCreatedSuccessfully: "Definición de consulta para geoanálisis creada con éxito",
    hiringType: "Tipo de contratación",
    conceptToProcess: "Concepto para procesar",
    massiveCostCenterChange: "Cambio masivo de centros de costo",
    thisDocumentTypeDoesNotRequireThisField: "Este tipo de documento no requiere este campo",
    projectCreatedSuccessfully: "Proyecto creado con éxito",
    cannotDeleteHealthInstitutionBecauseInUse: "No es posible eliminar la institución de salud porque está en uso",
    administrator: "Administrador",
    gatheringInformation: "Recopilando información",
    onboardingProcess: "Proceso de onboarding",
    lastRecognitionDate: "Última fecha de reconocimiento",
    receptionDate: "Fecha de recepción",
    sqlForChartsHorizontalVerticalPieLinePolarOrRadar:
        "SQL para Gráficos (Horizontal, Vertical, de Torta, de Líneas, Polar o Radar)",
    potentialScaleType: "Tipo de escala potencial",
    overtimeTypesDefinition: "Definición de tipos de horas extras",
    cannotDeleteSpecializationBecauseInUse: "No es posible eliminar la especialización porque está en uso",
    assignEvaluator: "Asignar evaluador",
    toUseInFutureAdditionalOrProgressive: "Por utilizar a futuro (adicionales o progresivos)",
    specifyObjectivesToEvaluate: "Especifique los objetivos a evaluar",
    workShiftType: "Tipo de jornada",
    dropdownAndNotEligibleAsMarker: "Lista desplegable y no elegible como marcador",
    massRehireCompletedSuccessfully: "La recontratación masiva ha finalizado con éxito",
    massRehireWithDeleteCompletedSuccessfully:
        "Recontratación exitosa. Las cuentas corrientes también han sido eliminadas.",
    rehireWithVacationLine1:
        '¿Desea ELIMINAR "las cuentas corrientes de: vacaciones, monetaria y permisos en horas" del colaborador o de los colaboradores que está recontratando, o desea CONSERVARLAS?',
    rehireWithVacationLine2:
        "Si el nuevo contrato es una continuidad del anterior deberían conservarse, en caso contrario debería eliminarse todo el histórico de las cuentas corrientes.",
    keepHistory: "Conservar",
    feb: "Feb",
    fileTypeName: "Nombre del tipo de archivo",
    mustSelectNextSigner: "Debe seleccionar al próximo firmante",
    noSurveysFoundForSelectedFilters: "No se encontraron encuestas para los filtros seleccionados",
    accumulators: "Acumuladores",
    viewRole: "Rol de Visualización",
    youHaveModifiedFamilyGroupAndEmployeeExistsInCurrentCalculationProcessReprocessingIsRequired:
        "Ha modificado el grupo familiar y el colaborador existe en un proceso de cálculo actual, es necesario reprocesarlo",
    forecastInstitutionCreatedSuccessfully: "Institución de previsión creada con éxito",
    maximumPossibleScore: "Puntaje máximo posible",
    changeEmployeeCode: "Cambiar código de empleado",
    myEvaluators: "Mis evaluadores",
    permissionManagement: "Gestión de permisos",
    calibrationStartDate: "Fecha inicio de calibración",
    aJobWithSameIdAlreadyExists: "Ya existe un cargo con el mismo ID",
    editNumericWith2Decimals: "Edit numérico con 2 decimales",
    youCannotEditYourOwnOvertime: "Usted no puede editar sus propias horas extras",
    modifiedEntrySuccessfully: "Ingreso modificado con éxito",
    timeManagementSettings: "De gestión de tiempos",
    deleteUnion: "Eliminar sindicato",
    createSigner: "Creación de firmante",
    forMultipleEmailsSeparateWith: "Para ingresar más de un correo sepárelos con ;",
    importAbsences: "Importar inasistencias",
    indicateFormTypeAndItsWeightings: "Indique el tipo de formulario y sus ponderados",
    formCode: "Código de formulario",
    treeStructureWithRightShift: "Estructura en forma de árbol con desplazamiento a la derecha",
    noPublicationsGeneratedYet: "Aún no se han generado publicaciónes",
    verifyThatAllFieldsAreComplete: "Verifique que todos los campos esten completos",
    allocationPeriod: "Período de imputación",
    deleteConcept: "Eliminar concepto",
    wantToDeleteUserMenu: "¿Desea eliminar el menú de usuario?",
    dateValue: "Valor fecha",
    cannotHaveMoreThanOneGeoanalysisQueryWithSameCodeOrName:
        "No puede existir más de una consulta para geoanálisis que comparta el mismo código o nombre",
    searchEmployee: "Buscar colaborador",
    payrollTypeCode: "Codigo del tipo de nómina",
    processStages: "Etapas del proceso",
    months: "Meses",
    response: "Respuesta",
    earningsDeletedSuccessfully: "Haberes eliminados con éxito",
    target: "Target",
    catalogTableCode: "Código de la tabla en catálogo",
    institutionCode: "Código de institución",
    all: "Todas",
    totalDiscounts: "Total de descuentos",
    organizationGoal1: "Objetivo de la organización 1",
    mondayShort: "Lun",
    coWorkersSameGroupsSameManagementSameFunctionOrSharingSamePosition:
        "Compañeros de trabajo (mismos grupos, misma gerencia, misma función o que compartan el mismo cargo).",
    noForecastInstitutionsFound: "No se encontraron instituciónes de previsión",
    formatName: "Nombre del formato",
    noIndicatorsInThisCategory: "No existen indicadores en esta categoría",
    viewVacationAccount: "Ver cta. cte. de vacaciones",
    positionGroupOfEvaluated: "Grupo de cargo del evaluado",
    managementDepartmentsAndSections: "(Gerencias, Departamentos y Seccciones)",
    conceptSheet: "Planilla de conceptos",
    numericWithDecimals: "Numérico con decimales",
    only5DecimalsAllowed: "Solo se permiten 5 decimales.",
    goalLinkedPeriod: "Período vinculado al objetivo",
    importEntry: "Ingreso via importación",
    loanCreatedSuccessfully: "Prestamo creado con éxito",
    employeesWithCompletedOnboarding: "Colaboradores con onboarding realizado",
    successfulDeletion: "Eliminación exitosa",
    fonasaContributionPercentage: "Porcentaje aporte FONASA",
    currency: "Moneda",
    cannotDeletePerformanceFormBecauseInUse: "No es posible eliminar el formulario de desempeño porque está en uso",
    modifyMarkingSystem: "Cambiar sistema de marcaje",
    byConceptSet: "Por conjunto de conceptos",
    acceptedByEvaluator: "Aceptada por el evaluado",
    potentialPointsFor9boxes2: "Pts. Potencial hasta para 9-Boxes 2",
    group03: "Grupo 03",
    competencyCreatedSuccessfully: "Competencia creada con éxito",
    errors: "Errores-",
    calibratedPotentialNumericScore: "Nota numérica potencial calibrada",
    clickEachOneForMoreInformation: "Haga clic en cada uno para ver más información",
    newAbsenceType: "Nuevo tipo de inasistencia",
    createPositionClassification: "Creación de clasificación de cargos",
    newClassificationType: "Nuevo tipo de clasificación",
    mySuggestions: "Mis sugerencias",
    deleteConsentType: "Eliminar tipo de consentimiento",
    valueFromGreen: "Valor desde Green",
    instanceString: "Instancia string",
    hoursAndMinutes: "Horas y Minutos",
    editNumericWith5Decimals: "Edit numérico con 5 decimales",
    userMenu: "Menú de usuario",
    classString: "Clase string",
    emailBodyText: "Texto para cuerpo del email",
    specificCompetency1OfPosition: "Competencia específica 1 del cargo",
    specificCompetency2OfPosition: "Competencia específica 2 del cargo",
    blockUser: "Bloquear usuario",
    thirdPartyString: "Tercero String",
    totalEarnedDays: "Total de días ganados",
    calibratedTalentClassification: "Clasificación del talento calibrada",
    peerEvaluator: "Evaluador par",
    entryDelays: "Atrasos en la entrada",
    cannotHaveMoreThanOneCompetencyWithSameName: "No puede existir más de una competencia que comparta el mismo nombre",
    fechanone: "FechaNone",
    noActivePerformanceEvaluationsFound: "No se encontraron evaluaciones del desempeño activas",
    specifyParametersForNewPerformanceForm: "Indique los parámetros del nuevo formulario de desempeño",
    surveys: "Encuestas",
    cannotDeleteMaterialOrResourceBecauseInUseInOnboardingProfiles:
        "No es posible eliminar el material o recurso porque está en uso en perfiles de onboarding",
    forMassSalaryChangeSelectOnlyActiveEmployeesWithSameCurrencyType:
        "Para el cambio masivo de sueldos o salarios debe seleccionar a colaboradores solo vigentes y con el mismo tipo de moneda",
    channelName: "Nombre del canal",
    thirdPartyCode: "Código de tercero",
    replicatedEntrySuccessfully: "Ingreso replicado con éxito",
    customized: "Personalizada",
    importCalendars: "Importar calendarios",
    positionCode: "Código del cargo",
    monComma: "Mon,",
    list: "Lista",
    unionFee: "Cuota sindical",
    importVacations: "Importar vacaciones",
    totalUsedDays: "Total de días utilizados",
    potentialUpdateDate: "Fecha actualización del potencial",
    overtimeAuthorization: "Autorización de horas extras",
    createOnboardingActionTypes: "Creación de tipos de acción de onboarding",
    feedbackPurposes: "Propósitos de feedback",
    asAdminYouAreViewingAllCommunications: "Como administrador estás viendo todas las comunicaciones",
    authorizedOvertimeHoursNoDot: "Hrs Extras Autorizadas",
    catalogTablesList: "Lista de tablas en el catálogo",
    goalEvaluationPeriod: "Período para evaluación de objetivos",
    performanceEvaluationAnalytics: "Analítica de evaluaciones del desempeño",
    loanTotal: "Total del préstamo",
    paymentTypeString: "Tipo de pago String",
    consentTypeDeletedSuccessfully: "Tipo de consentimiento eliminado con éxito",
    order: "Orden",
    theEmployee: "El empleado",
    discrepancy: "Discrepancia",
    periodStatus: "Estado del período",
    pendingApproval: "Aprobación pendiente",
    newPositionClassification: "Nueva clasificación de cargos",
    deleteClassificationType: "Eliminar tipo de clasificación",
    startYear: "Año de inicio",
    cannotDeleteSpecialProcessBecauseInUse: "No es posible eliminar el proceso especial porque está en uso",
    halfHour: "Media Hora",
    positionMotivatorPotentialMustBeANumber: "El potencial motivador del cargo debe ser un número",
    contextInformation: "Información de contexto",
    builtWithAI: "Construido con IA",
    fileTypeUpdatedSuccessfully: "Tipo de archivo actualizado con éxito",
    enableInPayrolls: "Habilitar en nóminas",
    province: "Provincia",
    emailSubjectAndName: "Nombre y asunto del correo",
    costCenterShort: "Centro de costo",
    goalPeriods: "Períodos para objetivos",
    salariesWithoutContribution: "Haberes sin aporte",
    headerValues: "Valores para cabecera",
    createOrganizationalBenefit: "Crear beneficio organizacional",
    exchange: "Canje",
    digitalFolder: "Carpeta digital",
    payrolls: "Nóminas",
    selectEmployees: "Seleccionar colaboradores",
    scheduledTime: "Horario programado",
    sqlForLevel3ChartTitleOptional: "SQL para titulo de Gráficos Nivel 3 (Optativo)",
    newClassification: "Nueva clasificación",
    legalDaysLong: "Días legales",
    recordMustHaveUnjustifiedAbsences: "El registro debe tener ausencias no justificadas",
    gender: "Sexo",
    massEnableInPayrolls: "Habilitación masiva en nóminas",
    valueFromRed: "Valor desde Red",
    noTraceOfCalculationProcessToView: "No existe trace del proceso de cálculo para visualizar",
    editCalendar: "Editar calendario",
    importTableDefinition: "Importar definición de tablas",
    classificationState: "Estado para clasificación",
    destinationTable: "Tabla destino",
    descendingEvaluator: "Evaluador descendente",
    profileName: "Nombre de perfil",
    profileComments: "Comentarios del perfil",
    permissionsAccountInHours: "Cuenta corriente de permisos en horas",
    apr: "Abr",
    cannotHaveMoreThanOneProjectWithSameCodeOrName:
        "No puede existir más de un proyecto que comparta el mismo código o nombre",
    exportImportStructure: "Exportar estructura de importación",
    setNameAlreadyInUse: "El nombre de conjunto ya se encuentra en uso",
    selectPayrollTypeToStart: "Seleccione tipo de nómina para comenzar",
    linkAlt: "Link o Enlace",
    averages: "Promedios",
    scheduleProgramming: "Programación de horarios",
    maria: "María",
    goldShields: "Escudos de oro",
    viewBenefitForPlan: "Ver beneficio para plan",
    costCenters: "Centros de costo",
    evaluatedEmployeeCode: "Código de empleado del evaluado",
    deleteAttendanceMark: "Eliminar marca de asistencia",
    deletePositionClassification: "Eliminar clasificación de cargos",
    employeeTypes: "Tipos de funcionario",
    checkThatCellsInDateAreComplete: "Verifique que las celdas de En fecha estén completas",
    hrs: "Hrs",
    minAndMaxScoresCannotBeGreaterThan9999: "Las notas mínimas y máximas no pueden ser mayores a 9999",
    fromOrgChart: "Del organigrama",
    calculationProcessApprovalCompletedSuccessfully: "La aprobación del proceso de cálculo ha finalizado con éxito",
    editFamilyRecord: "Editar registro de familiar",
    filtersAppliedSuccessfully: "Filtros aplicados con éxito",
    selectProcessToRun: "Selección de proceso a ejecutar",
    minimumRatingValueIs01: "El valor mínimo de la calificación es 0,1",
    yellowMale: "Amarillo",
    massPayrollEnablementCompletedSuccessfully: "La habilitación de nóminas masiva ha finalizado con éxito",
    performance: "Desempeño",
    structureTypeOrSetType: "Tipo de estructura o Tipo de conjunto",
    startDateOrDateFromCannotBeSaturdaySundayOrHoliday:
        "La fecha de inicio o fecha desde no puede ser un día Sábado, Domingo o Feriado",
    createMedicalLeave: "Crear licencia médica",
    accumulatorsImport: "Importación de acumuladores",
    associatedQuery: "Consulta asociada",
    onboardingProfileDeletedSuccessfully: "Perfil de onboarding eliminado con éxito",
    myUsedBenefits: "Mis beneficios utilizados",
    actionDeletedSuccessfully: "Acción eliminada con éxito",
    conceptsInSet: "Conceptos en el conjunto",
    conceptTypeString: "Tipo de concepto String",
    destinationDescriptionField: "Campo descripción destino",
    viewOnboardingSurveys: "Ver encuestas de onboarding",
    deleteThirdPartyClassificationConfirmation: "¿Desea eliminar la clasificación de terceros?",
    evaluatedCostCenterManagement: "Centro de costo de gestión del evaluado",
    mustSelectOnlyOneItem: "Debe seleccionar un único item",
    timeControlType: "Tipo de control horario",
    mustSelectOnlyOneRow: "Debe seleccionar una única fila",
    mustSelectOneRecordOrNone: "Debe seleccionar un registro o ninguno",
    multipleFiltersApplied: "Múltiples filtros aplicados",
    deleteAbsenceTypeConfirmation: "¿Desea eliminar el tipo de inasistencia?",
    executionDayOfMonth: "Día del mes de ejecución",
    medalTable: "Medallero",
    conceptInputStructureUpdatedSuccessfully: "Estructura de ingreso de conceptos actualizada con éxito",
    functions: "Funciones",
    newScaleType: "Nuevo tipo de escala",
    evaluatedPhoto: "Fotografía del evaluado",
    deleteUnionConfirmation: "¿Desea eliminar el sindicato?",
    selectTransversalCompetenciesAndWeightingsForForm:
        "Seleccione las competencias transversales y los ponderados que incluirá el formulario",
    cannotHaveMoreThanOnePeriodWithSameCodeOrName:
        "No puede existir más de un período que comparta el mismo código o nombre",
    cannotDeleteMenuBecauseInUse: "No es posible eliminar el menú porque está en uso",
    calculationProcessApproval: "Aprobación del proceso de cálculo",
    permissionExceedsAvailableDailyTimeForEmployee:
        "El permiso excede el tiempo por día disponible para el colaborador",
    valueOfEachRecognition: "Valor de cada reconocimiento",
    consentDoesNotHaveAssociatedDocument: "El consentimiento no tiene documento asociado",
    editSpecialProcess: "Editar proceso especial",
    systemAlertsAndNotices: "Alertas y avisos del sistema",
    changeContracts: "Cambiar contratos",
    noJobClassificationsFound: "No se encontraron clasificaciones de cargos",
    recordReplica: "Replica de registro",
    payrollEnablementCompletedSuccessfully: "La habilitación de nóminas ha finalizado con éxito",
    quadrantDescription: "Descripción del cuadrante",
    inconsistentMarks: "Marcas inconsistentes",
    createRelatedTableDefinition: "Crear definición de tabla relacionada",
    feedbackRequestedInPeriod: "Feedbacks solicitados en el período",
    calculationProcessNotCurrentlyPublished: "El proceso de cálculo no se encuentra publicado actualmente",
    deleteFamilyAssignment: "Eliminar asignación familiar",
    employeeHasNoAvailableHours: "El colaborador no tiene horas diarias asignadas en su contrato",
    loadResponsible: "Responsable de la carga",
    recognitionLevel: "Nivel de reconocimientos",
    goldShield: "Escudo de oro",
    codeForBook: "Código para libro",
    percentage: "Porcentaje",
    functionDeletedSuccessfully: "Función eliminada con éxito",
    plus9: "+9",
    userNameThatBlocked: "Nombre de usuario que bloqueó",
    descendingEvaluationWeighting: "Ponderado evaluación descendente",
    minimumRatingsQty: "Qty calificaciones mínimas",
    newAccumulator: "Nuevo acumulador",
    competenciesCalibratedSuccessfully: "Competencias calibradas con éxito",
    cannotDeleteUnionBecauseInUse: "No es posible eliminar el sindicato porque está en uso",
    dimension2: "Dimensión 2",
    noPublicationsGeneratedYetWarning: "Aún no has generado ninguna publicación",
    onlyEvaluatedBySelectedCommittee: "Solo los evaluados por el comité seleccionado",
    confirmDeleteWorkplace: "¿Desea eliminar el lugar de trabajo?",
    benefitValue: "Valor del beneficio",
    massShiftChangeCompletedSuccessfully: "El cambio de turnos masivo ha finalizado con éxito",
    massDivisionChangeCompletedSuccessfully: "El cambio de unidad de negocios masivo ha finalizado con éxito",
    massManagementCenterChangeCompletedSuccessfully:
        "El cambio de centro de publicación masivo ha finalizado con éxito",
    employeesUnderEvaluatedManagementDependentJobsLevel1:
        "Colaboradores a cargo del evaluado (Cargos dependientes del 1er nivel de dependencia).",
    checkThirdLevelOfGeographicalOrganization: "Verifique el tercer nivel de organización geográfica",
    lreCode: "Código LRE",
    delayInBreak: "Demora en el break",
    viewInCalendar: "Ver en calendario",
    specificCompetencyGroup: "Grupo de competencias",
    conceptCreatedSuccessfullyRememberToAssignToAnIncomeStructureOrConceptSet:
        "Concepto creado con éxito. Recuerde asignar el concepto a una estructura de ingreso o conjunto de conceptos",
    fieldNameAlt: "Nombre del campo",
    mapAddress: "Dirección en el Mapa",
    deleteAbsenceType: "Eliminar tipo de inasistencia",
    noCompetencies: "Sin competencias",
    confirmApproveProcessAndMoveToHistoric: "¿Desea aprobar el proceso y pasarlo a histórico?",
    queryDefinitionDeletedSuccessfully: "Definición de consulta eliminada con éxito",
    parameterModifiedSuccessfully: "Parámetro modificado con éxito",
    modify: "Modificar",
    saveOrder: "Guardar orden",
    actionDescription: "Descripción de la acción",
    cannotHaveMoreThanOneParameterWithSameCodeOrName:
        "No puede existir más de un parámetro que comparta el mismo código o nombre",
    reminderDateForAlert: "Fecha recordatoria para alerta",
    scheduleCodeShort: "Código del horario",
    languageDeletedSuccessfully: "Idioma eliminado con éxito",
    calculateAttendanceAnalysis: "Calcular análisis de asistencia",
    selfAssessment: "Autoevaluación",
    legalTerminationReason: "Motivo de término legal",
    create9boxClassification: "Crear clasificación 9-box",
    feedbackDelivered: "Feedback entregado",
    performancePointsFromFor9Boxes3: "Pts. Desempeño desde para 9-Boxes 3",
    purposeName: "Nombre del propósito",
    createSpecialProcess: "Crear proceso especial",
    groupCreatedSuccessfully: "Grupo creado con éxito",
    completedFemale: "Realizada",
    deleteDescendantEvaluationRecordConfirmation:
        "Si elimina registros con el tipo de evaluación descendente se eliminarán también todos los tipos de evaluaciones para el colaborador o colaboradores seleccionados y quedarán fuera del proceso, ¿desea continuar con la eliminación?",
    dimension4: "Dimensión 4",
    queryParameterCreatedSuccessfully: "Parámetro de consulta creado con éxito",
    overallPerformanceAverageByEvaluation: "Promedio global del desempeño por evaluación",
    createGradeType: "Creación de tipo de nota",
    newQuestion: "Nueva pregunta",
    newFamilyAssignment: "Nueva asignación familiar",
    entryOrModificationDate: "Fecha de ingreso o modificación",
    globalPerformanceAveragePotential: "Promedio global potencial",
    cannotHaveMoreThanOneDefinitionWithSameCodeOrName:
        "No puede existir más de una definición que comparta el mismo código o nombre",
    newUnion: "Nuevo sindicato",
    kpiDefinitionModifiedSuccessfully: "Definición de KPI modificada con éxito",
    talentAnalytics: "Analítica del talento",
    assignEmployeesToProcess: "Asignar colaboradores al proceso",
    overtimeCode: "Código de hora extra",
    medalPoints: "Puntos para medallero",
    systemTableEditors: "Editores de tablas del sistema",
    ratingPercentage: "Porcentaje de calificación",
    deleteDocuments: "Eliminar documentos",
    sqlVisualizationColumnSelectorsTypes:
        "Para cada columna de SQL de visualización, los tipos de selectores pueden ser: Lista, Fecha, Alfa, Num, Mon.",
    relatedTableUpdatedSuccessfully: "Tabla relacionada actualizada con éxito",
    deleteJobGroupForEvaluation: "Eliminar grupo de cargo para evaluación",
    seniority: "Antigüedad",
    performancePointsFromFor9Boxes1: "Pts. Desempeño desde para 9-Boxes 1",
    evaluatesSpecificSkills: "Evalúa comp. específicas",
    generalCommentsFromEvaluator: "Comentarios generales del evaluador",
    cannotDeleteCalendarBecauseInHistoricalState:
        "No es posible eliminar el calendario porque se encuentra en estado histórico",
    chooseHowRecordWillAppearInNotes: "Elija como quedará registro en las anotaciones",
    imputationAlreadyExistsForSameConceptImputationTypeAndEntry:
        "Ya existe una imputación para el mismo concepto, tipo de imputación y asiento",
    byConcept: "Por concepto",
    formAndWeightings: "Formulario y ponderados",
    massiveSalaryModificationCompletedSuccessfully:
        "La modificación masiva de Sueldos o salarios ha finalizado con éxito",
    mustEnterClassification: "Debe ingresar la clasificación",
    benefitDescription: "Descripción del beneficio",
    conceptSet: "Conjunto de conceptos",
    imputationDuplicatedSuccessfully: "Imputación duplicada con éxito",
    permissionSingular: "Permiso",
    importCostDistributionTemplate: "Importar plantilla de distribución de costos",
    requireApprovalFromReceiver: "Requerir aprobación del receptor",
    sqlToGetValueListForParameter: "SQL para obtener la lista de valores para el parámetro",
    filters: "Filtros",
    deleteProject: "Eliminar proyecto",
    createProject: "Creación de proyecto",
    groupDuplicatedSuccessfully: "Grupo duplicado con éxito",
    specialLocationGroupsMyStaffPeopleMasterPersonalDataUserMenuAndTest:
        "Grupos de ubicación especiales: Mi personal, Maestro de Personas, Datos Personales, Menú del usuario y Test",
    numericRatings: "Calificaciones numéricas",
    permissionCurrentAccount: "Cuenta corriente de permisos",
    modifiedCostAccountingDistributionAndEmployeeInCurrentCalculationProcessReprocessingNeeded:
        "Ha modificado la distribución contable de costos y el colaborador existe en un proceso de cálculo actual, es necesario reprocesarlo",
    earningsAndDeductionsSummary: "Resumen de haberes y descuentos",
    commune: "Comuna",
    jobGroupForEvaluationUpdatedSuccessfully: "Grupo de cargo para evaluación actualizado con éxito",
    startPeriod: "Período de inicio",
    includesEmployerDigitalSignature: "¿Incluye firma digital del empleador?",
    replaceEvaluator: "Reemplazar evaluador",
    endDateOfApplication: "Fecha hasta de aplicación",
    generateAndSendToEmail: "Generar y enviar al correo",
    calculationProcess: "Proceso de cálculo",
    finalPotentialScore: "Puntaje final potencial",
    govHolidays: "Feriados",
    byCompetency: "Por competencia",
    scheduleFieldIsRequired: "El campo horario es obligatorio",
    viewContextResult: "Ver resultado del contexto",
    massiveWorkOrTaskChange: "Cambio masivo de obra o faena",
    cannotDeleteBenefitBecauseItHasBeenUsedLeaveInactiveButCannotDelete:
        "No es posible eliminar el beneficio porque ya se lo ha utilizado. Puede dejarlo como Inactivo pero no eliminarlo",
    sendReminderForPending: "Enviar recordatorio de pendiente",
    visibleToEmployee: "Visible para el colaborador",
    duplicateConcept: "Duplicar concepto",
    objectiveAnalysis: "Análisis de objetivos",
    historicalAccumulatorCreatedSuccessfully: "Acumulador histórico creado con éxito",
    npsValue: "Valor NPS",
    viewOnlyIncompleteMarks: "Ver solo las marcas incompletas",
    cannotRunCalculationProcessBecauseNoEmployeesSelected:
        "No es posible ejecutar el proceso de cálculo porque no existen colaboradores seleccionados",
    fromTheOrganization: "De la organización",
    expirationDate: "Fecha de vencimiento",
    searchConceptByName: "Buscar concepto por nombre",
    exportSurvey: "Exportar encuesta",
    mustEnterCommunicationComment: "Debe ingresar el comentario de la comunicación",
    createDocumentTemplate: "Crear plantilla para documentos",
    mySelfAssessmentComments: "Comentarios de mi autoevaluación",
    newJobGroupForEvaluation: "Nuevo grupo de cargo para evaluación",
    pointsEarned: "Puntos ganados",
    corporateEmailAlreadyExistsForAnotherEmployeeChangeIt:
        "El email corporativo ingresado ya existe para otro colaborador, debe cambiarlo",
    noJobGroupsFoundForConcept: "No se encontraron grupos para concepto",
    thu: "Jue",
    scheduleType: "Tipo de horario",
    confirmation: "Confirmación",
    abbreviatedSchedule: "Horario abreviado",
    group06: "Grupo 06",
    evaluationProcessDeletedSuccessfully: "Proceso de evaluación eliminado con éxito",
    recognitionPlanAlreadyAssociatedWithSelectedBenefitType:
        "El plan de reconocimiento ingresado ya está asociado al tipo de beneficio seleccionado",
    newFeedbackPurpose: "Nuevo propósito de feedback",
    string: "String",
    totalStandardCompanyCost: "Total costo empresa estándar",
    closed: "Cerrado",
    showNameInScoreboard: "Mostrar nombre en el marcador",
    endDateOfTimes: "Fecha hasta de tiempos",
    viewConceptsBySociety: "Visualizar conceptos por sociedad",
    vacations: "Vacaciones",
    situation: "Situación",
    objectiveTypeDeletedSuccessfully: "Tipo de objetivo eliminado con éxito",
    planAssignmentDate: "Fecha de asignación el plan",
    loanDeletedSuccessfully: "Prestamo eliminado con éxito",
    allFieldsRequiredAndAtLeastOneNote: "Todos los campos son obligatorios y debe haber al menos una nota",
    editAuthorizedOvertime: "Editar horas extra autorizadas",
    mandatory: "Obligatorio",
    highlightByManagement: "Resaltar por gerencia",
    selectNextSignerWhoMustAlsoApproveThisDocumentAfterYouSignIt:
        "Seleccione quien será el siguiente firmante que también deberá aprobar este documento luego que sea firmado por usted.",
    visnote: "Visnote",
    icon3minimumvalue: "icon3MinimumValue",
    allHistorical: "Todos los históricos",
    createFieldDefinition: "Crear definición de campo",
    costDistribution: "Distribución de costos",
    indicatorUpdatedSuccessfully: "Indicador actualizado con éxito",
    labels: "Etiquetas",
    viewOrganizationalBenefit: "Ver beneficio organizacional",
    concept: "Concepto",
    canceled: "Se deja sin efecto",
    executionMode: "Modo de ejecución",
    selectTableTypeAndYear: "Seleccionar tipo de tabla y año",
    cannotDeleteTemplateBecauseInUse: "No es posible eliminar la plantilla porque está en uso",
    onboardingProcessCreatedSuccessfully: "Proceso de onboarding creado con éxito",
    unprocessableEntity: "Unprocessable Entity",
    deleteScaleType: "Eliminar tipo de escala",
    exitAction: "Salir",
    addEmployees: "Agregar colaboradores",
    personalObjective1: "Objetivo personal 1",
    activePluralFemale: "Activas",
    activeBenefit: "Beneficio activo",
    selectedEmployees: "Colaboradores seleccionados",
    endDateAlternative: "Fecha hasta",
    globalValues: "Valores globales",
    cannotDeleteAccumulatorBecauseInUse: "No es posible eliminar el acumulador porque está en uso",
    valuesUpdatedSuccessfully: "Valores actualizados con éxito",
    deleteObjectiveType: "Eliminar tipo de objetivo",
    conceptId: "ID del concepto",
    listanone: "ListaNone",
    activeStatusShort: "Activo",
    conditionalConcept1: "Concepto condicional 1",
    schedulesUpdatedSuccessfully: "Horarios actualizados con éxito",
    areYouSureYouWantToDeleteConceptSet: "¿Está seguro que desea eliminar al conjunto de conceptos?",
    conceptsAnalysisByStructure: "Análisis de conceptos por estructura",
    codeCode: "Code",
    createCalendar: "Crear calendario",
    updateName: "Nombre actualizacion",
    cannotHaveConceptSetsWithSameNameOrCode: "No pueden existir conjuntos de conceptos con el mismo nombre o código",
    conditionalInstallment: "Condicional cuota",
    reasonName: "Nombre del motivo",
    normalHours: "Horas normales",
    deleteChannelType: "Eliminar tipo de canal",
    viewBalances: "Ver saldos",
    silverMedals: "Medallas de plata",
    performanceEvaluationsDetailsForHistoricalAnalysis:
        "Detalle de las evaluaciones del desempeño para el análisis histórico",
    conceptWithSameNameAlreadyExists: "Ya existe un concepto con el mismo nombre.",
    selectedEvaluationAlreadyHasAssociatedFeedback:
        "La evaluación seleccionada ya tiene asociado un feedback. Si desea modificarlo acceda a Mis Feedbacks desde Mi Escritorio",
    unauthorizedOvertimeShortDots: "Hrs. Extras Sin Autorizar",
    atLeastOneTypeOfCompetencyMustBeEvaluated: "Se deben evaluar competencias de al menos un tipo",
    creatingMedicalLeaveTypes: "Creación de tipos de licencia médica",
    previsionInstitutionDeletedSuccessfully: "Institución de previsión eliminada con éxito",
    performanceFormWithSameCodeTypeAndJobGroupAlreadyExists:
        "Ya existe un formulario de desempeño con el mismo código, tipo y grupo de cargos a evaluar",
    others: "Otros",
    scalesForRatings: "Escalas para calificaciones",
    specificWeight: "Peso específico",
    ascending: "Ascendente",
    calibratedPotentialFrom9boxes1To3: "Potencial calibrado desde 9-Boxes (1 a 3)",
    cannotHaveRatingsWithSameName: "No puede haber calificaciones con el mismo nombre",
    usedAdditionalOrProgressive: "Utilizados (adicionales o progresivos)",
    overtimeTolerance: "Tolerancia antes de horas extras",
    noDataRetrieved: "No se obtuvieron datos",
    earningsWithContributions: "Haberes con aportes",
    newShift: "Nuevo turno",
    newGrade: "Nueva nota",
    allProcesses: "Todos los procesos",
    profileCode: "Código del perfil",
    reportedValue: "Valor informado",
    week: "Semana",
    finalGradeRangesFor9boxes: "Indique los rangos de la nota final que utilizará 9-Boxes",
    valid: "Vigente",
    jobGroupForEvaluationDeletedSuccessfully: "Grupo de cargo para evaluación eliminado con éxito",
    digitalSignatureConsent: "Consentimiento para firma digital",
    potentialPointsFromFor9boxes3: "Pts. Potencial desde para 9-Boxes 3",
    surveyWithEnteredNameAlreadyExists: "Ya existe una encuesta con el nombre ingresado",
    onboardingMaterialsAndResources: "Materiales y recursos de onboarding",
    downloadFinalEvaluationSummary: "Descargar resumen final de la evaluación",
    specificExecutionDate: "Fecha de ejecución específica",
    executionYearMonth: "Mes del año de ejecución",
    cannotDeleteObjectivePeriodBecauseInUseInPerformanceEvaluationProcesses:
        "No es posible eliminar el período para objetivos porque está en uso en los procesos de evaluación del desempeño",
    hideContextResult: "Ocultar resultado del contexto",
    mustEnterNewEmployeeCode: "Debe ingresar un nuevo código de empleado",
    evaluationProcessDefinitionSettings: "Definición de procesos de evaluación",
    youHaveSelectedTheLowestRatingPleaseJustifyWithYourComments:
        "Ha seleccionado la menor calificación, justifique con sus comentarios por favor",
    shareInformationWithYourTeamToMotivateThem: "Comparte información con tu equipo para motivarlos",
    newPayrollType: "Nuevo tipo de nómina",
    finalCalibratedPotentialGrade: "Nota final potencial calibrada",
    group10: "Grupo 10",
    cannotDeleteGroupBecauseRelatedToActionsAndReminders:
        "No es posible eliminar el grupo, está relacionado con acciones y recordatorios",
    top10: "Top 10",
    competencies: "Competencias",
    cannotDeleteGroupBecauseInUse: "No es posible eliminar el grupo porque está en uso",
    areYouSureYouWantToDeleteKPIDefinition: "¿Está seguro que desea eliminar la definición de KPI?",
    scheduleRequest: "Solicitud de horario",
    blockedUserCode: "Código de usuario bloqueado",
    cannotDeleteAbsenceBecauseInUse: "No es posible eliminar la inasistencia porque está en uso",
    processTypeCannotBeApprovedBecauseItIsASpecialOrSimulationProcess:
        "El tipo de proceso no puede aprobarse porque es un tipo de proceso especial o de simulación",
    pendingBalance: "Saldo pendiente",
    firstLevelOfGeographicalOrganizationIsRequired: "El primer nivel de organización geográfica es obligatorio",
    icon2MaximumValue: "icon2MaximumValue",
    forSQLChartsYouMustAlwaysSelect2Columns:
        "Para los gráficos de SQL debe seleccionar siempre 2 columnas, la primera de tipo alfanumérico y se utilizará como el nombre de la serie, y la segunda de tipo numérica y se tomará como Valor de la serie, a excepción de los gráficos de Radar, donde podrán ser varias las columnas numéricas (Ideal entre 5 y 10)",
    goalDescription: "Descripción del objetivo",
    icon3MaximumValue: "icon3MaximumValue",
    duplicatedQueryDefinitionSuccessfully: "Definición de consulta duplicada con éxito",
    deleteGroup: "Eliminar grupo",
    programmerUser: "Usuario programador",
    youMustSelectAtLeastOneExcelTemplate: "Debe seleccionar al menos una plantilla de excel",
    centralization: "Centralización",
    workOnUnscheduledDays: "Trabajo en días no programados",
    recordMustHaveUnauthorizedOvertime: "El registro debe tener horas extras sin autorizar",
    classificationTypesForApplicants: "Tipos de clasificación para postulantes",
    classifyCommunication: "Clasificar la comunicación",
    endDateAlt: "Fecha final",
    deleteFeedbackPurpose: "Eliminar propósito de feedback",
    userCode: "Código de usuario",
    paymentPlace: "Lugar de pago",
    benefitName: "Nombre del beneficio",
    criticalNPS: "NPS crítico",
    unauthorizedExtras: "Extras sin autorizar",
    fileTypes: "Tipos de archivo",
    familyGroup: "Grupo familiar",
    editScheduleAlt: "Editar programación",
    lastProcessTime: "Hora último proceso",
    createAbsence: "Crear inasistencia",
    hourType: "Tipo de hora",
    goalStatus: "Estado del objetivo",
    templateIsRequiredWhenInstanceIsSelected: "La plantilla es obligatoria cuando hay instancia seleccionada",
    fromAnEmployeeWithSubordinateStaff: "Desde un colaborador con personal a cargo",
    nineBoxesPerformanceIndicator: "Indicador desempeño 9-Boxes",
    toChangeJobsInBulkAllSelectedEmployeesMustHaveTheSameJob:
        "Para poder cambiar cargos masivamente, todos los colaboradores seleccionados deben tener el mismo cargo",
    earningsAndDiscountsByCompanyAutomatic: "Haberes y descuentos - Por sociedad (Automáticos)",
    accessMap: "Mapa de acceso",
    totalLegalAndOtherDays: "Total días legales y otros",
    totalSocialLaws: "Total de leyes sociales",
    noPaymentMethodsFound: "No se encontraron formas de pago",
    modificationMadeSuccessfully: "Modificación realizada con éxito",
    areYouSureYouWantToDeleteTheCalendar: "¿Está seguro que desea eliminar al calendario?",
    performancePointsFor9Boxes2: "Pts. Desempeño hasta para 9-Boxes 2",
    contractEndDateForCurrentContract: "Fecha de término de contrato para el contrato actual",
    newPrevisionInstitution: "Nueva institución de previsión",
    shiftCode: "Código del turno",
    holidaySchedule: "Código de horario para días feriados",
    forMassRehiringYouCanOnlySelectInactiveEmployees:
        "Para la recontratación masiva de colaboradores solo puede seleccionar a colaboradores no vigentes",
    goodNPS: "NPS bueno",
    weighted: "Ponderado",
    destination: "Destino",
    templateDeletedSuccessfully: "Plantilla eliminada con éxito",
    last5Years: "Últimos 5 años",
    employeeBalance: "Cuadratura por colaborador",
    bulkEntry: "Ingreso masivo",
    doYouWantToDeleteTheStudyType: "¿Desea eliminar el tipo de estudio?",
    newMaterialOrResource: "Nuevo material o recurso",
    performanceFormUpdatedSuccessfully: "Formulario de desempeño actualizado con éxito",
    myNotesAlt: "Mis anotaciones",
    overtimeTypes: "Tipos de horas extras",
    thereCannotBeMoreThanOneJobClassificationWithTheSameCodeOrName:
        "No puede existir más de una clasificación de cargo que comparta el mismo código o nombre",
    theDateMustBeEqualOrGreaterThanTheCurrentDate: "La fecha debe ser igual o mayor que la fecha actual",
    competencyAnalysis: "Análisis de competencias",
    conceptName: "Nombre del concepto",
    doYouWantToDeleteJobClassification: "¿Desea eliminar la clasificación de cargos?",
    w16Ml0Whitetext: "w-16 ml-0 whiteText",
    attendanceDate: "Fecha de asistencia",
    doYouWantToDeleteConcept: "¿Desea eliminar el concepto?",
    activeDocument: "¿Documento activo?",
    toIndicateThatTheTableHasVisadoYouMustEnterAccessType:
        "Para indicar que la tabla tiene visado debe ingresar “Tipo de acceso”: Colaborador, Manager o Empleador.",
    notApplicable: "(No aplica)",
    planBudget: "Presupuesto del Plan",
    minimumRatingsQtyDot: "Qty. calificaciones mínimas",
    totalAdditionalOrProgressiveDays: "Total de días adicionales o progresivos",
    doYouWantToDeleteMaterialOrResource: "¿Desea eliminar el material o recurso?",
    summaryAndResults: "Resumen y resultados",
    doYouWantToDeleteClassification: "¿Desea eliminar la clasificación?",
    myComplaints: "Mis denuncias",
    deleteFunction: "Eliminar función",
    deleteUserMenu: "Eliminar menú de usuario",
    formIdentification: "Identificación del formulario",
    ascendingWeighted: "Ponderado ascendente",
    codeCannotExceed3Characters: "El código no puede exceder los 3 caracteres!",
    withoutCategory: "Sin Categoría",
    workShiftCode: "Código de jornada",
    bankAccountRequiredForPaymentMethod: "Se requiere Cuenta Bancaria para la forma de pago ",
    doYouWantToDeletePayrollType: "¿Desea eliminar el tipo de nómina?",
    scheduleGroup: "Grupo del horario",
    consentName: "Nombre de consentimiento",
    specificCompetencies: "Competencias específicas",
    check: "Check",
    fileNameAlt: "Nombre del archivo",
    onboardingProfileWithSameCodeTypeAndJobGroupAlreadyExists:
        "Ya existe un perfil de onboarding con el mismo código, tipo y grupo de cargos a evaluar",
    overtimeTypesXlsx: "Tipos de horas extras.xlsx",
    forEachSQLColumnSelectorTypesCanBeListDateAlphanumericNumericCurrency:
        "Para cada columna de SQL, los tipos de selectores pueden ser: Lista,Fecha,Alfa,Num,Mon",
    newFileType: "Nuevo tipo de archivo",
    accountingEntries: "Asientos contables",
    successfulDuplication: "Duplicación exitosa",
    timePerDayString: "Tiempo por día string",
    vacationTable: "Tabla de vacaciones",
    includeInDigitalFolder: "¿Incluir en carpeta digital?",
    factor: "Factor",
    cannotExistMoreThanOneThirdPartyWithSameCodeOrName:
        "No puede existir más de un tercero que comparta el mismo código o nombre",
    consentIsInUseInOnboardingMaterialsAndResourcesCannotBeDeleted:
        "El consentimiento está en uso en los materiales y recursos de Onboarding, no puede ser eliminado",
    exceptions: "Excepciones",
    performanceFormDeletedSuccessfully: "Formulario de desempeño eliminado con éxito",
    pointsToGetIt: "Puntos para obtenerlo",
    conceptDeletedSuccessfully: "Concepto eliminado con éxito",
    goalTypeUpdatedSuccessfully: "Tipo de objetivo actualizado con éxito",
    valueBetween0And100: "Valor entre 0 y 100",
    importedTableDefinitionSuccessfully: "Definición de tabla importada con éxito",
    defineAffiliationInstitutions: "Definir instituciones de afiliación",
    costCenterDesc3: "Desc. Centro de costo 3",
    alertOrNoticeType: "Tipo de Alerta o Aviso",
    groupsForConcepts: "Grupos para conceptos",
    createSchedule: "Crear programación",
    feedbackPurposeCodeCannotBeDeletedItIsInUse:
        "El código del propósito del feedback no puede eliminarse, está en uso",
    finalPerformanceScore: "Puntaje final desempeño",
    valueUpToIcon3: "Valor hasta Icono 3",
    cannotExistMoreThanOneCostCenterWithSameCodeOrName:
        "No puede existir más de un centro de costo que comparta el mismo código o nombre",
    twoMediumPotential: "2 Potencial medio",
    copiedToClipboard: "Copiado al portapapeles",
    parameterCreatedSuccessfully: "Parámetro creado con éxito",
    deleteNoteType: "Eliminar tipo de nota",
    editIndex: "Editar índice",
    competencyRatingScale: "Escala calificación competencias",
    hhmm: "HH:mm",
    areYouSureYouWantToDeleteUserFromList: "¿Está seguro que desea eliminar al usuario de la lista?",
    processScheduleDuplicatedSuccessfully: "Programación de proceso duplicada con éxito",
    changeMarkingSystem: "Cambio sistema de marcaje",
    noConceptSetsFound: "No se encontraron conjuntos de conceptos",
    viewObservations: "Ver observaciones",
    cannotDeleteFormBecauseItIsInUseInEvaluationProcesses:
        "No es posible eliminar el formulario porque está en uso en los procesos de evaluación",
    finalStandardPerformanceScore: "Nota final desempeño estándar",
    indicateParametersForNewEvaluationProcess: "Indique los parámetros del nuevo proceso de evaluación",
    assignmentDueDate: "Fecha de vencimiento de la asignación",
    geographicalOrganization: "Organización geográfica",
    scheduleModifiedSuccessfully: "Horario modificado con éxito",
    additionalDaysPermissions: "Días adicionales",
    kpiType: "Tipo de KPI",
    versionCode: "Código de versión",
    tableGroup: "Grupo de la tabla",
    noJobGroupsFoundForEvaluations: "No se encontraron grupos de cargos para evaluaciones",
    editMedicalLeave: "Editar licencia médica",
    entryWorkTime: "Hora de entrada",
    performanceDefinitions: "Definiciones de desempeño",
    forInternalUse: "Para uso interno:",
    currencyColon: "Moneda:",
    workerType: "Tipo de trabajador",
    activeStandard: "Estándar activa",
    setCode: "Código del conjunto",
    youMustSelectTableType: "Debe seleccionar tipo de tabla",
    totalEarnings: "Total de Haberes",
    userMenuCreation: "Creación de menú de usuario",
    fieldType: "Tipo de campo",
    whenPassingCommunicationToStates: "Al pasar la comunicación a los estados ",
    forMassEnablingInPayrollYouMustSelectOnlyActiveEmployees:
        "Para la habilitación masiva en nóminas debe seleccionar solo a colaboradores vigentes",
    onboardingStepsForProfile: "Pasos de onboarding para el perfil",
    cannotDeleteAccumulatorBecauseItIsUsedInFormulas:
        "No es posible eliminar el acumulador porque está siendo utilizado en fórmulas",
    dataEntryViaApi: "Ingreso de datos via API",
    noBenefitsAvailableAtTheMoment: "No hay beneficios disponibles en estos momentos",
    jobClassification: "Clasificación del cargo",
    withObservations: "Con observaciones",
    hrsWithTrailingSpace: "Hrs ",
    actionOrMomentType: "Tipo de acción o momento",
    noThirdPartiesFound: "No se encontraron Terceros",
    enterYourCommentsHere: "Ingrese aquí sus comentarios",
    conceptSetDeletedSuccessfully: "Conjunto de conceptos eliminado con éxito",
    sqlToDetermineValueListForParameter: "SQL para determinar la lista de valores para el parámetro",
    actionCreatedSuccessfully: "Acción creada con éxito",
    cannotDeleteOwnAbsences: "No puede eliminar sus propias inasistencias",
    ufLastDayOfCurrentMonth: "UF Último día mes actual",
    icon1MaximumValue: "icon1MaximumValue",
    menuName: "Nombre de menú",
    planDeletedSuccessfully: "Plan eliminado con éxito",
    bronzeMedal: "Medalla de bronce",
    jun: "Jun",
    send: "Enviar",
    valueFromIcon1: "Valor desde Icono 1",
    average: "Promedio",
    searchEllipsis: "Buscar...",
    performancePointsFor9Boxes1: "Pts. Potencial hasta para 9-Boxes 1",
    tableIsEmptyIfHeaderDataFilledPress:
        "La tabla se encuentra vacía. En caso de haber llenado los datos de cabecera, presione ",
    numericStandardPotentialScore: "Nota numérica potencial estándar",
    hireDate: "Fecha contratacion",
    origin: "Origen",
    communicationClassificationSingular: "Clasificación de la comunicación",
    showNameInMarker: "Mostrar nombre en marcador",
    missingPlural: "Faltantes",
    duplicateByCompetencyGroup: "Duplicar por grupo de competencia",
    forMassShiftChangeYouMustSelectOnlyActiveEmployees:
        "Para el cambio de turnos masivo debe seleccionar solo a colaboradores vigentes",
    cannotDeleteOwnPermissions: "No puede eliminar sus propios permisos",
    massive: "Masivo",
    youCanAlsoChangePlanStatusToHistoric: "También puede cambiar el estado del plan a histórico.",
    classificationTypeUpdatedSuccessfully: "Tipo de clasificación actualizada con éxito",
    variables: "Variables",
    sqlForOptionalKpiSubtitleAndItWillDependOnEachKpi: "SQL para subtítulo del KPI (Optativo y dependerá de cada KPI)",
    earningsAndDeductionsInstallmentEntry: "Haberes y descuentos - Ingreso en cuotas",
    goalsAndObjectivesShort: "Metas y objetivos",
    queryDefinitionModifiedSuccessfully: "Definición de consulta modificada con éxito",
    scheduledHoursPlan: "Horarios programados",
    ifYouEnterAuthorizedAbsenceDaysYouMustDefineAccessModeViaRequestToManager:
        "Si ingresa días de ausencia autorizados debe definir como modo de acceso vía solicitud al manager",
    doYouWantToDeleteClassificationType: "¿Desea eliminar el tipo de clasificación?",
    movementDate: "Fecha de movimiento",
    evaluationWithSpace: "Evaluación ",
    oneOfTheEnteredEmployeesIsAlreadyAssociatedWithThePlan:
        "Uno de los colaboradores ingresados ya está asociado al plan",
    sectionAlt: "Tramo",
    deleteActionType: "Eliminar tipo de acción",
    noFeedbackPurposesFound: "No se encontraron propósitos de feedback",
    selectEmployeeOrReferenceGroup: "Seleccionar colaborador o grupo de referencia",
    youMustPreviewFileBeforeSigningIt: "Debe previsualizar el archivo antes de firmarlo",
    brandGeoposition: "Geoposición de marcas",
    toDefineAccessModeViaRequestToManagerYouMustHaveAuthorizedAbsenceDays:
        "Para definir modo de acceso vía solicitud al manager debe tener días de ausencia autorizados",
    provinceCode: "Código de provincia",
    calibrationDate: "Fecha de calibración",
    commentColon: "Comentario:",
    performanceIndicator: "Indicador de desempeño",
    planName: "Nombre del plan",
    sqlToDisplayNumberInBoxOrClock: "SQL para mostrar un Número dentro del BOX o CLOCK",
    group07: "Grupo 07",
    genericReference2: "Referencia genérica 2",
    geoanalysisQueryDefinitionDeletedSuccessfully: "Definición de consulta para geoanálisis eliminada con éxito",
    totemManagement: "Gestión de totems",
    group04: "Grupo 04",
    myDigitalFolder: "Mi carpeta digital",
    managementCode: "Código de gerencia",
    updatedPrevisionInstitutionSuccessfully: "Institución de previsión actualizada con éxito",
    saveReference: "Graba referencia",
    yAxisFor9Boxes: "Eje Y para 9-boxes",
    legalAndOtherUsed: "Utilizados (legales y otros)",
    highlightMotivatorPotential: "Resaltar potencial motivador",
    selectedDocumentsNotFound: "No existen los documentos seleccionados",
    rating: "Calificación",
    createFormatTypesForPublications: "Creación de tipos de formato para las publicaciones",
    sectionCode: "Código de sección",
    planStatus: "Estado del plan",
    totalTax: "Total Impuesto",
    enableEditors: "¿Habilitar editores?",
    ifNotPayingTotalInstallmentsThePrepaidInstallmentsWillAlwaysBeTheLast:
        "Si no se prepaga el total de cuotas, las cuotas que prepague serán siempre las últimas",
    daysToUseInFutureAdditionalOrProgressive: "Días por utilizar a futuro (adicionales o progresivos)",
    usedDays: "Días utilizados",
    alfanone: "AlfaNone",
    cannotExistMoreThanOneClassificationWithSameCodeOrName:
        "No puede existir más de una clasificación que comparta el mismo código o nombre",
    viewConcepts: "Ver conceptos",
    communicationType: "Tipo de comunicación",
    fromEmployeeMaster: "Del Maestro de Empleados",
    planCreatedSuccessfully: "Plan creado con éxito",
    updatedFamilyAllowanceSuccessfully: "Asignación familiar actualizada con éxito",
    doYouWantToDeletePermission: "¿Desea eliminar el permiso?",
    hiringDateColon: "Fecha de contratación: ",
    createPermissionTypes: "Creación de tipos de permiso",
    processScope: "Alcance del proceso",
    standardPotential9Boxes: "Potencial estándar 9-Boxes",
    checkFormatItShouldBeForExample0900: "Verifique el formato. El mismo debe ser, por ejemplo, 09:00.",
    queryParameterModifiedSuccessfully: "Parámetro de consulta modificado con éxito",
    goals: "Objetivos",
    thankYouForRespondingNowCommunicationReturnedToResponsibleEmployerToContinueTheirAttention:
        "Gracias por responder. Ahora la comunicación ha retornado al Empleador responsable para continuar con su atención.",
    standardTalentClassification: "Clasificación del talento estándar",
    progressControl: "Control del progreso",
    onboardingProcessAssignment: "Asignación a proceso de onboarding",
    associatedSystemTable: "Tabla de sistema asociada",
    difference: "Diferencia",
    conceptSetUpdatedSuccessfully: "Conjunto de conceptos actualizado con éxito",
    workplaces: "Lugares de trabajo",
    cannotRemovePublicationFromCalculationProcessBecauseDocumentsWithDigitalSignatureHaveAlreadyBeenGeneratedForThatProcess:
        "No es posible quitar la publicación del proceso de cálculo porque ya se han generado documentos con firma digital para dicho proceso",
    cannotExistMoreThanOneGroupWithSameCodeOrName:
        "No puede existir más de un grupo que comparta el mismo código o nombre",
    conceptEntryStructure: "Estructura de ingreso de conceptos",
    enteredTextWillBeFileNameWhenUploaded: "El texto que se ingresa será el nombre del archivo que se carga",
    withNumberValueRelatedIconWillBeShownInBoxOrNeedleInClock:
        "Con el valor del Número, se mostrará el Icono relacionado en el BOX o en el valor de la aguja en el CLOCK",
    exitDate: "Fecha de egreso",
    scheduleDefinitions: "Definición de horarios",
    forConditionalSqlFiltersRememberYouHaveVariablesCodempAndEmployeeWhichContainEmployeeCodeAndWillDisplayAvailableBenefits:
        "Para poder realizar filtros en el SQL condicional recuerde que dispone de las variables #CODEMP# y #EMPLOYEE# las cuales contendrán el código del colaborador conectado y que es quién visualizará los beneficios disponibles",
    youMustSelectARow: "Debe seleccionar una fila",
    hiringDate: "Fecha de contratación",
    selectConcepts: "Seleccionar conceptos",
    blockedUsername: "Nombre de usuario bloqueado",
    lastProcessDate: "Fecha último proceso",
    valuesCannotExistWithSameEmployeeAndDate: "No pueden existir valores con el mismo colaborador y fecha",
    youMustEnterResponsibleForCommunication: "Debe ingresar el responsable de la comunicación",
    cannotDeleteCrossCompetenceBecauseItIsInUseInPerformanceForms:
        "No es posible eliminar la competencia transversal porque está en uso en los formularios de desempeño",
    familyType: "Tipo de familiar",
    specialProcessToExecute: "Proceso especial a ejecutar",
    cannotExistMoreThanOneCompetenceWithSameNameAndGroup:
        "No puede existir más de una competencia que comparta el mismo nombre y grupo",
    jobDescription: "Descripción de la función",
    userMenuDeletedSuccessfully: "Menú de usuario eliminado con éxito",
    onboardingProcessDeletedSuccessfully: "Proceso de onboarding eliminado con éxito",
    alertOrNoticeWithSameNameAlreadyExists: "Ya existe una alerta o aviso con el mismo nombre que ha ingresado",
    relatedElementsToDocument: "Elementos relacionados al documento",
    alphanumeric: "Alfanumérico",
    rate: "Tasa",
    transversal: "Transversales",
    conceptString: "Concepto String",
    cannotDeleteRecordInUse: "No puede eliminar un registro que se encuentre en uso",
    judicialRetentionString: "Retención judicial string",
    functionDuplicatedSuccessfully: "Función duplicada con éxito",
    taxBase: "Tope imponible",
    userPermissionError: "Error de permisos del usuario",
    initialLoadDate: "Fecha de carga inicial",
    cannotDeleteFunctionInUse: "No es posible eliminar la función porque está en uso",
    deleteClassification: "Eliminar clasificación",
    group02: "Grupo 02",
    jul: "Jul",
    totalVariousDiscounts: "Total de descuentos varios",
    areYouSureYouWantToDeleteRecord: "¿Está seguro que desea eliminar el registro?",
    valueUntilYellow: "Valor hasta Yellow",
    xAxisFor9Boxes: "Eje X para 9-boxes",
    hrsDot: "Hrs.",
    silverShields: "Escudos de plata",
    workedDays: "Días trabajados",
    checkSecondLevelOfGeographicOrganization: "Verifique el segundo nivel de organización geográfica",
    parameterDeletedSuccessfully: "Parámetro eliminado con éxito",
    yourCompetenceRating: "Su calificación en competencias",
    viewDetail: "Ver detalle",
    surveyAnalysis: "Análisis de encuestas",
    benefitTypeDeletedSuccessfully: "Tipo de beneficio eliminado con éxito",
    specialProcessUpdatedSuccessfully: "Proceso especial actualizado con éxito",
    vacationType: "Tipo de vacaciones",
    markerIcon: "Icono para marcador",
    youCannotSendFeedbackForAnEvaluationYouAreBeingEvaluatedIn:
        "No puedes enviar feedback de una evaluación en la que eres el evaluado",
    recipientGroups: "Grupos de destinatarios",
    userMenuUpdatedSuccessfully: "Menú de usuario actualizado con éxito",
    accessEvaluations: "Acceder a las evaluaciones",
    parameterName: "Nombre del parámetro",
    noPayrollTypesFound: "No se encontraron tipos de nómina",
    reasonsForEntry: "Motivos de ingreso",
    nonExistent: "No existentes",
    alertOrNoticeClass: "Clase de Alerta o Aviso",
    publicationDate: "Fecha de publicación",
    calendarDefinitions: "Definición de calendarios",
    viewGroupsWithThisClassification: "Ver grupos con esta clasificación",
    scheduledBreakStart: "Inicio break programado",
    actionTypeCreatedSuccessfully: "Tipo de acción creada con éxito",
    cannotExistMoreThanOneTemplateWithSameCodeOrName:
        "No puede existir más de una plantilla que comparta el mismo código o nombre",
    associatedUserTable: "Tabla de usuario asociada",
    benefitTypeImage: "Imagen del tipo de beneficio",
    ifChangeAppliesToEmployeesWithoutExistingContractNewHiresTopTwoDataWillBeIgnored:
        "Si el cambio se aplica en colaboradores sin contrato existente (nuevas contrataciones), los dos datos de arriba serán ignorados",
    isCustomFormula: "Es Fórmula Personalizada",
    recordsModifiedSuccessfully: "Registros modificados con éxito",
    evaluatedManager: "Gerencia del evaluado",
    showWeek: "Mostrar semana",
    registrationDate: "Fecha de registro",
    number: "Número",
    positionRecompositionSuccessfullyDone: "Recomposición de puestos realizada con éxito",
    shiftDefinitions: "Definición de turnos",
    reasonForCurrentContractTermination: "Motivo de término del contrato actual",
    unjustifiedAbsencesAlt: "Ausencias no justificadas",
    feedbackStartDate: "Fecha inicio de feedback",
    exchangeObligation: "Obligatoriedad de canje",
    requiresBankAccount: "Requiere cuenta bancaria",
    cannotExistConceptSetsWithSameName: "No pueden existir conjuntos de conceptos con el mismo nombre",
    areYouSureYouWantToDeleteGeoAnalysisQueryDefinition:
        "¿Está seguro que desea eliminar la definición de consulta para geoanálisis?",
    enterNumericValueBetween1And125: "Ingrese un valor numérico entre 1 y 125.",
    numericGradeAveragesByEvaluators: "Promedios de notas numéricas por evaluadores",
    calibratedFrom9Boxes: "Calibrado desde 9-Boxes",
    byAccountAndCostCenter: "Por cuenta y centro de costo",
    processedEmployees: "Colaboradores procesados",
    calculationProcessCannotBeDeletedBecauseDigitalSignedDocumentsHaveBeenGeneratedForThatProcess:
        "El proceso de cálculo no puede eliminarse porque ya se han generados documentos con firma digital para dicho proceso",
    license: "Licencia",
    plantStaff: "Personal de planta",
    executionSQL: "SQL de ejecución",
    editBenefitType: "Editar tipo de beneficio",
    expirationDateString: "Fecha de vencimiento string",
    icon3Box: "Icono 3 BOX",
    earningsWithoutContributions: "Haberes sin aportes",
    fileTypeCreatedSuccessfully: "Tipo de archivo creado con éxito",
    totalValueOfLoansGranted: "Valor total préstamos otorgados",
    createPublicationChannelTypes: "Creación de tipos de canales para las publicaciones",
    illnesses: "Enfermedades",
    searchInSQL: "Buscar en SQL",
    forAssignmentYouMustSelectOnlyActiveEmployees: "Para la asignación debe seleccionar solo a colaboradores vigentes",
    endTime: "Hora de término",
    cannotExistMoreThanOneTableWithSameNameAndVersionCode:
        "No puede existir más de una tabla con el mismo nombre y código de versión",
    enter: "Enter",
    selectedUser: "Usuario seleccionado",
    motivatorPotential: "Potencial motivador",
    defaultValue: "Valor por defecto",
    notNull: "No Nulo",
    addOption: "Agregar opción",
    sqlContextResult: "Resultado del SQL del contexto",
    scheduleCreatedSuccessfullyAlt: "Horario creado con éxito",
    maxValueForCashRedemption: "Valor máximo para canje por dinero",
    competenciesPerEvaluation: "Competencias por evaluación",
    chooseAwardDeliveryAndDiffusionType: "Elija la entrega de premios y tipo de difusión",
    enteredPersonalEmailAlreadyExistsForAnotherEmployeeMustChangeIt:
        "El email personal ingresado ya existe para otro colaborador, debe cambiarlo",
    feedbackProcessStart: "Inicio del proceso de feedback",
    processPeriodLong: "Período del proceso",
    areYouSureYouWantToGenerateVacationCertificateAlreadyApprovedByYouAndThatMustBeDigitallySignedByEmployeeToReceiveItByEmail:
        "¿Está seguro que desea generar un comprobante de vacaciones ya aprobado por usted, y que deberá ser firmado digitalmente por el colaborador, para que luego de su firma reciba el comprobante por correo?",
    entryCoordinates: "Coordenadas de entrada",
    selfEvaluationWeight: "Ponderado autoevaluación",
    noHealthInstitutionsFound: "No se encontraron instituciones de salud",
    saveCalibrations: "Guardar calibraciones",
    objectivesWeight: "Ponderado objetivos",
    noAccessToLicenseManagement: "No posee acceso a la gestión de licencias",
    ifYouDeleteThisPayrollTypeAllConceptsAndEmployeesRelatedToThisPayrollTypeWillBeDisabledDoYouWantToContinue:
        "Si elimina este tipo de nómina, todos los conceptos y todos los colaboradores que estén relacionados con este tipo de nómina serán deshabilitados de la misma. ¿Desea continuar?",
    options: "Opciones",
    classificationCreatedSuccessfully: "Clasificación creada con éxito",
    valueUntilRed: "Valor hasta Red",
    totalExemptEarnings: "Total de haberes exentos",
    downloadCapture: "Descargar captura",
    dateAndNotEligibleAsMarker: "Fecha y no elegible como marcador",
    thirdPartiesUpdatedSuccessfully: "Terceros actualizado con éxito",
    noConsentTypesFound: "No se encontraron tipos de consentimiento",
    hasRelatedEditors: "Tiene editores relacionados",
    contextComments: "Comentarios del contexto",
    competencyScale: "La escala de competencias",
    areYouSureYouWantToSaveChanges: "¿Está seguro que desea guardar los cambios?",
    showMonth: "Mostrar mes",
    conceptCreatedSuccessfully: "Concepto creado con éxito",
    noClassificationsFound: "No se encontraron clasificaciones",
    selectedEmployee: "Colaborador seleccionado",
    totalGrossEarnings: "Total de Haberes (Brutos)",
    doYouWantToDownloadSelectedFiles: "¿Desea descargar los archivos seleccionados?",
    setCodeAlreadyInUse: "El código de conjunto ya se encuenta en uso",
    userUnlockedSuccessfully: "Usuario desbloqueado con éxito",
    loanValues: "Valores de Préstamos",
    functionModifiedSuccessfully: "Función modificada con éxito",
    performancePointsFromFor9Boxes2: "Pts. Desempeño desde para 9-Boxes 2",
    deletePaymentMethod: "Eliminar forma de pago",
    creationDate: "Fecha de creación",
    communeCode: "Código de comuna",
    accumulatorCreation: "Creación de acumulador",
    cannotHaveNotesWithSameName: "No puede haber notas con el mismo nombre",
    reviewFollowingFormSummary: "Revise el siguiente resumen del formulario",
    newCostCenter: "Nuevo centro de costo",
    scheduled: "Programado",
    gridColumnType: "Tipo de columna en grilla",
    potentialPointsFromFor9Boxes2: "Pts. Potencial desde para 9-Boxes 2",
    goalAssigner: "Asignador del objetivo",
    healthInstitutionCreatedSuccessfully: "Institución de salud creada con éxito",
    familyAllowanceString: "Asignación familiar string",
    remuneration: "Remuneración",
    maxPlanBudgetInCash: "Presupuesto máximo del plan en dinero",
    allDataFieldsAreRequired: "Todos los datos son obligatorios",
    otherConcepts: "Otros Conceptos",
    vacationsDeletedSuccessfully: "Vacaciones eliminadas con éxito",
    allMale: "Todos",
    deltaSoftSa: "Delta Soft SA",
    noteTypeCode: "Código del tipo de nota",
    quadrantClassificationLong: "Clasificación del cuadrante",
    entryReference: "Referencia de entrada",
    ratingName: "Nombre de la calificación",
    jobClassificationUpdatedSuccessfully: "Clasificación de cargo actualizada con éxito",
    cannotChangeCalendarToState: "No es posible cambiar un calendario a estado ",
    noScaleTypesFound: "No se encontraron tipos de escala",
    enteredTimeExceedsEmployeeWorkday: "La hora ingresada supera la jornada del colaborador",
    overtimeReleased: "Horas extras liberadas",
    actionsShort: "Acciones",
    feedbackResponsible: "Responsable del feedback",
    bySociety: "Por sociedad",
    overtime: "Horas extra",
    competencyWeight: "Ponderado de la competencia",
    specifyDocumentAcceptanceTypeRequiredFromEmployee:
        "Indicar el tipo de aceptación que el documento requiere por parte del colaborador.",
    benefitImage: "Imagen del beneficio",
    cannotDeleteActionTypeBecauseInUse: "No es posible eliminar el tipo de acción porque está en uso",
    familyAllocations: "Asignaciones familiares",
    noteTypeWithEnteredCodeAlreadyExists: "Ya existe un tipo de nota con el código ingresado",
    queryCodeLong: "Codigo de la consulta",
    currentPlural: "Actuales",
    byCompetenciesAndEvaluators: "Por competencias y evaluados",
    paymentMethodCreatedSuccessfully: "Forma de pago creada con éxito",
    doNotApplyChanges: "No aplicar cambios",
    cannotExistMoreThanOneRelativeWithSameCode: "No puede existir más de un familiar con el mismo código",
    indicators: "Indicadores",
    earlyWithdrawal: "Retiro anticipado",
    stay: "Quedarme",
    percentages: "Porcentajes",
    receiverRole: "Rol receptor",
    doYouWantToDeleteThePeriod: "¿Desea eliminar el período?",
    onlyOvertime: "Solo horas extras",
    competencyGroupSingular: "Grupo de competencia",
    calculationProcessPublication: "Publicación de procesos de cálculo",
    cannotDeleteObjectiveTypeBecauseInUse: "No es posible eliminar el tipo de objetivo porque está en uso",
    legalDiscounts: "Descuentos legales",
    size: "Tamaño",
    cannotExistMoreThanOneMenuWithSameCodeOrFunctionName:
        "No puede existir más de un menú que comparta el mismo código o nombre de función",
    regionCode: "Código de región",
    noAccessToVacationManagement: "No posee acceso a la gestión de vacaciones",
    cannotExistMoreThanOneAccumulatorWithSameCodeOrName:
        "No puede existir más de un acumulador que comparta el mismo código o nombre",
    scaleTypeWithEnteredCodeAlreadyExists: "Ya existe un tipo de escala con el código ingresado",
    newChannelTypeForPublications: "Nuevo tipo de canal para las publicaciones",
    lockDate: "Fecha de bloqueo",
    potentialFrom: "Potencial desde",
    dimension3: "Dimensión 3",
    redemptionType: "Tipo de canje",
    employeesInRecognitionPlans: "Colaboradores en planes de reconocimientos",
    indexDuplicatedSuccessfully: "Índice duplicado con éxito",
    uploadDocument: "Subir documento",
    jobGroupForEvaluation: "Grupo del cargo para evaluación",
    onboardingStage: "Etapa en el onboarding",
    num: "Num,",
    specifics: "Específicas",
    noCategory: "Sin categoría",
    deletePayrollType: "Eliminar tipo de nómina",
    receiveNotice: "Recibir aviso",
    historicalPerformanceAnalysis: "Análisis histórico del desempeño",
    alpha: "Alfa",
    discountFrequency: "Frecuencia del descuento",
    deleteCalculationReference: "Eliminar referencia de cálculo",
    evaluationStepsAndStages: "Pasos y etapas de la evaluación",
    exportPdf: "Exportar PDF",
    onboardingEndDateAlt: "Fecha fin onboarding",
    periodsForObjectivesLong: "Períodos para los objetivos",
    calculationFunctions: "Funciones de cálculo",
    actionPerformanceEvaluationCalibration: "Calibrar evaluación de desempeño",
    progressDateAlt: "Fecha del progreso",
    projectDesc: "Desc. del Proyecto",
    groupDeletedSuccessfully: "Grupo eliminado con éxito",
    feedbacks: "Feedbacks",
    nineBoxesDefinition: "Definición de 9-Boxes",
    evaluationProcessName: "Nombre del proceso de evaluación",
    familyAllowance: "Asignación familiar",
    benefitCode: "Código del beneficio",
    newThirdPartyClassification: "Nueva clasificación de terceros",
    accountCode: "Cuenta contable",
    toMakeAnyChangeGoBackToTheAppropriateStep: "Para realizar cualquier cambio, vuelva al paso adecuado",
    processIdentification: "Identificación del proceso",
    detailedDataView: "Visualización de datos detallados",
    top5: "Top 5",
    calibrationState: "Estado para calibración",
    sqlForLevel3ChartsHorizontalVerticalPieOrLine:
        "SQL para Gráficos Nivel 3 (Horizontal, Vertical, de Torta o de Líneas)",
    mypeople: "MyPeople",
    cannotDeleteCalculationReferenceBecauseInUse: "No es posible eliminar la referencia de cálculo porque está en uso",
    doYouWantToDeleteTheGroup: "¿Desea eliminar el grupo?",
    parameterType: "Tipo de parámetro",
    cannotExistMoreThanOnePensionInstitutionWithSameCodeOrName:
        "No puede existir más de una institución de previsión que comparta el mismo código o nombre",
    finalPerformanceGrade: "Nota final desempeño",
    totalShiftHours: "Horas totales del turno",
    userBlockedSuccessfully: "Usuario bloqueado con éxito",
    monthsMustBeBetween1And12: "Los meses deben ser entre 1 y 12",
    dayWithScheduleChange: "Día con cambio de horario",
    importSurvey: "Importar encuesta",
    highPotential3: "3 Potencial alto",
    hidden: "Oculto",
    myClaims: "Mis reclamos",
    doYouWantToDeleteAllReadAlertsAndNotices: "¿Desea eliminar todas las alertas y avisos leídos?",
    physicalTableCode: "Código físico de la tabla",
    doYouWantToDeleteTheReasonForPointDelivery: "¿Desea eliminar el motivo para la entrega de puntos?",
    editOrganizationalBenefit: "Editar beneficio organizacional",
    forBulkTimecardSystemChangeYouMustSelectOnlyActiveEmployees:
        "Para el cambio de sistema de marcaje masivo debe seleccionar solo a colaboradores vigentes",
    noPermissionTypesFound: "No se encontraron tipos de permiso",
    processNameAlt: "Nombre del proceso",
    99: "+99",
    records: "Registros",
    scaleTypeWithEnteredNameAlreadyExists: "Ya existe un tipo de escala con el nombre ingresado",
    highlightByEvaluationGroup: "Resaltar por grupo de evaluación",
    doYouWantToDeleteTheConsentType: "¿Desea eliminar el tipo de consentimiento?",
    continue: "Continuar",
    consentTypeCreatedSuccessfully: "Tipo de consentimiento creado con éxito",
    cannotDeleteNoteTypeBecauseInUseInPerformanceEvaluationProcesses:
        "No es posible eliminar el tipo de nota porque está en uso en los procesos de evaluación del desempeño",
    deleteFormatType: "Eliminar tipo de formato",
    selectedFiles: "Archivos seleccionados",
    lorenzo: "Lorenzo",
    noUpdateDateRecorded: "Sin fecha de actualización registrada",
    conceptModifiedSuccessfully: "Concepto modificado con éxito",
    forMassiveJobChangeYouMustSelectOnlyActiveEmployees:
        "Para el cambio masivo de cargo debe seleccionar solo a colaboradores vigentes",
    conceptSetDuplicatedSuccessfully: "Conjunto de conceptos duplicado con éxito",
    assignmentDateToPlan: "Fecha de asignación al plan",
    talentAcquisitionDefinitions: "Definiciones de adquisición del talento",
    cannotExistValuesWithSameCodeOrName: "No pueden existir valores con el mismo código o nombre",
    shiftHours: "Horas turno",
    changeDate: "Cambiar fecha",
    familyCreatedSuccessfully: "Familiar creado con éxito",
    managementDefinitionConsultationsGeoAnalysisKPI: "Definición de gestión (Consultas-GeoAnálisis-KPI)",
    doYouWantToDeleteCalculationReference: "¿Desea eliminar la referencia de cálculo?",
    noCalculationReferencesFound: "No se encontraron referencias de cálculo",
    noShiftsFound: "No se encontraron turnos",
    incomeAddedSuccessfully: "Ingreso agregado con éxito",
    evaluatePersonalObjectives: "Evalúa objetivos personales",
    detailTableCannotBeSelectedBecauseItIsInUse:
        "La tabla de detalle no puede seleccionarse porque ya se encuentra en uso.",
    filterOrgChart: "Filtrar organigrama",
    noSalariesOrDiscountsFound: "No se encontraron haberes y descuentos",
    result: "Resultado",
    dataForSeveranceSimulation: "Datos para la simulación de finiquitos",
    ifYouEnterRelatedPaymentConceptYouMustDefineAsAccessMethodViaEmployerRequest:
        "Si ingresa concepto de pago relacionado debe definir como modo de acceso vía solicitud al empleador",
    cannotDeleteBenefitBecauseItIsRelatedToRecognitionPlan:
        "No es posible eliminar el beneficio porque está relacionado con un Plan de Reconocimiento",
    includeCurrentYearProcesses: "Incluir procesos del año actual",
    neutrals: "Neutros",
    conceptStructureDoesNotExist: "La estructura de conceptos no existe",
    performanceAndTalentAnalytics: "Analítica del desempeño y talento",
    vacantPositions: "Puestos libres",
    youMustSelectAStructure: "Debe seleccionar una estructura",
    numericValue: "Valor numérico",
    enteredBenefitTypeCodeAlreadyExists: "El código del tipo de beneficio ingresado ya existe",
    selectSchedule: "Seleccionar horario",
    attendanceMarkEditedSuccessfully: "Marca de asistencia editada con éxito",
    calibrationCompleted: "Calibración realizada",
    permissionUpdatedSuccessfully: "Permiso actualizado con éxito",
    descendingWeighted: "Ponderado descendente",
    evaluator: "Evaluador",
    evaluationYear: "Año de evaluación",
    evaluationMustBeInFeedbackState: "La evaluación debe estar en estado “En Feedback”",
    jobClassificationDeletedSuccessfully: "Clasificación de cargo eliminada con éxito",
    noAvailablePositions: "No hay cargos disponibles",
    referenceGroup: "Grupo de referencia",
    newSpecialization: "Nueva especialización",
    conditionalSQL: "SQL condicional",
    periodCode: "Código de período",
    createBenefitForPlan: "Crear beneficio para plan",
    registrationTime: "Hora de registro",
    sendApprovedRequestProofWithCopyTo: "Enviar comprobante de solicitud aprobado con copia a",
    only5DecimalsAllowedCannotEnter0: "Solo se permiten 5 decimales. No se puede ingresar 0.",
    strength: "Fortaleza",
    totemCreation: "Creación de tótem",
    cannotExistMoreThanOneIndicatorWithSameNameOrNumber:
        "No puede existir más de un indicator que comparta el mismo nombre o número de indicador",
    editAction: "Editar acción",
    shiftDetail: "Detalle del turno",
    evaluateJobSpecificCompetencies: "Evalúa competencias específicas del cargo?",
    specialProcessQuery: "Consulta del proceso especial",
    editFieldDefinition: "Editar definición de campo",
    projectDeletedSuccessfully: "Proyecto eliminado con éxito",
    areYouSureYouWantToDeleteTheProcess: "¿Está seguro que desea eliminar el proceso?",
    dashboard: "Tablero de control",
    paymentToThirdParty: "Pago a tercero",
    markerScheme: "Esquema de marcadores",
    theFileYouAreTryingToImportIsDamaged: "El archivo que está intentando importar se encuentra dañado",
    selectedSingular: "Seleccionado",
    authorizedOvertimeHoursShort: "Hrs. extras autorizadas",
    queryCannotBeDeletedBecauseItIsAssociatedWithSpecialProcess:
        "La consulta no puede ser eliminada porque está asociada a un proceso especial",
    updateDate: "Fecha de actualización",
    noDocumentsPublishedWithDigitalSignature: "No existen documentos publicados con firma digital",
    doYouWantToDownloadTheFile: "¿Desea descargar el archivo?",
    languageCreatedSuccessfully: "Idioma creado con éxito",
    advancesForRequests: "Anticipos para solicitudes",
    licenseDeletedSuccessfully: "Licencia eliminada con éxito",
    integerNumericAndNotEligibleAsMarker: "Numérico entero y no elegible como marcador",
    cannotReplaceEvaluatorBecauseNoGrades: "No es posible reemplazar el evaluador ya que no hay calificaciones",
    detractors: "Detractores",
    overtimeHoursPerformed: "Hrs. Extras Realizadas",
    myOnboardingProcess: "Mi proceso de onboarding",
    potentialIndicator: "Indicador de potencial",
    doYouWantToSendReminderMessageToEmployeesToRequestVacation:
        "¿Desea enviar un mensaje recordatorio a los colaboradores para que soliciten vacaciones?",
    calibratedQuadrantClassification: "Clasificación cuadrante calibrado",
    internalUseCommentOnlyVisibleToManagersAndEmployers:
        "Comentario de uso interno (Estos comentarios solo serán visualizados por Managers y Empleadores):",
    variousDiscounts: "Descuentos varios",
    sendMessageToStartRatings: "Enviar mensaje de inicio de calificaciones",
    group05: "Grupo 05",
    descr: "Descr",
    approve: "Aprobar",
    mon: "Mon",
    youMustSelectAFunction: "Debe seleccionar una función",
    weddingDate: "Fecha de casamiento",
    cannotExistFunctionsWithSameCode: "No pueden existir funciones con el mismo código",
    canReceiveActions: "¿Puede recibir acciones?",
    rehire: "Recontratar",
    group08: "Grupo 08",
    newTemplate: "Nueva plantilla",
    forThisPermissionTypeAttachmentUploadIsRequired: "Para este tipo de permiso la carga del adjunto es obligatoria",
    detailedInformation: "Información detallada",
    currentLoadedTemplateNoTemplateLoaded: "Plantilla cargada actualmente: Sin plantilla cargada",
    finished: "Finalizado",
    byEvaluatedAndCompetencies: "Por evaluado y competencias",
    kpiDefinitionDuplicatedSuccessfully: "Definición de KPI duplicada con éxito",
    contractors: "Contratistas",
    importStructures: "Importar estructuras",
    stepDescription: "Descripción del paso",
    youMustSelectAUser: "Debe seleccionar un usuario",
    potentialPointsFromFor9boxes1: "Pts. Potencial desde para 9-Boxes 1",
    executeQuery: "Ejecutar consulta",
    anOpenCalculationProcessAlreadyExistsWithTheSamePayrollType:
        "Ya existe un proceso de cálculo abierto con el mismo tipo de nómina",
    activePlans: "Planes activos",
    codeTIsReservedForInternalUseCannotDefineIt: "El código T está reservado para uso interno, no es posible definirlo",
    yourPotentialRating: "Su calificación en potencial",
    createRecord: "Crear registro",
    inInstallments: "En cuotas",
    classificationCreation: "Creación de clasificaciones",
    thirdPartyDeletedSuccessfully: "Tercero eliminado con éxito",
    accountingAllocations: "Imputaciones contables",
    crossFunctionalPond: "Pond. comp. transversales",
    thirdPartyCreatedSuccessfully: "Tercero creado con éxito",
    totalLegalVacationsAndOthers: "Total de vacaciones legales y otros",
    functionNameLongAlt: "Nombre de la función",
    fees: "Honorarios",
    permanenceHours: "Horas de permanencia",
    studyTypeCreatedSuccessfully: "Tipo de estudio creado con éxito",
    editRelatedTableDefinition: "Editar definición de tabla relacionada",
    associatedValues: "Valores asociados",
    actionTypesAndReminders: "Tipos de acciones y recordatorios",
    noCharacteristicsDefinedForThisQuadrant: "No se definieron características para este cuadrante.",
    occupation: "Ocupación",
    noEmployeesInSelectedQuadrant: "No hay colaboradores en el cuadrante seleccionado",
    selectGroups: "Seleccionar grupos",
    publicationDateMustBeEqualOrLaterThanCurrentDate:
        "La fecha de publicación debe ser igual o mayor que la fecha actual",
    ifYouDefinePotentialQuestionsTheyWillOnlyBeVisibleInTheDescendingEvaluationForm:
        "Si define preguntas de potencial solo se verán en el formulario de evaluación Descendente",
    kpiCode: "Codigo de KPI",
    indices: "Índices",
    costCenterDescription2: "Desc. Centro de costo 2",
    noClassification: "Sin clasificación",
    marchShort: "Mar",
    conceptCannotBeDeletedBecauseItIsInUse: "No se puede eliminar el concepto por estar en uso",
    languageUpdatedSuccessfully: "Idioma actualizado con éxito",
    workplaceName: "Nombre del lugar de trabajo",
    emailSentSuccessfully: "Mail enviado con éxito",
    licenses: "Licencias",
    costCenter3: "Centro de costo 3",
    communicationMustBeAssignedToAResponsiblePerson: "La comunicación debe estar asignada a un responsable",
    transferFromPlan: "Traspasar de plan",
    publicationFormatTypes: "Tipos de formatos para las publicaciones",
    noteName: "Nombre de la nota",
    cannotDeleteConsentTypeBecauseItIsInUse: "No es posible eliminar el tipo de consentimiento porque está en uso",
    accountingPeriod: "Periodo de imputación",
    requestingRole: "Rol solicitante",
    family: "Familia",
    actionTypeUpdatedSuccessfully: "Tipo de acción actualizada con éxito",
    bulkUploadOfEvaluatedAndTheirEvaluators: "Carga masiva de evaluados y sus evaluadores",
    youMustSelectASinglePerformanceEvaluation: "Debe seleccionar una única evaluación del desempeño",
    salariesAndDeductions: "Haberes y Descuentos",
    relatedPaymentConcept: "Concepto de pago relacionado",
    silverShield: "Escudo de plata",
    newContract: "Nuevo contrato",
    ratingCriteria: "Criterio de la calificación",
    conceptModifiedSuccessfullyRememberToAssignConceptToAnIncomeStructureOrConceptSet:
        "Concepto modificado con éxito. Recuerde asignar el concepto a una estructura de ingreso o conjunto de conceptos",
    employeeCodeAlreadyExistsCannotCreateNewEmployeeWithThatCode:
        "El código de empleado ya existe, no es posible crear al nuevo empleado con ese código",
    notRequired: "No necesario",
    highlightByWorkplace: "Resaltar por lugar de trabajo",
    functionCreatedSuccessfully: "Función creada con éxito",
    unionDeletedSuccessfully: "Sindicato eliminado con éxito",
    unlink: "Desvincular",
    cannotDeleteBenefitBecauseItIsEnabledAsOrganizationalBenefit:
        "No es posible eliminar el beneficio porque está habilitado como Beneficio Organizacional",
    series: "Serie",
    executionInProgressForSelectedSpecialAction: "Ejecución en proceso para la acción especial seleccionada",
    associatedGroups: "Grupos asociados",
    selectConceptSet: "Seleccione un conjunto de conceptos",
    successfulModification: "Modificación exitosa",
    dollar: "Dólar",
    anOpenCalendarAlreadyExistsForSameCalendarType:
        "Ya existe un calendario en estado abierto para el mismo tipo de calendario",
    performanceAndPotential: "Desempeño y Potencial",
    employeeCodeAlreadyExistsCannotUpdateEmployeeWithThatCode:
        "El código de empleado ya existe, no es posible actualizar al empleado con ese código",
    shiftAssignmentDateShort: "Fecha asignación turno",
    kpiDefinitionDeletedSuccessfully: "Definición de KPI eliminada con éxito",
    hoursAndMinutesHhmmColon: "Horas y Minutos (hh:mm)",
    cannotDeleteShiftBecauseItIsBeingUsed: "No es posible eliminar el turno porque está siendo utilizado",
    cannotExistMoreThanOneClassificationTypeWithSameCodeOrName:
        "No puede existir más de un tipo de clasificación que comparta el mismo código o nombre",
    cannotExistMoreThanOneTableWithSameCodeOrName:
        "No puede existir más de un registro que comparta el mismo código o nombre",
    verifyThatTheDateCellsAreComplete: "Verifique que las celdas de Fecha esten completas",
    taxTablexlsx: "Tabla de impuestos.xlsx",
    theMinimumNoteValueIs01: "El valor mínimo de la nota es 0,1",
    newActionRegistrationDate: "Nueva fecha de registro de la acción",
    integerNumeric: "Numérico entero",
    unpaidSalary: "Salario no remunerado",
    organizationChart: "Organigrama",
    newObjectiveType: "Nuevo tipo de objetivo",
    ratingNameCannotBeLongerThan60Characters: "El nombre de la calificación no puede tener más de 60 caracteres",
    valueFromIcon2: "Valor desde Icono 2",
    viewAllMarks: "Ver todas las marcas",
    noNoteTypesFound: "No se encontraron tipos de notas",
    visualComponentForEditor: "Componente visual para editor",
    cannotExistMoreThanOneFileTypeWithSameCodeOrName:
        "No puede existir más de un tipo de archivo que comparta el mismo código o nombre",
    accumulatorDefinition: "Definición de acumuladores",
    familyAssignmentsCreation: "Creación de asignaciones familiares",
    sendMessageToEvaluatorsRequestingPromptAttentionOnPerformanceRatings:
        "¿Desea enviar a los evaluadores seleccionados un mensaje solicitando la pronta atención de las calificaciones del desempeño?",
    bulkPhotoUpload: "Carga masiva de fotografías",
    usedBenefits: "Beneficios utilizados",
    mandatoryPercentage: "Porcentaje obligatorio",
    isDetailTable: "Es tabla de detalle",
    union: "Sindicato",
    targets: "Targets",
    newRecordsCannotHaveSameTableTypeAndYearAsOriginalRecords:
        "Los nuevos registros no pueden tener el mismo tipo de tabla y año que los registros originales",
    copy: "Copiar",
    deleteRecordsConfirmation: "¿Desea eliminar los registros?",
    youMustSelectACertificate: "Debe seleccionar un certificado",
    nonChargeable: "No imputable",
    structuresCannotHaveSameCodeOrName: "No pueden existir estructuras con el mismo código o nombre",
    executionDate: "Fecha de ejecución",
    newReason: "Nuevo motivo",
    recomposePeriodAccumulators: "Recomponer acumuladores del periodo",
    cannotExistMoreThanOneFieldWithSameOrderNumber: "No puede existir más de un campo con el mismo número de orden",
    selectUserToBlock: "Seleccione qué usuario desea bloquear",
    selectProcessToQuery: "Selección de proceso a consultar",
    requestDeletedSuccessfully: "Solicitud eliminada con éxito",
    icon2Box: "Icono 2 BOX",
    deleteSpecialProcessConfirmation: "¿Desea eliminar el proceso especial?",
    after: "Después",
    documentName: "Nombre del documento",
    allAccessGroups: "Todos los grupos de acceso",
    createAction: "Crear acción",
    sentimentAnalysis: "Análisis de sentimientos",
    accumulatorName: "Nombre del acumulador",
    competencyUpdatedSuccessfully: "Competencia actualizada con éxito",
    responseDistribution: "Distribución de respuestas",
    modeling: "Modelamiento",
    uploadPhotos: "Cargar fotografías",
    rangesFor9boxes: "Rangos para 9-Boxes",
    consentTypeUpdatedSuccessfully: "Tipo de consentimiento actualizado con éxito",
    addCollaboratorList: "Agregar lista de colaboradores",
    unsavedChangesConfirmation: "Hay modificaciones sin guardar, ¿Está seguro que desea salir?",
    indicateProfileParameters: "Indique los parámetros del perfil",
    postponeLoanInstallmentsConfirmation: "¿Está seguro que desea posponer las cuotas del préstamo?",
    comparative: "Comparativa",
    conceptSetCreatedSuccessfully: "Conjunto de conceptos creado con éxito",
    evaluationStatus: "Estado de la evaluación",
    noteStatusMustBeFinalToAcceptOrObjectYourPerformanceEvaluation:
        "Para aceptar u objetar tu evaluación del desempeño, el estado de la nota debe ser final",
    kpiIconographyIcons: "Iconografia KPI - Iconos",
    queryParameterDuplicatedSuccessfully: "Parámetro de consulta duplicado con éxito",
    pointsRedemption: "Canje de puntos",
    publicationEndDate: "Fecha hasta publicación",
    minimumNote: "Nota mínima",
    pointsForMedalTable: "Puntos para medallero",
    statusR2a:
        "Si las notas finales definidas para el proceso otorgan puntos para el medallero, estos puntos serán asignados al pasar a este estado.",
    evaluationProcessUpdatedSuccessfullyMedalPoints:
        "Proceso de evaluación actualizado con éxito y puntos asignados a los medalleros de los evaluados según sus notas obtenidas",
    evaluationProcessUpdatedSuccessfullyMedalPointsDeleted:
        "Proceso de evaluación actualizado con éxito. Se han eliminado los puntos entregados a los medalleros.",
    newUserMenu: "Nuevo menú de usuario",
    vacationsUpdatedSuccessfully: "Vacaciones actualizadas con éxito",
    sendReminderMessage: "Enviar mensaje recordatorio",
    noMaterialsOrResourcesFound: "No se encontraron materiales o recursos",
    totalEmployerContributions: "Total aportes del empleador",
    objectiveTypeCreatedSuccessfully: "Tipo de objetivo creado con éxito",
    employeeCannotBePublishedMoreThanOnceForSameConsentType:
        "El colaborador no puede estar publicado más de una vez para el mismo tipo de consentimiento",
    positionName: "Nombre del cargo",
    importPermissions: "Importar permisos",
    blockedUsersInSocial: "Usuarios bloqueados en Social",
    projectUpdatedSuccessfully: "Proyecto actualizado con éxito",
    specializationCreatedSuccessfully: "Especialización creada con éxito",
    standard: "Estándar",
    createBenefitType: "Crear tipo de beneficio",
    shiftCreation: "Creación de turno",
    fromPublications: "De las publicaciones",
    clickOnTheGraphToSeeDetails: "Click en el gráfico para ver el detalle",
    recommendation: "Recomendación",
    queryMustBeActive: "La consulta debe estar activa",
    loanDate: "Fecha del préstamo",
    completedFemalePlural: "Realizadas",
    maxOvertimeHoursForPreauthorization: "Horas diarias en contrato",
    othersFemale: "Otras",
    noSignatoriesRegistered: "No se hay firmante registrados",
    classification9boxes: "Clasificación 9-Boxes",
    recordUpdatedSuccessfully: "Registro actualizado con éxito",
    nameUnderWhichItWillBePublished: "Nombre con el cual será publicado",
    bulkDuplicate: "Duplicar de forma masiva",
    deleteCompetencyConfirmation: "¿Desea borrar la competencia?",
    vacationTypeString: "Tipo de vacaciones string",
    ascendingEvaluationWeighted: "Ponderado evaluación ascendente",
    atLeastOneObjectiveTypeMustBeEvaluated: "Se deben evaluar objetivos de al menos un tipo",
    earnedLegalAndOthers: "Ganados (legales y otros)",
    duplicateScheduling: "Duplicar programación",
    currentConsultationHour: "Hora de consulta (Actual)",
    areYouSureYouWantToDeleteTheQuestion: "¿Está seguro que desea eliminar la pregunta?",
    doYouWantToDeleteTheLoan: "¿Desea eliminar el préstamo?",
    markRecordsAsObservedForLaterReview: "Marcar registros como observados (Para revisión posterior)",
    payrollTypeDuplicatedSuccessfully: "Tipo de nómina duplicado con éxito",
    destinationTableName: "Nombre de la tabla destino",
    acceptOrObject: "Aceptar u objetar",
    doYouWantToDeleteTheSelectedDocuments: "¿Desea eliminar los documentos seleccionados?",
    documentGeneratedSuccessfullyAndSentForEmployeeReceipt:
        "Documento generado con éxito y enviado para la recepción del colaborador",
    periodDeletedSuccessfully: "Período eliminado con éxito",
    objectiveTypes: "Tipos de objetivos",
    youCanSendUsYourQueriesMakeClaimsContributeSuggestionsAndReportComplaints:
        "Podrás enviarnos tus consultas, hacer reclamos, realizar aportes o sugerir mejoras y canalizar denuncias.",
    cannotDeleteFileTypeBecauseItIsInUse: "No es posible eliminar el tipo de archivo porque está en uso",
    mayShort: "May",
    doYouWantToDeleteTheChannelType: "¿Desea eliminar el tipo de canal?",
    importFinishedCheckFileForResult: "Importación finalizada, verifique el archivo para ver el resultado",
    pointsAvailableForRedemption: "Puntos disponibles para canje",
    medicalLeaves: "Licencias médicas",
    actionTypesCreation: "Creación de tipos de acción",
    functionCodeLong: "Código de función",
    noGeoPositionInAttendanceMarkToShowOnMap: "No existe geoposición en la marca de asistencia para mostrar en el mapa",
    forAscendingEvaluatorSelectionAllSelectedCollaboratorsMustHaveTheSamePosition:
        "Para la elección del evaluador ascendente, todos los colaboradores seleccionados deben tener el mismo cargo",
    cannotDeleteCostCenterBecauseItIsInUse: "No es posible eliminar el centro de costo porque está en uso",
    youCanPublish: "Puedes publicar",
    valueUpToGreen: "Valor hasta Green",
    employeeMasterAlt: "Maestro de Empleados",
    positionClassifications: "Clasificaciones de cargos",
    toDo: "Por hacer",
    current: "Actual",
    calculationIndicator: "Indicador de cálculo",
    onlyOpenProcesses: "Solo procesos abiertos",
    selectRedemptionFormat: "Seleccione el formato del canje",
    folderWithoutHiddenFiles: "Carpeta sin archivos ocultos",
    youCanSendUsYourQueriesMakeClaimsContributeSuggestions:
        "Podrás enviarnos tus consultas, hacer reclamos, realizar aportes y sugerir mejoras.",
    markWithScheduledNotice: "Marcar con aviso programado",
    sat: "Sab",
    onlySystemTablesCanHaveEditorsEnabledUserTablesAreAlreadyAutomaticallyEnabledForEditorCreation:
        "Solo pueden habilitarse editores para tablas del sistema. Las tablas del usuario ya están habilitadas en forma automática para la creación de editores.",
    abbreviationLabels: "Abreviatura etiquetas",
    plan: "Plan",
    cannotDeleteLicenseBecauseItIsInUse: "No es posible eliminar la licencia porque está en uso",
    viewBenefitType: "Ver tipo de beneficio",
    duplicateVacationTable: "Duplicar tabla de vacaciones",
    doYouWantToDeleteThePaymentMethod: "¿Desea eliminar la forma de pago?",
    monnone: "MonNone",
    cannotDeleteWorkplaceBecauseItIsInUse: "No es posible eliminar el lugar de trabajo porque está en uso",
    deleteCollaborator: "Borrar colaborador",
    evaluatedComments: "Comentarios del evaluado",
    areYouSureYouWantToApproveTheCalculationProcessAndMoveItToTheHistory:
        "¿Está seguro que desea aprobar el proceso de cálculo y pasarlo al histórico?",
    licenseUpdatedSuccessfully: "Licencia actualizada con éxito",
    allFieldsAreRequiredAndAtLeastOneRatingMustExist:
        "Todos los campos son obligatorios y debe haber al menos una calificación",
    duplicateCompetency: "Duplicar competencia",
    defaultProcess: "Proceso por defecto",
    paymentMethodCreation: "Creación de forma de pago",
    processDescriptionLong: "Descripción del proceso",
    atLeastOneTransversalCompetencyMustBeSelected: "Se debe seleccionar al menos una competencia transversal",
    wed: "Mie",
    evaluationGroup: "Grupo de evaluación",
    noFamilyAssignmentsFound: "No se encontraron asignaciones familiares",
    columnSelectorType: "Tipo selector por columna",
    referenceQuotaNumber: "Número de cuota de referencia",
    profileCodeAlt: "Código de perfil",
    workdayChange: "Cambio de jornada laboral",
    noStudyTypesFound: "No se encontraron tipos de estudio",
    requestedValuePercentageOnSalary: "Porcentaje del valor solicitado sobre el sueldo",
    timekeepingSystemChangeCompletedSuccessfully: "El cambio del sistema de marcaje ha finalizado con éxito",
    workplaceModifiedSuccessfully: "Lugar de trabajo modificado con éxito",
    fromPeers: "De pares",
    subprocessType: "Tipo de subproceso",
    benefitMaximumBudget: "Presupuesto máximo del beneficio",
    maximumNote: "Nota máxima",
    unemploymentInsuranceTaxableLimit: "Tope imponible seguro cesantía",
    monthlyContractHours: "Horas mensuales contrato",
    changeWorkday: "Cambiar jornada laboral",
    noTemplatesFound: "No se encontraron plantillas",
    enterJobID: "Ingrese el ID del cargo",
    variableAccordingToType: "Variable según type",
    managersUppercase: "Managers",
    recipientSelection: "Selección de destinatario",
    ufLastDayPreviousMonth: "UF Último día mes anterior",
    indicatorDeletedSuccessfully: "Indicador eliminado con éxito",
    theProcessScheduleWasCreatedSuccessfully: "Programación de proceso creada con éxito",
    registrationName: "Nombre registro",
    specializationDeletedSuccessfully: "Especialización eliminada con éxito",
    alertAndEmailBodyText: "Texto para el cuerpo de la alerta y correo",
    dissemination: "Difusión",
    extraFunction: "Extra función",
    noCostCentersFound: "No se encontraron centros de costo",
    entryDelay: "Atraso en la entrada",
    noUserMenusFound: "No se encontraron menús de usuario",
    commission: "Comisión",
    versionCodeForDestinationTable: "Código de versión para tabla destino",
    mandatoryDocument: "Documento obligatorio",
    fieldsThatCouldNotBeDuplicated: "Campos que no se pudieron duplicar",
    details: "Detalles",
    assignEmployeesToPlan: "Asignar colaboradores al plan",
    conceptEntryStructurexlsx: "Estructura de ingreso de conceptos.xlsx",
    areYouSureYouWantToDeleteTheCommunication: "¿Está seguro que quiere eliminar la comunicación?",
    sqlToExecuteWhenSaving: "SQL para ejecutar al momento de grabar",
    sqlToExecuteWhenDeleting: "SQL para ejecutar al momento de eliminar",
    timeReference: "Referencia de tiempo",
    formName: "Nombre del formulario",
    potentialEvaluationQuestions: "Preguntas para evaluación del potencial",
    benefitType: "Tipo de beneficio",
    noEvaluatorAssigned: "Sin evaluador asignado",
    cannotAccessBecausePINRecoveryIsInProcess:
        "No es posible acceder porque tiene una recuperación de su PIN en trámite.",
    ratingString: "Calificación string",
    evaluationTypesAndTheirWeights: "Tipo de evaluaciones y sus ponderados",
    objectiveTypesCreation: "Creación de tipos de objetivos",
    cannotHaveMoreThanOneFamilyAssignmentSharingSameBracket:
        "No puede existir más de una asignación familiar que comparta el mismo tramo",
    cannotEditCommunicationBecauseItHasAssignedResponsible:
        "No es posible editar la comunicación porque ya tiene un responsable asignado",
    newHealthInstitution: "Nueva institución de salud",
    nullify: "Dejarla sin efecto",
    requestVacation: "Solicitar vacaciones",
    requestPermission: "Solicitar permiso",
    requestLoan: "Solicitar anticipo",
    costCenterDesc4: "Desc. Centro de costo 4",
    thirdPartyClassificationCreation: "Creación de clasificación de terceros",
    summaryAndVisualization: "Resumen y visualización",
    noAccumulatorsFound: "No se encontraron acumuladores",
    alertOrNoticeText: "Texto de la Alerta o Aviso",
    usesMultipleApproversOrSigners: "¿Utiliza múltiples aprobadores o firmantes?",
    usageFrequency: "Frecuencia de uso",
    actionOrMomentCode: "Código de acción o momento",
    jobMotivationalPotential: "Potencial motivador del cargo",
    doYouWantToDeleteTheFile: "¿Desea eliminar el archivo?",
    mail: "Mail",
    birthDate: "Fecha de nacimiento",
    importOvertimeAuthorization: "Importar autorización de horas extras",
    unauthorizedOvertime: "Horas extras sin autorizar",
    doYouWantToDeleteTheAlert: "¿Desea eliminar la alerta?",
    companyDepartmentStructure: "Estructura departamental de la empresa",
    exportCostDistributionTemplate: "Exportar plantilla de distribución de costos",
    fieldCode: "Código de campo",
    finalRatingDate: "Fecha final de calificación",
    communicationsWhereYouAreResponsibleForTheAttentionOrCanSelfAssignResponsibility:
        "Comunicaciones donde eres el responsable de la atención o en las cuales puedes auto asignarte como responsable de la atención",
    doYouWantToDeleteTheSchedule: "¿Desea eliminar la programación de horario?",
    cannotHaveMoreThanOnePayrollTypeSharingSameCodeOrName:
        "No puede existir más de un tipo de nómina que comparta el mismo código o nombre",
    additionalDaysCanContainUpTo3Decimals: "Días adicionales puede contener hasta 3 decimales",
    pendingQuotas: "Cuotas pendientes",
    orderSavedSuccessfully: "Orden guardado con éxito",
    organizationDefinition: "Definición de la organización",
    reasonCode: "Código de motivo",
    permissionDeletedSuccessfully: "Permiso eliminado con éxito",
    dataImportMethod: "Vía importación de datos",
    accountUpdateDate: "Fecha de actualización de la Cta.Cte.: ",
    noMedicalLeaveTypesFound: "No se encontraron tipos de licencia médica",
    cannotDeleteJobGroupForEvaluationsBecauseItIsInUseInPerformanceForms:
        "No es posible eliminar el grupo de cargo para evaluaciones porque está en uso en los formularios de desempeño",
    alphanumericValue: "Valor alfanumérico",
    forMassDepartmentalStructureChangeOnlyActiveEmployeesShouldBeSelected:
        "Para el cambio masivo de estructura departamental debe seleccionar solo a colaboradores vigentes",
    noIncomeStructuresFound: "No se encontraron estructuras de ingreso",
    transversalCompetenciesAndTheirWeightsDetail: "Detalle de las competencias transversales y sus ponderados",
    justifyAbsence: "Justificar ausencia",
    progressfilter: "ProgressFilter",
    cannotDeleteCommunicationBecauseItHasAssignedResponsible:
        "No es posible eliminar la comunicación porque ya tiene un responsable asignado",
    generateImageWithGroupOfPeople: "Generar imagen con grupo de personas",
    templateUpdatedSuccessfully: "Plantilla actualizada con éxito",
    laborInstance: "Instancia laboral",
    deleteMedicalLeaveType: "Eliminar tipo de licencia médica",
    paymentToThirdPartyComments: "Comentarios del pago al tercero",
    activation: "Activación",
    quotaValue: "Valor cuota",
    byRole: "Por ROL",
    icon1Box: "Icono 1 BOX",
    finalPerformanceRatingType: "Tipo nota final desempeño",
    whatsappTemplate: "Plantilla de WhatsApp",
    employeeStatusInPlan: "Estado empleado en el plan",
    fieldName: "Nombre de campo",
    recordsDeletedSuccessfully: "Registros borrados con éxito",
    noCurrentDataToGraph: "Sin datos actuales para graficar",
    cajaContributionPercentage: "Porcentaje aporte CAJA",
    theFollowingStructuresCannotBeImportedBecauseTheyHaveDataInDestination:
        "Las siguientes estructuras no se pueden importar ya que tienen datos en el destino: ",
    absenceDeletedSuccessfully: "Inasistencia eliminada con éxito",
    doYouWantToDeleteTheFunction: "¿Desea eliminar la función?",
    publicationCreatedSuccessfully: "Publicación creadas con éxito",
    numericFieldsMustHavePositiveValues: "Los campos numéricos deben tener valores positivos",
    payrollTypeCodeDoesNotExistInDatabase: "El código de tipo de nomina no existe en la base de datos",
    managementCostCenter: "Centro de costo de gestión",
    profileNameAlt: "Nombre del perfil",
    forecast: "Previsión",
    calibratedRatingObjectives: "Calificación calibrada objetivos",
    noValue: "Sin valor",
    level: "Nivel",
    annotationsVisibilityOnlyAllowedInDescendingEvaluations:
        "La visualización de anotaciones solo se permiten en evaluaciones descendentes",
    sourceTable: "Tabla origen",
    printCurrentAccount: "Imprimir cuenta corriente",
    categories: "Categorías",
    dimension5: "Dimensión 5",
    groupLeftSuccessfully: "Grupo abandonado con éxito",
    permissionStartDate: "Fecha de inicio del permiso",
    calculationBase: "Base de cálculo",
    totalEmployerContributionsNote: "Total aportes del empleador (Aportes patronales)",
    totalHours: "Horas totales",
    learnMore: "Conocer más...",
    group11: "Grupo 11",
    minimumValue1: "Valor minimo 1",
    discountStartPeriod: "Período de inicio del descuento",
    forMassCostCenterChangeOnlyActiveEmployeesShouldBeSelected:
        "Para el cambio masivo de centros de costo debe seleccionar solo a colaboradores vigentes",
    messageSentSuccessfully: "Mensaje enviado con éxito",
    codeShort: "Código",
    pleaseSpecifyNewRecognitionPlanParameters: "Indique los parámetros del nuevo plan de reconocimiento",
    thereIsAlreadyASubmissionForThisDay: "Ya existe una solicitud para este dia",
    evaluatedName: "Nombre del evaluado",
    socialSecurityInstitution: "Institución de Previsión",
    consentType: "Tipo de consentimiento",
    surveyDefinition: "Definición de encuestas",
    standardPerformance9boxes: "Desempeño estandar 9-Boxes",
    calibratedPerformance9boxes: "Desempeño calibrado 9-Boxes",
    valueFromIcon3: "Valor desde Icono 3",
    quotaNumber: "N° de cuota",
    evaluationType: "Tipo de evaluación",
    youMustSelectAGeneralManagement: "Debe seleccionar una gerencia",
    feedbackPurposeCreation: "Creación de propósito de feedback",
    duplicateEmployee: "Duplicar empleado",
    setFixedFilters: "Fijar filtros",
    removeFixedFilters: "Quitar filtros",
    medicalExamsDefinition: "Definición de exámenes médicos",
    actionTypeDeletedSuccessfully: "Tipo de acción eliminada con éxito",
    deleteWorkplace: "Eliminar lugar de trabajo",
    createVacation: "Crear vacaciones",
    additionalOrProgressiveDays: "Días adicionales o progresivos",
    doYouWantToDeleteTheLicense: "¿Desea eliminar la licencia?",
    classificationStartDate: "Fecha inicio clasificación",
    authToken: "AuthToken",
    nameCannotExceed60Characters: "El nombre no puede exceder los 60 caracteres!",
    numShort: "Num",
    recipient: "Destinatario",
    openMapLatitudeLongitude: "Abrir mapa (Latitud y Longitud)",
    byAccountAndProject: "Por cuenta y proyecto",
    used: "Utilizado",
    linkedTask: "Tarea vinculada",
    requirementsAndConditions: "Requisitos y condiciones",
    medicalExams: "Exámenes médicos",
    unsavedChangesDoYouWantToExitAnyway: "Hay cambios sin guardar, ¿desea salir de todos modos?",
    consents: "Consentimientos",
    receiveNoticeString: "Recibir aviso string",
    requestBenefit: "Solicitar beneficio",
    positive: "Positivo",
    consultationsDefinition: "Definición de consultas",
    planCode: "Código del plan",
    doYouWantToDeleteTheSelectedAlerts: "¿Desea eliminar las alertas seleccionadas?",
    contract: "Contrato",
    noDocumentsPublishedWithoutDigitalSignature: "No existen documentos publicados sin firma digital",
    associatedGrid: "Grilla asociada",
    schoolCertificateYear: "Año del certificado escolar",
    reject: "Rechazar",
    deleteScheduleAlt: "Eliminar programación",
    userMenuCreatedSuccessfully: "Menú de usuario creado con éxito",
    forMassWorkScheduleChangeOnlyActiveEmployeesShouldBeSelected:
        "Para el cambio masivo de jornada laboral debe seleccionar solo a colaboradores vigentes",
    managerColon: "Manager: ",
    totalLoansGranted: "Total de Préstamos Otorgados",
    surveyIsInUseInOnboardingMaterialsCannotBeDeleted:
        "La encuesta está en uso en los materiales y recursos de Onboarding, no puede ser eliminada",
    findEmoji: "Buscar emoji",
    emojisAndPeople: "Emojis y personas",
    animalsAndNature: "Animales y naturaleza",
    foodAndDrinks: "Alimentos y bebidas",
    activities: "Actividades",
    travelAndPlaces: "Viajes y lugares",
    objects: "Objetos",
    symbols: "Símbolos",
    noSystemTables: "No existen tablas del sistema disponibles por el momento",
    noUserTables: "No existen tablas del usuario disponibles por el momento",
    viewMyUsedBenefits: "Ver mis beneficios utilizados",
    benefitsToRequest: "Beneficios que puedes solicitar",
    youHaveAMoneyBenefit: "¡Tienes un beneficio con cobro directo en dinero!",
    requestVacations: "Solicitar vacaciones",
    activeCalendar: "Calendario de tiempos vigente",
    clickScheduleToRequestChange: "Click en un horario para solicitar el cambio.",
    yourWeeklyHoursContract: "Tus horas semanales por contrato",
    filterTypes: "Filtrar tipos",
    assistanceExitPlace: "Lugar de asistencia de salida",
    exitReference: "Referencia de salida",
    exitOrigin: "Origen de salida",
    timeBetweenMarks: "Tiempo transcurrido entre marcas",
    exitCoordinates: "Coordenadas de salida",
    evaluatedFullName: "Apellido y nombre del evaluado",
    evaluatorFullName: "Apellido y nombre del evaluador",
    evaluationDateFrom: "Fecha de evaluación desde",
    evaluationDateTo: "Fecha de evaluación hasta",
    partialNotePerformance: "NOTA PARCIAL DE DESEMPEÑO",
    finalNotePerformance: "NOTA FINAL DE DESEMPEÑO",
    executeProcess: "Ejecutar proceso",
    workMode: "Modalidad de trabajo",
    subsidyYoungWorker: "Subsidio trabajador joven",
    insurancePolicyType: "MCC - Tipo de póliza",
    insuranceValueUF: "MCC - Valor de la prima en UF",
    insurancePolicyNumber: "MCC - Número de póliza",
    rateAllEvent: "Tasa idem. a todo evento",
    unitAssignationDate: "Fecha asignación a unidad",
    icariusAccessEnabled: "Acceso a ICARIUS habilitado",
    icariusAccess: "Acceso a ICARIUS",
    clickScheduleToChangeDoubleCkickToAuth:
        "Click en un horario para cambiarlo. Doble click en área en blanco de una fecha para autorizar horas extras",
    types: "Tipos",
    assetsDiscountsIssues: "Haberes, descuentos e incidencias",
    issueMatrix: "Matriz de incidencias",
    selectTemplateSingle: "Seleccione plantilla",
    extraHoursToAuth: "Horas extra por autorizar",
    onlyExtraHoursToAuth: "Solo con horas extras sin autorizar",
    openCalendars: "Calendarios abiertos",
    historicCalendars: "Calendarios históricos",
    audio: "Audio",
    mustEnterDisagreementReason: "Debe ingresar el motivo de disconformidad",
    low: "Bajo",
    mid: "Medio",
    high: "Alto",
    withPerformanceClassificationNoPotential: "Con clasificación de desempeño y sin clasificación de potencial",
    withAccessFor: "Con acceso para",
    consent: "Consentimiento",
    useOrAccessRequired: "Uso o acceso obligatorio",
    answers: "Respuestas",
    viewAttachmentClickToOpen: "Ver adjunto (haga clic para abrir)",
    beforeAnsweringCheckAttachment: "Antes de responder, por favor revisa el adjunto (haga clic para abrir)",
    clickImageToEnlarge: "Haga clic en la imagen para ampliarla",
    processStartedCorrectly: "El proceso se ha iniciado correctamente",
    mustSelectAtLeastOneUser: "Debe seleccionar al menos un usuario",
    nextSigner: "Siguiente firmante",
    itContainsDigitalWarehouse: "El mismo contiene una bodega digital.",
    youHaveNoAccessToDigitalFolderOf: "No posee acceso a la carpeta digital de",
    filesWithWrongCode: "Hay archivos con código incorrecto",
    filesWithWrongExtension: "Hay archivos con extensión incorrecta",
    digitalWarehouseTypesOfFiles: "Tipos de archivo de la bodega digital",
    noInformationFound: "No se ha obtenido información",
    contractualDataSuccessfullyModified: "Los datos contractuales han sido modificados con éxito",
    resizingPositionsWarning:
        "Si pulsa REDIMENSIONAR PUESTOS Y MODIFICAR se aplicará el cambio de cargos y para ambos cargos (Origen y Destino) se reasignará la cantidad de puestos en forma automática y quedarán con el total de sus puestos ocupados.",
    forbidden: "Forbidden",
    businessUnitCreation: "Creación de unidad de negocio",
    anErrorOccurred: "Ha ocurrido un error",
    schoolingSuccessfullyDeleted: "Escolaridad eliminada con éxito",
    selectedAnnotationHasNoEvidence: "La anotación seleccionada no posee evidencia",
    dataForRecalculation: "Datos para reliquidación",
    errorWhileTryingToDeleteProcess: "Ha ocurrido un error al intentar eliminar el proceso.",
    invalidSelectors: "Selectores invalidos",
    checkThresholdsMatch: "Verifique que coincidan los umbrales minimos y máximos de las notas",
    minimumGreaterThanMaximum: "La nota mínima es mayor a la nota máxima",
    unsupportedFileType: "Tipo de archivo no admitido",
    confirmUserDeletionFromList: "¿Esta seguro que desea eliminar al usuario de la lista?",
    evaluatorFullNamePlural: "Apellido y nombres del evaluador",
    breakExit: "Salida al break",
    businessUnitName: "Nombre de la unidad de negocio",
    onlyOneLanguageWithSameCodeOrNameAllowed: "No puede existir más de un idioma que comparta el mismo código o nombre",
    assumedAllReportsPaymentsAndAccountingDone:
        "Se entendrá que usted ya ha emitido todos los reportes relacionados al proceso, que ha realizado todos los pagos respectivos (Tanto a los colaboradores como a terceros: Bancos, instituciones de recaudación previsional, etc) y que también lo ha contabilizado.",
    evaluatedFullNamePlural: "Apellido y nombres del evaluado",
    silverShieldsCount: "Cantidad de escudos de plata",
    entryMode: "Modalidad de ingreso",
    specifyColumnNumbersSeparatedByComma: " e indique los números de columna separados por coma (Ej. 1,2,5)",
    exitHours: "Horas de salida",
    businessUnit: "Unidad de negocio",
    newBusinessUnit: "Nueva unidad de negocio",
    schoolingCreation: "Creación de escolaridades",
    attendanceMarkingRange: "Rango permitido para marcar asistencia",
    confirmRecordDeletion: "¿Esta seguro que desea eliminar el registro?",
    rateObjectivesWithPercentage: "Califica a los objetivos con %",
    noInformationRetrieved: "No se ha obtenido información",
    scheduleChangeNotAllowedDueToExcessHours:
        "El cambio de horario no está permitido porque la suma de las horas de todos los horarios programados para la semana, supera la cantidad pactada contractualmente con el colaborador",
    dateComma: "Fecha,",
    fromTo: "{from} a {to}",
    warningBeforeEnablingEmployeesInPayroll:
        "Antes de habilitar a los colaboradores seleccionados en las nóminas elegidas, considere que primero se eliminarán todas las habilitaciones en nóminas ya existentes para dichos colaboradores.",
    calculationProcessPublishedSuccessfully: "El proceso de cálculo se ha publicado con éxito",
    quantityForPeriod: "Cantidad para el período",
    globalEvaluationCountByGradeType: "Campana de Gausss por tipo de nota",
    evaluationLockedDueToCalibration:
        "No podrá modificar la evaluación porque el evaluado ya ha sido calibrado, solo accederá en modo de visualización",
    meritsReceived: "Méritos recibidos",
    newLanguage: "Nuevo idioma",
    analyticsSummary: "Resumen de analítica",
    incidentType: "Tipo de incidencia",
    fromIncidents: "De las incidencias",
    employeeCodeUpdatedSuccessfully: "El código de empleado ha sido modificado con éxito",
    executionModeAlreadyHasProcessDefined:
        "Para este modo de ejecución ya existe un proceso definido. No es posible definir más de uno.",
    requesterParenthesis: " (Solicitante)",
    disabilityInsurance: "Seguro de invalidez",
    attendanceMarksRequireEntryOrExit: "Las marcas de asistencia deben tener fecha de entrada o salida",
    calculationProcessDeletedSuccessfully:
        "El proceso de cálculo ha sido eliminado de los proceso publicados con éxito",
    invalidYearEntry: "En año es necesario que ingrese un año válido, Ej: 2022",
    disability: "Incapacidad",
    transversalCompetenciesWithoutIndicators:
        "Ha seleccionado competencias transversales que no tiene indicadores definidos para evaluar",
    healthInstitutionUppercase: "Institución de Salud",
    jobStatistics: "Estadistica de cargo",
    workOrProjectModifiedSuccessfully: "La obra o faena ha sido modificada con éxito",
    protected: "Protegido",
    generateInstallments: "Generar cuotas",
    schoolingSingular: "Escolaridad",
    performanceEvaluationCalibrationAlt: "Calibración de evaluación de desempeño",
    weighted20Percent: "Ponderado 20%",
    goldShieldsCount: "Cantidad de escudos de oro",
    processCodeAlt: "Código del proceso",
    cannotDeleteBusinessUnitInUse: "No es posible eliminar la unidad de negocio porque está en uso",
    gradesDisplayedAreNotFinal:
        "Las calificaciones y notas mostradas no son notas finales y solo consideran las evaluaciones que se han realizado hasta este momento.",
    invalidRut: "El RUT ingresado no es válido",
    demeritsReceived: "Deméritos recibidos",
    cannotSelectSelf: "No puede seleccionarse a si mismo",
    percentageRankingByEvaluated: "Ranking porcentual (%) por evaluado",
    variableByType: "Variable segun type",
    invalidInstallmentCount: "La cantidad de cuotas no es válida",
    mustSelectSingleItem: "Debe seleccionar un unico item",
    nameExceeds60Characters: "El nombre no puede exceder los 60 caracteres",
    geoAnalysisQueryDefinition: "Definición de consultas para geoanálisis",
    businessUnitCode: "Código de unidad de negocio",
    schoolingUpdatedSuccessfully: "Escolaridad actualizada con éxito",
    onlyOneSchoolingWithSameCodeOrNameAllowed:
        "No puede existir más de una escolaridad que comparta el mismo código o nombre",
    choosePointAmountAndRedemptionType:
        "Elija la cantidad de puntos para alcanzar cada reconocimiento, y el tipo de canje",
    invalidYear: "El año no es válido",
    noLanguagesFound: "No se encontraron idiomas",
    conceptsWithoutAssignment: "Conceptos sin imputación",
    dailyUnit: "Unidad diaria",
    languageCreation: "Creación de idioma",
    daysElapsed: "Días transcurridos",
    conceptSetsWithDuplicateNameOrCodeNotAllowed:
        "No pueden existir conjuntos de conceptos con el mismo nombre o codigo",
    employeesWithPausedOnboarding: "Colaboradores con onboarding detenido",
    listComma: "Lista,",
    onboardingStepChangeWarning:
        "Si cambia el momento o tipo de acción hay materiales o recursos vinculados al paso del Onboarding que no corresponden al tipo de momento o acción que está definiendo y serán eliminados, ¿Desea proceder de todos modos?",
    enterValidNumericValue: "Ingrese un valor numérico válido.",
    numberOfEvaluated: "Cantidad de evaluados",
    invalidDataOrDateTimeExceedsNow:
        "Hay datos invalidos, y la fecha y hora no pueden superar a la fecha y hora actual",
    welcomeToCommunicationChannel: "¡Estás en nuestro canal de comunicaciones, bienvenido!",
    entryAndExitDaysMustBeContiguous: "El día de entrada y el de salida deben ser contiguos o iguales",
    startDateCannotBeWeekendOrHoliday:
        "La fecha de inicio o fecha desde, no puede ser un día Sábado, Domingo o Feriado",
    customFormulaUppercase: "Fórmula personalizada",
    criticalIncidentLog: "Registro de incidentes críticos (Anotaciones)",
    enterValidPercentage: "Ingrese un porcentaje válido",
    duplicateProfileNamesNotAllowed: "No puede haber perfiles con nombres repetidos",
    clickAreaTrackingHelp:
        " para luego saber en que área del gráfico se hizo click. Dicho código se cargará en la variable #CODE1# y el ",
    enteredCodeIsInvalid: "El código ingresado es inválido",
    dailyUnitString: "Unidad diaria string",
    silverMedalsCount: "Cantidad de medallas de plata",
    mandatoryValue: "Valor obligatorio",
    averagePercentageRankingByEvaluator: "Promedio de ranking porcentual (%) por evaluador",
    attachmentsCount: "Cantidad de adjuntos",
    useMultipleApproversOrSignatories: "¿Utiliza multiples aprobadores o firmantes?",
    deleteBusinessUnit: "Eliminar unidad de negocio",
    acceptingTheEvaluationWillGenerateADocument:
        "Aceptando la evaluación emitira un documento con firma digital que se guardara en su carpeta digital",
    cannotDeleteConsentForEmployee:
        "No es posible eliminar el consentimiento para el colaborador porque ya ha sido recepcionado",
    disabilityString: "Incapacidad string",
    daysElapsedSinceEntry: "Días transcurridos desde el ingreso",
    goldMedalsCount: "Cantidad de medallas de oro",
    invalidReferenceInstallmentNumber: "El número de cuota de referencia no es válido",
    confirmLanguageDeletion: "¿Desea eliminar el idioma?",
    incidentsAlreadyExistInDateRange:
        "Ya existen incidencias dentro de las fechas ingresadas, la licencia no puede grabarse",
    fullName: "Apellido y Nombres",
    activeAndPausedPlans: "Planes activos y detenidos",
    schoolingString: "Escolaridad string",
    listSelectionTypeValidOnlyForParamsFromSQL:
        "Tipo de selección de lista solo es válido para parámetros cuya lista de valores se obtenga utilizando el SQL de arriba",
    confirmProcessDeletion: "¿Está seguro que desea eliminar el proceso?",
    deleteSchooling: "Eliminar escolaridad",
    generalValuesUppercase: "Valores Generales",
    stopped: "Detenido",
    totalDaysSpentOnCare: "Días totales que tomó la atención",
    optionalKpiSqlDescription:
        "Optativo. Si existe, se mostrará el resultado de este SQL en una grilla cuando se haga click en el KPI. Si es un KPI anidado se mostrará cuando haga click en el último gráfico.",
    allowedCharactersLettersNumbersDash: "Permitido letras, numeros y guión (-)",
    maxGrade: "Nota hasta",
    newSchooling: "Nueva escolaridad",
    confirmSchoolingDeletion: "¿Desea eliminar la escolaridad?",
    noMoreThanOneFieldWithSameOrderNumber: "No puede existir más de un campo que con el mismo número de orden",
    downloadEvidence: "Descargar evidencia",
    sqlForKpiSubtitle: "SQL para subtitulo del KPI (Optativo y dependerá de cada KPI)",
    reviewDate: "Fecha de revision",
    functionNameRestrictions:
        "El nombre de la función solo puede contener caracteres de la: “a” a la “z”. La “ñ” no está permitida y tampoco espacios dentro del nombre.",
    sqlVisualizationColumnTypes:
        "Para cada columna de SQL de visualización, los tipos de selectores pueden ser: Lista,Fecha,Alfa,Num,Mon.",
    noDuplicateProfileCodes: "No puede haber perfiles con códigos repetidos",
    weakness: "Debilidad",
    incidentsAlreadyExistInEnteredDates:
        "Ya existen incidencias dentro de las fechas ingresadas, la inasistencia no puede grabarse",
    daysElapsedWithoutReception: "Días transcurridos sin recepcionar",
    invalidEnteredTime: "La hora ingresada no es válida",
    maxGradeCannotExceed9999: "La notá maxima no puede ser mayor a 9999",
    communicationAlreadyCompleted: "La comunicación ya fue concluida",
    confirmBusinessUnitDeletion: "¿Desea eliminar la unidad de negocio?",
    schoolingCreatedSuccessfully: "Escolaridad creada con éxito",
    sqlGraphsColumnSelectionInstructions:
        "Para los gráficos de SQL debe seleccionar siempre 2 columnas, la primera de tipo alfanumérico y se utilizará como el nombre de la serie, y la segunda de tipo numérica y se tomará como Valor de la serie, a excepción de los gráficos de Radar, donde podrán ser varias las columnas numéricas (Ideal entre 5 y 10). Si es un gráfico de tortas, horizontal, vertical o de líneas y contiene KPI anidados, incluya una tercer columna alfanumérica que contenga el ",
    cannotEditBecauseDigitallySigned: "No es posible editarlo porque ha sido firmado digitalmente",
    calculationSequenceUppercase: "Secuencia de Cálculo",
    exitTimeMustBeGreaterThanOrEqualToEntry:
        "La fecha y hora de salida debe ser mayor o igual que la fecha y hora de entrada",
    feedbacksReceivedDuringPeriod: "Feedbacks recibidos en el período",
    noDuplicateStepNames: "No puede haber pasos con nombres repetidos",
    workDayDataSuccessfullyModified: "Los datos de la jornada laboral han sido modificados con éxito",
    momentarilyStopped: "Momentáneamente detenida",
    allowedRangeFromGeoposition: "Rango permitido desde la geoposición",
    numberOfPositionsCannotBeZero: "La cantidad de puestos no puede ser cero",
    positionsMustBeANumber: "La cantidad de puestos debe ser un número",
    units: "Unidades",
    thankYouForReporting:
        "Gracias por compartir tu denuncia con nosotros. A la brevedad asignaremos a un encargado para su atención y te garantizamos total confidencialidad.",
    codeCannotExceed8Characters: "El código no puede exceder los 8 caracteres",
    vacationTableDuplicatedSuccessfully: "La tabla de vacaciones ha sido duplicada con éxito",
    noMoreThanOneBusinessUnitWithSameCodeOrName:
        "No puede existir más de una unidad de negocio que comparta el mismo código o nombre",
    percentageSumMustBe100: "La sumatoria de los porcentajes debe ser 100%",
    bronzeShieldsCount: "Cantidad de escudos de bronce",
    recordDeletionPossibleOnlyWhen: "Solo es posible eliminar el registro cuando ",
    requiredPoints: "Puntos requeridos",
    positionSuccessfullyModified: "El cargo ha sido modificado con éxito",
    validValuesList: "Lista de valores válidos asociados",
    fieldHasValidValuesList:
        "Este campo tiene una lista de valores válidos asociados. Por ende, la lista desplegable se cargará en forma automática excepto que usted ingrese su propio SQL para la lista.",
    cannotDeleteSchoolingBecauseInUse: "No es posible eliminar la escolaridad porque está en uso",
    freePositionsMustBeANumber: "La cantidad de puestos libres debe ser un número",
    gradeFrom: "Nota desde",
    cannotDeleteBenefitOrDiscountBySociety:
        "No es posible eliminar un haber o descuento cuya modalidad de ingreso sea por sociedad",
    requiredSeniorityMonths: "Meses de antigüedad requeridos",
    cannotDeleteLanguageBecauseInUse: "No es posible eliminar el idioma porque está en uso",
    indicatorNumberAlt: "Número del indicador",
    cannotDeleteRecordBecauseIntegrityControl:
        "No es posible eliminar el registro porque la tabla detalle asociada tiene control de integridad",
    serverErrorOccurred: "Ocurrió un error en el servidor",
    deleteLanguage: "Eliminar idioma",
    totalRecognitionsCount: "Cantidad total de reconocimientos",
    processAlreadyPublished: "Este proceso ya ha sido publicado",
    globalEvaluationCountByGradeAndEvaluator: "Cantidad global de evaluaciones por tipo de nota y evaluador",
    bankAndAccountFieldsCannotBeEmpty: "Los campos Banco y Cuenta bancaria no pueden estar vacios",
    actionsOrResponsesCount: "Cantidad de acciones o respuestas",
    confirmDownloadFolderWithoutHiddenFiles: "¿Desea descargar la carpeta sin los archivos ocultos?",
    cannotDeletePeriodForObjectivesBecauseInUse:
        "No es posible eliminar el período para objetivos porque está en uso en las Metas y Objetivos definidos para los colaboradores",
    installmentsCount: "Cantidad de cuotas",
    invalidFileExtension: "Archivo de extensión invalida",
    feedbackCanOnlyBeGivenIfGradeStatusIsFinal:
        "Para poder dar feedback, el estado de la nota del evaluado debe ser “Nota Final”",
    incidentsAlreadyExistInDateRangePermissionCannotBeSaved:
        "Ya existen incidencias dentro de las fechas ingresadas, el permiso no puede grabarse",
    requiredPointsForBenefitMustBeEntered: "Debe ingresar los puntos requeridos para el beneficio",
    ifUnsureOfStructureUseWagesAndDiscountsFunction:
        "Si no está seguro de la estructura que debe utilizar, acceda a la función de Haberes y Descuentos, seleccione una modalidad de ingreso, y dentro de ella seleccione la estructura deseada. Luego, pulse el ícono para exportar estructura de importación.",
    pleaseEnterConceptCodeAndName:
        "Por favor, ingrese el código de concepto y nombre. Estos datos reemplazarán los originales.",
    historicalData: "Historicas",
    noSeniorityRequired: "Sin antiguedad requerida",
    verifyThatCellsInDateAreComplete: "Verifique que las celdas de En fecha esten completas",
    ifEnteringIntegrityControlDataEnterAll3Fields:
        "Si ingresa datos para control de integridad, es necesario que ingrese los 3 campos",
    numberOfPositionsCannotBeLessThanOccupiedPositions:
        "La cantidad de puestos no puede ser menor a la cantidad de puestos ocupados.",
    invalidEnteredValue: "El valor ingresado no es válido",
    youHaveASubmissionWithPendingDocumentationApproval:
        "Tiene una solicitud con documentación pendiente de aprobación en tramite",
    noBusinessUnitsFound: "No se encontraron unidades de negocio",
    conceptCodeIsInvalidCanContainOnlyLettersNumbersAndCharacters:
        "El código del concepto no es válido. Puede contener únicamente letras, números y los caracteres ",
    holidayTableDuplicatedSuccessfully: "La tabla de feriados ha sido duplicada con éxito",
    countryOfResidence: "País de residencia",
    sumOfCompetenciesMustBe100: "La sumatoria de las competencias debe ser 100%",
    allAnswers: "Todas las respuestas",
    globalQuantities: "Cantidades globales",
    scheduledExit: "Salida programada",
    ifYouPressCancelNoModificationWillBeMade:
        "Si pulsa CANCELAR, no se hará la modificación y deberá reasignar para el cargo destino la cantidad de puestos desde la función “Estructura de cargos” para dejar los puestos libres que son necesarios.",
    verifyThatCellsHaveValidValues: "Verifique que las celdas tengan valores válidos",
    recognitionPointsReceived: "Puntos recibidos de reconocimiento",
    forExternalDocumentsYouCanDecideIfAcceptanceIsRequired:
        "Para los documentos externos, podrá decidir si el tipo de aceptación es necesario al momento de firmarlo.",
    whatsappTemplateAlt: "Plantilla WhatsApp",
    sumOfPendingInstallmentsDoesNotMatchPendingBalance:
        "La sumatoria de cuotas pendientes no coincide con el saldo pendiente",
    totalCount: "Cantidad total",
    occupiedPositionsMustBeANumber: "La cantidad de puestos ocupados debe ser un número",
    evaluatedColon: "Evaluado:",
    fromClickedAreaFirstColumnInDescVariable:
        " del área clickeada, 1er columna, en la variable #DESC1#. Si se accede a un 2do gráfico, sucederá lo mismo y se cargarán las variables #CODE2# y #DESC2#.",
    quantity: "(Cantidad)",
    atLeastOneCompetencyMustBeSelectedSumMustBe100:
        "Al menos una competencia debe ser seleccionada. La sumatoria de las competencias debe ser 100%",
    unit: "Unidad",
    uponRequest: "A pedido",
    averageGlobalPercentageRankingByGroups: "Promedio de ranking porcentual (%) global y por grupos",
    noSchoolingsFound: "No se encontraron escolaridades",
    sumOfAllWeightedEvaluationsMustBe100: "La sumatoria de todos los ponderados de evaluaciones debe ser 100%",
    cannotDeleteBecauseDigitallySigned: "No es posible eliminarlo porque ha sido firmado digitalmente",
    bronzeMedalsCount: "Cantidad de medallas de bronce",
    pointsExchangeModeRequiresRequiredPoints:
        "Para definir modo de acceso mediante canje por puntos es necesario que ingrese los puntos requeridos",
    daysWorkedCount: "Cantidad de días trabajados",
    incidentsAlreadyExistInEnteredDatesVacationsCannotBeSaved:
        "Ya existen incidencias dentro de las fechas ingresadas, las vacaciones no pueden grabarse",
    invalidDate: "Invalid date",
    competencyOrigin: "Origen de la competencia",
    chosenDateIsInUse: "La fecha elegida se encuentra en uso",
    considerThatSelectedFileMustBeCompatibleWithWagesAndDiscountsImportStructures:
        "Considere que el archivo seleccionado debe tener una estructura compatible con las estructuras de ingreso para Haberes y Descuentos.",
    doYouConsiderTheFollowingAs: "¿Considera a las siguientes como ",
    enteredQuantityExceedsMaximumDaysForPermissionType:
        "La cantidad ingresada supera la cantidad de días máximo del tipo de permiso",
    changeRole: "Cambiar rol",
    roleChangedOk: "Rol cambiado con éxito",
    noUtilsDownloads: "No existen descargas de utilidad por el momento",
    previousMenuLocation: "Menú de ubicación anterior",
    deleteWorkAndTask: "Eliminar obra/faena",
    doYouWishToDeleteWorkAndTask: "¿Desea eliminar la obra/faena?",
    workAndTaskCreation: "Creación de obra/faena",
    newWorkAndTask: "Nueva obra/faena",
    noWorkAndTask: "No se encontraron obras/faenas",
    workTaskRepeatedCode: "No puede existir más de una obra/faena que comparta el mismo código",
    workTaskDeletedOk: "Obra o Faena se ha eliminado correctamente",
    workTaskCreatedOk: "Obra y Faena se ha creado correctamente",
    workTaskUpdatedOk: "Obra y Faena se ha actualizado correctamente",
    areYouSureYouWantToRunTheProcessWithName: "¿Está seguro que desea ejecutar el proceso: {process}?",
    accessGroupsAmount: "{amount} grupo/s de acceso",
    accessCreation: "Creación de acceso",
    userAssignedToCalculation1: "El usuario está asignado para la ejecución de los cálculos en alertas.",
    userAssignedToCalculation2:
        "Antes de cambiar su estado de Staff de RR.HH. o de eliminarlo, reemplace al usuario por otro, en ‘Accesos y Propiedades’",
    monthsBackwardsCalculations: "Meses hacia atrás para cálculos",
    accumulatorDeletedOk: "Acumulador se ha eliminado correctamente",
    accumulatorCreatedOk: "Acumulador se ha creado correctamente",
    accumulatorUpdatedOk: "Acumulador se ha actualizado correctamente",
    view2: "Vista",
    clickOnActionToChangeDate:
        "Click en una acción planificada para cambiar la fecha de registro de la acción o la fecha de la alerta",
    changeDates: "Modificar fechas",
    actionTypeDeletedOk: "El tipo de acción se ha eliminado correctamente",
    actionTypeCreatedOk: "El tipo de acción se ha creado correctamente",
    actionTypeUpdatedOk: "El tipo de acción se ha actualizado correctamente",
    employersToReceiveRequests: "Empleadores para recepción de solicitudes",
    alertActivation: "Activación de alerta/aviso",
    alertDefinition: "definición de alerta/aviso",
    howToIncludeSQLDataInMail:
        "Si desea que en el cuerpo del correo se incluyan datos del SQL de visualización, marque Graba referencia e indique los números de columna separados por coma (Ej. 1,2,4)",
    systemAlerts: "Alertas/avisos del sistema",
    userAlerts: "Alertas/avisos del usuario",
    deleteAlertConfirmation: "¿Está seguro que desea eliminar la alerta/aviso?",
    alertCreatedOk: "Alerta/Aviso creada con éxito",
    alertUpdatedOk: "Alerta/Aviso actualizada con éxito",
    alertDeletedOk: "Alerta/Aviso eliminada con éxito",
    alertDuplicatedOk: "Alerta/Aviso duplicada con éxito",
    alertActivationUpdateOk: "Activación de alerta/aviso modificada con éxito",
    templatesCreation: "Creación de plantillas",
    deleteTypeOf: "Eliminar tipo de {type}",
    deleteTypeOfConfirmation: "¿Desea eliminar el tipo de {type}?",
    createTypeOf: "Creación de tipo de {type}",
    definitionTypeOf: "Definición de tipo de {type}",
    noFoundTypeOf: "No se encontraron tipos de {type}",
    newTypeOf: "Nuevo tipo de {type}",
    repeatedTypeOf: "No puede existir más de un tipo de {type} que comparta el mismo código o nombre",
    inUseTypeOf: "No es posible eliminar el tipo de {type} porque está en uso",
    typeOfDeletedOk: "El tipo de {type} se ha eliminado correctamente",
    typeOfCreatedOk: "El tipo de {type} se ha creado correctamente",
    typeOfUpdatedOk: "El tipo de {type} se ha actualizado correctamente",
    secuence: "Secuencia",
    selectPayrollType: "Seleccione tipo de nómina",
    calculateProcess: "Calcular proceso",
    assetsAndDiscountsEntryByAPI: "Haberes y descuentos - Ingreso de datos via API",
    bankDeletedOk: "El banco se ha eliminado correctamente",
    bankCreatedOk: "El banco se ha creado correctamente",
    bankUpdatedOk: "El banco se ha actualizado correctamente",
    dimension: "Dimensión",
    planBenefit: "Beneficio para plan",
    collaboratorAcceptanceType: "Tipo de aceptación del colaborador",
    externalDocumentsHelperText:
        "Para los documentos externos, podrá decidir si el tipo de aceptación es necesario al momento de firmarlo",
    selectTemplateRelatedToDocument: "Seleccione que plantilla se relaciona con el documento",
    typeOfRequestRelatedToQuestion: "¿Con qué tipo de solicitud se relaciona?",
    entry2: "ingreso",
    exit2: "egreso",
    familyTypeCreation: "Creación de tipo de familiar",
    purposeDeletedOk: "El propósito se ha eliminado correctamente",
    purposeCreatedOk: "El propósito se ha creado correctamente",
    purposeUpdatedOk: "El propósito se ha actualizado correctamente",
    icariusPortal: "Portal informativo de ICARIUS",
    calificationToUse: "Calificación a utilizar",
    useColor: "¿Utiliza color?",
    califications: "Calificaciones",
    reasonDeletedOk: "El motivo se ha eliminado correctamente",
    reasonCreatedOk: "El motivo se ha creado correctamente",
    reasonUpdatedOk: "El motivo se ha actualizado correctamente",
    turnDeletedOk: "El turno se ha eliminado correctamente",
    turnCreatedOk: "El turno se ha creado correctamente",
    turnUpdatedOk: "El turno se ha actualizado correctamente",
    scores: "Notas",
    authAbsenceDays: "Días de ausencia autorizados",
    imageSignatureNoDigital: "Imagen para firma no digital",
    pixels: "pixeles",
    loginImage: "Imagen de login",
    recommended: "recomendado",
    setCorporateColor: "Configurar color corporativo",
    doYouConsiderObservationsForAssistanceAnalysis:
        "¿Considera a las siguientes como observaciones para el análisis de asistencia?",
    functionTypeCreation: "Creación de tipo de función",
    seniorityTo: "Antigüedad hasta (Años)",
    absenceByTraining: "Ausencia por capacitación o cursos",
    absenceCode: "Código de inasistencias",
    absence: "inasistencia",
    medicalLicence: "licencia médica",
    absenceTypeDeletedOk: "Tipo de inasistencia eliminado correctamente",
    absenceTypeCreatedOk: "Tipo de inasistencia creado correctamente",
    absenceTypeUpdatedOk: "Tipo de inasistencia actualizado correctamente",
    permissionTypeDeletedOk: "Tipo de permiso eliminado correctamente",
    permissionTypeCreatedOk: "Tipo de permiso creado correctamente",
    permissionTypeUpdatedOk: "Tipo de permiso actualizado correctamente",
    licenceTypeDeletedOk: "Tipo de licence eliminado correctamente",
    licenceTypeCreatedOk: "Tipo de licence creado correctamente",
    licenceTypeUpdatedOk: "Tipo de licence actualizado correctamente",
    balanceCC: "Saldo disponible en cuenta corriente",
    createKPIDefinition: "Crear definición de KPI",
    editKPIDefinition: "Editar definición de KPI",
    kpiDefinitionGraphSQLHelper:
        "Para los gráficos de SQL debe seleccionar siempre 2 columnas, la primera de tipo alfanumérico y se utilizará como el nombre de la serie, y la segunda de tipo numérica y se tomará como Valor de la serie, a excepción de los gráficos de Radar, donde podrán ser varias las columnas numéricas (Ideal entre 5 y 10). Si es un gráfico de tortas, horizontal, vertical o de líneas y contiene KPI anidados, incluya una tercer columna alfanumérica que contenga el Código de la Serie para luego saber en que área del gráfico se hizo click. Dicho código se cargará en la variable #CODE1# y el Nombre del área clickeada, 1er columna, en la variable #DESC1#. Si se accede a un 2do gráfico, sucederá lo mismo y se cargarán las variables #CODE2# y #DESC2#.",
    holidayType: "Tipo de feriados",
    doYouWishToRquestBenefit: "¿Desea solicitar el beneficio {benefit}?",
    lastAccess: "Último acceso",
    moveToNoNecessaryWarning:
        "Si mueve la acción a “No necesaria” tenga presente que posteriormente no podrá moverla a otro estado.",
    moveToDoneWarning1: "Si mueve la acción a la columna Realizado es porque la tarea ha terminado.",
    moveToDoneWarning2: "Considere que no podrá moverse a otro estado posteriormente.",
    activateBySelection: "Activar por selección",
    allowConcurrentPayrollSameType: "Permitir nóminas concurrentes de este mismo tipo",
    enabledCollaboratorDetermination: "Determinación de colaboradores habilitados",
    payrollTypeDeletedOk: "Tipo de nómina eliminado correctamente",
    payrollTypeCreatedOk: "Tipo de nómina creado correctamente",
    payrollTypeUpdatedOk: "Tipo de nómina actualizado correctamente",
    selectPeriod: "Seleccionar periodo",
    doYouWantToRecompose: "¿Está seguro que desea recomponer los acumuladores históricos del período {period}",
    recomposingHistoricAccumulators: "Recomponiendo acumuladores históricos para {period}",
    recompositionFinished: "La recomposición de acumuladores históricos para {period} ha finalizado",
    signDocumentWarning1: "La selección de documentos realizada incluye aprobaciones simples y multiples.",
    signDocumentWarning2:
        "Para firmar la documentación, debe hacerlo separando los grupos de documentos teniendo en cuenta el tipo de aprobación de los mismos.",
    deleteRequestWarning:
        "Si confirma, será notificado tanto el solicitante {appealer_name} como el receptor de la solicitud {responsible_name} indicando que la solicitud de {type} con fecha {start_date} ha sido eliminada, ¿confirma de todos modos?",
    deleteOpenRequestWarning: "¿Está seguro que desea eliminar la solicitud seleccionada que está en curso?",
    insurance: "Seguro",
    scheduleCodeForDate: "Código de horario para la fecha",
    blockUserQuestion: "¿Desea desbloquear a {name}?",
    protectedOnEdit: "Protegido en edición",
    deleteImageFieldQuestion: "¿Desea borrar la imagen del campo {name}?",
    deleteFileFieldQuestion: "¿Desea borrar el archivo del campo {name}?",
    manyRegistryWithSameFieldsWarning: "No puede existir más de un registro que comparta los siguientes campos",
    registriesDeletedOk: "Los registros se han eliminado correctamente",
    registryCreatedOk: "El registro se ha creado correctamente",
    registryUpdatedOk: "El registro se ha actualizado correctamente",
    registryStartedOk: "El registro se ha iniciado correctamente",
    entryType: "Tipo de ingreso",
    max40Char: "Cant. caracteres: {length}. Max. permitido: 40.",
    repetitionControl: "Control de repetición",
    dropdownSQLWarning1:
        "Para el SQL es necesario que el primer campo del SELECT se llame Code, el cual debe contener el código del desplegable, y el segundo campo se llame Name, el cual debe contener la descripción del desplegable.",
    dropdownSQLWarning2: "Si utiliza filtro, incluya el campo para filtrar como tercer campo de la consulta.",
    filterField: "Campo para filtro",
    fieldDefinitionOfTable: "Definición de campos de la tabla",
    cantChangeVisualComponent:
        "No es posible cambiar el componente visual de este campo porque está definido como filtro para el campo",
    cantDeleteFilterField:
        "No es posible eliminar este campo del editor porque está definido como filtro para el campo",
    fieldDeletedOk: "El campo se ha eliminado correctamente",
    fieldCreatedOk: "El campo se ha creado correctamente",
    fieldUpdatedOk: "El campo se ha actualizado correctamente",
    thirdPartyClassificationAlt: "Clasificación del tercero",
    conceptSetCreation: "Creación de conjunto de conceptos",
    setType: "Tipo de conjunto",
    duplicateConceptSet: "Duplicar conjunto de conceptos",
    changeContractDataEmployeesQuestion:
        "¿Está seguro que quiere cambiar los datos contractuales para {length} colaborador/es?",
    cantAddNewCollaboratorsToProcess1:
        "No es posible agregar a nuevos colaboradores a este proceso, porque ya hay actividades avanzadas para uno o más colaboradores.",
    cantAddNewCollaboratorsToProcess2: "Cree un nuevo proceso para incorporar a nuevos colaboradores.",
    zeroHoursMinutes: "0,00 / 00:00 horas y minutos",
    currentBalance: "Saldo actual",
    positionNotEnoughSpaceWarning:
        "El cargo destino no tiene los puestos libres suficientes para aplicar el cambio masivo. Solo dispone de {amountInUse} puestos libres y se requieren {amountNeeded}.",
    changePositionsQuestion: "¿Está seguro que quiere cambiar el cargo para {length} colaborador/es?",
    rehireQuestion: "¿Está seguro que quiere recontratar a {length} colaborador/es?",
    changeWorkOrTaskQuestion: "¿Está seguro que quiere cambiar la obra o faena para {length} colaborador/es?",
    changeCostCenterQuestion: "¿Está seguro que quiere modificar el centro de costo para {length} colaborador/es?",
    payRollChangeWarning1:
        "Ha modificado la habilitación en nóminas y el colaborador existe en un proceso de cálculo actual. Es necesario recalcular el proceso en forma total si desea omitir a dicho colaborador del proceso.",
    payRollChangeWarning2:
        "Si lo ha deshabilitado de un tipo de nómina también puede utilizar la opción de eliminar al colaborador del proceso de cálculo sin necesidad de realizar un recálculo total.",
    markingSystemQuestion:
        "¿Está seguro que quiere cambiar los datos del tipo de marcaje para {length} colaborador/es?",
    salaryRequiredAndPositive: "Sueldo/salario es obligatorio y debe ser un valor positivo",
    salaryMassiveChange: "Cambio masivo de sueldos/salarios",
    newSalary: "Nuevo sueldo/salario",
    terminationQuestion: "¿Está seguro que quiere asignar los datos de desvinculación para {length} colaborador/es?",
    turnChangeQuestion: "¿Está seguro que quiere cambiar los datos de turnos para {length} colaborador/es?",
    fileWIthEmployeeCodeHelperText:
        "Los archivos deben comenzar con el código del empleado o número interno seguido de guión bajo (Ej. 12345_nombre_archivo.jpg)",
    workingDayQuestion: "¿Está seguro que quiere cambiar los datos de la jornada laboral para {length} colaborador/es?",
    massiveActions: "Acciones masivas/especiales",
    changeSalary: "Cambiar sueldos/salarios",
    massiveChangeProcessWarning1:
        "Ha cambiado datos que tienen relación con la habilitación de los Colaboradores en los procesos de cálculo.",
    massiveChangeProcessWarning2:
        "Acceda a los procesos de cálculo actuales y actualice la lista de colaboradores que están seleccionados para los procesos, porque en función de los datos que ha cambiado, la lista de colaboradores seleccionados pudo haber variado.",
    massiveChangeProcessWarning3:
        "Posterior a la revisión de los procesos, es muy recomendable que ejecute un proceso de cálculo total.",
    calculationProcesses: "Procesos de cálculo",
    internNumberInUse:
        "El Número Interno ya está siendo utilizado, por favor asigne otro o déjelo vacío. El próximo disponible para utilizar es {nextInternalNumber}",
    internNumberInUse2: "El Número Interno ya está siendo utilizado, por favor asigne otro",
    inUseOnboardingWarning1: "La asignación no se ha realizado.",
    inUseOnboardingWarning2: "Ha seleccionado empleados que ya se encuentran en un proceso actual de onboarding.",
    inUseOnboardingWarning3: "Debe omitirlos de la lista seleccionada",
    createSpecialProcessParameter: "Crear parámetro del proceso especial",
    editSpecialProcessParameter: "Editar parámetro del proceso especial",
    sqlParameterHelperText:
        'Para el SQL es necesario que el primer campo del SELECT se llame "Code", el cual debe contener el código del parámetro, y el segundo campo se llame "Name", el cual debe contener la descripción del parámetro. Utilice el AS para definir el Alias dentro del SELECT y asignarle a los campos los nombres "Code" y "Name".',
    listSelectionType: "Tipo de selección de lista",
    requiredParameter: "Parámetro obligatorio",
    testValueForParameter: "Valor de prueba",
    specialProcessParameters: "Parámetros del proceso especial",
    executeProcessQuestion: "¿Está seguro que desea ejecutar el proceso especial: {process}?",
    answersOf: "Respuestas de",
    npsRange1: "-100 a -1 (crítico)",
    npsRange2: "0 a 49 (bueno)",
    npsRange3: "50 a 74 (muy bueno)",
    npsRange4: "75 a 100 (excelente)",
    accordingToOnaPollRespondents: "De acuerdo con los encuestados que pudieron participar en esta encuesta ONA",
    byFilterAppliedPublicationsRelated: "De acuerdo con el filtro aplicado/publicaciones asociadas",
    pollParticipationPercentage: "Porcentaje de participación de encuesta",
    pollTotalOver: "Total de participantes {answersAmount}, sobre un universo total de {availableVoters}",
    selectedPolls: "Encuestas seleccionadas",
    createQueryDefinition: "Crear definición de consulta",
    editQueryDefinition: "Editar definición de consulta",
    sqlSelectorsCouldBe: "Para cada columna de SQL, los tipos de selectores pueden ser",
    createQueryDefinitionParameter: "Crear parámetro de consulta",
    editQueryDefinitionParameter: "Editar parámetro de consulta",
    queryParameters: "Parámetros de la consulta",
    associateNewsToCollaborator: "Asociar noticia a colaborador",
    willIncludePhotoOf: "Se incluirá la fotografía de",
    viewAnswersAfterAnswering: "Ver respuestas al responder",
    anonymousFemale: "Anónima",
    onlyForOnboarding: "Solo para onboarding",
    relatedSpecialProcess: "Proceso especial asociado",
    evaluatedGroupSelectedFromQuadrant: "Grupo de evaluados seleccionados del cuadrante",
    amountOfCollaboratorsInQuadrant: "Cantidad de colaboradores en este cuadrante",
    yearsToCheck: "Años a consultar",
    directBoss: "Jefe directo",
    analyticCloud: "Nube analítica",
    evaluations: "Evaluaciones",
    globalAmountOfEvaluationsPerScore: "Cantidad global de evaluaciones por nota",
    evaluatedGroupSelectedWithScore: "Grupo de evaluados seleccionados con nota",
    amountOfCollaboratorsWithThisScore: "Cantidad de colaboradores con esta nota",
    completeMarkTitle:
        "{name} - Completar la marca de {entryOrExit1} para la marca de {entryOrExit2} del {date} a las {time}",
    markTitle: "{name} - Marca de asistencia para el día {date}",
    assistanceDateMustFitOpenCalendar:
        "La fecha de asistencia debe corresponder a un calendario de tiempos que esté abierto",
    onlyMarksWithGeopositionWillShow:
        "De todas las marcas de asistencia seleccionadas en la grilla, solo se visualizarán en el mapa las que cuenten con registro de geoposición, por ejemplo las realizadas con la APP de ICARIUS",
    deleteMarkQuestion: "¿Está seguro que quiere eliminar para {name} las marca de asistencia para el día {date}?",
    cantEditEmployeeHasNoOpenCalendar: "{name} no posee calendario abierto, no se puede editar la marca de asistencia.",
    employeeHasNoOpenCalendar: "{name} no posee calendario abierto.",
    loanDiscount: "Descuento de anticipo",
    conceptEntryStructureAlt: "Estructuras de ingreso del concepto",
    processApproval: "Aprobación del proceso",
    specialAction: "Acción especial",
    entryMotive: "Motivo de egreso",
    festivitiesTableTitle: "Feriados y días festivos - Tabla {type} - Año {year}",
    deleteHolidayQuestion:
        "¿Está seguro que quiere eliminar el feriado o festivo {holiday} - {title}, para la tabla {type}?",
    newTableType: "Nuevo tipo de tabla",
    duplicateQueryDefinition: "Duplicar definición de consulta",
    createGeoanalysisDefinition: "Crear definición de consulta para geoanálisis",
    editGeoanalysisDefinition: "Editar definición de consulta para geoanálisis",
    sqlSelectorTypes1: "Para cada columna de SQL, los tipos de selectores pueden ser: Lista,Fecha,Alfa,Num,Mon.",
    sqlSelectorTypes2:
        "Si desea que alguna de las columnas no puedan seleccionarse como marcador, escoja del listado las columnas según su tipo pero tome aquella que indica no elegibles como marcador",
    createGeoanalysisParameter: "Crear parámetro de consulta para geoanálisis",
    editGeoanalysisParameter: "Editar parámetro de consulta para geoanálisis",
    geoanalysisParameters: "Parámetros de la consulta para geonálisis",
    deleteSystemTable: "Eliminar tabla del sistema",
    deleteUserTable: "Eliminar tabla del usuario",
    systemTableCreation: "Creación de tabla del sistema",
    userTableCreation: "Creación de tabla del usuario",
    accessType: "Tipo de acceso",
    importerActive: "Importador activo",
    fieldsForDataFilterInGridHelperText: "Por ej.: “U_cttipfun“ = ‘PROD’ and “U_ctcodof” IN('FA001','FA006')",
    dataGridSortingFieldsHelperText: 'Campos separados por coma. Por ej.: "U_codemp","U_fecha"',
    relatedDetailTable: "Tabla de detalle asociada",
    sqlToExecuteWhenSavingHelperText:
        'La variable #CODE# contiene el valor del campo "Code" del registro insertado o modificado',
    sqlToExecuteWhenDeletingHelperText: "La variable #CODES# contiene los códigos de los registros seleccionados",
    duplicateTableDefinition: "Duplicar definición de tabla",
    systemTableDefinition: "Definición de tablas del sistema",
    userTableDefinition: "Definición de tablas del usuario",
    newSystemTable: "Nueva tabla del sistema",
    newUserTable: "Nueva tabla del usuario",
    noSystemTableFound: "No se encontraron tablas del sistema",
    noUserTableFound: "No se encontraron tablas del usuario",
    tradeForPoints: "Canje por puntos",
    maxPercentageMoneyTrade: "% máximo para canje directo por dinero",
    criticalIncidentLogShort: "Registro de incidentes críticos",
    createRecognitionPlan: "Crear plan de reconocimiento",
    editRecognitionPlan: "Editar plan de reconocimiento",
    duplicatePlan: "Duplicar plan",
    planCharts: "Gráficos del plan",
    pointsToObtainThem: "Puntos para obtenerlos",
    valueEachRecognition: "Valor de cada reconocimiento",
    prizeDelivery: "Entrega de premio",
    criticalIncidentLogNotes: "Registro de incidentes críticos (Anotaciones)",
    mandatoryRedemption: "Obligatoriedad de canje",
    addCollaboratorsToPlan: "Incorporar colaboradores al plan",
    editPlanAssignation: "Modificar asignación al plan",
    transferCollaboratorToPlan: "Traspasar al colaborador de plan",
    destinationRecognitionPlan: "Plan de reconocimiento de destino",
    createOnboardingProfile: "Crear perfil de onboarding",
    editOnboardingProfile: "Editar perfil de onboarding",
    duplicateOnboardingProfile: "Duplicar perfil de onboarding",
    visualizationTree: "Árbol de visualización",
    stepCreation: "Creación de paso",
    materialsOrResources: "Materiales o recursos (Puede seleccionar más de uno a la vez)",
    addCollaboratorsToProcess: "Incorporar colaboradores al proceso",
    viewProcessCollaborators: "Ver colaboradores del proceso",
    createOnboardingProcess: "Crear proceso de onboarding",
    editOnboardingProcess: "Editar proceso de onboarding",
    cantChangeActionMomentTypeOrCodeInUse1:
        'No puede cambiar el "Tipo de acción o momento" o el "Código de acción o momento" de este material o recurso, porque ya está vinculado con pasos en perfiles de onboarding.',
    cantChangeActionMomentTypeOrCodeInUse2:
        "Para poder cambiar la acción o momento primero elimine el material o recurso de los perfiles de Onboarding donde estén vinculados.",
    evaluationsYear: "Año de evaluaciones",
    performanceEvaluationProcess: "Proceso de evaluación de desempeño",
    dateChangeRequestMustBeBetweenDates:
        "Para solicitar cambio de horario, la fecha del cambio debe estar entre el {dateFrom} y el {dateTo}",
    requestedDayIsBiggerThanAvailable:
        "El día solicitado supera el saldo disponible en la cuenta corriente en {amount} día/s",
    requestedDaysAreBiggerThanAvailable:
        "Los {requested} días solicitados superan el saldo disponible en la cuenta corriente en {amount} día/s",
    changeScheduleRequests: "Solicitudes de cambio de horario",
    clickOnScheduleToChangeOrAuth:
        "Haga clic en un horario para modificarlo, o autorizarlo en caso de que se trate de una solicitud de cambio de horario.",
    doubleClickWhitespaceToPreAuthExtraHours:
        "Haga doble clic en un espacio en blanco del calendario para preautorizar horas extras.",
    extraHoursAuth: "hrs Ext. autorizadas",
    descendantEvaluatorDirectBoss: "Evaluador descendente (Jefe directo)",
    willBeAssignedToManagers: "Se asignarán los jefes directos (Managers) en forma automática.",
    evaluatorSelectionForCollaborators: 'Selección de evaluador para el tipo "{type}" ({length} colaboradores)',
    assignReplaceEvaluator: "Asignar/Reemplazar evaluador",
    createdFemale: "Creada",
    seniorityRequiredToParticipate: "Antigüedad requerida para participar",
    possibleFinalScoresPerformance: "Notas finales posibles de la evaluación del desempeño: Desde {min} - Hasta {max}",
    possibleFinalScoresPotential: "Notas finales posibles de la evaluación del potencial: Desde {min} - Hasta {max}",
    finalScoreTypePerformance: "Tipo de nota final desempeño",
    finalScoreTypePotential: "Tipo de nota final potencial",
    createEvaluationProcess: "Crear proceso de evaluación",
    editEvaluationProcess: "Editar proceso de evaluación",
    statusE1:
        "Verifique que los ponderados de todas las metas y objetivos totalicen 100%, y lo mismo para los ponderados de las competencias específicas del cargo en caso de utilizarlas.",
    statusE2:
        "Para verificar el 100% de los ponderados de metas y objetivos accede con el rol del empleador a: Gestión del desempeño / Metas y Objetivos y selecciona el período.",
    statusE3:
        "Para verificar el 100% de los ponderados de las competencias específicas del cargo accede con el rol del empleador a: Gestión del desempeño / Definiciones de desempeño / Competencias específicas.",
    statusE4:
        "También verifique que para todos los evaluados y para cada tipo de evaluación esté asignado el evaluador correspondiente. Considere que, desde los procesos de evaluación, puede eliminar a determinados evaluados en ciertos tipos de evaluaciones si así lo desea.",
    statusE5:
        "Recuerde enviar el mensaje a todos los evaluadores indicando que la evaluación del desempeño se pondrá en curso para que inicien con sus calificaciones, para enviar el mensaje acceda con el rol de empleador a: Gestión del desempeño / Procesos de evaluación y utilice el siguiente botón para el proceso de evaluación seleccionado:",
    statusE6: "Estado al cual puede regresar el proceso, si ya se encuentra en este estado: Ninguno.",
    statusE7: "Estado al cual puede avanzar el proceso, si ya se encuentra en este estado: Calificada.",
    statusF1:
        "Solo debe pasar el proceso a este estado si todas las calificaciones de desempeño se han completado. Acceda con el rol de empleador a Gestión del desempeño / Evaluaciones de desempeño y verifique el progreso de las calificaciones con este botón, el cual mostrará una grilla con los estados de las evaluaciones, los evaluados y sus evaluadores:",
    statusF2:
        "Una vez que visualice el estado de las evaluaciones, ordene las mismas haciendo clic en la columna estado de la evaluación, filtre todas las pendientes, que se destacan con color, seleccione a todos los registros con ese estado y envié el mensaje automático a los evaluadores el cual les solicitará que culminen con sus evaluaciones pendientes a la brevedad posible.",
    statusF3: "Para enviar el mensaje automático desde la grilla utilice el siguiente botón:",
    statusF4:
        "Solo en caso, que alguna evaluación esté pendiente y no deba realizarse tal evaluación para el evaluado, puede eliminarla desde Gestión del desempeño / Procesos de evaluación / Asignar colaboradores al proceso, utilizando el botón eliminar.",
    statusF5:
        "Considere que si mantiene el proceso en curso, podrá de todos modos acceder al resumen y resultado, realizar la calibración y la entrega del feedback sin cambiar el estado del proceso. (Estos 2 últimos solo con nota final en las evaluaciones).",
    statusF6:
        "Por tal motivo, no es necesario pasar a calificada para poder acceder al resumen y resultado de las evaluaciones, calibrar o dar feedback.",
    statusF7: "Estado al cual puede regresar el proceso, si ya se encuentra en este estado: En curso.",
    statusF8: "Estado al cual puede avanzar el proceso, si ya se encuentra en este estado: En calibración.",
    statusB1: "El estado de calibración es optativo.",
    statusB2:
        "Sin embargo es altamente recomendable revisar determinadas evaluaciones (Conformando un comité entre Gestión de las Personas y algunos evaluadores) para verificar que las calificaciones realizadas a los evaluados hayan sido justas, equitativas y sin sesgos por parte de sus evaluadores, o bien debatir en el comité las evaluaciones que pudieron ser objetadas por los evaluados.",
    statusB3:
        "Debe considerar que el comité de calibración tiene la capacidad de modificar las calificaciones de los evaluados si así lo determina.",
    statusB4: "Estado al cual puede regresar el proceso, si ya se encuentra en este estado: Calificada.",
    statusB5: "Estado al cual puede avanzar el proceso, si ya se encuentra en este estado: En feedback.",
    statusK1:
        "Antes de pasar al este estado, recuerde crear un nuevo período de metas y objetivos para permitir que cuando el evaluador entregue el feedback al evaluado, pueda asignarle nuevas metas y objetivos para un nuevo período y de ese modo, dichas metas y objetivos, puedan ser gestionadas y posteriormente evaluadas en el próximo proceso de evaluación del desempeño.",
    statusK2:
        "Antes de pasar a En Feedback verifique desde Evaluaciones del desempeño que todas las evaluaciones estén en estado Realizadas.",
    statusK3:
        "Considere que, si durante el feedback un evaluado objeta su evaluación, podrá recalibrar la evaluación cuestionada si fuera necesario.",
    statusK4:
        "Recuerde enviar el mensaje a todos los evaluadores indicando que la evaluación del desempeño ha pasado a la etapa de feedback y que deben realizar las entrevista de evaluación con cada uno de sus evaluados. Para enviar el mensaje acceda con el rol de empleador a: Gestión del desempeño / Procesos de evaluación y utilice el siguiente botón para el proceso de evaluación seleccionado:",
    statusK5: "Estado al cual puede regresar el proceso, si ya se encuentra en este estado: En calibración.",
    statusK6:
        "Estado al cual puede avanzar el proceso, si ya se encuentra en este estado: En clasificación del talento.",
    statusT1: "Avance a este estado para clasificar el desempeño y potencial en una matriz 9-Boxes.",
    statusT2: "Estado al cual puede regresar el proceso, si ya se encuentra en este estado: En feedback.",
    statusT3: "Estado al cual puede avanzar el proceso, si ya se encuentra en este estado: Cerrada.",
    statusR1:
        "Cuando pase el proceso a este estado, la evaluación del desempeño quedará completamente finalizada y las calificaciones ya no podrán modificarse ni recalibrarse.",
    statusR2:
        "Este estado será definitivo y todos los datos del proceso y sus calificaciones permanecerán para realizar gestión de información únicamente.",
    statusR3:
        "Estado al cual puede regresar el proceso, si ya se encuentra en este estado: En clasificación del talento.",
    noValueCanBeLessThanMinValuePerformance:
        "Ningun valor de desempeño puede ser menor al valor mínimo de la nota ({min})",
    noValueCanBeMoreThanMaxValuePerformance:
        "Ningun valor de desempeño puede ser mayor al valor máximo de la nota ({max})",
    noValueCanBeLessThanMinValuePotential:
        "Ningun valor de potencial puede ser menor al valor mínimo de la nota ({min})",
    noValueCanBeMoreThanMaxValuePotential:
        "Ningun valor de potencial puede ser mayor al valor máximo de la nota ({max})",
    duplicateEvaluationProcess: "Duplicar proceso de evaluación",
    feedbackEvaluationProcessStart: "Inicio del proceso de evaluación de feedback",
    willInformFeedbackStarted:
        "Informamos a todos los evaluadores que pondremos en feedback el proceso {processName}, para que inicien con las entrevistas del desempeño.\n\nAcceda a Gestión del desempeño / Resumen y Resultados y utilice los siguientes botones: “Resumen final” (Para la visualización completa de la evaluación del desempeño de cada evaluado), y posteriormente el botón “Dar feedback” (Para dejar por escrito el feedback entregado al evaluado).\n\n¡Muchas gracias por su participación!",
    willInformProcessStarted:
        "Informamos a todos los evaluadores que pondremos en curso el proceso {processName}, para que inicien con las calificaciones del desempeño.\n\nAcceda a Gestión del desempeño / Evaluaciones del desempeño y complete los formularios de calificación para cada uno de sus evaluados.\n\n¡Muchas gracias por su participación!",
    collaboratorsNotInProcess: "Colaboradores que no participan en el proceso",
    historicalMale: "Históricos",
    currentMonth: "Mes actual ({from} al {to})",
    previousMonth: "Mes anterior ({from} al {to})",
    nextMonth: "Mes siguiente ({from} al {to})",
    currentQuarter: "Trimestre actual ({from} al {to})",
    currentSemester: "Semestre actual ({from} al {to})",
    currentYear: "Año actual ({from} al {to})",
    previousQuarter: "Trimestre anterior ({from} al {to})",
    previousSemester: "Semestre anterior ({from} al {to})",
    previousYear: "Año anterior ({from} al {to})",
    last24Months: "Últimos 24 meses ({from} al {to})",
    last36Months: "Últimos 36 meses ({from} al {to})",
    maxAllowed: "Máximo permitido",
    groupToDuplicate: "Grupo a duplicar",
    specificSkill: "Competencia específica",
    transversalSkill: "Competencia transversal",
    duplicateSpecificSkill: "Duplicar competencia específica",
    skillType: "Tipo de competencia",
    noIndicatorsFound: "No posee indicadores",
    createSkillIndicator: "Crear indicador para la competencia: {name} - Grupo: {group}",
    editSkillIndicator: "Editar indicador para la competencia: {name} - Grupo: {group}",
    skillIndicators: "Indicadores para la competencia: {name} - Grupo: {group}",
    duplicateTransversalSkill: "Duplicar competencia transversal",
    createTransversalSkill: "Crear competencia transversal",
    editTransversalSkill: "Editar competencia transversal",
    createTransversalSkillIndicator: "Crear indicador para la competencia transversal: {name}",
    editTransversalSkillIndicator: "Editar indicador para la competencia transversal: {name}",
    transversalSkillIndicators: "Indicadores para la competencia transversal: {name}",
    assistanceAnalysisProcess: "Proceso de análisis de asistencia",
    assistanceAnalysisPeriod: "Período de análisis de asistencia",
    totalExtraHoursDone: "Total horas extra realizadas",
    unauthorizedExtraHours: "Horas extra sin autorizar",
    absenceHoursAlt: "Horas de ausencia",
    maxValueAllowed: "Valor máximo permitido",
    generalAssistanceAnalysis: "Análisis de asistencia general",
    totalLiquidsNet: "Total Líquidos/netos",
    liquidNet: "Líquido/Neto",
    valuesOccurrences: "Valores/Ocurrencias",
    conceptAnalysis: "Análisis concepto",
    calculationProcessName: "Nombre del proceso de cálculo",
    topAndBottom: "Top & Bottom",
    appliedFilter: "Filtro aplicado",
    invalidInfo:
        "Para recuperar o asignar el PIN de acceso es necesario que ingrese el código de CLIENTE y su USUARIO personal",
    invalidPin: "El pin debe contener entre 4 y 10 caracteres",
    templateAlreadyExists: "Ya existe una plantilla con el nombre indicado",
    selectSociety: "Seleccione una sociedad para continuar",
    selectColor: "Seleccione un color para continuar",
    loginError: "Usted no puede ingresar como {role} con el Cliente, Usuario y PIN que ha ingresado",
    noCurrentPin: "Falta ingresar el PIN actual",
    noNewPin: "Falta ingresar el nuevo PIN",
    noNewPinConfirm: "Falta re-ingresar el nuevo PIN",
    pinsMustBeEqual: "No coinciden los nuevos PINs ingresados",
    pinsMustBeDifferent: "El pin actual no debe coincidir con el nuevo",
    pinMustHaveMinCharacters: "El PIN ingresado debe tener entre 4 y 10 caracteres",
    pinMustHaveMaxCharacters: "El PIN ingresado debe tener entre 4 y 10 caracteres",
    motiveMustHaveMinCharacters: "El motivo ingresado debe tener hasta 254 caracteres",
    motiveMustHaveMaxCharacters: "El motivo ingresado debe tener hasta 254 caracteres",
    noMotive: "Falta ingresar el motivo",
    noPin: "Falta ingresar el PIN",
    pinMustBeAlphanumeric: "El nuevo PIN no puede contener caracteres que no sean números y/o letras",
    noEmployeesFound: "No se ha encontrado personal de acuerdo con los datos de búsqueda ingresados",
    noLoansFound: "No se han encontrado prestamos",
    invalidTitle: "El titulo obtenido es inválido",
    invalidSubtitle: "El subtitulo obtenido es inválido",
    invalidDataAlt: "La información obtenida es inválida",
    invalidAlt: "La imagen obtenida es inválida",
    defaultException: "Ocurrió un problema, intente nuevamente más tarde",
    invalidParams: "Ocurrió un problema, intente nuevamente más tarde",
    invalidToken: "Su sesión no es válida, intente logearte de nuevo",
    tokenMissing: "Ocurrió un problema, debe relogearse en la aplicación",
    userNotFound: "Su usuario no tiene acceso, debe solicitar permiso al Administrador de la plataforma",
    googleError: "Error al intentar ingresar con google",
    defaultErrorDialogTitle: "Mensaje",
    defaultError: "Ocurrió un problema, intente nuevamente más tarde",
    invalid: "Inválido",
    pinValidationError: "El PIN ingresado como actual es incorrecto",
    completeWithValidInformation: "Complete con información válida",
    serverError: "Error de servidor",
    societyNotFound: "Sociedad no encontrada",
    loginInvalidCredentials: "Credenciales inválidas",
    userAlreadyExists: "El usuario ya existe",
    googleDataError: "Error de google",
    unAuthorized: "No autorizado",
    emptyEmployees: "Sin empleados",
    invalidImages: "Imágenes inválidas",
    clientNotExist: "El cliente no existe",
    validationErrorAlt: "Error de validación",
    noPollError: "Error al obtener la encuesta",
    nameNotValid: "Ingrese el nombre de la plantilla",
    templateMustHaveMinCharacters: "El nombre de la plantilla debe tener entre 4 y 60 caracteres",
    templateMustHaveMaxCharacters: "El nombre de la plantilla debe tener entre 4 y 60 caracteres",
    mustSelectPermissions: "Seleccione el rol de visualización",
    noAssistanceFound: "No se han encontrado registros de asistencia",
    tooManyLoginRequests:
        "Su usuario ha sido bloqueado por haber realizado demasiados intentos de inicio de sesión fallidos. Vuelva a intentarlo en {minutos} minutos",
    certificateNotCreated: "Certificado no creado.",
    certificatesNotAvailable: "No hay certificados disponibles",
    receiptsNotAvailable: "No hay recibos disponibles",
    selectCertificateType: "Seleccione un tipo de certificado",
    receiptNotCreated: "Recibo no creado.",
    receiptNoMail: "No se pueden seleccionar documentos pertenecientes a usuarios sin mail",
    selectReceiptType: "Seleccione un tipo de recibo",
    selectCalcProcess: "Seleccione un proceso de cálculo",
    noRequests: "No se encontraron solicitudes",
    dateErrorRequests: "Las fechas recibidas no estan permitidas",
    validationErrorRequests: "Ingrese datos válidos",
    errorDaysQuantityRequests: "Se recibió una cantidad de días incorrecta",
    overlapErrorRequests: "Las fechas recibidas se solapan con otra solicitud de vacaciones del usuario",
    requiredFieldEmpty: "Hay datos obligatorios vacíos",
    tagRepeated: "Ya existe una etiqueta con el mismo nombre",
    totemAlreadyExists: "Ya existe un totem con el mismo código",
    verifyDateTime: "Verifique las fechas y horas",
    invalidUser: "Usuario inválido",
    signerAlreadyExists: "Firmante duplicado",
    invalidDocs: "Documentos inválidos",
    errorGettingDocsType: "Error al obtener los tipos de documentos",
    noRequestedDocuments: "No existen documentos solicitados",
    incorrectPin: "PIN incorrecto",
    appealExistsRiseErrorRequest:
        "No se pudo dar de alta la solicitud de aumento de sueldo ya que el colaborador seleccionado posee una en curso",
    appealExistsFireErrorRequest:
        "No se pudo dar de alta la solicitud de desvinculación ya que el colaborador seleccionado posee una en curso",
    certificateNoMail:
        "Se firmarán {amount} documentos de un total de {total} porque hay Colaboradores sin email asignado",
    assistanceAlreadyDone:
        "Usted no puede marcar asistencia el día de hoy ya que tiene un permiso o vacaciones en esta fecha",
    assistanceBlocked: "Usted no puede marcar asistencia, por favor póngase en contacto con un administrador",
    incorrectQuery: "La consulta que está intentando importar se encuentra dañada",
    noNextSigner: "Debe seleccionar al siguiente firmante",
    recognitionTotalAmount: "Cantidad total de reconocimientos",
    myVacationCurrentAccount: "Mi cuenta corriente de vacaciones",
    changeDivision: "Cambiar unidad de negocio",
    allFieldsMustBeginWithU: "Todos los campos deben iniciar con U_",
    allTablesMustBeginWithA1A: "Todos los códigos de tablas deben iniciar con @A1A",
    managementCenterDivision: "Cambiar centro de publicación",
    sqlFilterLabel: "SQL para filtrar el editor e indicar que Colaboradores, Managers o Empleadores podrán acceder",
    sqlFilterHelperText:
        "Genere una lista de los Códigos de empleados que serán solo quienes podrán acceder al editor ya sea como Colaborador, Manager o Empleador. Asigne el nombre Code al campo del SQL",
    sqlFilterLabelPermissions: "SQL para filtrar el tipo de permiso e indicar que Colaboradores podrán solicitarlo",
    sqlFilterHelperTextPermissions:
        "Genere una lista de los Códigos de empleados que serán solo quienes podrán acceder al permiso. Asigne el nombre Code al campo del SQL.",
    sqlFilterLabelAdvance: "SQL para filtrar el tipo de anticipo e indicar que Colaboradores podrán solicitarlo",
    sqlFilterHelperTextAdvance:
        "Genere una lista de los Códigos de empleados que serán solo quienes podrán acceder al anticipo. Asigne el nombre Code al campo del SQL.",
    tooltip: "Tooltip",
    editImputation: "Editar imputación contable",
    createImputation: "Crear imputación contable",
    alternativeFieldName: "Nombre de campo alternativo",
    alternativeFieldNameHelperText:
        "Puede usar '#LANGUAGE#' y debe usar AS \"Title\" para el titulo personalizado por sql",
    alternativeMenuName: "Nombre de menú alternativo",
    alternativeMenuNameHelperText:
        "Puede usar '#LANGUAGE#' y debe usar  AS 'MenuTitle' y 'FunctionTitle' para el titulo de menu y de función personalizado por sql",
    scheduleDefinitionInUse: "No se puede eliminar el horario porque ya está en uso",
    onlyRequestDocumentsCanHaveUnderscoreInCode: 'Solo los Documentos de solicitudes pueden incluir "_" en el código',
    employerContributionGroup: "Grupo de aportes del empleador",
    isEmployerContributionGroup: "Es grupo de aportes del empleador",
    INTERVIEW_FEEDBACK_POINTS_ASSIGNATION_ENABLED:
        "Permitir a evaluadores entregar puntos para medallero durante proceso de Entrevista y Feedback",
    deliverPointsToRequestBenefits: "Entregar puntos en medallero para solicitar beneficios",
    employeeMustBeInPlan: "El empleado seleccionado debe estar en un plan de reconocimiento",
    pointsAssigned: "Puntos ganados en el medallero",
    usesMedalPoints: "Entrega puntos para medallero",
    completeImputations: "Completar imputaciones",
    missingAccountsTitle: "Cuentas contables faltantes para los conceptos del proceso: {processName}",
    completeImputationsSuccessfull:
        "Las imputaciones contables han sido completadas con éxito. Complete las cuentas faltantes y reprocese el proceso de cálculo",
    completeImputationsQuestionTitle:
        "¿Está seguro que desea completar la ‘Definición de imputaciones contables’ con estos conceptos que no tienen una cuenta contable relacionada?",
    completeImputationsQuestion1:
        "Al haber optado por ‘Si’ considere que en la ‘Definición de imputaciones contables’ se agregarán todas las imputaciones faltantes mostradas en la grilla y considere que en la columna ‘Cuenta contable’ se pondrá ‘Sin cuenta contable' para facilitarle la búsqueda de las cuentas que debe completar desde ‘Remuneraciones/Imputaciones contables’.",
    completeImputationsQuestion2:
        "Recuerde revisar, cuando complete las cuentas, las columnas de: ‘Referencia', 'Información detallada’,  ‘Distribución’ o ‘Condición’, si fuera necesario.",
    completeImputationsQuestion3: "¿Confirma completar las imputaciones contables?",
    imputationType: "Tipo de imputación",
    duplicatedAttendanceMarksDeletedSuccessfully: "Marcas de asistencia duplicadas eliminadas con éxito",
    deleteDuplicatedAttendanceMarks: "Eliminar marcas de asistencia duplicadas",
    deleteDuplicatedMarksQuestion:
        "Se ha detectado la existencia de marcas de asistencia duplicadas, ¿Desea eliminarlas?",
    advanceOrAdvancedPaymentName: "Nombre del anticipo o adelanto",
    advanceOrAdvancedPaymentType: "Tipo del anticipo o adelanto",
    advanceOrAdvancedPaymentCode: "Código del anticipo o adelanto",
    advanceOrAdvancedPaymentSettings: "Anticipos o adelantos para solicitudes",
    advanceOrAdvancedPaymentCreation: "Creación de anticipos o adelantos",
    advanceOrAdvancedPaymentNew: "Nuevo anticipo o adelanto",
    noAdvancesOrAdvancedPayment: "Aún no hay anticipos o adelantos creados",
    variableCommission: "Comisión variable",
    balanceCommission: "Comisión por saldo",
    afpCode: "ID AFP",
    structureConceptsAddedSuccessfully: "Conceptos modificados con éxito",
    addConcepts: "Agregar conceptos",
    availableDays: "Días disponibles",
    availableBalance: "Saldo disponible",
    duplicateConceptInStructure: "Duplicar concepto en estructura",
    originConcept: "Concepto origen",
    originID: "Id origen",
    conceptToCreate: "Concepto a crear",
    duplicateConceptNameCodeInUse:
        "No se puede duplicar el concepto porque el nombre o codigo ingresados ya están en uso",
    importAccountingImputations: "Importar imputaciones contables",
    noProcessedCollaboratorsToCheck: "No existen colaboradores procesados para consultar",
    trainingAndDevelopment: "Capacitación y desarrollo",
    coursesMaster: "Maestro de cursos",
    themeArea: "Área temática",
    themes: "Temas",
    length: "Duración",
    certification: "Certificación",
    createCourse: "Crear curso",
    createSkillBasedCourse: "Crear curso basado en competencias",
    skillToDevelop: "Competencia a desarrollar",
    updateCourse: "Actualizar curso",
    finalizationCertificates: "Certificaciones de finalización",
    hasAssistanceCertificate: "Con certificado de asistencia",
    assistancePercentageRequired: "Asistencia requerida",
    hasKnowledgeCertificate: "Con certificado de conocimiento",
    knowledgeCertificateMinScore: "Nota mínima",
    knowledgeCertificateMaxScore: "Nota máxima",
    knowledgeCertificateMinScoreToPass: "Nota mínima para aprobación",
    courseCreatedOk: "Curso creado con éxito",
    courseUpdatedOk: "Curso actualizado con éxito",
    courseDeletedOk: "Curso eliminado con éxito",
    modulesAndActivitiesFromCourse: "Módulos y actividades del curso - {courseName}",
    modules: "Módulos",
    doYouWantToDeleteCourse: "¿Desea eliminar el curso?",
    doYouWantToDeleteModule: "¿Desea eliminar el módulo?",
    doYouWantToDeleteActivity: "¿Desea eliminar la actividad?",
    createModule: "Crear módulo",
    updateModule: "Actualizar módulo",
    viewModule: "Ver módulo",
    nextOrderModule:
        "Próximo libre: {nextOrder}. De colocar un orden existente para otro modulo, se desplazara de este en adelante los modulos.",
    moduleCreatedOk: "Módulo creado con éxito",
    moduleUpdatedOk: "Módulo actualizado con éxito",
    moduleDeletedOk: "Módulo eliminado con éxito",
    activityCreatedOk: "Actividad creada con éxito",
    activityUpdatedOk: "Actividad actualizada con éxito",
    activityDeletedOk: "Actividad eliminada con éxito",
    module: "Módulo",
    userFields: "Campos de usuario",
    pressEnterToAdd: "Escriba un tema y presione Enter para agregarlo",
    nextOrderActivity:
        "Próximo libre en el módulo: {nextOrder}. De colocar un orden existente para otra actividad, se desplazará de esta en adelante las actividades del módulo.",
    selectResources: "Seleccionar recursos",
    createActivity: "Crear actividad",
    updateActivity: "Actualizar actividad",
    viewActivity: "Ver actividad",
    activityDependency: "Depende de la finalizacion de la actividad",
    noDependency: "Sin dependencia",
    enterContent: "Ingresar contenido",
    attempts: "Intentos",
    attempt: "Intento",
    externalVideo: "Video externo",
    externalMedia: "Archivo externo",
    selectVideoFromLibrary: "Video de biblioteca",
    selectMediaFromLibrary: "Archivo de la biblioteca",
    uploadVideo: "Subir video",
    hasResources: "Tiene recursos",
    courseInUseUpdate: "El curso no se puede modificar porque se encuentra asociado a una capacitación",
    courseInUseDelete: "El curso no se puede eliminar porque se encuentra asociado a una capacitación",
    courseInUse: "El curso no se puede modificar/eliminar porque se encuentra asociado a una capacitación",
    moduleInUse: "El módulo no se puede eliminar porque se encuentra asociado a actividades",
    activityInUse: "La actividad no se puede eliminar porque se encuentra asociada a otras actividades",
    courseDuplicatedData: "Ya existe un curso con el mismo nombre",
    moduleDuplicatedData: "Ya existe un módulo con el mismo nombre",
    activityDuplicatedData: "Ya existe una actividad con el mismo nombre",
    content: "Contenido",
    addSession: "Agregar sesión",
    sessions: "Sesiones",
    sessionType: "Tipo de sesión",
    questionsAmountToUse: "Cantidad de preguntas a utilizar",
    activityQuestionsAmountToUseHelperText:
        "En caso de seleccionar una cantidad de preguntas inferior al total de preguntas definidas, al momento de realizar la evaluación se determinará qué preguntas utilizar de manera aleatoria.",
    useRandomOrder: "Usar orden aleatorio",
    useSelfCorrection: "Usar autocorrección",
    activityUseSelfCorrectionHelperText:
        "Si su evaluación tiene preguntas de tipo descriptivas no puede utilizar autocorrección. En dicho caso la evaluacion requerirá una correccion manual por parte del instructor.",
    updateQuestion: "Actualizar pregunta",
    questionType: "Tipo de pregunta",
    addAnswer: "Agregar respuesta",
    doYouWantToDeleteQuestion: "¿Desea eliminar la pregunta?",
    recognitionPoints: "Puntos de reconocimiento",
    courseDuplicatedOk: "Curso duplicado con éxito",
    duplicateCourse: "Duplicar curso: {courseName}",
    courseExportedOk: "Curso exportado con éxito",
    courseImportedOk: "Curso importado con éxito",
    usedSpaceMB: "Espacio utilizado (MB)",
    training: "Capacitaciones",
    trainingSingular: "Capacitación",
    trainingDuplicatedData: "Ya existe una capacitación con el mismo nombre",
    instructor: "Instructor",
    createTraining: "Crear capacitación",
    updateTraining: "Actualizar capacitación",
    course: "Curso",
    duplicateTraining: "Duplicar capacitación: {trainingName}",
    modulesAndActivitiesFromTraining: "Módulos y actividades de la capacitación - {trainingName}",
    doYouWantToDeleteTraining: "¿Desea eliminar la capacitación?",
    trainingPublishedRequiredFields:
        "Para configurar la capacitación como Publicada, debe ingresar las fechas desde, fecha hasta y seleccionar un instructor",
    trainingPublishedActivityRequiredFields:
        "Para configurar la capacitación como Publicada, debe ingresar la fechas, hora y ubicación de las actividades",
    dateTo: "Fecha hasta",
    isInPersonActivity: "Actividad presencial",
    additionalInfo: "Información adicional",
    time: "Hora",
    location: "Ubicación",
    session: "Sesión",
    instructorsOrigin:
        "Se visualiza a las personas que se encuentran en los grupos etiquetados como “Entrenadores o Capacitadores”",
    courseTree: "Árbol de visualización del curso: {courseName}",
    courseMode: "Modo de cursado",
    assignEmployeesToTraining: "Asignar colaboradores a capacitación",
    assignEmployeesToTrainingWithTrainingName: "Asignar colaboradores a capacitación: {trainingName}",
    trainingAssignmentDeleteQuestion:
        "¿Confirma que eliminara a este colaborador, perdiendo asi todo su progreso obtenido dentro de esta capacitación?",
    enterLinkOrAddress: "Ingrese link o dirección física",
    uploadThumbnailFile: "Subir archivo de previsualización",
    thumbnail: "Previsualización",
    trainingThumbnailExplanation:
        "El archivo seleccionado se mostrará como imagen en representación de la capacitación",
    myTraining: "Mis capacitaciones",
    activeTraining: "Capacitaciones en curso",
    finishedTraining: "Capacitaciones finalizadas",
    myTrainingCertificatesExportedOk: "Certificados descargados con éxito",
    downloadCertificates: "Descargar certificados",
    noActiveTraining: "No se encontraron capacitaciones en curso",
    noFinishedTraining: "No se encontraron capacitaciones finalizadas",
    complete: "Completo",
    incomplete: "Incompleto",
    trainingDefinition: "Definición de capacitaciones",
    courseName: "Nombre del curso",
    alertBodyTextHelperText:
        "Si ha seleccionado campos para el cuerpo del correo, por ejemplo el 1,2,4 y desea insertarlos en una posición específica, utilice <DATA1> <DATA2> <DATA4> en la posición que desea.",
    stop: "Detener",
    play: "Reproducir",
    notesAlt: "Notas",
    byAlt: "Por",
    inPerson: "Presencial",
    virtual: "Virtual",
    accessSession: "Acceder a sesión",
    noSessionData: "No hay información sobre la sesión, comuníquese con su instructor.",
    noSessionDataShort: "No hay información sobre la sesión.",
    activityDependencyToCompleteFirst: "Para acceder a esta actividad debe completar primero: {activityName}",
    resources: "Recursos",
    answerSentSuccessfully: "Respuesta enviada con éxito",
    activityAlreadyAnswered: "Ya ha respondido esta actividad previamente",
    activityPassed: "Actividad aprobada",
    activityFailed: "Actividad reprobada",
    enterAnswer: "Ingrese respuesta",
    solveExercise: "Resolver ejercicio",
    solve: "Resolver",
    activityPendingInstructor: "Actividad resuelta y en espera de calificación",
    grade: "Calificación",
    grades: "Calificaciones",
    gradeActivity: "Corregir",
    gradeOrViewActivity: "Ver o corregir",
    score: "Puntaje",
    noScore: "Sin puntaje",
    enterOptionalFeedback: "Ingrese feedback (opcional)",
    enterRequiredFeedback: "Ingrese feedback (requerido)",
    minMaxPassValues: "Min.: {min}. Max.: {max}. Aprobación: {pass}",
    gradeSentSuccessfully: "Corrección enviada con éxito",
    resolution: "Resolución",
    correct: "Correcto",
    incorrect: "Incorrecto",
    pendingGrades: "Correcciones pendientes",
    trainingInUseUpdate:
        "La capacitación no puede modificarse porque los participantes ya tienen actividades realizadas",
    trainingInUseDelete:
        "La capacitación no puede eliminarse porque los participantes ya tienen actividades realizadas",
    attemptUpdatedSuccessfully: "Datos actualizados con éxito",
    updateSession: "Actualizar sesión",
    updateAttempt: "Actualizar intento de evaluación",
    cannotAssignParticipantAsInstructor: "No puede asignar como instructor a un participante",
    participants: "Participantes",
    viewParticipants: "Ver participantes",
    knowledgeCompleted: "Conocimiento completo",
    knowledgeIncompleted: "Conocimiento incompleto",
    assistanceCompleted: "Asistencia completa",
    assistanceIncompleted: "Asistencia incompleta",
    correctAnswer: "Respuesta correcta",
    correctUnpickedAnswer: "Respuesta correcta pero no seleccionada",
    incorrectAnswer: "Respuesta incorrecta",
    clicToOpenModulesAndActivities: "Clic en un curso para ver o definir sus módulos y actividades",
    activityNotSolved: "Sin resolver",
    noResolutionsMatchFilter: "No hay resoluciones que cumplan el criterio de filtro",
    solvedPlural: "Resueltos",
    notSolved: "Sin resolver",
    approved: "Aprobado",
    approvedPlural: "Aprobados",
    failed: "Desaprobado",
    failedPlural: "Desaprobados",
    toGrade: "Para calificar",
    grading: "Calificar",
    viewResolution: "Ver resolución",
    trainingMedalTablePoints: "Quienes completen esta capacitación recibirán {points} puntos en su medallero",
    ask: "Preguntar",
    deleteQuestionConfirmation: "¿Desea eliminar la pregunta?",
    deleteAnswerConfirmation: "¿Desea eliminar la respuesta?",
    closeQuestionConfirmation: "¿Desea marcar la pregunta como cerrada?",
    noQuestionsMatchFilterQAndA: "No hay preguntas que cumplan el criterio de filtro",
    markAsSolved: "Marcar como cerrado",
    questionsWithoutAnswer: "Hay preguntas sin responder",
    newAnswersToSee: "Hay nuevas preguntas para ver",
    questionMarkedAsSolvedSuccessfully: "Pregunta marcada como resuelta con éxito",
    questionCreatedSuccessfully: "Pregunta creada con éxito",
    questionUpdatedSuccessfully: "Pregunta actualizada con éxito",
    questionDeletedSuccessfully: "Pregunta eliminada con éxito",
    answerCreatedSuccessfully: "Respuesta creada con éxito",
    answerUpdatedSuccessfully: "Respuesta actualizada con éxito",
    answerDeletedSuccessfully: "Respuesta eliminada con éxito",
    closedQuestions: "Preguntas cerradas",
    openQuestions: "Preguntas abiertas",
    thisActivityHasLengthOf: "Esta actividad tiene una duración de",
    activityCountdownExplanation1:
        "Una vez finalizado el tiempo ya no podrá resolver la actividad y, en dicho caso, el intento actual se considerará desaprobado.",
    activityCountdownExplanation2: "Pulse el botón para comenzar la actividad e iniciar el contador de tiempo.",
    startActivity: "Comenzar actividad",
    timeIsUp: "Se acabó el tiempo",
    timeRemaining: "Tiempo restante",
    enterNotes: "Ingrese sus notas",
    notesUpdatedSuccessfully: "Notas guardadas con éxito",
    hasSavedNotes: "Tienes notas guardadas",
    noParticipantsFound: "No se encontraron participantes",
    activity: "Actividad",
    accessTraining: "Acceder a la capacitación",
    viewStats: "Ver estadísticas",
    stats: "Estadísticas",
    participant: "Participante",
    trainingPlural: "Capacitaciones",
    noTrainingMatchFilter: "Ninguna capacitación cumple los criterios de filtro",
    statsByTraining: "Estadísticas por capacitaciones",
    statsByParticipant: "Estadísticas por participante",
    clickColumnToViewMoreAboutTraining: "Haga clic en una columna para ver más información de la capacitación",
    activitiesByTraining: "Actividades por capacitación",
    usersByTraining: "Participantes por capacitación",
    percentageUsersFinishedByTraining: "Porcentaje de participantes que finalizaron cada capacitación",
    totalFinishedPercentage: "Porcentaje realizado total",
    percentageFinishedByTraining: "Porcentaje realizado por curso",
    activitiesFinishedByTraining: "Actividades realizadas por curso",
    activitiesFinished: "Actividades realizadas",
    percentageFinishedByUser: "Porcentaje realizado por participante",
    progress: "Progreso",
    filtersAppliedSelectTrainingAgain: "Filtros aplicados, debe seleccionar las capacitaciones que desee visualizar",
    youMustSelectTraining: "Debe seleccionar una capacitación",
    activityFinished: "Actividad realizada",
    activityName: "Nombre de la actividad",
    participantCode: "Código del participante",
    participantName: "Apellido y nombres del participante",
    viewAnswers: "Ver respuestas",
    positionDescriptionDownloaded: "La descripción del cargo ha sido descargada",
    noAnswersFound: "No se encontraron respuestas",
    responsibilities: "Responsabilidades",
    expectedResults: "Resultados esperados",
    intellectualRequirements: "Req. Intelectuales",
    physicalRequirements: "Req. Físicos",
    workConditions: "Condiciones de trabajo",
    addTask: "Agregar Tarea",
    taskName: "Tarea",
    addResponsibility: "Agregar Responsabilidad",
    whichOnes: "Cuáles",
    descriptionOfExpectedResults: "Descripción de los resultados esperados",
    addIntellectualRequirement: "Agregar Requisito Intelectual",
    addPhysicalRequirement: "Agregar Requisito Físico",
    addWorkCondition: "Agregar Condición de trabajo",
    noWorkConditionsAdded: "No hay condiciones de trabajo registradas.",
    noTasksAdded: "No hay tareas registradas.",
    noResponsibilitiesAdded: "No hay responsabilidades registradas.",
    noIntellectualRequirementsAdded: "No hay requisitos intelectuales registrados.",
    noPhysicalRequirementsAdded: "No hay requisitos físicos registrados.",
    nodeVisualization: "Visualización de nodo",
    default: "Por defecto",
    centrality: "Centralidad",
    onaDestinatary: "Destinatario",
    skillClass: "Clase de competencia",
    targetSkillSpecific: "Nivel requerido",
    assignedToPosition: "Asignada directa al cargo",
    competencyAssignedToGroup: "Del grupo de competencias para el cargo",
    pollNetworkType: "Tipo de red de la encuesta",
    cannotShowScope:
        "No es posible visualizar el Alcance en encuestas relacionadas con los grupos de tareas o con un grupo de colaboradores específicos",
    noDataForFilter: "No se encontraron datos para los filtros seleccionados",
    searchSkill: "Buscar competencia",
    selectedSkills: "Competencias seleccionadas",
    relatedSkills: "Competencias relacionadas",
    skillInUseInCourse: "No es posible eliminar la competencia porque está siendo utilizada en uno o más cursos",
    hasRelatedSkills: "Tiene competencias relacionadas",
    moduleVisualizationFilterHelperText:
        'SQL que debe cumplirse para visualizar el módulo.\nIngrese una consulta SQL completa con formato: SELECT TOP 1 "Code" FROM... WHERE...\nSi devuelve al menos un registro para el usuario logueado, el módulo se visualizará. Si no devuelve registros, no se mostrará.\nUse la variable "#CODEMP#" para representar el código del usuario consultado.',
    menuVisualizationFilterHelperText:
        'SQL que debe cumplirse para visualizar el menú.\nIngrese una consulta SQL completa con formato: SELECT TOP 1 "Code" FROM... WHERE...\nSi devuelve al menos un registro para el usuario logueado, el menú se visualizará. Si no devuelve registros, no se mostrará.\nUse la variable "#CODEMP#" para representar el código del usuario consultado.',
    menus: "Menús",
    menu: "Menú",
    exclusions: "Exclusiones",
    editable: "Editable",
    sqlFilter: "Filtro SQL",
    path: "Path",
    childrenOf: "Padre",
    hiddenByChildren: "Oculto si no tiene hijos activos",
    employees: "Empleados",
    menuUpdatedOk: "Menú actualizado con éxito",
    visualizationFilter: "Filtro de visualización",
    menuData: "Datos del menú",
    modulesAndMenus: "Módulos y menús",
    updateMenu: "Editar menú",
    exclusionSQLHelperText:
        "Ingrese una consulta SQL que devuelva únicamente los códigos de empleados a excluir.\nFormato esperado: SELECT ...AS 'Code' FROM... WHERE...",
    applyExclusionTo: "Aplicar exclusión a",
    submenu: "Submenú",
    employeeHasNoAcessToRole: "El empleado no tiene acceso al rol seleccionado",
    createExclusion: "Crear exclusión",
    updateExclusion: "Editar exclusión",
    deleteExclusionQuestion: "¿Desea eliminar la exclusión?",
    requiredMenu: "Menu requerido",
    button: "Botón",
    box: "Box",
    clickToSelectMenu: "Haga clic en un menú en el árbol para seleccionarlo",
    visualizationEmployees: "Empleados que visualizan",
    onaEmployees: "Empleados para ONA",
    organizationalDevelopment: "Desarrollo organizacional",
    skills: "Competencias",
    globalRanking: "Ranking global",
    fulfillment: "Cumplimiento",
    gap: "Brecha",
    realLevel: "Nivel real (1-5)",
    requiredLevel: "Nivel requerido (1-5)",
    skill: "Competencia",
    collaboratorRanking: "Ranking de colaboradores",
    profileMatches: "Cumple perfil",
    surpassesProfile: "Supera perfil",
    lowGap: "Brecha baja",
    suggestedCourses: "Cursos sugeridos",
    skillMatrix: "Matriz de competencias",
    lms: "L.M.S.",
    toImproveDevelopment: "Para mejorar el desarrollo",
    currentDevelopmentLevel: "Nivel de desarrollo actual",
    byPositionSkills: "Según competencias del cargo",
    masteryLevel: "Niveles de dominio",
    skillsRanking: "Ranking de competencias",
    dependency: "Dependencia",
    blockedByPendingActivity: "Bloqueado por actividad pendiente ({activityName})",
    pendingCorrection: "Corrección pendiente",
    sessionHowToComplete:
        "Para completar esta actividad, debe asistir a alguna de las siguientes sesiones y el instructor debe marcarle la asistencia.",
    sessionHowToCompleteAsInstructor:
        "Para que los participantes concluyan esta actividad debe marcarles asistencia en una de las sesiones propuestas.",
    cannotEditSession: "Esta sesión no puede editarse porque ya presenta asistencias marcadas",
    readOnlyAdmin: "Solo lectura (Administrador)",
    viewAssistance: "Ver asistencia",
    privacyPolicyContent1:
        ' es una plataforma SaaS absolutamente segura" que resguarda el total de tu información personal de manera confidencial.',
    privacyPolicyContent2:
        "Mantiene todos los datos relacionados con tu clave e identificación de acceso en forma encriptada, no permitiendo el acceso a tus datos por parte de terceros.",
    privacyPolicyContent3: 'En "Datos personales" podrás visualizar toda la información que ',
    privacyPolicyContent4:
        " tiene de tu ficha como colaborador y, adicionalmente, tiene toda la información relacionada con otros procesos donde puedas estar participando, tales como: procesos de cálculo de nómina, evaluaciones de tu desempeño, capacitaciones, anotaciones realizadas por tu jefatura directa, tu carpeta digital (documentos firmados digitalmente: contratos de trabajo, recibos de cálculo de nómina, solicitudes de permisos o vacaciones, consentimientos firmados, etc.).",
    privacyPolicyContent5: "¿Quiénes pueden acceder a esta información?",
    privacyPolicyContent6: "Tú, al ingresar a la plataforma de ",
    privacyPolicyContent7: " como colaborador e identificarte correctamente.",
    privacyPolicyContent8: "Tu jefatura directa (que ingresa como manager).",
    privacyPolicyContent9:
        "El personal de Gestión de Personas, encargados de la gestión del personal de tu organización, que ingresan como empleadores.",
    privacyPolicyContent10: "Y nadie más.",
    privacyPolicyContent11:
        'Para ello, jamás debes compartir tu PIN de acceso, el cual puedes cambiar cuando quieras desde el menú lateral y mediante el punto de menú "Mi PIN", una vez que estés dentro de la plataforma. Ahora bien, si no has ingresado a la plataforma o no recuerdas cómo hacerlo, desde la pantalla de LOGIN puedes pulsar en "Recuperar PIN de acceso", previamente ingresando los datos de CLIENTE y tu USUARIO; de ese modo, podrás restaurar un nuevo PIN de acceso, simplemente sigue los pasos que ',
    privacyPolicyContent12: " te irá mostrando y solicitando.",
    privacyPolicyContent13:
        "Puedes tener plena garantía de que nada de tu información se comparte con terceras personas o compañías externas y para ningún tipo de fin.",
    privacyPolicyContent14:
        "TU INFORMACIÓN PERSONAL y PRIVACIDAD se mantiene bajo estricto control de confidencialidad.",
    privacyPolicyContent15:
        "Asimismo, la base de datos donde tu información es contenida es única, privada y está almacenada en la nube con uno de los proveedores más seguros a nivel mundial, como lo es Amazon Web Services (AWS), quienes, por normas y políticas internacionales, solo hostean dichas bases de datos, pero no interfieren sobre ellas de modo alguno.",
    privacyPolicyContent16:
        'Cuando revises tus "Datos personales" tendrás a tu disposición un botón llamado "Reclamar corrección", el cual, si lo pulsas, te permitirá indicar qué datos personales has visualizado que son incorrectos o imprecisos. Una vez realizada esa acción, ',
    privacyPolicyContent17:
        ' enviará un correo de alerta al personal de "Gestión de personas" de tu organización para que proceda a cambiar los datos o corregirlos, y posteriormente te avisará que los cambios solicitados se han realizado, si corresponde.',
    privacyPolicyContent18: "Derecho a la portabilidad",
    privacyPolicyContent19: "Tu organización, si suspende el servicio SaaS con ",
    privacyPolicyContent20: ", tiene el derecho de recibir toda la información que ",
    privacyPolicyContent21:
        " contiene en la base de datos de la organización y poder cambiarse a otra plataforma o hacer uso de esa información como ellos lo determinen más apropiado. Nosotros tenemos la obligación de eliminarla por completo cuando así lo determine tu organización, y eso debe ser dentro de los 90 días corridos de haber recibido la base de datos solicitada y que fue entregada por nosotros, lo cual quedará debidamente documentado.",
    privacyPolicyContent22: "Ambientes de desarrollo",
    privacyPolicyContent23:
        " jamás utiliza para desarrollar su software ambientes de terceros; es decir, no utiliza los datos de ninguno de nuestros clientes. O sea, no utilizamos los servidores productivos que mantenemos con AWS; muy por el contrario, se utiliza información propia y en servidores de desarrollo que están hosteados con otros proveedores y que son exclusivos para el desarrollo y mantenimiento de nuestro software.",
    tourBack: "Atrás",
    tourClose: "Cerrar",
    tourFinish: "Finalizar",
    tourNext: "Siguiente",
    tourSkip: "Saltar",
    commandPaletteTourTitleSearch: "Buscador Inteligente",
    commandPaletteTourSearch: "Aquí puedes buscar menús, configuraciones y pantallas de forma instantánea.",
    commandPaletteTourTitleList: "Resultados al instante",
    commandPaletteTourList:
        "Los resultados de tu búsqueda aparecerán aquí. Puedes navegar por ellos rápidamente usando tu teclado.",
    commandPaletteTourTitleFooter: "Atajos de Teclado",
    commandPaletteTourFooter: "Utiliza estos atajos para moverte más rápido por la paleta sin tener que usar el ratón.",
    toNavigate: "para navegar",
    toSelect: "para seleccionar",
    toClose: "para cerrar",
    toHelp: "para ayuda",
    porcentajeRentabilidadProtegida: "Porcentaje rentabilidad protegida",
    porcentajeExpectativaDeVida: "Porcentaje Expectativa de vida",
    porcentajeCapitalizaciónIndividual: "Porcentaje capitalización individual",
    duplicateExclusion: "Duplicar exclusión",
    exclusionDuplicateOk: "Exclusión duplicada con éxito",
    icariusAssistant: "Asistente de IA de ICARIUS",
    howCanIHelp: "¿Cómo puedo ayudate?",
    writeYourMessage: "Escribe tu mensaje...",
    doNotShareInformation: "No compartas información sensible",
    groupOwner: "Dueño del grupo",
    enableGroupChatbot: "Habilitar Chatbot",
    BOT_ASSISTANT_ENABLED: "Habilitar Chatbot para grupos y bodegas digitales",
    groupChatbotDisabledGeneralParameters: "Chatbot desactivado desde Parámetros Generales",
    confirmSyncFiles:
        "¿Desea sincronizar los archivos seleccionados para ser consultados por el Asistente de IA de ICARIUS?",
    syncFiles: "Sincronizar archivos para la IA de ICARIUS",
    fileSyncStatus: "Estado de sincronización",
    filesSyncedSuccessfully: "Sincronización realizada con éxito",
    fileInvalidFormat: "Archivo con formato inválido",
    cannotSelectMoreThanTwoFiles: "No puede seleccionar más de dos archivos",
    cancelMessage: "Cancelar mensaje",
    conversationDeletedOk: "Conversación eliminada con éxito",
    deleteConversation: "Eliminar conversación",
    attachFile: "Adjuntar archivo",
    confirmDeleteConversation: "¿Desea eliminar la conversación, incluyendo los nuevos archivos subidos?",
    suggestedQuestions: "Preguntas sugeridas",
    REQUEST_BLOCK: "APP de carga de datos en la tarja debe pedir el cuartel",
    REQUEST_VARIETY: "APP de carga de datos en la tarja debe pedir la variedad",
    generateOrUpdateWithAI: "Crear o modificar con IA",
    updateQueryWithAI: "Modificar con IA",
    mustSelectSingleItemOrNone: "Debe seleccionar un item para modificarlo o ninguno para crear de cero",
    questionsEnabledAfterFirstGeneration:
        "Podrá modificar las preguntas luego de modificar la consulta con IA por primera vez",
    invalidParamValues: "Valores de parámetros inválidos",
    operationModeSql: "SQL de modo de operación",
    operationModeSqlHelperText:
        'Debe devolver exactamente una fila con columna "Code" y valor Y/M/V/N (Y: permite alta, modificación y eliminación; M: permite solamente modificación; V o N: no permite ninguna escritura). Sin resultado, error o estructura inválida: se usa el editor activo como siempre.',
    recordBlockSql: "SQL de bloqueo de registros",
    recordBlockSqlHelperText:
        'Sirve para dejar solo en visualización los registros retornados como "Code" y no permitir ni editar ni eliminar (debe retornar como "Code" todos los registros que desee bloquear, cero o más filas). Cualquier error, valor o estructura inválida se ignora.',
    recordBlockSqlVariablesHelperText:
        "Disponibles las variables #CODEMP# y #EMPLOYEESLIST# y en tablas de detalle #ColN#. Utilice 'Explicación de protección' AS 'Error' para personalizar un mensaje de error con el motivo del bloqueo de eliminación o modificación del registro.",
    protectionSql: "SQL de bloqueo",
    protectionSqlHelperText:
        'Por cada "Code" retornado, se protege únicamente ese campo contra modificaciones. No bloquea la eliminación ni otros campos.',
    sqlVariablesAvailableHelperText:
        "Disponibles las variables #CODEMP# y #EMPLOYEESLIST# y en tablas de detalle #ColN#",
    cannotModifyOrDeleteBlockedRecords:
        "No se pueden modificar o eliminar uno o más registros porque están bloqueados.",
    connectionRestored: "Conexión restablecida",
    noConnection: "Sin conexión",
    extraHoursDone: "Horas extras realizadas",
};

export default stringsES;
